
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
// Import các module cần thiết
/*
	The MIT License (MIT)

	Copyright (c) 2016 Meetecho

	Permission is hereby granted, free of charge, to any person obtaining
	a copy of this software and associated documentation files (the "Software"),
	to deal in the Software without restriction, including without limitation
	the rights to use, copy, modify, merge, publish, distribute, sublicense,
	and/or sell copies of the Software, and to permit persons to whom the
	Software is furnished to do so, subject to the following conditions:

	The above copyright notice and this permission notice shall be included
	in all copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
	THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
	OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
	ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
	OTHER DEALINGS IN THE SOFTWARE.
 */ // List of sessions
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ /*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 'use strict';
let $584b81f9a9b8bf97$var$logDisabled_ = true;
let $584b81f9a9b8bf97$var$deprecationWarnings_ = true;
function $584b81f9a9b8bf97$export$e3c02be309be1f23(uastring, expr, pos) {
    const match = uastring.match(expr);
    return match && match.length >= pos && parseInt(match[pos], 10);
}
function $584b81f9a9b8bf97$export$1f48841962b828b1(window1, eventNameToWrap, wrapper) {
    if (!window1.RTCPeerConnection) return;
    const proto = window1.RTCPeerConnection.prototype;
    const nativeAddEventListener = proto.addEventListener;
    proto.addEventListener = function(nativeEventName, cb) {
        if (nativeEventName !== eventNameToWrap) return nativeAddEventListener.apply(this, arguments);
        const wrappedCallback = (e)=>{
            const modifiedEvent = wrapper(e);
            if (modifiedEvent) {
                if (cb.handleEvent) cb.handleEvent(modifiedEvent);
                else cb(modifiedEvent);
            }
        };
        this._eventMap = this._eventMap || {};
        if (!this._eventMap[eventNameToWrap]) this._eventMap[eventNameToWrap] = new Map();
        this._eventMap[eventNameToWrap].set(cb, wrappedCallback);
        return nativeAddEventListener.apply(this, [
            nativeEventName,
            wrappedCallback
        ]);
    };
    const nativeRemoveEventListener = proto.removeEventListener;
    proto.removeEventListener = function(nativeEventName, cb) {
        if (nativeEventName !== eventNameToWrap || !this._eventMap || !this._eventMap[eventNameToWrap]) return nativeRemoveEventListener.apply(this, arguments);
        if (!this._eventMap[eventNameToWrap].has(cb)) return nativeRemoveEventListener.apply(this, arguments);
        const unwrappedCb = this._eventMap[eventNameToWrap].get(cb);
        this._eventMap[eventNameToWrap].delete(cb);
        if (this._eventMap[eventNameToWrap].size === 0) delete this._eventMap[eventNameToWrap];
        if (Object.keys(this._eventMap).length === 0) delete this._eventMap;
        return nativeRemoveEventListener.apply(this, [
            nativeEventName,
            unwrappedCb
        ]);
    };
    Object.defineProperty(proto, 'on' + eventNameToWrap, {
        get () {
            return this['_on' + eventNameToWrap];
        },
        set (cb) {
            if (this['_on' + eventNameToWrap]) {
                this.removeEventListener(eventNameToWrap, this['_on' + eventNameToWrap]);
                delete this['_on' + eventNameToWrap];
            }
            if (cb) this.addEventListener(eventNameToWrap, this['_on' + eventNameToWrap] = cb);
        },
        enumerable: true,
        configurable: true
    });
}
function $584b81f9a9b8bf97$export$afbfee8cc06fd3e4(bool) {
    if (typeof bool !== 'boolean') return new Error('Argument type: ' + typeof bool + '. Please use a boolean.');
    $584b81f9a9b8bf97$var$logDisabled_ = bool;
    return bool ? 'adapter.js logging disabled' : 'adapter.js logging enabled';
}
function $584b81f9a9b8bf97$export$51516be4b019e41e(bool) {
    if (typeof bool !== 'boolean') return new Error('Argument type: ' + typeof bool + '. Please use a boolean.');
    $584b81f9a9b8bf97$var$deprecationWarnings_ = !bool;
    return 'adapter.js deprecation warnings ' + (bool ? 'disabled' : 'enabled');
}
function $584b81f9a9b8bf97$export$bef1f36f5486a6a3() {
    if (typeof window === 'object') {
        if ($584b81f9a9b8bf97$var$logDisabled_) return;
        if (typeof console !== 'undefined' && typeof console.log === 'function') console.log.apply(console, arguments);
    }
}
function $584b81f9a9b8bf97$export$cdd73fc4100a6ef4(oldMethod, newMethod) {
    if (!$584b81f9a9b8bf97$var$deprecationWarnings_) return;
    console.warn(oldMethod + ' is deprecated, please use ' + newMethod + ' instead.');
}
function $584b81f9a9b8bf97$export$2d31490a0c05f094(window1) {
    // Returned result object.
    const result = {
        browser: null,
        version: null
    };
    // Fail early if it's not a browser
    if (typeof window1 === 'undefined' || !window1.navigator || !window1.navigator.userAgent) {
        result.browser = 'Not a browser.';
        return result;
    }
    const { navigator: navigator } = window1;
    if (navigator.mozGetUserMedia) {
        result.browser = 'firefox';
        result.version = $584b81f9a9b8bf97$export$e3c02be309be1f23(navigator.userAgent, /Firefox\/(\d+)\./, 1);
    } else if (navigator.webkitGetUserMedia || window1.isSecureContext === false && window1.webkitRTCPeerConnection) {
        // Chrome, Chromium, Webview, Opera.
        // Version matches Chrome/WebRTC version.
        // Chrome 74 removed webkitGetUserMedia on http as well so we need the
        // more complicated fallback to webkitRTCPeerConnection.
        result.browser = 'chrome';
        result.version = $584b81f9a9b8bf97$export$e3c02be309be1f23(navigator.userAgent, /Chrom(e|ium)\/(\d+)\./, 2);
    } else if (window1.RTCPeerConnection && navigator.userAgent.match(/AppleWebKit\/(\d+)\./)) {
        result.browser = 'safari';
        result.version = $584b81f9a9b8bf97$export$e3c02be309be1f23(navigator.userAgent, /AppleWebKit\/(\d+)\./, 1);
        result.supportsUnifiedPlan = window1.RTCRtpTransceiver && 'currentDirection' in window1.RTCRtpTransceiver.prototype;
    } else {
        result.browser = 'Not a supported browser.';
        return result;
    }
    return result;
}
/**
 * Checks if something is an object.
 *
 * @param {*} val The something you want to check.
 * @return true if val is an object, false otherwise.
 */ function $584b81f9a9b8bf97$var$isObject(val) {
    return Object.prototype.toString.call(val) === '[object Object]';
}
function $584b81f9a9b8bf97$export$15384eac40dc88c8(data) {
    if (!$584b81f9a9b8bf97$var$isObject(data)) return data;
    return Object.keys(data).reduce(function(accumulator, key) {
        const isObj = $584b81f9a9b8bf97$var$isObject(data[key]);
        const value = isObj ? $584b81f9a9b8bf97$export$15384eac40dc88c8(data[key]) : data[key];
        const isEmptyObject = isObj && !Object.keys(value).length;
        if (value === undefined || isEmptyObject) return accumulator;
        return Object.assign(accumulator, {
            [key]: value
        });
    }, {});
}
function $584b81f9a9b8bf97$export$571b373e75babb58(stats, base, resultSet) {
    if (!base || resultSet.has(base.id)) return;
    resultSet.set(base.id, base);
    Object.keys(base).forEach((name)=>{
        if (name.endsWith('Id')) $584b81f9a9b8bf97$export$571b373e75babb58(stats, stats.get(base[name]), resultSet);
        else if (name.endsWith('Ids')) base[name].forEach((id)=>{
            $584b81f9a9b8bf97$export$571b373e75babb58(stats, stats.get(id), resultSet);
        });
    });
}
function $584b81f9a9b8bf97$export$93439ffc3f787d51(result, track, outbound) {
    const streamStatsType = outbound ? 'outbound-rtp' : 'inbound-rtp';
    const filteredResult = new Map();
    if (track === null) return filteredResult;
    const trackStats = [];
    result.forEach((value)=>{
        if (value.type === 'track' && value.trackIdentifier === track.id) trackStats.push(value);
    });
    trackStats.forEach((trackStat)=>{
        result.forEach((stats)=>{
            if (stats.type === streamStatsType && stats.trackId === trackStat.id) $584b81f9a9b8bf97$export$571b373e75babb58(result, stats, filteredResult);
        });
    });
    return filteredResult;
}


var $558eb894511c4db3$exports = {};

$parcel$export($558eb894511c4db3$exports, "shimMediaStream", () => $558eb894511c4db3$export$33ee24e7a300bcd1);
$parcel$export($558eb894511c4db3$exports, "shimOnTrack", () => $558eb894511c4db3$export$f358708f68ab068);
$parcel$export($558eb894511c4db3$exports, "shimGetSendersWithDtmf", () => $558eb894511c4db3$export$a41a030a2842f5d6);
$parcel$export($558eb894511c4db3$exports, "shimGetStats", () => $558eb894511c4db3$export$90608323826f0b17);
$parcel$export($558eb894511c4db3$exports, "shimSenderReceiverGetStats", () => $558eb894511c4db3$export$f2f0f2338114eb4b);
$parcel$export($558eb894511c4db3$exports, "shimAddTrackRemoveTrackWithNative", () => $558eb894511c4db3$export$30e3cdd46f8d5100);
$parcel$export($558eb894511c4db3$exports, "shimAddTrackRemoveTrack", () => $558eb894511c4db3$export$9588259fcf4ebc91);
$parcel$export($558eb894511c4db3$exports, "shimPeerConnection", () => $558eb894511c4db3$export$852a08dda9a55ea7);
$parcel$export($558eb894511c4db3$exports, "fixNegotiationNeeded", () => $558eb894511c4db3$export$341293bbeaae37cb);
$parcel$export($558eb894511c4db3$exports, "shimGetUserMedia", () => $bbd222a30988f5e1$export$1ed4910f4d37dc5e);
$parcel$export($558eb894511c4db3$exports, "shimGetDisplayMedia", () => $37b941bc77cf20ee$export$97270b87351d9c04);
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
'use strict';
const $bbd222a30988f5e1$var$logging = $584b81f9a9b8bf97$export$bef1f36f5486a6a3;
function $bbd222a30988f5e1$export$1ed4910f4d37dc5e(window, browserDetails) {
    const navigator = window && window.navigator;
    if (!navigator.mediaDevices) return;
    const constraintsToChrome_ = function(c) {
        if (typeof c !== 'object' || c.mandatory || c.optional) return c;
        const cc = {};
        Object.keys(c).forEach((key)=>{
            if (key === 'require' || key === 'advanced' || key === 'mediaSource') return;
            const r = typeof c[key] === 'object' ? c[key] : {
                ideal: c[key]
            };
            if (r.exact !== undefined && typeof r.exact === 'number') r.min = r.max = r.exact;
            const oldname_ = function(prefix, name) {
                if (prefix) return prefix + name.charAt(0).toUpperCase() + name.slice(1);
                return name === 'deviceId' ? 'sourceId' : name;
            };
            if (r.ideal !== undefined) {
                cc.optional = cc.optional || [];
                let oc = {};
                if (typeof r.ideal === 'number') {
                    oc[oldname_('min', key)] = r.ideal;
                    cc.optional.push(oc);
                    oc = {};
                    oc[oldname_('max', key)] = r.ideal;
                    cc.optional.push(oc);
                } else {
                    oc[oldname_('', key)] = r.ideal;
                    cc.optional.push(oc);
                }
            }
            if (r.exact !== undefined && typeof r.exact !== 'number') {
                cc.mandatory = cc.mandatory || {};
                cc.mandatory[oldname_('', key)] = r.exact;
            } else [
                'min',
                'max'
            ].forEach((mix)=>{
                if (r[mix] !== undefined) {
                    cc.mandatory = cc.mandatory || {};
                    cc.mandatory[oldname_(mix, key)] = r[mix];
                }
            });
        });
        if (c.advanced) cc.optional = (cc.optional || []).concat(c.advanced);
        return cc;
    };
    const shimConstraints_ = function(constraints, func) {
        if (browserDetails.version >= 61) return func(constraints);
        constraints = JSON.parse(JSON.stringify(constraints));
        if (constraints && typeof constraints.audio === 'object') {
            const remap = function(obj, a, b) {
                if (a in obj && !(b in obj)) {
                    obj[b] = obj[a];
                    delete obj[a];
                }
            };
            constraints = JSON.parse(JSON.stringify(constraints));
            remap(constraints.audio, 'autoGainControl', 'googAutoGainControl');
            remap(constraints.audio, 'noiseSuppression', 'googNoiseSuppression');
            constraints.audio = constraintsToChrome_(constraints.audio);
        }
        if (constraints && typeof constraints.video === 'object') {
            // Shim facingMode for mobile & surface pro.
            let face = constraints.video.facingMode;
            face = face && (typeof face === 'object' ? face : {
                ideal: face
            });
            const getSupportedFacingModeLies = browserDetails.version < 66;
            if (face && (face.exact === 'user' || face.exact === 'environment' || face.ideal === 'user' || face.ideal === 'environment') && !(navigator.mediaDevices.getSupportedConstraints && navigator.mediaDevices.getSupportedConstraints().facingMode && !getSupportedFacingModeLies)) {
                delete constraints.video.facingMode;
                let matches;
                if (face.exact === 'environment' || face.ideal === 'environment') matches = [
                    'back',
                    'rear'
                ];
                else if (face.exact === 'user' || face.ideal === 'user') matches = [
                    'front'
                ];
                if (matches) // Look for matches in label, or use last cam for back (typical).
                return navigator.mediaDevices.enumerateDevices().then((devices)=>{
                    devices = devices.filter((d)=>d.kind === 'videoinput');
                    let dev = devices.find((d)=>matches.some((match)=>d.label.toLowerCase().includes(match)));
                    if (!dev && devices.length && matches.includes('back')) dev = devices[devices.length - 1]; // more likely the back cam
                    if (dev) constraints.video.deviceId = face.exact ? {
                        exact: dev.deviceId
                    } : {
                        ideal: dev.deviceId
                    };
                    constraints.video = constraintsToChrome_(constraints.video);
                    $bbd222a30988f5e1$var$logging('chrome: ' + JSON.stringify(constraints));
                    return func(constraints);
                });
            }
            constraints.video = constraintsToChrome_(constraints.video);
        }
        $bbd222a30988f5e1$var$logging('chrome: ' + JSON.stringify(constraints));
        return func(constraints);
    };
    const shimError_ = function(e) {
        if (browserDetails.version >= 64) return e;
        return {
            name: ({
                PermissionDeniedError: 'NotAllowedError',
                PermissionDismissedError: 'NotAllowedError',
                InvalidStateError: 'NotAllowedError',
                DevicesNotFoundError: 'NotFoundError',
                ConstraintNotSatisfiedError: 'OverconstrainedError',
                TrackStartError: 'NotReadableError',
                MediaDeviceFailedDueToShutdown: 'NotAllowedError',
                MediaDeviceKillSwitchOn: 'NotAllowedError',
                TabCaptureError: 'AbortError',
                ScreenCaptureError: 'AbortError',
                DeviceCaptureError: 'AbortError'
            })[e.name] || e.name,
            message: e.message,
            constraint: e.constraint || e.constraintName,
            toString () {
                return this.name + (this.message && ': ') + this.message;
            }
        };
    };
    const getUserMedia_ = function(constraints, onSuccess, onError) {
        shimConstraints_(constraints, (c)=>{
            navigator.webkitGetUserMedia(c, onSuccess, (e)=>{
                if (onError) onError(shimError_(e));
            });
        });
    };
    navigator.getUserMedia = getUserMedia_.bind(navigator);
    // Even though Chrome 45 has navigator.mediaDevices and a getUserMedia
    // function which returns a Promise, it does not accept spec-style
    // constraints.
    if (navigator.mediaDevices.getUserMedia) {
        const origGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
        navigator.mediaDevices.getUserMedia = function(cs) {
            return shimConstraints_(cs, (c)=>origGetUserMedia(c).then((stream)=>{
                    if (c.audio && !stream.getAudioTracks().length || c.video && !stream.getVideoTracks().length) {
                        stream.getTracks().forEach((track)=>{
                            track.stop();
                        });
                        throw new DOMException('', 'NotFoundError');
                    }
                    return stream;
                }, (e)=>Promise.reject(shimError_(e))));
        };
    }
}


/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 'use strict';
function $37b941bc77cf20ee$export$97270b87351d9c04(window, getSourceId) {
    if (window.navigator.mediaDevices && 'getDisplayMedia' in window.navigator.mediaDevices) return;
    if (!window.navigator.mediaDevices) return;
    // getSourceId is a function that returns a promise resolving with
    // the sourceId of the screen/window/tab to be shared.
    if (typeof getSourceId !== 'function') {
        console.error("shimGetDisplayMedia: getSourceId argument is not a function");
        return;
    }
    window.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
        return getSourceId(constraints).then((sourceId)=>{
            const widthSpecified = constraints.video && constraints.video.width;
            const heightSpecified = constraints.video && constraints.video.height;
            const frameRateSpecified = constraints.video && constraints.video.frameRate;
            constraints.video = {
                mandatory: {
                    chromeMediaSource: 'desktop',
                    chromeMediaSourceId: sourceId,
                    maxFrameRate: frameRateSpecified || 3
                }
            };
            if (widthSpecified) constraints.video.mandatory.maxWidth = widthSpecified;
            if (heightSpecified) constraints.video.mandatory.maxHeight = heightSpecified;
            return window.navigator.mediaDevices.getUserMedia(constraints);
        });
    };
}


'use strict';
function $558eb894511c4db3$export$33ee24e7a300bcd1(window) {
    window.MediaStream = window.MediaStream || window.webkitMediaStream;
}
function $558eb894511c4db3$export$f358708f68ab068(window) {
    if (typeof window === 'object' && window.RTCPeerConnection && !('ontrack' in window.RTCPeerConnection.prototype)) {
        Object.defineProperty(window.RTCPeerConnection.prototype, 'ontrack', {
            get () {
                return this._ontrack;
            },
            set (f) {
                if (this._ontrack) this.removeEventListener('track', this._ontrack);
                this.addEventListener('track', this._ontrack = f);
            },
            enumerable: true,
            configurable: true
        });
        const origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
        window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
            if (!this._ontrackpoly) {
                this._ontrackpoly = (e)=>{
                    // onaddstream does not fire when a track is added to an existing
                    // stream. But stream.onaddtrack is implemented so we use that.
                    e.stream.addEventListener('addtrack', (te)=>{
                        let receiver;
                        if (window.RTCPeerConnection.prototype.getReceivers) receiver = this.getReceivers().find((r)=>r.track && r.track.id === te.track.id);
                        else receiver = {
                            track: te.track
                        };
                        const event = new Event('track');
                        event.track = te.track;
                        event.receiver = receiver;
                        event.transceiver = {
                            receiver: receiver
                        };
                        event.streams = [
                            e.stream
                        ];
                        this.dispatchEvent(event);
                    });
                    e.stream.getTracks().forEach((track)=>{
                        let receiver;
                        if (window.RTCPeerConnection.prototype.getReceivers) receiver = this.getReceivers().find((r)=>r.track && r.track.id === track.id);
                        else receiver = {
                            track: track
                        };
                        const event = new Event('track');
                        event.track = track;
                        event.receiver = receiver;
                        event.transceiver = {
                            receiver: receiver
                        };
                        event.streams = [
                            e.stream
                        ];
                        this.dispatchEvent(event);
                    });
                };
                this.addEventListener('addstream', this._ontrackpoly);
            }
            return origSetRemoteDescription.apply(this, arguments);
        };
    } else // even if RTCRtpTransceiver is in window, it is only used and
    // emitted in unified-plan. Unfortunately this means we need
    // to unconditionally wrap the event.
    $584b81f9a9b8bf97$export$1f48841962b828b1(window, 'track', (e)=>{
        if (!e.transceiver) Object.defineProperty(e, 'transceiver', {
            value: {
                receiver: e.receiver
            }
        });
        return e;
    });
}
function $558eb894511c4db3$export$a41a030a2842f5d6(window) {
    // Overrides addTrack/removeTrack, depends on shimAddTrackRemoveTrack.
    if (typeof window === 'object' && window.RTCPeerConnection && !('getSenders' in window.RTCPeerConnection.prototype) && 'createDTMFSender' in window.RTCPeerConnection.prototype) {
        const shimSenderWithDtmf = function(pc, track) {
            return {
                track: track,
                get dtmf () {
                    if (this._dtmf === undefined) {
                        if (track.kind === 'audio') this._dtmf = pc.createDTMFSender(track);
                        else this._dtmf = null;
                    }
                    return this._dtmf;
                },
                _pc: pc
            };
        };
        // augment addTrack when getSenders is not available.
        if (!window.RTCPeerConnection.prototype.getSenders) {
            window.RTCPeerConnection.prototype.getSenders = function getSenders() {
                this._senders = this._senders || [];
                return this._senders.slice(); // return a copy of the internal state.
            };
            const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
            window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
                let sender = origAddTrack.apply(this, arguments);
                if (!sender) {
                    sender = shimSenderWithDtmf(this, track);
                    this._senders.push(sender);
                }
                return sender;
            };
            const origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
            window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
                origRemoveTrack.apply(this, arguments);
                const idx = this._senders.indexOf(sender);
                if (idx !== -1) this._senders.splice(idx, 1);
            };
        }
        const origAddStream = window.RTCPeerConnection.prototype.addStream;
        window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
            this._senders = this._senders || [];
            origAddStream.apply(this, [
                stream
            ]);
            stream.getTracks().forEach((track)=>{
                this._senders.push(shimSenderWithDtmf(this, track));
            });
        };
        const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
        window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
            this._senders = this._senders || [];
            origRemoveStream.apply(this, [
                stream
            ]);
            stream.getTracks().forEach((track)=>{
                const sender = this._senders.find((s)=>s.track === track);
                if (sender) this._senders.splice(this._senders.indexOf(sender), 1);
            });
        };
    } else if (typeof window === 'object' && window.RTCPeerConnection && 'getSenders' in window.RTCPeerConnection.prototype && 'createDTMFSender' in window.RTCPeerConnection.prototype && window.RTCRtpSender && !('dtmf' in window.RTCRtpSender.prototype)) {
        const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
        window.RTCPeerConnection.prototype.getSenders = function getSenders() {
            const senders = origGetSenders.apply(this, []);
            senders.forEach((sender)=>sender._pc = this);
            return senders;
        };
        Object.defineProperty(window.RTCRtpSender.prototype, 'dtmf', {
            get () {
                if (this._dtmf === undefined) {
                    if (this.track.kind === 'audio') this._dtmf = this._pc.createDTMFSender(this.track);
                    else this._dtmf = null;
                }
                return this._dtmf;
            }
        });
    }
}
function $558eb894511c4db3$export$90608323826f0b17(window) {
    if (!window.RTCPeerConnection) return;
    const origGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function getStats() {
        const [selector, onSucc, onErr] = arguments;
        // If selector is a function then we are in the old style stats so just
        // pass back the original getStats format to avoid breaking old users.
        if (arguments.length > 0 && typeof selector === 'function') return origGetStats.apply(this, arguments);
        // When spec-style getStats is supported, return those when called with
        // either no arguments or the selector argument is null.
        if (origGetStats.length === 0 && (arguments.length === 0 || typeof selector !== 'function')) return origGetStats.apply(this, []);
        const fixChromeStats_ = function(response) {
            const standardReport = {};
            const reports = response.result();
            reports.forEach((report)=>{
                const standardStats = {
                    id: report.id,
                    timestamp: report.timestamp,
                    type: {
                        localcandidate: 'local-candidate',
                        remotecandidate: 'remote-candidate'
                    }[report.type] || report.type
                };
                report.names().forEach((name)=>{
                    standardStats[name] = report.stat(name);
                });
                standardReport[standardStats.id] = standardStats;
            });
            return standardReport;
        };
        // shim getStats with maplike support
        const makeMapStats = function(stats) {
            return new Map(Object.keys(stats).map((key)=>[
                    key,
                    stats[key]
                ]));
        };
        if (arguments.length >= 2) {
            const successCallbackWrapper_ = function(response) {
                onSucc(makeMapStats(fixChromeStats_(response)));
            };
            return origGetStats.apply(this, [
                successCallbackWrapper_,
                selector
            ]);
        }
        // promise-support
        return new Promise((resolve, reject)=>{
            origGetStats.apply(this, [
                function(response) {
                    resolve(makeMapStats(fixChromeStats_(response)));
                },
                reject
            ]);
        }).then(onSucc, onErr);
    };
}
function $558eb894511c4db3$export$f2f0f2338114eb4b(window) {
    if (!(typeof window === 'object' && window.RTCPeerConnection && window.RTCRtpSender && window.RTCRtpReceiver)) return;
    // shim sender stats.
    if (!('getStats' in window.RTCRtpSender.prototype)) {
        const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
        if (origGetSenders) window.RTCPeerConnection.prototype.getSenders = function getSenders() {
            const senders = origGetSenders.apply(this, []);
            senders.forEach((sender)=>sender._pc = this);
            return senders;
        };
        const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
        if (origAddTrack) window.RTCPeerConnection.prototype.addTrack = function addTrack() {
            const sender = origAddTrack.apply(this, arguments);
            sender._pc = this;
            return sender;
        };
        window.RTCRtpSender.prototype.getStats = function getStats() {
            const sender = this;
            return this._pc.getStats().then((result)=>/* Note: this will include stats of all senders that
         *   send a track with the same id as sender.track as
         *   it is not possible to identify the RTCRtpSender.
         */ $584b81f9a9b8bf97$export$93439ffc3f787d51(result, sender.track, true));
        };
    }
    // shim receiver stats.
    if (!('getStats' in window.RTCRtpReceiver.prototype)) {
        const origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
        if (origGetReceivers) window.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
            const receivers = origGetReceivers.apply(this, []);
            receivers.forEach((receiver)=>receiver._pc = this);
            return receivers;
        };
        $584b81f9a9b8bf97$export$1f48841962b828b1(window, 'track', (e)=>{
            e.receiver._pc = e.srcElement;
            return e;
        });
        window.RTCRtpReceiver.prototype.getStats = function getStats() {
            const receiver = this;
            return this._pc.getStats().then((result)=>$584b81f9a9b8bf97$export$93439ffc3f787d51(result, receiver.track, false));
        };
    }
    if (!('getStats' in window.RTCRtpSender.prototype && 'getStats' in window.RTCRtpReceiver.prototype)) return;
    // shim RTCPeerConnection.getStats(track).
    const origGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function getStats() {
        if (arguments.length > 0 && arguments[0] instanceof window.MediaStreamTrack) {
            const track = arguments[0];
            let sender;
            let receiver;
            let err;
            this.getSenders().forEach((s)=>{
                if (s.track === track) {
                    if (sender) err = true;
                    else sender = s;
                }
            });
            this.getReceivers().forEach((r)=>{
                if (r.track === track) {
                    if (receiver) err = true;
                    else receiver = r;
                }
                return r.track === track;
            });
            if (err || sender && receiver) return Promise.reject(new DOMException('There are more than one sender or receiver for the track.', 'InvalidAccessError'));
            else if (sender) return sender.getStats();
            else if (receiver) return receiver.getStats();
            return Promise.reject(new DOMException('There is no sender or receiver for the track.', 'InvalidAccessError'));
        }
        return origGetStats.apply(this, arguments);
    };
}
function $558eb894511c4db3$export$30e3cdd46f8d5100(window) {
    // shim addTrack/removeTrack with native variants in order to make
    // the interactions with legacy getLocalStreams behave as in other browsers.
    // Keeps a mapping stream.id => [stream, rtpsenders...]
    window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        return Object.keys(this._shimmedLocalStreams).map((streamId)=>this._shimmedLocalStreams[streamId][0]);
    };
    const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
    window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
        if (!stream) return origAddTrack.apply(this, arguments);
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        const sender = origAddTrack.apply(this, arguments);
        if (!this._shimmedLocalStreams[stream.id]) this._shimmedLocalStreams[stream.id] = [
            stream,
            sender
        ];
        else if (this._shimmedLocalStreams[stream.id].indexOf(sender) === -1) this._shimmedLocalStreams[stream.id].push(sender);
        return sender;
    };
    const origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        stream.getTracks().forEach((track)=>{
            const alreadyExists = this.getSenders().find((s)=>s.track === track);
            if (alreadyExists) throw new DOMException('Track already exists.', 'InvalidAccessError');
        });
        const existingSenders = this.getSenders();
        origAddStream.apply(this, arguments);
        const newSenders = this.getSenders().filter((newSender)=>existingSenders.indexOf(newSender) === -1);
        this._shimmedLocalStreams[stream.id] = [
            stream
        ].concat(newSenders);
    };
    const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        delete this._shimmedLocalStreams[stream.id];
        return origRemoveStream.apply(this, arguments);
    };
    const origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
    window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        if (sender) Object.keys(this._shimmedLocalStreams).forEach((streamId)=>{
            const idx = this._shimmedLocalStreams[streamId].indexOf(sender);
            if (idx !== -1) this._shimmedLocalStreams[streamId].splice(idx, 1);
            if (this._shimmedLocalStreams[streamId].length === 1) delete this._shimmedLocalStreams[streamId];
        });
        return origRemoveTrack.apply(this, arguments);
    };
}
function $558eb894511c4db3$export$9588259fcf4ebc91(window, browserDetails) {
    if (!window.RTCPeerConnection) return;
    // shim addTrack and removeTrack.
    if (window.RTCPeerConnection.prototype.addTrack && browserDetails.version >= 65) return $558eb894511c4db3$export$30e3cdd46f8d5100(window);
    // also shim pc.getLocalStreams when addTrack is shimmed
    // to return the original streams.
    const origGetLocalStreams = window.RTCPeerConnection.prototype.getLocalStreams;
    window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        const nativeStreams = origGetLocalStreams.apply(this);
        this._reverseStreams = this._reverseStreams || {};
        return nativeStreams.map((stream)=>this._reverseStreams[stream.id]);
    };
    const origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        stream.getTracks().forEach((track)=>{
            const alreadyExists = this.getSenders().find((s)=>s.track === track);
            if (alreadyExists) throw new DOMException('Track already exists.', 'InvalidAccessError');
        });
        // Add identity mapping for consistency with addTrack.
        // Unless this is being used with a stream from addTrack.
        if (!this._reverseStreams[stream.id]) {
            const newStream = new window.MediaStream(stream.getTracks());
            this._streams[stream.id] = newStream;
            this._reverseStreams[newStream.id] = stream;
            stream = newStream;
        }
        origAddStream.apply(this, [
            stream
        ]);
    };
    const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        origRemoveStream.apply(this, [
            this._streams[stream.id] || stream
        ]);
        delete this._reverseStreams[this._streams[stream.id] ? this._streams[stream.id].id : stream.id];
        delete this._streams[stream.id];
    };
    window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
        if (this.signalingState === 'closed') throw new DOMException('The RTCPeerConnection\'s signalingState is \'closed\'.', 'InvalidStateError');
        const streams = [].slice.call(arguments, 1);
        if (streams.length !== 1 || !streams[0].getTracks().find((t)=>t === track)) // this is not fully correct but all we can manage without
        // [[associated MediaStreams]] internal slot.
        throw new DOMException("The adapter.js addTrack polyfill only supports a single  stream which is associated with the specified track.", 'NotSupportedError');
        const alreadyExists = this.getSenders().find((s)=>s.track === track);
        if (alreadyExists) throw new DOMException('Track already exists.', 'InvalidAccessError');
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        const oldStream = this._streams[stream.id];
        if (oldStream) {
            // this is using odd Chrome behaviour, use with caution:
            // https://bugs.chromium.org/p/webrtc/issues/detail?id=7815
            // Note: we rely on the high-level addTrack/dtmf shim to
            // create the sender with a dtmf sender.
            oldStream.addTrack(track);
            // Trigger ONN async.
            Promise.resolve().then(()=>{
                this.dispatchEvent(new Event('negotiationneeded'));
            });
        } else {
            const newStream = new window.MediaStream([
                track
            ]);
            this._streams[stream.id] = newStream;
            this._reverseStreams[newStream.id] = stream;
            this.addStream(newStream);
        }
        return this.getSenders().find((s)=>s.track === track);
    };
    // replace the internal stream id with the external one and
    // vice versa.
    function replaceInternalStreamId(pc, description) {
        let sdp = description.sdp;
        Object.keys(pc._reverseStreams || []).forEach((internalId)=>{
            const externalStream = pc._reverseStreams[internalId];
            const internalStream = pc._streams[externalStream.id];
            sdp = sdp.replace(new RegExp(internalStream.id, 'g'), externalStream.id);
        });
        return new RTCSessionDescription({
            type: description.type,
            sdp: sdp
        });
    }
    function replaceExternalStreamId(pc, description) {
        let sdp = description.sdp;
        Object.keys(pc._reverseStreams || []).forEach((internalId)=>{
            const externalStream = pc._reverseStreams[internalId];
            const internalStream = pc._streams[externalStream.id];
            sdp = sdp.replace(new RegExp(externalStream.id, 'g'), internalStream.id);
        });
        return new RTCSessionDescription({
            type: description.type,
            sdp: sdp
        });
    }
    [
        'createOffer',
        'createAnswer'
    ].forEach(function(method) {
        const nativeMethod = window.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                const args = arguments;
                const isLegacyCall = arguments.length && typeof arguments[0] === 'function';
                if (isLegacyCall) return nativeMethod.apply(this, [
                    (description)=>{
                        const desc = replaceInternalStreamId(this, description);
                        args[0].apply(null, [
                            desc
                        ]);
                    },
                    (err)=>{
                        if (args[1]) args[1].apply(null, err);
                    },
                    arguments[2]
                ]);
                return nativeMethod.apply(this, arguments).then((description)=>replaceInternalStreamId(this, description));
            }
        };
        window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
    const origSetLocalDescription = window.RTCPeerConnection.prototype.setLocalDescription;
    window.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
        if (!arguments.length || !arguments[0].type) return origSetLocalDescription.apply(this, arguments);
        arguments[0] = replaceExternalStreamId(this, arguments[0]);
        return origSetLocalDescription.apply(this, arguments);
    };
    // TODO: mangle getStats: https://w3c.github.io/webrtc-stats/#dom-rtcmediastreamstats-streamidentifier
    const origLocalDescription = Object.getOwnPropertyDescriptor(window.RTCPeerConnection.prototype, 'localDescription');
    Object.defineProperty(window.RTCPeerConnection.prototype, 'localDescription', {
        get () {
            const description = origLocalDescription.get.apply(this);
            if (description.type === '') return description;
            return replaceInternalStreamId(this, description);
        }
    });
    window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
        if (this.signalingState === 'closed') throw new DOMException('The RTCPeerConnection\'s signalingState is \'closed\'.', 'InvalidStateError');
        // We can not yet check for sender instanceof RTCRtpSender
        // since we shim RTPSender. So we check if sender._pc is set.
        if (!sender._pc) throw new DOMException("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.", 'TypeError');
        const isLocal = sender._pc === this;
        if (!isLocal) throw new DOMException('Sender was not created by this connection.', 'InvalidAccessError');
        // Search for the native stream the senders track belongs to.
        this._streams = this._streams || {};
        let stream;
        Object.keys(this._streams).forEach((streamid)=>{
            const hasTrack = this._streams[streamid].getTracks().find((track)=>sender.track === track);
            if (hasTrack) stream = this._streams[streamid];
        });
        if (stream) {
            if (stream.getTracks().length === 1) // if this is the last track of the stream, remove the stream. This
            // takes care of any shimmed _senders.
            this.removeStream(this._reverseStreams[stream.id]);
            else // relying on the same odd chrome behaviour as above.
            stream.removeTrack(sender.track);
            this.dispatchEvent(new Event('negotiationneeded'));
        }
    };
}
function $558eb894511c4db3$export$852a08dda9a55ea7(window, browserDetails) {
    if (!window.RTCPeerConnection && window.webkitRTCPeerConnection) // very basic support for old versions.
    window.RTCPeerConnection = window.webkitRTCPeerConnection;
    if (!window.RTCPeerConnection) return;
    // shim implicit creation of RTCSessionDescription/RTCIceCandidate
    if (browserDetails.version < 53) [
        'setLocalDescription',
        'setRemoteDescription',
        'addIceCandidate'
    ].forEach(function(method) {
        const nativeMethod = window.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                arguments[0] = new (method === 'addIceCandidate' ? window.RTCIceCandidate : window.RTCSessionDescription)(arguments[0]);
                return nativeMethod.apply(this, arguments);
            }
        };
        window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
}
function $558eb894511c4db3$export$341293bbeaae37cb(window, browserDetails) {
    $584b81f9a9b8bf97$export$1f48841962b828b1(window, 'negotiationneeded', (e)=>{
        const pc = e.target;
        if (browserDetails.version < 72 || pc.getConfiguration && pc.getConfiguration().sdpSemantics === 'plan-b') {
            if (pc.signalingState !== 'stable') return;
        }
        return e;
    });
}


var $c518d147eb169a8d$exports = {};

$parcel$export($c518d147eb169a8d$exports, "shimOnTrack", () => $c518d147eb169a8d$export$f358708f68ab068);
$parcel$export($c518d147eb169a8d$exports, "shimPeerConnection", () => $c518d147eb169a8d$export$852a08dda9a55ea7);
$parcel$export($c518d147eb169a8d$exports, "shimSenderGetStats", () => $c518d147eb169a8d$export$f0525502095c04ef);
$parcel$export($c518d147eb169a8d$exports, "shimReceiverGetStats", () => $c518d147eb169a8d$export$83d69126527b1171);
$parcel$export($c518d147eb169a8d$exports, "shimRemoveStream", () => $c518d147eb169a8d$export$825e523ef749bd8c);
$parcel$export($c518d147eb169a8d$exports, "shimRTCDataChannel", () => $c518d147eb169a8d$export$ff9cb3bc8990e8f7);
$parcel$export($c518d147eb169a8d$exports, "shimAddTransceiver", () => $c518d147eb169a8d$export$70c77533b6e9908d);
$parcel$export($c518d147eb169a8d$exports, "shimGetParameters", () => $c518d147eb169a8d$export$66238223c298fbaa);
$parcel$export($c518d147eb169a8d$exports, "shimCreateOffer", () => $c518d147eb169a8d$export$51beccf0e777b843);
$parcel$export($c518d147eb169a8d$exports, "shimCreateAnswer", () => $c518d147eb169a8d$export$df0b46e7cef08150);
$parcel$export($c518d147eb169a8d$exports, "shimGetUserMedia", () => $365b77720cb4f52a$export$1ed4910f4d37dc5e);
$parcel$export($c518d147eb169a8d$exports, "shimGetDisplayMedia", () => $cd853a759273f164$export$97270b87351d9c04);
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
'use strict';
function $365b77720cb4f52a$export$1ed4910f4d37dc5e(window, browserDetails) {
    const navigator = window && window.navigator;
    const MediaStreamTrack = window && window.MediaStreamTrack;
    navigator.getUserMedia = function(constraints, onSuccess, onError) {
        // Replace Firefox 44+'s deprecation warning with unprefixed version.
        $584b81f9a9b8bf97$export$cdd73fc4100a6ef4('navigator.getUserMedia', 'navigator.mediaDevices.getUserMedia');
        navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
    };
    if (!(browserDetails.version > 55 && 'autoGainControl' in navigator.mediaDevices.getSupportedConstraints())) {
        const remap = function(obj, a, b) {
            if (a in obj && !(b in obj)) {
                obj[b] = obj[a];
                delete obj[a];
            }
        };
        const nativeGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
        navigator.mediaDevices.getUserMedia = function(c) {
            if (typeof c === 'object' && typeof c.audio === 'object') {
                c = JSON.parse(JSON.stringify(c));
                remap(c.audio, 'autoGainControl', 'mozAutoGainControl');
                remap(c.audio, 'noiseSuppression', 'mozNoiseSuppression');
            }
            return nativeGetUserMedia(c);
        };
        if (MediaStreamTrack && MediaStreamTrack.prototype.getSettings) {
            const nativeGetSettings = MediaStreamTrack.prototype.getSettings;
            MediaStreamTrack.prototype.getSettings = function() {
                const obj = nativeGetSettings.apply(this, arguments);
                remap(obj, 'mozAutoGainControl', 'autoGainControl');
                remap(obj, 'mozNoiseSuppression', 'noiseSuppression');
                return obj;
            };
        }
        if (MediaStreamTrack && MediaStreamTrack.prototype.applyConstraints) {
            const nativeApplyConstraints = MediaStreamTrack.prototype.applyConstraints;
            MediaStreamTrack.prototype.applyConstraints = function(c) {
                if (this.kind === 'audio' && typeof c === 'object') {
                    c = JSON.parse(JSON.stringify(c));
                    remap(c, 'autoGainControl', 'mozAutoGainControl');
                    remap(c, 'noiseSuppression', 'mozNoiseSuppression');
                }
                return nativeApplyConstraints.apply(this, [
                    c
                ]);
            };
        }
    }
}


/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 'use strict';
function $cd853a759273f164$export$97270b87351d9c04(window, preferredMediaSource) {
    if (window.navigator.mediaDevices && 'getDisplayMedia' in window.navigator.mediaDevices) return;
    if (!window.navigator.mediaDevices) return;
    window.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
        if (!(constraints && constraints.video)) {
            const err = new DOMException("getDisplayMedia without video constraints is undefined");
            err.name = 'NotFoundError';
            // from https://heycam.github.io/webidl/#idl-DOMException-error-names
            err.code = 8;
            return Promise.reject(err);
        }
        if (constraints.video === true) constraints.video = {
            mediaSource: preferredMediaSource
        };
        else constraints.video.mediaSource = preferredMediaSource;
        return window.navigator.mediaDevices.getUserMedia(constraints);
    };
}


'use strict';
function $c518d147eb169a8d$export$f358708f68ab068(window) {
    if (typeof window === 'object' && window.RTCTrackEvent && 'receiver' in window.RTCTrackEvent.prototype && !('transceiver' in window.RTCTrackEvent.prototype)) Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
        get () {
            return {
                receiver: this.receiver
            };
        }
    });
}
function $c518d147eb169a8d$export$852a08dda9a55ea7(window, browserDetails) {
    if (typeof window !== 'object' || !(window.RTCPeerConnection || window.mozRTCPeerConnection)) return; // probably media.peerconnection.enabled=false in about:config
    if (!window.RTCPeerConnection && window.mozRTCPeerConnection) // very basic support for old versions.
    window.RTCPeerConnection = window.mozRTCPeerConnection;
    if (browserDetails.version < 53) // shim away need for obsolete RTCIceCandidate/RTCSessionDescription.
    [
        'setLocalDescription',
        'setRemoteDescription',
        'addIceCandidate'
    ].forEach(function(method) {
        const nativeMethod = window.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                arguments[0] = new (method === 'addIceCandidate' ? window.RTCIceCandidate : window.RTCSessionDescription)(arguments[0]);
                return nativeMethod.apply(this, arguments);
            }
        };
        window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
    const modernStatsTypes = {
        inboundrtp: 'inbound-rtp',
        outboundrtp: 'outbound-rtp',
        candidatepair: 'candidate-pair',
        localcandidate: 'local-candidate',
        remotecandidate: 'remote-candidate'
    };
    const nativeGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function getStats() {
        const [selector, onSucc, onErr] = arguments;
        return nativeGetStats.apply(this, [
            selector || null
        ]).then((stats)=>{
            if (browserDetails.version < 53 && !onSucc) // Shim only promise getStats with spec-hyphens in type names
            // Leave callback version alone; misc old uses of forEach before Map
            try {
                stats.forEach((stat)=>{
                    stat.type = modernStatsTypes[stat.type] || stat.type;
                });
            } catch (e) {
                if (e.name !== 'TypeError') throw e;
                // Avoid TypeError: "type" is read-only, in old versions. 34-43ish
                stats.forEach((stat, i)=>{
                    stats.set(i, Object.assign({}, stat, {
                        type: modernStatsTypes[stat.type] || stat.type
                    }));
                });
            }
            return stats;
        }).then(onSucc, onErr);
    };
}
function $c518d147eb169a8d$export$f0525502095c04ef(window) {
    if (!(typeof window === 'object' && window.RTCPeerConnection && window.RTCRtpSender)) return;
    if (window.RTCRtpSender && 'getStats' in window.RTCRtpSender.prototype) return;
    const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
    if (origGetSenders) window.RTCPeerConnection.prototype.getSenders = function getSenders() {
        const senders = origGetSenders.apply(this, []);
        senders.forEach((sender)=>sender._pc = this);
        return senders;
    };
    const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
    if (origAddTrack) window.RTCPeerConnection.prototype.addTrack = function addTrack() {
        const sender = origAddTrack.apply(this, arguments);
        sender._pc = this;
        return sender;
    };
    window.RTCRtpSender.prototype.getStats = function getStats() {
        return this.track ? this._pc.getStats(this.track) : Promise.resolve(new Map());
    };
}
function $c518d147eb169a8d$export$83d69126527b1171(window) {
    if (!(typeof window === 'object' && window.RTCPeerConnection && window.RTCRtpSender)) return;
    if (window.RTCRtpSender && 'getStats' in window.RTCRtpReceiver.prototype) return;
    const origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
    if (origGetReceivers) window.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
        const receivers = origGetReceivers.apply(this, []);
        receivers.forEach((receiver)=>receiver._pc = this);
        return receivers;
    };
    $584b81f9a9b8bf97$export$1f48841962b828b1(window, 'track', (e)=>{
        e.receiver._pc = e.srcElement;
        return e;
    });
    window.RTCRtpReceiver.prototype.getStats = function getStats() {
        return this._pc.getStats(this.track);
    };
}
function $c518d147eb169a8d$export$825e523ef749bd8c(window) {
    if (!window.RTCPeerConnection || 'removeStream' in window.RTCPeerConnection.prototype) return;
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        $584b81f9a9b8bf97$export$cdd73fc4100a6ef4('removeStream', 'removeTrack');
        this.getSenders().forEach((sender)=>{
            if (sender.track && stream.getTracks().includes(sender.track)) this.removeTrack(sender);
        });
    };
}
function $c518d147eb169a8d$export$ff9cb3bc8990e8f7(window) {
    // rename DataChannel to RTCDataChannel (native fix in FF60):
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1173851
    if (window.DataChannel && !window.RTCDataChannel) window.RTCDataChannel = window.DataChannel;
}
function $c518d147eb169a8d$export$70c77533b6e9908d(window) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window === 'object' && window.RTCPeerConnection)) return;
    const origAddTransceiver = window.RTCPeerConnection.prototype.addTransceiver;
    if (origAddTransceiver) window.RTCPeerConnection.prototype.addTransceiver = function addTransceiver() {
        this.setParametersPromises = [];
        // WebIDL input coercion and validation
        let sendEncodings = arguments[1] && arguments[1].sendEncodings;
        if (sendEncodings === undefined) sendEncodings = [];
        sendEncodings = [
            ...sendEncodings
        ];
        const shouldPerformCheck = sendEncodings.length > 0;
        if (shouldPerformCheck) // If sendEncodings params are provided, validate grammar
        sendEncodings.forEach((encodingParam)=>{
            if ('rid' in encodingParam) {
                const ridRegex = /^[a-z0-9]{0,16}$/i;
                if (!ridRegex.test(encodingParam.rid)) throw new TypeError('Invalid RID value provided.');
            }
            if ('scaleResolutionDownBy' in encodingParam) {
                if (!(parseFloat(encodingParam.scaleResolutionDownBy) >= 1.0)) throw new RangeError('scale_resolution_down_by must be >= 1.0');
            }
            if ('maxFramerate' in encodingParam) {
                if (!(parseFloat(encodingParam.maxFramerate) >= 0)) throw new RangeError('max_framerate must be >= 0.0');
            }
        });
        const transceiver = origAddTransceiver.apply(this, arguments);
        if (shouldPerformCheck) {
            // Check if the init options were applied. If not we do this in an
            // asynchronous way and save the promise reference in a global object.
            // This is an ugly hack, but at the same time is way more robust than
            // checking the sender parameters before and after the createOffer
            // Also note that after the createoffer we are not 100% sure that
            // the params were asynchronously applied so we might miss the
            // opportunity to recreate offer.
            const { sender: sender } = transceiver;
            const params = sender.getParameters();
            if (!('encodings' in params) || // Avoid being fooled by patched getParameters() below.
            params.encodings.length === 1 && Object.keys(params.encodings[0]).length === 0) {
                params.encodings = sendEncodings;
                sender.sendEncodings = sendEncodings;
                this.setParametersPromises.push(sender.setParameters(params).then(()=>{
                    delete sender.sendEncodings;
                }).catch(()=>{
                    delete sender.sendEncodings;
                }));
            }
        }
        return transceiver;
    };
}
function $c518d147eb169a8d$export$66238223c298fbaa(window) {
    if (!(typeof window === 'object' && window.RTCRtpSender)) return;
    const origGetParameters = window.RTCRtpSender.prototype.getParameters;
    if (origGetParameters) window.RTCRtpSender.prototype.getParameters = function getParameters() {
        const params = origGetParameters.apply(this, arguments);
        if (!('encodings' in params)) params.encodings = [].concat(this.sendEncodings || [
            {}
        ]);
        return params;
    };
}
function $c518d147eb169a8d$export$51beccf0e777b843(window) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window === 'object' && window.RTCPeerConnection)) return;
    const origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
    window.RTCPeerConnection.prototype.createOffer = function createOffer() {
        if (this.setParametersPromises && this.setParametersPromises.length) return Promise.all(this.setParametersPromises).then(()=>{
            return origCreateOffer.apply(this, arguments);
        }).finally(()=>{
            this.setParametersPromises = [];
        });
        return origCreateOffer.apply(this, arguments);
    };
}
function $c518d147eb169a8d$export$df0b46e7cef08150(window) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window === 'object' && window.RTCPeerConnection)) return;
    const origCreateAnswer = window.RTCPeerConnection.prototype.createAnswer;
    window.RTCPeerConnection.prototype.createAnswer = function createAnswer() {
        if (this.setParametersPromises && this.setParametersPromises.length) return Promise.all(this.setParametersPromises).then(()=>{
            return origCreateAnswer.apply(this, arguments);
        }).finally(()=>{
            this.setParametersPromises = [];
        });
        return origCreateAnswer.apply(this, arguments);
    };
}


var $9a20cef3f9b7f4b6$exports = {};

$parcel$export($9a20cef3f9b7f4b6$exports, "shimLocalStreamsAPI", () => $9a20cef3f9b7f4b6$export$8df41282f4fdcea2);
$parcel$export($9a20cef3f9b7f4b6$exports, "shimRemoteStreamsAPI", () => $9a20cef3f9b7f4b6$export$762aa4cbb4f2f857);
$parcel$export($9a20cef3f9b7f4b6$exports, "shimCallbacksAPI", () => $9a20cef3f9b7f4b6$export$da31df245debdd3);
$parcel$export($9a20cef3f9b7f4b6$exports, "shimGetUserMedia", () => $9a20cef3f9b7f4b6$export$1ed4910f4d37dc5e);
$parcel$export($9a20cef3f9b7f4b6$exports, "shimConstraints", () => $9a20cef3f9b7f4b6$export$494a01ac68ba81ac);
$parcel$export($9a20cef3f9b7f4b6$exports, "shimRTCIceServerUrls", () => $9a20cef3f9b7f4b6$export$671a8b47b41b6f41);
$parcel$export($9a20cef3f9b7f4b6$exports, "shimTrackEventTransceiver", () => $9a20cef3f9b7f4b6$export$85d53da088cb1b14);
$parcel$export($9a20cef3f9b7f4b6$exports, "shimCreateOfferLegacy", () => $9a20cef3f9b7f4b6$export$d444266503fdd2d4);
$parcel$export($9a20cef3f9b7f4b6$exports, "shimAudioContext", () => $9a20cef3f9b7f4b6$export$857cd739a7b795d2);
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ 
'use strict';
function $9a20cef3f9b7f4b6$export$8df41282f4fdcea2(window) {
    if (typeof window !== 'object' || !window.RTCPeerConnection) return;
    if (!('getLocalStreams' in window.RTCPeerConnection.prototype)) window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        if (!this._localStreams) this._localStreams = [];
        return this._localStreams;
    };
    if (!('addStream' in window.RTCPeerConnection.prototype)) {
        const _addTrack = window.RTCPeerConnection.prototype.addTrack;
        window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
            if (!this._localStreams) this._localStreams = [];
            if (!this._localStreams.includes(stream)) this._localStreams.push(stream);
            // Try to emulate Chrome's behaviour of adding in audio-video order.
            // Safari orders by track id.
            stream.getAudioTracks().forEach((track)=>_addTrack.call(this, track, stream));
            stream.getVideoTracks().forEach((track)=>_addTrack.call(this, track, stream));
        };
        window.RTCPeerConnection.prototype.addTrack = function addTrack(track, ...streams) {
            if (streams) streams.forEach((stream)=>{
                if (!this._localStreams) this._localStreams = [
                    stream
                ];
                else if (!this._localStreams.includes(stream)) this._localStreams.push(stream);
            });
            return _addTrack.apply(this, arguments);
        };
    }
    if (!('removeStream' in window.RTCPeerConnection.prototype)) window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        if (!this._localStreams) this._localStreams = [];
        const index = this._localStreams.indexOf(stream);
        if (index === -1) return;
        this._localStreams.splice(index, 1);
        const tracks = stream.getTracks();
        this.getSenders().forEach((sender)=>{
            if (tracks.includes(sender.track)) this.removeTrack(sender);
        });
    };
}
function $9a20cef3f9b7f4b6$export$762aa4cbb4f2f857(window) {
    if (typeof window !== 'object' || !window.RTCPeerConnection) return;
    if (!('getRemoteStreams' in window.RTCPeerConnection.prototype)) window.RTCPeerConnection.prototype.getRemoteStreams = function getRemoteStreams() {
        return this._remoteStreams ? this._remoteStreams : [];
    };
    if (!('onaddstream' in window.RTCPeerConnection.prototype)) {
        Object.defineProperty(window.RTCPeerConnection.prototype, 'onaddstream', {
            get () {
                return this._onaddstream;
            },
            set (f) {
                if (this._onaddstream) {
                    this.removeEventListener('addstream', this._onaddstream);
                    this.removeEventListener('track', this._onaddstreampoly);
                }
                this.addEventListener('addstream', this._onaddstream = f);
                this.addEventListener('track', this._onaddstreampoly = (e)=>{
                    e.streams.forEach((stream)=>{
                        if (!this._remoteStreams) this._remoteStreams = [];
                        if (this._remoteStreams.includes(stream)) return;
                        this._remoteStreams.push(stream);
                        const event = new Event('addstream');
                        event.stream = stream;
                        this.dispatchEvent(event);
                    });
                });
            }
        });
        const origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
        window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
            const pc = this;
            if (!this._onaddstreampoly) this.addEventListener('track', this._onaddstreampoly = function(e) {
                e.streams.forEach((stream)=>{
                    if (!pc._remoteStreams) pc._remoteStreams = [];
                    if (pc._remoteStreams.indexOf(stream) >= 0) return;
                    pc._remoteStreams.push(stream);
                    const event = new Event('addstream');
                    event.stream = stream;
                    pc.dispatchEvent(event);
                });
            });
            return origSetRemoteDescription.apply(pc, arguments);
        };
    }
}
function $9a20cef3f9b7f4b6$export$da31df245debdd3(window) {
    if (typeof window !== 'object' || !window.RTCPeerConnection) return;
    const prototype = window.RTCPeerConnection.prototype;
    const origCreateOffer = prototype.createOffer;
    const origCreateAnswer = prototype.createAnswer;
    const setLocalDescription = prototype.setLocalDescription;
    const setRemoteDescription = prototype.setRemoteDescription;
    const addIceCandidate = prototype.addIceCandidate;
    prototype.createOffer = function createOffer(successCallback, failureCallback) {
        const options = arguments.length >= 2 ? arguments[2] : arguments[0];
        const promise = origCreateOffer.apply(this, [
            options
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.createAnswer = function createAnswer(successCallback, failureCallback) {
        const options = arguments.length >= 2 ? arguments[2] : arguments[0];
        const promise = origCreateAnswer.apply(this, [
            options
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    let withCallback = function(description, successCallback, failureCallback) {
        const promise = setLocalDescription.apply(this, [
            description
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.setLocalDescription = withCallback;
    withCallback = function(description, successCallback, failureCallback) {
        const promise = setRemoteDescription.apply(this, [
            description
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.setRemoteDescription = withCallback;
    withCallback = function(candidate, successCallback, failureCallback) {
        const promise = addIceCandidate.apply(this, [
            candidate
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.addIceCandidate = withCallback;
}
function $9a20cef3f9b7f4b6$export$1ed4910f4d37dc5e(window) {
    const navigator = window && window.navigator;
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        // shim not needed in Safari 12.1
        const mediaDevices = navigator.mediaDevices;
        const _getUserMedia = mediaDevices.getUserMedia.bind(mediaDevices);
        navigator.mediaDevices.getUserMedia = (constraints)=>{
            return _getUserMedia($9a20cef3f9b7f4b6$export$494a01ac68ba81ac(constraints));
        };
    }
    if (!navigator.getUserMedia && navigator.mediaDevices && navigator.mediaDevices.getUserMedia) navigator.getUserMedia = (function getUserMedia(constraints, cb, errcb) {
        navigator.mediaDevices.getUserMedia(constraints).then(cb, errcb);
    }).bind(navigator);
}
function $9a20cef3f9b7f4b6$export$494a01ac68ba81ac(constraints) {
    if (constraints && constraints.video !== undefined) return Object.assign({}, constraints, {
        video: $584b81f9a9b8bf97$export$15384eac40dc88c8(constraints.video)
    });
    return constraints;
}
function $9a20cef3f9b7f4b6$export$671a8b47b41b6f41(window) {
    if (!window.RTCPeerConnection) return;
    // migrate from non-spec RTCIceServer.url to RTCIceServer.urls
    const OrigPeerConnection = window.RTCPeerConnection;
    window.RTCPeerConnection = function RTCPeerConnection(pcConfig, pcConstraints) {
        if (pcConfig && pcConfig.iceServers) {
            const newIceServers = [];
            for(let i = 0; i < pcConfig.iceServers.length; i++){
                let server = pcConfig.iceServers[i];
                if (server.urls === undefined && server.url) {
                    $584b81f9a9b8bf97$export$cdd73fc4100a6ef4('RTCIceServer.url', 'RTCIceServer.urls');
                    server = JSON.parse(JSON.stringify(server));
                    server.urls = server.url;
                    delete server.url;
                    newIceServers.push(server);
                } else newIceServers.push(pcConfig.iceServers[i]);
            }
            pcConfig.iceServers = newIceServers;
        }
        return new OrigPeerConnection(pcConfig, pcConstraints);
    };
    window.RTCPeerConnection.prototype = OrigPeerConnection.prototype;
    // wrap static methods. Currently just generateCertificate.
    if ('generateCertificate' in OrigPeerConnection) Object.defineProperty(window.RTCPeerConnection, 'generateCertificate', {
        get () {
            return OrigPeerConnection.generateCertificate;
        }
    });
}
function $9a20cef3f9b7f4b6$export$85d53da088cb1b14(window) {
    // Add event.transceiver member over deprecated event.receiver
    if (typeof window === 'object' && window.RTCTrackEvent && 'receiver' in window.RTCTrackEvent.prototype && !('transceiver' in window.RTCTrackEvent.prototype)) Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
        get () {
            return {
                receiver: this.receiver
            };
        }
    });
}
function $9a20cef3f9b7f4b6$export$d444266503fdd2d4(window) {
    const origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
    window.RTCPeerConnection.prototype.createOffer = function createOffer(offerOptions) {
        if (offerOptions) {
            if (typeof offerOptions.offerToReceiveAudio !== 'undefined') // support bit values
            offerOptions.offerToReceiveAudio = !!offerOptions.offerToReceiveAudio;
            const audioTransceiver = this.getTransceivers().find((transceiver)=>transceiver.receiver.track.kind === 'audio');
            if (offerOptions.offerToReceiveAudio === false && audioTransceiver) {
                if (audioTransceiver.direction === 'sendrecv') {
                    if (audioTransceiver.setDirection) audioTransceiver.setDirection('sendonly');
                    else audioTransceiver.direction = 'sendonly';
                } else if (audioTransceiver.direction === 'recvonly') {
                    if (audioTransceiver.setDirection) audioTransceiver.setDirection('inactive');
                    else audioTransceiver.direction = 'inactive';
                }
            } else if (offerOptions.offerToReceiveAudio === true && !audioTransceiver) this.addTransceiver('audio', {
                direction: 'recvonly'
            });
            if (typeof offerOptions.offerToReceiveVideo !== 'undefined') // support bit values
            offerOptions.offerToReceiveVideo = !!offerOptions.offerToReceiveVideo;
            const videoTransceiver = this.getTransceivers().find((transceiver)=>transceiver.receiver.track.kind === 'video');
            if (offerOptions.offerToReceiveVideo === false && videoTransceiver) {
                if (videoTransceiver.direction === 'sendrecv') {
                    if (videoTransceiver.setDirection) videoTransceiver.setDirection('sendonly');
                    else videoTransceiver.direction = 'sendonly';
                } else if (videoTransceiver.direction === 'recvonly') {
                    if (videoTransceiver.setDirection) videoTransceiver.setDirection('inactive');
                    else videoTransceiver.direction = 'inactive';
                }
            } else if (offerOptions.offerToReceiveVideo === true && !videoTransceiver) this.addTransceiver('video', {
                direction: 'recvonly'
            });
        }
        return origCreateOffer.apply(this, arguments);
    };
}
function $9a20cef3f9b7f4b6$export$857cd739a7b795d2(window) {
    if (typeof window !== 'object' || window.AudioContext) return;
    window.AudioContext = window.webkitAudioContext;
}


var $599d92f2f0dc2dee$exports = {};

$parcel$export($599d92f2f0dc2dee$exports, "shimRTCIceCandidate", () => $599d92f2f0dc2dee$export$cf133661e444ccfe);
$parcel$export($599d92f2f0dc2dee$exports, "shimRTCIceCandidateRelayProtocol", () => $599d92f2f0dc2dee$export$fdafb8d8280e29b5);
$parcel$export($599d92f2f0dc2dee$exports, "shimMaxMessageSize", () => $599d92f2f0dc2dee$export$a99147c78a56edc4);
$parcel$export($599d92f2f0dc2dee$exports, "shimSendThrowTypeError", () => $599d92f2f0dc2dee$export$d461c8d5c5db5da7);
$parcel$export($599d92f2f0dc2dee$exports, "shimConnectionState", () => $599d92f2f0dc2dee$export$63bb816cc75460);
$parcel$export($599d92f2f0dc2dee$exports, "removeExtmapAllowMixed", () => $599d92f2f0dc2dee$export$a57d114344295149);
$parcel$export($599d92f2f0dc2dee$exports, "shimAddIceCandidateNullOrEmpty", () => $599d92f2f0dc2dee$export$51d5e40b48c771c7);
$parcel$export($599d92f2f0dc2dee$exports, "shimParameterlessSetLocalDescription", () => $599d92f2f0dc2dee$export$7170d04e59f9d553);
/*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ var $7522343ecaeeccb8$exports = {};
/* eslint-env node */ 'use strict';
// SDP helpers.
const $7522343ecaeeccb8$var$SDPUtils = {};
// Generate an alphanumeric identifier for cname or mids.
// TODO: use UUIDs instead? https://gist.github.com/jed/982883
$7522343ecaeeccb8$var$SDPUtils.generateIdentifier = function() {
    return Math.random().toString(36).substring(2, 12);
};
// The RTCP CNAME used by all peerconnections from the same JS.
$7522343ecaeeccb8$var$SDPUtils.localCName = $7522343ecaeeccb8$var$SDPUtils.generateIdentifier();
// Splits SDP into lines, dealing with both CRLF and LF.
$7522343ecaeeccb8$var$SDPUtils.splitLines = function(blob) {
    return blob.trim().split('\n').map((line)=>line.trim());
};
// Splits SDP into sessionpart and mediasections. Ensures CRLF.
$7522343ecaeeccb8$var$SDPUtils.splitSections = function(blob) {
    const parts = blob.split('\nm=');
    return parts.map((part, index)=>(index > 0 ? 'm=' + part : part).trim() + '\r\n');
};
// Returns the session description.
$7522343ecaeeccb8$var$SDPUtils.getDescription = function(blob) {
    const sections = $7522343ecaeeccb8$var$SDPUtils.splitSections(blob);
    return sections && sections[0];
};
// Returns the individual media sections.
$7522343ecaeeccb8$var$SDPUtils.getMediaSections = function(blob) {
    const sections = $7522343ecaeeccb8$var$SDPUtils.splitSections(blob);
    sections.shift();
    return sections;
};
// Returns lines that start with a certain prefix.
$7522343ecaeeccb8$var$SDPUtils.matchPrefix = function(blob, prefix) {
    return $7522343ecaeeccb8$var$SDPUtils.splitLines(blob).filter((line)=>line.indexOf(prefix) === 0);
};
// Parses an ICE candidate line. Sample input:
// candidate:702786350 2 udp 41819902 8.8.8.8 60769 typ relay raddr 8.8.8.8
// rport 55996"
// Input can be prefixed with a=.
$7522343ecaeeccb8$var$SDPUtils.parseCandidate = function(line) {
    let parts;
    // Parse both variants.
    if (line.indexOf('a=candidate:') === 0) parts = line.substring(12).split(' ');
    else parts = line.substring(10).split(' ');
    const candidate = {
        foundation: parts[0],
        component: {
            1: 'rtp',
            2: 'rtcp'
        }[parts[1]] || parts[1],
        protocol: parts[2].toLowerCase(),
        priority: parseInt(parts[3], 10),
        ip: parts[4],
        address: parts[4],
        port: parseInt(parts[5], 10),
        // skip parts[6] == 'typ'
        type: parts[7]
    };
    for(let i = 8; i < parts.length; i += 2)switch(parts[i]){
        case 'raddr':
            candidate.relatedAddress = parts[i + 1];
            break;
        case 'rport':
            candidate.relatedPort = parseInt(parts[i + 1], 10);
            break;
        case 'tcptype':
            candidate.tcpType = parts[i + 1];
            break;
        case 'ufrag':
            candidate.ufrag = parts[i + 1]; // for backward compatibility.
            candidate.usernameFragment = parts[i + 1];
            break;
        default:
            if (candidate[parts[i]] === undefined) candidate[parts[i]] = parts[i + 1];
            break;
    }
    return candidate;
};
// Translates a candidate object into SDP candidate attribute.
// This does not include the a= prefix!
$7522343ecaeeccb8$var$SDPUtils.writeCandidate = function(candidate) {
    const sdp = [];
    sdp.push(candidate.foundation);
    const component = candidate.component;
    if (component === 'rtp') sdp.push(1);
    else if (component === 'rtcp') sdp.push(2);
    else sdp.push(component);
    sdp.push(candidate.protocol.toUpperCase());
    sdp.push(candidate.priority);
    sdp.push(candidate.address || candidate.ip);
    sdp.push(candidate.port);
    const type = candidate.type;
    sdp.push('typ');
    sdp.push(type);
    if (type !== 'host' && candidate.relatedAddress && candidate.relatedPort) {
        sdp.push('raddr');
        sdp.push(candidate.relatedAddress);
        sdp.push('rport');
        sdp.push(candidate.relatedPort);
    }
    if (candidate.tcpType && candidate.protocol.toLowerCase() === 'tcp') {
        sdp.push('tcptype');
        sdp.push(candidate.tcpType);
    }
    if (candidate.usernameFragment || candidate.ufrag) {
        sdp.push('ufrag');
        sdp.push(candidate.usernameFragment || candidate.ufrag);
    }
    return 'candidate:' + sdp.join(' ');
};
// Parses an ice-options line, returns an array of option tags.
// Sample input:
// a=ice-options:foo bar
$7522343ecaeeccb8$var$SDPUtils.parseIceOptions = function(line) {
    return line.substring(14).split(' ');
};
// Parses a rtpmap line, returns RTCRtpCoddecParameters. Sample input:
// a=rtpmap:111 opus/48000/2
$7522343ecaeeccb8$var$SDPUtils.parseRtpMap = function(line) {
    let parts = line.substring(9).split(' ');
    const parsed = {
        payloadType: parseInt(parts.shift(), 10)
    };
    parts = parts[0].split('/');
    parsed.name = parts[0];
    parsed.clockRate = parseInt(parts[1], 10); // was: clockrate
    parsed.channels = parts.length === 3 ? parseInt(parts[2], 10) : 1;
    // legacy alias, got renamed back to channels in ORTC.
    parsed.numChannels = parsed.channels;
    return parsed;
};
// Generates a rtpmap line from RTCRtpCodecCapability or
// RTCRtpCodecParameters.
$7522343ecaeeccb8$var$SDPUtils.writeRtpMap = function(codec) {
    let pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    const channels = codec.channels || codec.numChannels || 1;
    return 'a=rtpmap:' + pt + ' ' + codec.name + '/' + codec.clockRate + (channels !== 1 ? '/' + channels : '') + '\r\n';
};
// Parses a extmap line (headerextension from RFC 5285). Sample input:
// a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
// a=extmap:2/sendonly urn:ietf:params:rtp-hdrext:toffset
$7522343ecaeeccb8$var$SDPUtils.parseExtmap = function(line) {
    const parts = line.substring(9).split(' ');
    return {
        id: parseInt(parts[0], 10),
        direction: parts[0].indexOf('/') > 0 ? parts[0].split('/')[1] : 'sendrecv',
        uri: parts[1],
        attributes: parts.slice(2).join(' ')
    };
};
// Generates an extmap line from RTCRtpHeaderExtensionParameters or
// RTCRtpHeaderExtension.
$7522343ecaeeccb8$var$SDPUtils.writeExtmap = function(headerExtension) {
    return 'a=extmap:' + (headerExtension.id || headerExtension.preferredId) + (headerExtension.direction && headerExtension.direction !== 'sendrecv' ? '/' + headerExtension.direction : '') + ' ' + headerExtension.uri + (headerExtension.attributes ? ' ' + headerExtension.attributes : '') + '\r\n';
};
// Parses a fmtp line, returns dictionary. Sample input:
// a=fmtp:96 vbr=on;cng=on
// Also deals with vbr=on; cng=on
$7522343ecaeeccb8$var$SDPUtils.parseFmtp = function(line) {
    const parsed = {};
    let kv;
    const parts = line.substring(line.indexOf(' ') + 1).split(';');
    for(let j = 0; j < parts.length; j++){
        kv = parts[j].trim().split('=');
        parsed[kv[0].trim()] = kv[1];
    }
    return parsed;
};
// Generates a fmtp line from RTCRtpCodecCapability or RTCRtpCodecParameters.
$7522343ecaeeccb8$var$SDPUtils.writeFmtp = function(codec) {
    let line = '';
    let pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    if (codec.parameters && Object.keys(codec.parameters).length) {
        const params = [];
        Object.keys(codec.parameters).forEach((param)=>{
            if (codec.parameters[param] !== undefined) params.push(param + '=' + codec.parameters[param]);
            else params.push(param);
        });
        line += 'a=fmtp:' + pt + ' ' + params.join(';') + '\r\n';
    }
    return line;
};
// Parses a rtcp-fb line, returns RTCPRtcpFeedback object. Sample input:
// a=rtcp-fb:98 nack rpsi
$7522343ecaeeccb8$var$SDPUtils.parseRtcpFb = function(line) {
    const parts = line.substring(line.indexOf(' ') + 1).split(' ');
    return {
        type: parts.shift(),
        parameter: parts.join(' ')
    };
};
// Generate a=rtcp-fb lines from RTCRtpCodecCapability or RTCRtpCodecParameters.
$7522343ecaeeccb8$var$SDPUtils.writeRtcpFb = function(codec) {
    let lines = '';
    let pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    if (codec.rtcpFeedback && codec.rtcpFeedback.length) // FIXME: special handling for trr-int?
    codec.rtcpFeedback.forEach((fb)=>{
        lines += 'a=rtcp-fb:' + pt + ' ' + fb.type + (fb.parameter && fb.parameter.length ? ' ' + fb.parameter : '') + '\r\n';
    });
    return lines;
};
// Parses a RFC 5576 ssrc media attribute. Sample input:
// a=ssrc:3735928559 cname:something
$7522343ecaeeccb8$var$SDPUtils.parseSsrcMedia = function(line) {
    const sp = line.indexOf(' ');
    const parts = {
        ssrc: parseInt(line.substring(7, sp), 10)
    };
    const colon = line.indexOf(':', sp);
    if (colon > -1) {
        parts.attribute = line.substring(sp + 1, colon);
        parts.value = line.substring(colon + 1);
    } else parts.attribute = line.substring(sp + 1);
    return parts;
};
// Parse a ssrc-group line (see RFC 5576). Sample input:
// a=ssrc-group:semantics 12 34
$7522343ecaeeccb8$var$SDPUtils.parseSsrcGroup = function(line) {
    const parts = line.substring(13).split(' ');
    return {
        semantics: parts.shift(),
        ssrcs: parts.map((ssrc)=>parseInt(ssrc, 10))
    };
};
// Extracts the MID (RFC 5888) from a media section.
// Returns the MID or undefined if no mid line was found.
$7522343ecaeeccb8$var$SDPUtils.getMid = function(mediaSection) {
    const mid = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=mid:')[0];
    if (mid) return mid.substring(6);
};
// Parses a fingerprint line for DTLS-SRTP.
$7522343ecaeeccb8$var$SDPUtils.parseFingerprint = function(line) {
    const parts = line.substring(14).split(' ');
    return {
        algorithm: parts[0].toLowerCase(),
        value: parts[1].toUpperCase()
    };
};
// Extracts DTLS parameters from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the fingerprint line as input. See also getIceParameters.
$7522343ecaeeccb8$var$SDPUtils.getDtlsParameters = function(mediaSection, sessionpart) {
    const lines = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=fingerprint:');
    // Note: a=setup line is ignored since we use the 'auto' role in Edge.
    return {
        role: 'auto',
        fingerprints: lines.map($7522343ecaeeccb8$var$SDPUtils.parseFingerprint)
    };
};
// Serializes DTLS parameters to SDP.
$7522343ecaeeccb8$var$SDPUtils.writeDtlsParameters = function(params, setupType) {
    let sdp = 'a=setup:' + setupType + '\r\n';
    params.fingerprints.forEach((fp)=>{
        sdp += 'a=fingerprint:' + fp.algorithm + ' ' + fp.value + '\r\n';
    });
    return sdp;
};
// Parses a=crypto lines into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#dictionary-rtcsrtpsdesparameters-members
$7522343ecaeeccb8$var$SDPUtils.parseCryptoLine = function(line) {
    const parts = line.substring(9).split(' ');
    return {
        tag: parseInt(parts[0], 10),
        cryptoSuite: parts[1],
        keyParams: parts[2],
        sessionParams: parts.slice(3)
    };
};
$7522343ecaeeccb8$var$SDPUtils.writeCryptoLine = function(parameters) {
    return 'a=crypto:' + parameters.tag + ' ' + parameters.cryptoSuite + ' ' + (typeof parameters.keyParams === 'object' ? $7522343ecaeeccb8$var$SDPUtils.writeCryptoKeyParams(parameters.keyParams) : parameters.keyParams) + (parameters.sessionParams ? ' ' + parameters.sessionParams.join(' ') : '') + '\r\n';
};
// Parses the crypto key parameters into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#rtcsrtpkeyparam*
$7522343ecaeeccb8$var$SDPUtils.parseCryptoKeyParams = function(keyParams) {
    if (keyParams.indexOf('inline:') !== 0) return null;
    const parts = keyParams.substring(7).split('|');
    return {
        keyMethod: 'inline',
        keySalt: parts[0],
        lifeTime: parts[1],
        mkiValue: parts[2] ? parts[2].split(':')[0] : undefined,
        mkiLength: parts[2] ? parts[2].split(':')[1] : undefined
    };
};
$7522343ecaeeccb8$var$SDPUtils.writeCryptoKeyParams = function(keyParams) {
    return keyParams.keyMethod + ':' + keyParams.keySalt + (keyParams.lifeTime ? '|' + keyParams.lifeTime : '') + (keyParams.mkiValue && keyParams.mkiLength ? '|' + keyParams.mkiValue + ':' + keyParams.mkiLength : '');
};
// Extracts all SDES parameters.
$7522343ecaeeccb8$var$SDPUtils.getCryptoParameters = function(mediaSection, sessionpart) {
    const lines = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=crypto:');
    return lines.map($7522343ecaeeccb8$var$SDPUtils.parseCryptoLine);
};
// Parses ICE information from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the ice-ufrag and ice-pwd lines as input.
$7522343ecaeeccb8$var$SDPUtils.getIceParameters = function(mediaSection, sessionpart) {
    const ufrag = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=ice-ufrag:')[0];
    const pwd = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection + sessionpart, 'a=ice-pwd:')[0];
    if (!(ufrag && pwd)) return null;
    return {
        usernameFragment: ufrag.substring(12),
        password: pwd.substring(10)
    };
};
// Serializes ICE parameters to SDP.
$7522343ecaeeccb8$var$SDPUtils.writeIceParameters = function(params) {
    let sdp = 'a=ice-ufrag:' + params.usernameFragment + '\r\n' + 'a=ice-pwd:' + params.password + '\r\n';
    if (params.iceLite) sdp += 'a=ice-lite\r\n';
    return sdp;
};
// Parses the SDP media section and returns RTCRtpParameters.
$7522343ecaeeccb8$var$SDPUtils.parseRtpParameters = function(mediaSection) {
    const description = {
        codecs: [],
        headerExtensions: [],
        fecMechanisms: [],
        rtcp: []
    };
    const lines = $7522343ecaeeccb8$var$SDPUtils.splitLines(mediaSection);
    const mline = lines[0].split(' ');
    description.profile = mline[2];
    for(let i = 3; i < mline.length; i++){
        const pt = mline[i];
        const rtpmapline = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=rtpmap:' + pt + ' ')[0];
        if (rtpmapline) {
            const codec = $7522343ecaeeccb8$var$SDPUtils.parseRtpMap(rtpmapline);
            const fmtps = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=fmtp:' + pt + ' ');
            // Only the first a=fmtp:<pt> is considered.
            codec.parameters = fmtps.length ? $7522343ecaeeccb8$var$SDPUtils.parseFmtp(fmtps[0]) : {};
            codec.rtcpFeedback = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=rtcp-fb:' + pt + ' ').map($7522343ecaeeccb8$var$SDPUtils.parseRtcpFb);
            description.codecs.push(codec);
            // parse FEC mechanisms from rtpmap lines.
            switch(codec.name.toUpperCase()){
                case 'RED':
                case 'ULPFEC':
                    description.fecMechanisms.push(codec.name.toUpperCase());
                    break;
                default:
                    break;
            }
        }
    }
    $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=extmap:').forEach((line)=>{
        description.headerExtensions.push($7522343ecaeeccb8$var$SDPUtils.parseExtmap(line));
    });
    const wildcardRtcpFb = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=rtcp-fb:* ').map($7522343ecaeeccb8$var$SDPUtils.parseRtcpFb);
    description.codecs.forEach((codec)=>{
        wildcardRtcpFb.forEach((fb)=>{
            const duplicate = codec.rtcpFeedback.find((existingFeedback)=>{
                return existingFeedback.type === fb.type && existingFeedback.parameter === fb.parameter;
            });
            if (!duplicate) codec.rtcpFeedback.push(fb);
        });
    });
    // FIXME: parse rtcp.
    return description;
};
// Generates parts of the SDP media section describing the capabilities /
// parameters.
$7522343ecaeeccb8$var$SDPUtils.writeRtpDescription = function(kind, caps) {
    let sdp = '';
    // Build the mline.
    sdp += 'm=' + kind + ' ';
    sdp += caps.codecs.length > 0 ? '9' : '0'; // reject if no codecs.
    sdp += ' ' + (caps.profile || 'UDP/TLS/RTP/SAVPF') + ' ';
    sdp += caps.codecs.map((codec)=>{
        if (codec.preferredPayloadType !== undefined) return codec.preferredPayloadType;
        return codec.payloadType;
    }).join(' ') + '\r\n';
    sdp += 'c=IN IP4 0.0.0.0\r\n';
    sdp += 'a=rtcp:9 IN IP4 0.0.0.0\r\n';
    // Add a=rtpmap lines for each codec. Also fmtp and rtcp-fb.
    caps.codecs.forEach((codec)=>{
        sdp += $7522343ecaeeccb8$var$SDPUtils.writeRtpMap(codec);
        sdp += $7522343ecaeeccb8$var$SDPUtils.writeFmtp(codec);
        sdp += $7522343ecaeeccb8$var$SDPUtils.writeRtcpFb(codec);
    });
    let maxptime = 0;
    caps.codecs.forEach((codec)=>{
        if (codec.maxptime > maxptime) maxptime = codec.maxptime;
    });
    if (maxptime > 0) sdp += 'a=maxptime:' + maxptime + '\r\n';
    if (caps.headerExtensions) caps.headerExtensions.forEach((extension)=>{
        sdp += $7522343ecaeeccb8$var$SDPUtils.writeExtmap(extension);
    });
    // FIXME: write fecMechanisms.
    return sdp;
};
// Parses the SDP media section and returns an array of
// RTCRtpEncodingParameters.
$7522343ecaeeccb8$var$SDPUtils.parseRtpEncodingParameters = function(mediaSection) {
    const encodingParameters = [];
    const description = $7522343ecaeeccb8$var$SDPUtils.parseRtpParameters(mediaSection);
    const hasRed = description.fecMechanisms.indexOf('RED') !== -1;
    const hasUlpfec = description.fecMechanisms.indexOf('ULPFEC') !== -1;
    // filter a=ssrc:... cname:, ignore PlanB-msid
    const ssrcs = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map((line)=>$7522343ecaeeccb8$var$SDPUtils.parseSsrcMedia(line)).filter((parts)=>parts.attribute === 'cname');
    const primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
    let secondarySsrc;
    const flows = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=ssrc-group:FID').map((line)=>{
        const parts = line.substring(17).split(' ');
        return parts.map((part)=>parseInt(part, 10));
    });
    if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) secondarySsrc = flows[0][1];
    description.codecs.forEach((codec)=>{
        if (codec.name.toUpperCase() === 'RTX' && codec.parameters.apt) {
            let encParam = {
                ssrc: primarySsrc,
                codecPayloadType: parseInt(codec.parameters.apt, 10)
            };
            if (primarySsrc && secondarySsrc) encParam.rtx = {
                ssrc: secondarySsrc
            };
            encodingParameters.push(encParam);
            if (hasRed) {
                encParam = JSON.parse(JSON.stringify(encParam));
                encParam.fec = {
                    ssrc: primarySsrc,
                    mechanism: hasUlpfec ? 'red+ulpfec' : 'red'
                };
                encodingParameters.push(encParam);
            }
        }
    });
    if (encodingParameters.length === 0 && primarySsrc) encodingParameters.push({
        ssrc: primarySsrc
    });
    // we support both b=AS and b=TIAS but interpret AS as TIAS.
    let bandwidth = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'b=');
    if (bandwidth.length) {
        if (bandwidth[0].indexOf('b=TIAS:') === 0) bandwidth = parseInt(bandwidth[0].substring(7), 10);
        else if (bandwidth[0].indexOf('b=AS:') === 0) // use formula from JSEP to convert b=AS to TIAS value.
        bandwidth = parseInt(bandwidth[0].substring(5), 10) * 950 - 16000;
        else bandwidth = undefined;
        encodingParameters.forEach((params)=>{
            params.maxBitrate = bandwidth;
        });
    }
    return encodingParameters;
};
// parses http://draft.ortc.org/#rtcrtcpparameters*
$7522343ecaeeccb8$var$SDPUtils.parseRtcpParameters = function(mediaSection) {
    const rtcpParameters = {};
    // Gets the first SSRC. Note that with RTX there might be multiple
    // SSRCs.
    const remoteSsrc = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map((line)=>$7522343ecaeeccb8$var$SDPUtils.parseSsrcMedia(line)).filter((obj)=>obj.attribute === 'cname')[0];
    if (remoteSsrc) {
        rtcpParameters.cname = remoteSsrc.value;
        rtcpParameters.ssrc = remoteSsrc.ssrc;
    }
    // Edge uses the compound attribute instead of reducedSize
    // compound is !reducedSize
    const rsize = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=rtcp-rsize');
    rtcpParameters.reducedSize = rsize.length > 0;
    rtcpParameters.compound = rsize.length === 0;
    // parses the rtcp-mux attrіbute.
    // Note that Edge does not support unmuxed RTCP.
    const mux = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=rtcp-mux');
    rtcpParameters.mux = mux.length > 0;
    return rtcpParameters;
};
$7522343ecaeeccb8$var$SDPUtils.writeRtcpParameters = function(rtcpParameters) {
    let sdp = '';
    if (rtcpParameters.reducedSize) sdp += 'a=rtcp-rsize\r\n';
    if (rtcpParameters.mux) sdp += 'a=rtcp-mux\r\n';
    if (rtcpParameters.ssrc !== undefined && rtcpParameters.cname) sdp += 'a=ssrc:' + rtcpParameters.ssrc + ' cname:' + rtcpParameters.cname + '\r\n';
    return sdp;
};
// parses either a=msid: or a=ssrc:... msid lines and returns
// the id of the MediaStream and MediaStreamTrack.
$7522343ecaeeccb8$var$SDPUtils.parseMsid = function(mediaSection) {
    let parts;
    const spec = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=msid:');
    if (spec.length === 1) {
        parts = spec[0].substring(7).split(' ');
        return {
            stream: parts[0],
            track: parts[1]
        };
    }
    const planB = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=ssrc:').map((line)=>$7522343ecaeeccb8$var$SDPUtils.parseSsrcMedia(line)).filter((msidParts)=>msidParts.attribute === 'msid');
    if (planB.length > 0) {
        parts = planB[0].value.split(' ');
        return {
            stream: parts[0],
            track: parts[1]
        };
    }
};
// SCTP
// parses draft-ietf-mmusic-sctp-sdp-26 first and falls back
// to draft-ietf-mmusic-sctp-sdp-05
$7522343ecaeeccb8$var$SDPUtils.parseSctpDescription = function(mediaSection) {
    const mline = $7522343ecaeeccb8$var$SDPUtils.parseMLine(mediaSection);
    const maxSizeLine = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=max-message-size:');
    let maxMessageSize;
    if (maxSizeLine.length > 0) maxMessageSize = parseInt(maxSizeLine[0].substring(19), 10);
    if (isNaN(maxMessageSize)) maxMessageSize = 65536;
    const sctpPort = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=sctp-port:');
    if (sctpPort.length > 0) return {
        port: parseInt(sctpPort[0].substring(12), 10),
        protocol: mline.fmt,
        maxMessageSize: maxMessageSize
    };
    const sctpMapLines = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'a=sctpmap:');
    if (sctpMapLines.length > 0) {
        const parts = sctpMapLines[0].substring(10).split(' ');
        return {
            port: parseInt(parts[0], 10),
            protocol: parts[1],
            maxMessageSize: maxMessageSize
        };
    }
};
// SCTP
// outputs the draft-ietf-mmusic-sctp-sdp-26 version that all browsers
// support by now receiving in this format, unless we originally parsed
// as the draft-ietf-mmusic-sctp-sdp-05 format (indicated by the m-line
// protocol of DTLS/SCTP -- without UDP/ or TCP/)
$7522343ecaeeccb8$var$SDPUtils.writeSctpDescription = function(media, sctp) {
    let output = [];
    if (media.protocol !== 'DTLS/SCTP') output = [
        'm=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.protocol + '\r\n',
        'c=IN IP4 0.0.0.0\r\n',
        'a=sctp-port:' + sctp.port + '\r\n'
    ];
    else output = [
        'm=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.port + '\r\n',
        'c=IN IP4 0.0.0.0\r\n',
        'a=sctpmap:' + sctp.port + ' ' + sctp.protocol + ' 65535\r\n'
    ];
    if (sctp.maxMessageSize !== undefined) output.push('a=max-message-size:' + sctp.maxMessageSize + '\r\n');
    return output.join('');
};
// Generate a session ID for SDP.
// https://tools.ietf.org/html/draft-ietf-rtcweb-jsep-20#section-5.2.1
// recommends using a cryptographically random +ve 64-bit value
// but right now this should be acceptable and within the right range
$7522343ecaeeccb8$var$SDPUtils.generateSessionId = function() {
    return Math.random().toString().substr(2, 22);
};
// Write boiler plate for start of SDP
// sessId argument is optional - if not supplied it will
// be generated randomly
// sessVersion is optional and defaults to 2
// sessUser is optional and defaults to 'thisisadapterortc'
$7522343ecaeeccb8$var$SDPUtils.writeSessionBoilerplate = function(sessId, sessVer, sessUser) {
    let sessionId;
    const version = sessVer !== undefined ? sessVer : 2;
    if (sessId) sessionId = sessId;
    else sessionId = $7522343ecaeeccb8$var$SDPUtils.generateSessionId();
    const user = sessUser || 'thisisadapterortc';
    // FIXME: sess-id should be an NTP timestamp.
    return "v=0\r\no=" + user + ' ' + sessionId + ' ' + version + ' IN IP4 127.0.0.1\r\n' + 's=-\r\n' + 't=0 0\r\n';
};
// Gets the direction from the mediaSection or the sessionpart.
$7522343ecaeeccb8$var$SDPUtils.getDirection = function(mediaSection, sessionpart) {
    // Look for sendrecv, sendonly, recvonly, inactive, default to sendrecv.
    const lines = $7522343ecaeeccb8$var$SDPUtils.splitLines(mediaSection);
    for(let i = 0; i < lines.length; i++)switch(lines[i]){
        case 'a=sendrecv':
        case 'a=sendonly':
        case 'a=recvonly':
        case 'a=inactive':
            return lines[i].substring(2);
        default:
    }
    if (sessionpart) return $7522343ecaeeccb8$var$SDPUtils.getDirection(sessionpart);
    return 'sendrecv';
};
$7522343ecaeeccb8$var$SDPUtils.getKind = function(mediaSection) {
    const lines = $7522343ecaeeccb8$var$SDPUtils.splitLines(mediaSection);
    const mline = lines[0].split(' ');
    return mline[0].substring(2);
};
$7522343ecaeeccb8$var$SDPUtils.isRejected = function(mediaSection) {
    return mediaSection.split(' ', 2)[1] === '0';
};
$7522343ecaeeccb8$var$SDPUtils.parseMLine = function(mediaSection) {
    const lines = $7522343ecaeeccb8$var$SDPUtils.splitLines(mediaSection);
    const parts = lines[0].substring(2).split(' ');
    return {
        kind: parts[0],
        port: parseInt(parts[1], 10),
        protocol: parts[2],
        fmt: parts.slice(3).join(' ')
    };
};
$7522343ecaeeccb8$var$SDPUtils.parseOLine = function(mediaSection) {
    const line = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, 'o=')[0];
    const parts = line.substring(2).split(' ');
    return {
        username: parts[0],
        sessionId: parts[1],
        sessionVersion: parseInt(parts[2], 10),
        netType: parts[3],
        addressType: parts[4],
        address: parts[5]
    };
};
// a very naive interpretation of a valid SDP.
$7522343ecaeeccb8$var$SDPUtils.isValidSDP = function(blob) {
    if (typeof blob !== 'string' || blob.length === 0) return false;
    const lines = $7522343ecaeeccb8$var$SDPUtils.splitLines(blob);
    for(let i = 0; i < lines.length; i++){
        if (lines[i].length < 2 || lines[i].charAt(1) !== '=') return false;
    // TODO: check the modifier a bit more.
    }
    return true;
};
$7522343ecaeeccb8$exports = $7522343ecaeeccb8$var$SDPUtils;



'use strict';
function $599d92f2f0dc2dee$export$cf133661e444ccfe(window) {
    // foundation is arbitrarily chosen as an indicator for full support for
    // https://w3c.github.io/webrtc-pc/#rtcicecandidate-interface
    if (!window.RTCIceCandidate || window.RTCIceCandidate && 'foundation' in window.RTCIceCandidate.prototype) return;
    const NativeRTCIceCandidate = window.RTCIceCandidate;
    window.RTCIceCandidate = function RTCIceCandidate(args) {
        // Remove the a= which shouldn't be part of the candidate string.
        if (typeof args === 'object' && args.candidate && args.candidate.indexOf('a=') === 0) {
            args = JSON.parse(JSON.stringify(args));
            args.candidate = args.candidate.substring(2);
        }
        if (args.candidate && args.candidate.length) {
            // Augment the native candidate with the parsed fields.
            const nativeCandidate = new NativeRTCIceCandidate(args);
            const parsedCandidate = (0, (/*@__PURE__*/$parcel$interopDefault($7522343ecaeeccb8$exports))).parseCandidate(args.candidate);
            for(const key in parsedCandidate)if (!(key in nativeCandidate)) Object.defineProperty(nativeCandidate, key, {
                value: parsedCandidate[key]
            });
            // Override serializer to not serialize the extra attributes.
            nativeCandidate.toJSON = function toJSON() {
                return {
                    candidate: nativeCandidate.candidate,
                    sdpMid: nativeCandidate.sdpMid,
                    sdpMLineIndex: nativeCandidate.sdpMLineIndex,
                    usernameFragment: nativeCandidate.usernameFragment
                };
            };
            return nativeCandidate;
        }
        return new NativeRTCIceCandidate(args);
    };
    window.RTCIceCandidate.prototype = NativeRTCIceCandidate.prototype;
    // Hook up the augmented candidate in onicecandidate and
    // addEventListener('icecandidate', ...)
    $584b81f9a9b8bf97$export$1f48841962b828b1(window, 'icecandidate', (e)=>{
        if (e.candidate) Object.defineProperty(e, 'candidate', {
            value: new window.RTCIceCandidate(e.candidate),
            writable: 'false'
        });
        return e;
    });
}
function $599d92f2f0dc2dee$export$fdafb8d8280e29b5(window) {
    if (!window.RTCIceCandidate || window.RTCIceCandidate && 'relayProtocol' in window.RTCIceCandidate.prototype) return;
    // Hook up the augmented candidate in onicecandidate and
    // addEventListener('icecandidate', ...)
    $584b81f9a9b8bf97$export$1f48841962b828b1(window, 'icecandidate', (e)=>{
        if (e.candidate) {
            const parsedCandidate = (0, (/*@__PURE__*/$parcel$interopDefault($7522343ecaeeccb8$exports))).parseCandidate(e.candidate.candidate);
            if (parsedCandidate.type === 'relay') // This is a libwebrtc-specific mapping of local type preference
            // to relayProtocol.
            e.candidate.relayProtocol = ({
                0: 'tls',
                1: 'tcp',
                2: 'udp'
            })[parsedCandidate.priority >> 24];
        }
        return e;
    });
}
function $599d92f2f0dc2dee$export$a99147c78a56edc4(window, browserDetails) {
    if (!window.RTCPeerConnection) return;
    if (!('sctp' in window.RTCPeerConnection.prototype)) Object.defineProperty(window.RTCPeerConnection.prototype, 'sctp', {
        get () {
            return typeof this._sctp === 'undefined' ? null : this._sctp;
        }
    });
    const sctpInDescription = function(description) {
        if (!description || !description.sdp) return false;
        const sections = (0, (/*@__PURE__*/$parcel$interopDefault($7522343ecaeeccb8$exports))).splitSections(description.sdp);
        sections.shift();
        return sections.some((mediaSection)=>{
            const mLine = (0, (/*@__PURE__*/$parcel$interopDefault($7522343ecaeeccb8$exports))).parseMLine(mediaSection);
            return mLine && mLine.kind === 'application' && mLine.protocol.indexOf('SCTP') !== -1;
        });
    };
    const getRemoteFirefoxVersion = function(description) {
        // TODO: Is there a better solution for detecting Firefox?
        const match = description.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);
        if (match === null || match.length < 2) return -1;
        const version = parseInt(match[1], 10);
        // Test for NaN (yes, this is ugly)
        return version !== version ? -1 : version;
    };
    const getCanSendMaxMessageSize = function(remoteIsFirefox) {
        // Every implementation we know can send at least 64 KiB.
        // Note: Although Chrome is technically able to send up to 256 KiB, the
        //       data does not reach the other peer reliably.
        //       See: https://bugs.chromium.org/p/webrtc/issues/detail?id=8419
        let canSendMaxMessageSize = 65536;
        if (browserDetails.browser === 'firefox') {
            if (browserDetails.version < 57) {
                if (remoteIsFirefox === -1) // FF < 57 will send in 16 KiB chunks using the deprecated PPID
                // fragmentation.
                canSendMaxMessageSize = 16384;
                else // However, other FF (and RAWRTC) can reassemble PPID-fragmented
                // messages. Thus, supporting ~2 GiB when sending.
                canSendMaxMessageSize = 2147483637;
            } else if (browserDetails.version < 60) // Currently, all FF >= 57 will reset the remote maximum message size
            // to the default value when a data channel is created at a later
            // stage. :(
            // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
            canSendMaxMessageSize = browserDetails.version === 57 ? 65535 : 65536;
            else // FF >= 60 supports sending ~2 GiB
            canSendMaxMessageSize = 2147483637;
        }
        return canSendMaxMessageSize;
    };
    const getMaxMessageSize = function(description, remoteIsFirefox) {
        // Note: 65536 bytes is the default value from the SDP spec. Also,
        //       every implementation we know supports receiving 65536 bytes.
        let maxMessageSize = 65536;
        // FF 57 has a slightly incorrect default remote max message size, so
        // we need to adjust it here to avoid a failure when sending.
        // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1425697
        if (browserDetails.browser === 'firefox' && browserDetails.version === 57) maxMessageSize = 65535;
        const match = (0, (/*@__PURE__*/$parcel$interopDefault($7522343ecaeeccb8$exports))).matchPrefix(description.sdp, 'a=max-message-size:');
        if (match.length > 0) maxMessageSize = parseInt(match[0].substring(19), 10);
        else if (browserDetails.browser === 'firefox' && remoteIsFirefox !== -1) // If the maximum message size is not present in the remote SDP and
        // both local and remote are Firefox, the remote peer can receive
        // ~2 GiB.
        maxMessageSize = 2147483637;
        return maxMessageSize;
    };
    const origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
    window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
        this._sctp = null;
        // Chrome decided to not expose .sctp in plan-b mode.
        // As usual, adapter.js has to do an 'ugly worakaround'
        // to cover up the mess.
        if (browserDetails.browser === 'chrome' && browserDetails.version >= 76) {
            const { sdpSemantics: sdpSemantics } = this.getConfiguration();
            if (sdpSemantics === 'plan-b') Object.defineProperty(this, 'sctp', {
                get () {
                    return typeof this._sctp === 'undefined' ? null : this._sctp;
                },
                enumerable: true,
                configurable: true
            });
        }
        if (sctpInDescription(arguments[0])) {
            // Check if the remote is FF.
            const isFirefox = getRemoteFirefoxVersion(arguments[0]);
            // Get the maximum message size the local peer is capable of sending
            const canSendMMS = getCanSendMaxMessageSize(isFirefox);
            // Get the maximum message size of the remote peer.
            const remoteMMS = getMaxMessageSize(arguments[0], isFirefox);
            // Determine final maximum message size
            let maxMessageSize;
            if (canSendMMS === 0 && remoteMMS === 0) maxMessageSize = Number.POSITIVE_INFINITY;
            else if (canSendMMS === 0 || remoteMMS === 0) maxMessageSize = Math.max(canSendMMS, remoteMMS);
            else maxMessageSize = Math.min(canSendMMS, remoteMMS);
            // Create a dummy RTCSctpTransport object and the 'maxMessageSize'
            // attribute.
            const sctp = {};
            Object.defineProperty(sctp, 'maxMessageSize', {
                get () {
                    return maxMessageSize;
                }
            });
            this._sctp = sctp;
        }
        return origSetRemoteDescription.apply(this, arguments);
    };
}
function $599d92f2f0dc2dee$export$d461c8d5c5db5da7(window) {
    if (!(window.RTCPeerConnection && 'createDataChannel' in window.RTCPeerConnection.prototype)) return;
    // Note: Although Firefox >= 57 has a native implementation, the maximum
    //       message size can be reset for all data channels at a later stage.
    //       See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
    function wrapDcSend(dc, pc) {
        const origDataChannelSend = dc.send;
        dc.send = function send() {
            const data = arguments[0];
            const length = data.length || data.size || data.byteLength;
            if (dc.readyState === 'open' && pc.sctp && length > pc.sctp.maxMessageSize) throw new TypeError('Message too large (can send a maximum of ' + pc.sctp.maxMessageSize + ' bytes)');
            return origDataChannelSend.apply(dc, arguments);
        };
    }
    const origCreateDataChannel = window.RTCPeerConnection.prototype.createDataChannel;
    window.RTCPeerConnection.prototype.createDataChannel = function createDataChannel() {
        const dataChannel = origCreateDataChannel.apply(this, arguments);
        wrapDcSend(dataChannel, this);
        return dataChannel;
    };
    $584b81f9a9b8bf97$export$1f48841962b828b1(window, 'datachannel', (e)=>{
        wrapDcSend(e.channel, e.target);
        return e;
    });
}
function $599d92f2f0dc2dee$export$63bb816cc75460(window) {
    if (!window.RTCPeerConnection || 'connectionState' in window.RTCPeerConnection.prototype) return;
    const proto = window.RTCPeerConnection.prototype;
    Object.defineProperty(proto, 'connectionState', {
        get () {
            return ({
                completed: 'connected',
                checking: 'connecting'
            })[this.iceConnectionState] || this.iceConnectionState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(proto, 'onconnectionstatechange', {
        get () {
            return this._onconnectionstatechange || null;
        },
        set (cb) {
            if (this._onconnectionstatechange) {
                this.removeEventListener('connectionstatechange', this._onconnectionstatechange);
                delete this._onconnectionstatechange;
            }
            if (cb) this.addEventListener('connectionstatechange', this._onconnectionstatechange = cb);
        },
        enumerable: true,
        configurable: true
    });
    [
        'setLocalDescription',
        'setRemoteDescription'
    ].forEach((method)=>{
        const origMethod = proto[method];
        proto[method] = function() {
            if (!this._connectionstatechangepoly) {
                this._connectionstatechangepoly = (e)=>{
                    const pc = e.target;
                    if (pc._lastConnectionState !== pc.connectionState) {
                        pc._lastConnectionState = pc.connectionState;
                        const newEvent = new Event('connectionstatechange', e);
                        pc.dispatchEvent(newEvent);
                    }
                    return e;
                };
                this.addEventListener('iceconnectionstatechange', this._connectionstatechangepoly);
            }
            return origMethod.apply(this, arguments);
        };
    });
}
function $599d92f2f0dc2dee$export$a57d114344295149(window, browserDetails) {
    /* remove a=extmap-allow-mixed for webrtc.org < M71 */ if (!window.RTCPeerConnection) return;
    if (browserDetails.browser === 'chrome' && browserDetails.version >= 71) return;
    if (browserDetails.browser === 'safari' && browserDetails.version >= 605) return;
    const nativeSRD = window.RTCPeerConnection.prototype.setRemoteDescription;
    window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription(desc) {
        if (desc && desc.sdp && desc.sdp.indexOf('\na=extmap-allow-mixed') !== -1) {
            const sdp = desc.sdp.split('\n').filter((line)=>{
                return line.trim() !== 'a=extmap-allow-mixed';
            }).join('\n');
            // Safari enforces read-only-ness of RTCSessionDescription fields.
            if (window.RTCSessionDescription && desc instanceof window.RTCSessionDescription) arguments[0] = new window.RTCSessionDescription({
                type: desc.type,
                sdp: sdp
            });
            else desc.sdp = sdp;
        }
        return nativeSRD.apply(this, arguments);
    };
}
function $599d92f2f0dc2dee$export$51d5e40b48c771c7(window, browserDetails) {
    // Support for addIceCandidate(null or undefined)
    // as well as addIceCandidate({candidate: "", ...})
    // https://bugs.chromium.org/p/chromium/issues/detail?id=978582
    // Note: must be called before other polyfills which change the signature.
    if (!(window.RTCPeerConnection && window.RTCPeerConnection.prototype)) return;
    const nativeAddIceCandidate = window.RTCPeerConnection.prototype.addIceCandidate;
    if (!nativeAddIceCandidate || nativeAddIceCandidate.length === 0) return;
    window.RTCPeerConnection.prototype.addIceCandidate = function addIceCandidate() {
        if (!arguments[0]) {
            if (arguments[1]) arguments[1].apply(null);
            return Promise.resolve();
        }
        // Firefox 68+ emits and processes {candidate: "", ...}, ignore
        // in older versions.
        // Native support for ignoring exists for Chrome M77+.
        // Safari ignores as well, exact version unknown but works in the same
        // version that also ignores addIceCandidate(null).
        if ((browserDetails.browser === 'chrome' && browserDetails.version < 78 || browserDetails.browser === 'firefox' && browserDetails.version < 68 || browserDetails.browser === 'safari') && arguments[0] && arguments[0].candidate === '') return Promise.resolve();
        return nativeAddIceCandidate.apply(this, arguments);
    };
}
function $599d92f2f0dc2dee$export$7170d04e59f9d553(window, browserDetails) {
    if (!(window.RTCPeerConnection && window.RTCPeerConnection.prototype)) return;
    const nativeSetLocalDescription = window.RTCPeerConnection.prototype.setLocalDescription;
    if (!nativeSetLocalDescription || nativeSetLocalDescription.length === 0) return;
    window.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
        let desc = arguments[0] || {};
        if (typeof desc !== 'object' || desc.type && desc.sdp) return nativeSetLocalDescription.apply(this, arguments);
        // The remaining steps should technically happen when SLD comes off the
        // RTCPeerConnection's operations chain (not ahead of going on it), but
        // this is too difficult to shim. Instead, this shim only covers the
        // common case where the operations chain is empty. This is imperfect, but
        // should cover many cases. Rationale: Even if we can't reduce the glare
        // window to zero on imperfect implementations, there's value in tapping
        // into the perfect negotiation pattern that several browsers support.
        desc = {
            type: desc.type,
            sdp: desc.sdp
        };
        if (!desc.type) switch(this.signalingState){
            case 'stable':
            case 'have-local-offer':
            case 'have-remote-pranswer':
                desc.type = 'offer';
                break;
            default:
                desc.type = 'answer';
                break;
        }
        if (desc.sdp || desc.type !== 'offer' && desc.type !== 'answer') return nativeSetLocalDescription.apply(this, [
            desc
        ]);
        const func = desc.type === 'offer' ? this.createOffer : this.createAnswer;
        return func.apply(this).then((d)=>nativeSetLocalDescription.apply(this, [
                d
            ]));
    };
}



function $e095574c16a43495$export$e77bf46c04ac7d12({ window: window } = {}, options = {
    shimChrome: true,
    shimFirefox: true,
    shimSafari: true
}) {
    // Utils.
    const logging = $584b81f9a9b8bf97$export$bef1f36f5486a6a3;
    const browserDetails = $584b81f9a9b8bf97$export$2d31490a0c05f094(window);
    const adapter = {
        browserDetails: browserDetails,
        commonShim: $599d92f2f0dc2dee$exports,
        extractVersion: $584b81f9a9b8bf97$export$e3c02be309be1f23,
        disableLog: $584b81f9a9b8bf97$export$afbfee8cc06fd3e4,
        disableWarnings: $584b81f9a9b8bf97$export$51516be4b019e41e,
        sdp: // Expose sdp as a convenience. For production apps include directly.
        $7522343ecaeeccb8$exports
    };
    // Shim browser if found.
    switch(browserDetails.browser){
        case 'chrome':
            if (!$558eb894511c4db3$exports || !$558eb894511c4db3$exports.shimPeerConnection || !options.shimChrome) {
                logging('Chrome shim is not included in this adapter release.');
                return adapter;
            }
            if (browserDetails.version === null) {
                logging('Chrome shim can not determine version, not shimming.');
                return adapter;
            }
            logging('adapter.js shimming chrome.');
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $558eb894511c4db3$exports;
            // Must be called before shimPeerConnection.
            $599d92f2f0dc2dee$export$51d5e40b48c771c7(window, browserDetails);
            $599d92f2f0dc2dee$export$7170d04e59f9d553(window, browserDetails);
            $558eb894511c4db3$exports.shimGetUserMedia(window, browserDetails);
            $558eb894511c4db3$exports.shimMediaStream(window, browserDetails);
            $558eb894511c4db3$exports.shimPeerConnection(window, browserDetails);
            $558eb894511c4db3$exports.shimOnTrack(window, browserDetails);
            $558eb894511c4db3$exports.shimAddTrackRemoveTrack(window, browserDetails);
            $558eb894511c4db3$exports.shimGetSendersWithDtmf(window, browserDetails);
            $558eb894511c4db3$exports.shimGetStats(window, browserDetails);
            $558eb894511c4db3$exports.shimSenderReceiverGetStats(window, browserDetails);
            $558eb894511c4db3$exports.fixNegotiationNeeded(window, browserDetails);
            $599d92f2f0dc2dee$export$cf133661e444ccfe(window, browserDetails);
            $599d92f2f0dc2dee$export$fdafb8d8280e29b5(window, browserDetails);
            $599d92f2f0dc2dee$export$63bb816cc75460(window, browserDetails);
            $599d92f2f0dc2dee$export$a99147c78a56edc4(window, browserDetails);
            $599d92f2f0dc2dee$export$d461c8d5c5db5da7(window, browserDetails);
            $599d92f2f0dc2dee$export$a57d114344295149(window, browserDetails);
            break;
        case 'firefox':
            if (!$c518d147eb169a8d$exports || !$c518d147eb169a8d$exports.shimPeerConnection || !options.shimFirefox) {
                logging('Firefox shim is not included in this adapter release.');
                return adapter;
            }
            logging('adapter.js shimming firefox.');
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $c518d147eb169a8d$exports;
            // Must be called before shimPeerConnection.
            $599d92f2f0dc2dee$export$51d5e40b48c771c7(window, browserDetails);
            $599d92f2f0dc2dee$export$7170d04e59f9d553(window, browserDetails);
            $c518d147eb169a8d$exports.shimGetUserMedia(window, browserDetails);
            $c518d147eb169a8d$exports.shimPeerConnection(window, browserDetails);
            $c518d147eb169a8d$exports.shimOnTrack(window, browserDetails);
            $c518d147eb169a8d$exports.shimRemoveStream(window, browserDetails);
            $c518d147eb169a8d$exports.shimSenderGetStats(window, browserDetails);
            $c518d147eb169a8d$exports.shimReceiverGetStats(window, browserDetails);
            $c518d147eb169a8d$exports.shimRTCDataChannel(window, browserDetails);
            $c518d147eb169a8d$exports.shimAddTransceiver(window, browserDetails);
            $c518d147eb169a8d$exports.shimGetParameters(window, browserDetails);
            $c518d147eb169a8d$exports.shimCreateOffer(window, browserDetails);
            $c518d147eb169a8d$exports.shimCreateAnswer(window, browserDetails);
            $599d92f2f0dc2dee$export$cf133661e444ccfe(window, browserDetails);
            $599d92f2f0dc2dee$export$63bb816cc75460(window, browserDetails);
            $599d92f2f0dc2dee$export$a99147c78a56edc4(window, browserDetails);
            $599d92f2f0dc2dee$export$d461c8d5c5db5da7(window, browserDetails);
            break;
        case 'safari':
            if (!$9a20cef3f9b7f4b6$exports || !options.shimSafari) {
                logging('Safari shim is not included in this adapter release.');
                return adapter;
            }
            logging('adapter.js shimming safari.');
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $9a20cef3f9b7f4b6$exports;
            // Must be called before shimCallbackAPI.
            $599d92f2f0dc2dee$export$51d5e40b48c771c7(window, browserDetails);
            $599d92f2f0dc2dee$export$7170d04e59f9d553(window, browserDetails);
            $9a20cef3f9b7f4b6$exports.shimRTCIceServerUrls(window, browserDetails);
            $9a20cef3f9b7f4b6$exports.shimCreateOfferLegacy(window, browserDetails);
            $9a20cef3f9b7f4b6$exports.shimCallbacksAPI(window, browserDetails);
            $9a20cef3f9b7f4b6$exports.shimLocalStreamsAPI(window, browserDetails);
            $9a20cef3f9b7f4b6$exports.shimRemoteStreamsAPI(window, browserDetails);
            $9a20cef3f9b7f4b6$exports.shimTrackEventTransceiver(window, browserDetails);
            $9a20cef3f9b7f4b6$exports.shimGetUserMedia(window, browserDetails);
            $9a20cef3f9b7f4b6$exports.shimAudioContext(window, browserDetails);
            $599d92f2f0dc2dee$export$cf133661e444ccfe(window, browserDetails);
            $599d92f2f0dc2dee$export$fdafb8d8280e29b5(window, browserDetails);
            $599d92f2f0dc2dee$export$a99147c78a56edc4(window, browserDetails);
            $599d92f2f0dc2dee$export$d461c8d5c5db5da7(window, browserDetails);
            $599d92f2f0dc2dee$export$a57d114344295149(window, browserDetails);
            break;
        default:
            logging('Unsupported browser!');
            break;
    }
    return adapter;
}


'use strict';
const $09d981616173740d$var$adapter = (0, $e095574c16a43495$export$e77bf46c04ac7d12)({
    window: typeof window === 'undefined' ? undefined : window
});
var $09d981616173740d$export$2e2bcd8739ae039 = $09d981616173740d$var$adapter;


$daf510f834517ce2$export$2e2bcd8739ae039.sessions = new Map();
$daf510f834517ce2$export$2e2bcd8739ae039.isExtensionEnabled = function() {
    if (navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia) // No need for the extension, getDisplayMedia is supported
    return true;
    if (window.navigator.userAgent.match('Chrome')) {
        let chromever = parseInt(window.navigator.userAgent.match(/Chrome\/(.*) /)[1], 10);
        let maxver = 33;
        if (window.navigator.userAgent.match('Linux')) maxver = 35; // "known" crash in chrome 34 and 35 on linux
        if (chromever >= 26 && chromever <= maxver) // Older versions of Chrome don't support this extension-based approach, so lie
        return true;
        return $daf510f834517ce2$export$2e2bcd8739ae039.extension.isInstalled();
    } else // Firefox and others, no need for the extension (but this doesn't mean it will work)
    return true;
};
var $daf510f834517ce2$var$defaultExtension = {
    // Screensharing Chrome Extension ID
    extensionId: 'hapfgfdkleiggjjpfpenajgdnfckjpaj',
    isInstalled: function() {
        return document.querySelector('#janus-extension-installed') !== null;
    },
    getScreen: function(callback) {
        let pending = window.setTimeout(function() {
            let error = new Error('NavigatorUserMediaError');
            error.name = 'The required Chrome extension is not installed: click <a href="#">here</a> to install it. (NOTE: this will need you to refresh the page)';
            return callback(error);
        }, 1000);
        this.cache[pending] = callback;
        window.postMessage({
            type: 'janusGetScreen',
            id: pending
        }, '*');
    },
    init: function() {
        let cache = {};
        this.cache = cache;
        // Wait for events from the Chrome Extension
        window.addEventListener('message', function(event) {
            if (event.origin != window.location.origin) return;
            if (event.data.type == 'janusGotScreen' && cache[event.data.id]) {
                let callback = cache[event.data.id];
                delete cache[event.data.id];
                if (event.data.sourceId === '') {
                    // user canceled
                    let error = new Error('NavigatorUserMediaError');
                    error.name = 'You cancelled the request for permission, giving up...';
                    callback(error);
                } else callback(null, event.data.sourceId);
            } else if (event.data.type == 'janusGetScreenPending') window.clearTimeout(event.data.id);
        });
    }
};
$daf510f834517ce2$export$2e2bcd8739ae039.useDefaultDependencies = function(deps) {
    let f = deps && deps.fetch || fetch;
    let p = deps && deps.Promise || Promise;
    let socketCls = deps && deps.WebSocket || WebSocket;
    return {
        newWebSocket: function(server, proto) {
            return new socketCls(server, proto);
        },
        extension: deps && deps.extension || $daf510f834517ce2$var$defaultExtension,
        isArray: function(arr) {
            return Array.isArray(arr);
        },
        webRTCAdapter: deps && deps.adapter || (0, $09d981616173740d$export$2e2bcd8739ae039),
        httpAPICall: function(url, options) {
            let fetchOptions = {
                method: options.verb,
                headers: {
                    'Accept': 'application/json, text/plain, */*'
                },
                cache: 'no-cache'
            };
            if (options.verb === "POST") fetchOptions.headers['Content-Type'] = 'application/json';
            if (typeof options.withCredentials !== 'undefined') fetchOptions.credentials = options.withCredentials === true ? 'include' : options.withCredentials ? options.withCredentials : 'omit';
            if (options.body) fetchOptions.body = JSON.stringify(options.body);
            let fetching = f(url, fetchOptions).catch(function(error) {
                return p.reject({
                    message: 'Probably a network error, is the server down?',
                    error: error
                });
            });
            /*
			 * fetch() does not natively support timeouts.
			 * Work around this by starting a timeout manually, and racing it agains the fetch() to see which thing resolves first.
			 */ if (options.timeout) {
                let timeout = new p(function(resolve, reject) {
                    let timerId = setTimeout(function() {
                        clearTimeout(timerId);
                        return reject({
                            message: 'Request timed out',
                            timeout: options.timeout
                        });
                    }, options.timeout);
                });
                fetching = p.race([
                    fetching,
                    timeout
                ]);
            }
            fetching.then(function(response) {
                if (response.ok) {
                    if (typeof options.success === typeof $daf510f834517ce2$export$2e2bcd8739ae039.noop) return response.json().then(function(parsed) {
                        try {
                            options.success(parsed);
                        } catch (error) {
                            $daf510f834517ce2$export$2e2bcd8739ae039.error('Unhandled httpAPICall success callback error', error);
                        }
                    }, function(error) {
                        return p.reject({
                            message: 'Failed to parse response body',
                            error: error,
                            response: response
                        });
                    });
                } else return p.reject({
                    message: 'API call failed',
                    response: response
                });
            }).catch(function(error) {
                if (typeof options.error === typeof $daf510f834517ce2$export$2e2bcd8739ae039.noop) options.error(error.message || '<< internal error >>', error);
            });
            return fetching;
        }
    };
};
$daf510f834517ce2$export$2e2bcd8739ae039.useOldDependencies = function(deps) {
    let jq = deps && deps.jQuery || jQuery;
    let socketCls = deps && deps.WebSocket || WebSocket;
    return {
        newWebSocket: function(server, proto) {
            return new socketCls(server, proto);
        },
        isArray: function(arr) {
            return jq.isArray(arr);
        },
        extension: deps && deps.extension || $daf510f834517ce2$var$defaultExtension,
        webRTCAdapter: deps && deps.adapter || (0, $09d981616173740d$export$2e2bcd8739ae039),
        httpAPICall: function(url, options) {
            let payload = typeof options.body !== 'undefined' ? {
                contentType: 'application/json',
                data: JSON.stringify(options.body)
            } : {};
            let credentials = typeof options.withCredentials !== 'undefined' ? {
                xhrFields: {
                    withCredentials: options.withCredentials
                }
            } : {};
            return jq.ajax(jq.extend(payload, credentials, {
                url: url,
                type: options.verb,
                cache: false,
                dataType: 'json',
                async: options.async,
                timeout: options.timeout,
                success: function(result) {
                    if (typeof options.success === typeof $daf510f834517ce2$export$2e2bcd8739ae039.noop) options.success(result);
                },
                error: function(xhr, status, err) {
                    if (typeof options.error === typeof $daf510f834517ce2$export$2e2bcd8739ae039.noop) options.error(status, err);
                }
            }));
        }
    };
};
// Helper function to convert a deprecated media object to a tracks array
$daf510f834517ce2$export$2e2bcd8739ae039.mediaToTracks = function(media) {
    let tracks = [];
    if (!media) {
        // Default is bidirectional audio and video, using default devices
        tracks.push({
            type: 'audio',
            capture: true,
            recv: true
        });
        tracks.push({
            type: 'video',
            capture: true,
            recv: true
        });
    } else {
        if (!media.keepAudio && media.audio !== false && (typeof media.audio === 'undefined' || media.audio || media.audioSend || media.audioRecv || media.addAudio || media.replaceAudio || media.removeAudio)) {
            // We may need an audio track
            let track = {
                type: 'audio'
            };
            if (media.removeAudio) track.remove = true;
            else {
                if (media.addAudio) track.add = true;
                else if (media.replaceAudio) track.replace = true;
                // Check if we need to capture an audio device
                if (media.audioSend !== false) track.capture = media.audio || true;
                // Check if we need to receive audio
                if (media.audioRecv !== false) track.recv = true;
            }
            // Add an audio track if needed
            if (track.remove || track.capture || track.recv) tracks.push(track);
        }
        if (!media.keepVideo && media.video !== false && (typeof media.video === 'undefined' || media.video || media.videoSend || media.videoRecv || media.addVideo || media.replaceVideo || media.removeVideo)) {
            // We may need a video track
            let track = {
                type: 'video'
            };
            if (media.removeVideo) track.remove = true;
            else {
                if (media.addVideo) track.add = true;
                else if (media.replaceVideo) track.replace = true;
                // Check if we need to capture a video device
                if (media.videoSend !== false) {
                    track.capture = media.video || true;
                    if ([
                        'screen',
                        'window',
                        'desktop'
                    ].includes(track.capture)) {
                        // Change the type to 'screen'
                        track.type = 'screen';
                        track.capture = {
                            video: {}
                        };
                        // Check if there's constraints
                        if (media.screenshareFrameRate) track.capture.frameRate = media.screenshareFrameRate;
                        if (media.screenshareHeight) track.capture.height = media.screenshareHeight;
                        if (media.screenshareWidth) track.capture.width = media.screenshareWidth;
                    }
                }
                // Check if we need to receive video
                if (media.videoRecv !== false) track.recv = true;
            }
            // Add a video track if needed
            if (track.remove || track.capture || track.recv) tracks.push(track);
        }
        if (media.data) // We need a data channel
        tracks.push({
            type: 'data'
        });
    }
    // Done
    return tracks;
};
// Helper function to convert a track object to a set of constraints
$daf510f834517ce2$export$2e2bcd8739ae039.trackConstraints = function(track) {
    let constraints = {};
    if (!track || !track.capture) return constraints;
    if (track.type === 'audio') // Just put the capture part in the constraints
    constraints.audio = track.capture;
    else if (track.type === 'video') {
        // Check if one of the keywords was passed
        if ((track.simulcast || track.svc) && track.capture === true) track.capture = 'hires';
        if (track.capture === true || typeof track.capture === 'object') // Use the provided capture object as video constraint
        constraints.video = track.capture;
        else {
            let width = 0;
            let height = 0;
            if (track.capture === 'lowres') {
                // Small resolution, 4:3
                width = 320;
                height = 240;
            } else if (track.capture === 'lowres-16:9') {
                // Small resolution, 16:9
                width = 320;
                height = 180;
            } else if (track.capture === 'hires' || track.capture === 'hires-16:9' || track.capture === 'hdres') {
                // High(HD) resolution is only 16:9
                width = 1280;
                height = 720;
            } else if (track.capture === 'fhdres') {
                // Full HD resolution is only 16:9
                width = 1920;
                height = 1080;
            } else if (track.capture === '4kres') {
                // 4K resolution is only 16:9
                width = 3840;
                height = 2160;
            } else if (track.capture === 'stdres') {
                // Normal resolution, 4:3
                width = 640;
                height = 480;
            } else if (track.capture === 'stdres-16:9') {
                // Normal resolution, 16:9
                width = 640;
                height = 360;
            } else {
                $daf510f834517ce2$export$2e2bcd8739ae039.log('Default video setting is stdres 4:3');
                width = 640;
                height = 480;
            }
            constraints.video = {
                width: {
                    ideal: width
                },
                height: {
                    ideal: height
                }
            };
        }
    } else if (track.type === 'screen') // Use the provided capture object as video constraint
    constraints.video = track.capture;
    return constraints;
};
$daf510f834517ce2$export$2e2bcd8739ae039.noop = function() {};
$daf510f834517ce2$export$2e2bcd8739ae039.dataChanDefaultLabel = "JanusDataChannel";
// Note: in the future we may want to change this, e.g., as was
// attempted in https://github.com/meetecho/janus-gateway/issues/1670
$daf510f834517ce2$export$2e2bcd8739ae039.endOfCandidates = null;
// Stop all tracks from a given stream
$daf510f834517ce2$export$2e2bcd8739ae039.stopAllTracks = function(stream) {
    try {
        // Try a MediaStreamTrack.stop() for each track
        let tracks = stream.getTracks();
        for (let mst of tracks){
            $daf510f834517ce2$export$2e2bcd8739ae039.log(mst);
            if (mst && mst.dontStop !== true) mst.stop();
        }
    } catch (e) {
    // Do nothing if this fails
    }
};
// Initialization
$daf510f834517ce2$export$2e2bcd8739ae039.init = function(options) {
    options = options || {};
    options.callback = typeof options.callback == "function" ? options.callback : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
    if ($daf510f834517ce2$export$2e2bcd8739ae039.initDone) // Already initialized
    options.callback();
    else {
        if (typeof console.log == "undefined") console.log = function() {};
        // Console logging (all debugging disabled by default)
        $daf510f834517ce2$export$2e2bcd8739ae039.trace = $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        $daf510f834517ce2$export$2e2bcd8739ae039.debug = $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        $daf510f834517ce2$export$2e2bcd8739ae039.vdebug = $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        $daf510f834517ce2$export$2e2bcd8739ae039.log = $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        $daf510f834517ce2$export$2e2bcd8739ae039.warn = $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        $daf510f834517ce2$export$2e2bcd8739ae039.error = $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        if (options.debug === true || options.debug === "all") {
            // Enable all debugging levels
            $daf510f834517ce2$export$2e2bcd8739ae039.trace = console.trace.bind(console);
            $daf510f834517ce2$export$2e2bcd8739ae039.debug = console.debug.bind(console);
            $daf510f834517ce2$export$2e2bcd8739ae039.vdebug = console.debug.bind(console);
            $daf510f834517ce2$export$2e2bcd8739ae039.log = console.log.bind(console);
            $daf510f834517ce2$export$2e2bcd8739ae039.warn = console.warn.bind(console);
            $daf510f834517ce2$export$2e2bcd8739ae039.error = console.error.bind(console);
        } else if (Array.isArray(options.debug)) for (let d of options.debug)switch(d){
            case "trace":
                $daf510f834517ce2$export$2e2bcd8739ae039.trace = console.trace.bind(console);
                break;
            case "debug":
                $daf510f834517ce2$export$2e2bcd8739ae039.debug = console.debug.bind(console);
                break;
            case "vdebug":
                $daf510f834517ce2$export$2e2bcd8739ae039.vdebug = console.debug.bind(console);
                break;
            case "log":
                $daf510f834517ce2$export$2e2bcd8739ae039.log = console.log.bind(console);
                break;
            case "warn":
                $daf510f834517ce2$export$2e2bcd8739ae039.warn = console.warn.bind(console);
                break;
            case "error":
                $daf510f834517ce2$export$2e2bcd8739ae039.error = console.error.bind(console);
                break;
        }
        $daf510f834517ce2$export$2e2bcd8739ae039.log("Initializing library");
        let usedDependencies = options.dependencies || $daf510f834517ce2$export$2e2bcd8739ae039.useDefaultDependencies();
        $daf510f834517ce2$export$2e2bcd8739ae039.isArray = usedDependencies.isArray;
        $daf510f834517ce2$export$2e2bcd8739ae039.webRTCAdapter = usedDependencies.webRTCAdapter;
        $daf510f834517ce2$export$2e2bcd8739ae039.httpAPICall = usedDependencies.httpAPICall;
        $daf510f834517ce2$export$2e2bcd8739ae039.newWebSocket = usedDependencies.newWebSocket;
        $daf510f834517ce2$export$2e2bcd8739ae039.extension = usedDependencies.extension;
        $daf510f834517ce2$export$2e2bcd8739ae039.extension.init();
        // Helper method to enumerate devices
        $daf510f834517ce2$export$2e2bcd8739ae039.listDevices = function(callback, config) {
            callback = typeof callback == "function" ? callback : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
            if (!config) config = {
                audio: true,
                video: true
            };
            if ($daf510f834517ce2$export$2e2bcd8739ae039.isGetUserMediaAvailable()) navigator.mediaDevices.getUserMedia(config).then(function(stream) {
                navigator.mediaDevices.enumerateDevices().then(function(devices) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.debug(devices);
                    callback(devices);
                    // Get rid of the now useless stream
                    $daf510f834517ce2$export$2e2bcd8739ae039.stopAllTracks(stream);
                });
            }).catch(function(err) {
                $daf510f834517ce2$export$2e2bcd8739ae039.error(err);
                callback([]);
            });
            else {
                $daf510f834517ce2$export$2e2bcd8739ae039.warn("navigator.mediaDevices unavailable");
                callback([]);
            }
        };
        // Helper methods to attach/reattach a stream to a video element (previously part of adapter.js)
        $daf510f834517ce2$export$2e2bcd8739ae039.attachMediaStream = function(element, stream) {
            try {
                element.srcObject = stream;
            } catch (e) {
                try {
                    element.src = URL.createObjectURL(stream);
                } catch (e) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.error("Error attaching stream to element", e);
                }
            }
        };
        $daf510f834517ce2$export$2e2bcd8739ae039.reattachMediaStream = function(to, from) {
            try {
                to.srcObject = from.srcObject;
            } catch (e) {
                try {
                    to.src = from.src;
                } catch (e) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.error("Error reattaching stream to element", e);
                }
            }
        };
        // Detect tab close: make sure we don't loose existing onbeforeunload handlers
        // (note: for iOS we need to subscribe to a different event, 'pagehide', see
        // https://gist.github.com/thehunmonkgroup/6bee8941a49b86be31a787fe8f4b8cfe)
        let iOS = [
            'iPad',
            'iPhone',
            'iPod'
        ].indexOf(navigator.platform) >= 0;
        let eventName = iOS ? 'pagehide' : 'beforeunload';
        let oldOBF = window["on" + eventName];
        window.addEventListener(eventName, function() {
            $daf510f834517ce2$export$2e2bcd8739ae039.log("Closing window");
            for (const [sessionId, session] of $daf510f834517ce2$export$2e2bcd8739ae039.sessions)if (session && session.destroyOnUnload) {
                $daf510f834517ce2$export$2e2bcd8739ae039.log("Destroying session " + sessionId);
                session.destroy({
                    unload: true,
                    notifyDestroyed: false
                });
            }
            if (oldOBF && typeof oldOBF == "function") oldOBF();
        });
        // If this is a Safari, check if VP8 or VP9 are supported
        $daf510f834517ce2$export$2e2bcd8739ae039.safariVp8 = false;
        $daf510f834517ce2$export$2e2bcd8739ae039.safariVp9 = false;
        if ($daf510f834517ce2$export$2e2bcd8739ae039.webRTCAdapter.browserDetails.browser === 'safari' && $daf510f834517ce2$export$2e2bcd8739ae039.webRTCAdapter.browserDetails.version >= 605) {
            // Let's see if RTCRtpSender.getCapabilities() is there
            if (RTCRtpSender && RTCRtpSender.getCapabilities && RTCRtpSender.getCapabilities("video") && RTCRtpSender.getCapabilities("video").codecs && RTCRtpSender.getCapabilities("video").codecs.length) {
                for (let codec of RTCRtpSender.getCapabilities("video").codecs){
                    if (codec && codec.mimeType && codec.mimeType.toLowerCase() === "video/vp8") $daf510f834517ce2$export$2e2bcd8739ae039.safariVp8 = true;
                    else if (codec && codec.mimeType && codec.mimeType.toLowerCase() === "video/vp9") $daf510f834517ce2$export$2e2bcd8739ae039.safariVp9 = true;
                }
                if ($daf510f834517ce2$export$2e2bcd8739ae039.safariVp8) $daf510f834517ce2$export$2e2bcd8739ae039.log("This version of Safari supports VP8");
                else $daf510f834517ce2$export$2e2bcd8739ae039.warn("This version of Safari does NOT support VP8: if you're using a Technology Preview, try enabling the 'WebRTC VP8 codec' setting in the 'Experimental Features' Develop menu");
            } else {
                // We do it in a very ugly way, as there's no alternative...
                // We create a PeerConnection to see if VP8 is in an offer
                let testpc = new RTCPeerConnection({});
                testpc.createOffer({
                    offerToReceiveVideo: true
                }).then(function(offer) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.safariVp8 = offer.sdp.indexOf("VP8") !== -1;
                    $daf510f834517ce2$export$2e2bcd8739ae039.safariVp9 = offer.sdp.indexOf("VP9") !== -1;
                    if ($daf510f834517ce2$export$2e2bcd8739ae039.safariVp8) $daf510f834517ce2$export$2e2bcd8739ae039.log("This version of Safari supports VP8");
                    else $daf510f834517ce2$export$2e2bcd8739ae039.warn("This version of Safari does NOT support VP8: if you're using a Technology Preview, try enabling the 'WebRTC VP8 codec' setting in the 'Experimental Features' Develop menu");
                    testpc.close();
                    testpc = null;
                });
            }
        }
        $daf510f834517ce2$export$2e2bcd8739ae039.initDone = true;
        options.callback();
    }
};
// Helper method to check whether WebRTC is supported by this browser
$daf510f834517ce2$export$2e2bcd8739ae039.isWebrtcSupported = function() {
    return !!window.RTCPeerConnection;
};
// Helper method to check whether devices can be accessed by this browser (e.g., not possible via plain HTTP)
$daf510f834517ce2$export$2e2bcd8739ae039.isGetUserMediaAvailable = function() {
    return navigator.mediaDevices && navigator.mediaDevices.getUserMedia;
};
// Helper method to create random identifiers (e.g., transaction)
$daf510f834517ce2$export$2e2bcd8739ae039.randomString = function(len) {
    let charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let randomString = '';
    for(let i = 0; i < len; i++){
        let randomPoz = Math.floor(Math.random() * charSet.length);
        randomString += charSet.charAt(randomPoz);
    }
    return randomString;
};
function $daf510f834517ce2$export$2e2bcd8739ae039(gatewayCallbacks) {
    gatewayCallbacks = gatewayCallbacks || {};
    gatewayCallbacks.success = typeof gatewayCallbacks.success == "function" ? gatewayCallbacks.success : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
    gatewayCallbacks.error = typeof gatewayCallbacks.error == "function" ? gatewayCallbacks.error : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
    gatewayCallbacks.destroyed = typeof gatewayCallbacks.destroyed == "function" ? gatewayCallbacks.destroyed : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
    if (!$daf510f834517ce2$export$2e2bcd8739ae039.initDone) {
        gatewayCallbacks.error("Library not initialized");
        return {};
    }
    if (!$daf510f834517ce2$export$2e2bcd8739ae039.isWebrtcSupported()) {
        gatewayCallbacks.error("WebRTC not supported by this browser");
        return {};
    }
    $daf510f834517ce2$export$2e2bcd8739ae039.log("Library initialized: " + $daf510f834517ce2$export$2e2bcd8739ae039.initDone);
    if (!gatewayCallbacks.server) {
        gatewayCallbacks.error("Invalid server url");
        return {};
    }
    let websockets = false;
    let ws = null;
    let wsHandlers = {};
    let wsKeepaliveTimeoutId = null;
    let servers = null;
    let serversIndex = 0;
    let server = gatewayCallbacks.server;
    if ($daf510f834517ce2$export$2e2bcd8739ae039.isArray(server)) {
        $daf510f834517ce2$export$2e2bcd8739ae039.log("Multiple servers provided (" + server.length + "), will use the first that works");
        server = null;
        servers = gatewayCallbacks.server;
        $daf510f834517ce2$export$2e2bcd8739ae039.debug(servers);
    } else if (server.indexOf("ws") === 0) {
        websockets = true;
        $daf510f834517ce2$export$2e2bcd8739ae039.log("Using WebSockets to contact Janus: " + server);
    } else {
        websockets = false;
        $daf510f834517ce2$export$2e2bcd8739ae039.log("Using REST API to contact Janus: " + server);
    }
    let iceServers = gatewayCallbacks.iceServers || [
        {
            urls: "stun:stun.l.google.com:19302"
        }
    ];
    let iceTransportPolicy = gatewayCallbacks.iceTransportPolicy;
    let bundlePolicy = gatewayCallbacks.bundlePolicy;
    // Whether we should enable the withCredentials flag for XHR requests
    let withCredentials = false;
    if (typeof gatewayCallbacks.withCredentials !== 'undefined' && gatewayCallbacks.withCredentials !== null) withCredentials = gatewayCallbacks.withCredentials === true;
    // Optional max events
    let maxev = 10;
    if (typeof gatewayCallbacks.max_poll_events !== 'undefined' && gatewayCallbacks.max_poll_events !== null) maxev = gatewayCallbacks.max_poll_events;
    if (maxev < 1) maxev = 1;
    // Token to use (only if the token based authentication mechanism is enabled)
    let token = null;
    if (typeof gatewayCallbacks.token !== 'undefined' && gatewayCallbacks.token !== null) token = gatewayCallbacks.token;
    // API secret to use (only if the shared API secret is enabled)
    let apisecret = null;
    if (typeof gatewayCallbacks.apisecret !== 'undefined' && gatewayCallbacks.apisecret !== null) apisecret = gatewayCallbacks.apisecret;
    // Whether we should destroy this session when onbeforeunload is called
    this.destroyOnUnload = true;
    if (typeof gatewayCallbacks.destroyOnUnload !== 'undefined' && gatewayCallbacks.destroyOnUnload !== null) this.destroyOnUnload = gatewayCallbacks.destroyOnUnload === true;
    // Some timeout-related values
    let keepAlivePeriod = 25000;
    if (typeof gatewayCallbacks.keepAlivePeriod !== 'undefined' && gatewayCallbacks.keepAlivePeriod !== null) keepAlivePeriod = gatewayCallbacks.keepAlivePeriod;
    if (isNaN(keepAlivePeriod)) keepAlivePeriod = 25000;
    let longPollTimeout = 60000;
    if (typeof gatewayCallbacks.longPollTimeout !== 'undefined' && gatewayCallbacks.longPollTimeout !== null) longPollTimeout = gatewayCallbacks.longPollTimeout;
    if (isNaN(longPollTimeout)) longPollTimeout = 60000;
    // overrides for default maxBitrate values for simulcasting
    function getMaxBitrates(simulcastMaxBitrates) {
        let maxBitrates = {
            high: 900000,
            medium: 300000,
            low: 100000
        };
        if (typeof simulcastMaxBitrates !== 'undefined' && simulcastMaxBitrates !== null) {
            if (simulcastMaxBitrates.high) maxBitrates.high = simulcastMaxBitrates.high;
            if (simulcastMaxBitrates.medium) maxBitrates.medium = simulcastMaxBitrates.medium;
            if (simulcastMaxBitrates.low) maxBitrates.low = simulcastMaxBitrates.low;
        }
        return maxBitrates;
    }
    let connected = false;
    let sessionId = null;
    let pluginHandles = new Map();
    let that = this;
    let retries = 0;
    let transactions = new Map();
    createSession(gatewayCallbacks);
    // Public methods
    this.getServer = function() {
        return server;
    };
    this.isConnected = function() {
        return connected;
    };
    this.reconnect = function(callbacks) {
        callbacks = callbacks || {};
        callbacks.success = typeof callbacks.success == "function" ? callbacks.success : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        callbacks.error = typeof callbacks.error == "function" ? callbacks.error : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        callbacks["reconnect"] = true;
        createSession(callbacks);
    };
    this.getSessionId = function() {
        return sessionId;
    };
    this.getInfo = function(callbacks) {
        getInfo(callbacks);
    };
    this.destroy = function(callbacks) {
        destroySession(callbacks);
    };
    this.attach = function(callbacks) {
        createHandle(callbacks);
    };
    function eventHandler() {
        if (sessionId == null) return;
        $daf510f834517ce2$export$2e2bcd8739ae039.debug('Long poll...');
        if (!connected) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Is the server down? (connected=false)");
            return;
        }
        let longpoll = server + "/" + sessionId + "?rid=" + new Date().getTime();
        if (maxev) longpoll = longpoll + "&maxev=" + maxev;
        if (token) longpoll = longpoll + "&token=" + encodeURIComponent(token);
        if (apisecret) longpoll = longpoll + "&apisecret=" + encodeURIComponent(apisecret);
        $daf510f834517ce2$export$2e2bcd8739ae039.httpAPICall(longpoll, {
            verb: 'GET',
            withCredentials: withCredentials,
            success: handleEvent,
            timeout: longPollTimeout,
            error: function(textStatus, errorThrown) {
                $daf510f834517ce2$export$2e2bcd8739ae039.error(textStatus + ":", errorThrown);
                retries++;
                if (retries > 3) {
                    // Did we just lose the server? :-(
                    connected = false;
                    gatewayCallbacks.error("Lost connection to the server (is it down?)");
                    return;
                }
                eventHandler();
            }
        });
    }
    // Private event handler: this will trigger plugin callbacks, if set
    function handleEvent(json, skipTimeout) {
        retries = 0;
        if (!websockets && typeof sessionId !== 'undefined' && sessionId !== null && skipTimeout !== true) eventHandler();
        if (!websockets && $daf510f834517ce2$export$2e2bcd8739ae039.isArray(json)) {
            // We got an array: it means we passed a maxev > 1, iterate on all objects
            for(let i = 0; i < json.length; i++)handleEvent(json[i], true);
            return;
        }
        if (json["janus"] === "keepalive") {
            // Nothing happened
            $daf510f834517ce2$export$2e2bcd8739ae039.vdebug("Got a keepalive on session " + sessionId);
            return;
        } else if (json["janus"] === "server_info") {
            // Just info on the Janus instance
            $daf510f834517ce2$export$2e2bcd8739ae039.debug("Got info on the Janus instance");
            $daf510f834517ce2$export$2e2bcd8739ae039.debug(json);
            const transaction = json["transaction"];
            if (transaction) {
                const reportSuccess = transactions.get(transaction);
                if (reportSuccess) reportSuccess(json);
                transactions.delete(transaction);
            }
            return;
        } else if (json["janus"] === "ack") {
            // Just an ack, we can probably ignore
            $daf510f834517ce2$export$2e2bcd8739ae039.debug("Got an ack on session " + sessionId);
            $daf510f834517ce2$export$2e2bcd8739ae039.debug(json);
            const transaction = json["transaction"];
            if (transaction) {
                const reportSuccess = transactions.get(transaction);
                if (reportSuccess) reportSuccess(json);
                transactions.delete(transaction);
            }
            return;
        } else if (json["janus"] === "success") {
            // Success!
            $daf510f834517ce2$export$2e2bcd8739ae039.debug("Got a success on session " + sessionId);
            $daf510f834517ce2$export$2e2bcd8739ae039.debug(json);
            const transaction = json["transaction"];
            if (transaction) {
                const reportSuccess = transactions.get(transaction);
                if (reportSuccess) reportSuccess(json);
                transactions.delete(transaction);
            }
            return;
        } else if (json["janus"] === "trickle") {
            // We got a trickle candidate from Janus
            const sender = json["sender"];
            if (!sender) {
                $daf510f834517ce2$export$2e2bcd8739ae039.warn("Missing sender...");
                return;
            }
            const pluginHandle = pluginHandles.get(sender);
            if (!pluginHandle) {
                $daf510f834517ce2$export$2e2bcd8739ae039.debug("This handle is not attached to this session");
                return;
            }
            let candidate = json["candidate"];
            $daf510f834517ce2$export$2e2bcd8739ae039.debug("Got a trickled candidate on session " + sessionId);
            $daf510f834517ce2$export$2e2bcd8739ae039.debug(candidate);
            let config = pluginHandle.webrtcStuff;
            if (config.pc && config.remoteSdp) {
                // Add candidate right now
                $daf510f834517ce2$export$2e2bcd8739ae039.debug("Adding remote candidate:", candidate);
                if (!candidate || candidate.completed === true) // end-of-candidates
                config.pc.addIceCandidate($daf510f834517ce2$export$2e2bcd8739ae039.endOfCandidates);
                else // New candidate
                config.pc.addIceCandidate(candidate);
            } else {
                // We didn't do setRemoteDescription (trickle got here before the offer?)
                $daf510f834517ce2$export$2e2bcd8739ae039.debug("We didn't do setRemoteDescription (trickle got here before the offer?), caching candidate");
                if (!config.candidates) config.candidates = [];
                config.candidates.push(candidate);
                $daf510f834517ce2$export$2e2bcd8739ae039.debug(config.candidates);
            }
        } else if (json["janus"] === "webrtcup") {
            // The PeerConnection with the server is up! Notify this
            $daf510f834517ce2$export$2e2bcd8739ae039.debug("Got a webrtcup event on session " + sessionId);
            $daf510f834517ce2$export$2e2bcd8739ae039.debug(json);
            const sender = json["sender"];
            if (!sender) {
                $daf510f834517ce2$export$2e2bcd8739ae039.warn("Missing sender...");
                return;
            }
            const pluginHandle = pluginHandles.get(sender);
            if (!pluginHandle) {
                $daf510f834517ce2$export$2e2bcd8739ae039.debug("This handle is not attached to this session");
                return;
            }
            pluginHandle.webrtcState(true);
            return;
        } else if (json["janus"] === "hangup") {
            // A plugin asked the core to hangup a PeerConnection on one of our handles
            $daf510f834517ce2$export$2e2bcd8739ae039.debug("Got a hangup event on session " + sessionId);
            $daf510f834517ce2$export$2e2bcd8739ae039.debug(json);
            const sender = json["sender"];
            if (!sender) {
                $daf510f834517ce2$export$2e2bcd8739ae039.warn("Missing sender...");
                return;
            }
            const pluginHandle = pluginHandles.get(sender);
            if (!pluginHandle) {
                $daf510f834517ce2$export$2e2bcd8739ae039.debug("This handle is not attached to this session");
                return;
            }
            pluginHandle.webrtcState(false, json["reason"]);
            pluginHandle.hangup();
        } else if (json["janus"] === "detached") {
            // A plugin asked the core to detach one of our handles
            $daf510f834517ce2$export$2e2bcd8739ae039.debug("Got a detached event on session " + sessionId);
            $daf510f834517ce2$export$2e2bcd8739ae039.debug(json);
            const sender = json["sender"];
            if (!sender) {
                $daf510f834517ce2$export$2e2bcd8739ae039.warn("Missing sender...");
                return;
            }
            const pluginHandle = pluginHandles.get(sender);
            if (!pluginHandle) // Don't warn here because destroyHandle causes this situation.
            return;
            pluginHandle.ondetached();
            pluginHandle.detach();
        } else if (json["janus"] === "media") {
            // Media started/stopped flowing
            $daf510f834517ce2$export$2e2bcd8739ae039.debug("Got a media event on session " + sessionId);
            $daf510f834517ce2$export$2e2bcd8739ae039.debug(json);
            const sender = json["sender"];
            if (!sender) {
                $daf510f834517ce2$export$2e2bcd8739ae039.warn("Missing sender...");
                return;
            }
            const pluginHandle = pluginHandles.get(sender);
            if (!pluginHandle) {
                $daf510f834517ce2$export$2e2bcd8739ae039.debug("This handle is not attached to this session");
                return;
            }
            pluginHandle.mediaState(json["type"], json["receiving"], json["mid"]);
        } else if (json["janus"] === "slowlink") {
            $daf510f834517ce2$export$2e2bcd8739ae039.debug("Got a slowlink event on session " + sessionId);
            $daf510f834517ce2$export$2e2bcd8739ae039.debug(json);
            // Trouble uplink or downlink
            const sender = json["sender"];
            if (!sender) {
                $daf510f834517ce2$export$2e2bcd8739ae039.warn("Missing sender...");
                return;
            }
            const pluginHandle = pluginHandles.get(sender);
            if (!pluginHandle) {
                $daf510f834517ce2$export$2e2bcd8739ae039.debug("This handle is not attached to this session");
                return;
            }
            pluginHandle.slowLink(json["uplink"], json["lost"], json["mid"]);
        } else if (json["janus"] === "error") {
            // Oops, something wrong happened
            $daf510f834517ce2$export$2e2bcd8739ae039.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME
            $daf510f834517ce2$export$2e2bcd8739ae039.debug(json);
            let transaction = json["transaction"];
            if (transaction) {
                let reportSuccess = transactions.get(transaction);
                if (reportSuccess) reportSuccess(json);
                transactions.delete(transaction);
            }
            return;
        } else if (json["janus"] === "event") {
            $daf510f834517ce2$export$2e2bcd8739ae039.debug("Got a plugin event on session " + sessionId);
            $daf510f834517ce2$export$2e2bcd8739ae039.debug(json);
            const sender = json["sender"];
            if (!sender) {
                $daf510f834517ce2$export$2e2bcd8739ae039.warn("Missing sender...");
                return;
            }
            let plugindata = json["plugindata"];
            if (!plugindata) {
                $daf510f834517ce2$export$2e2bcd8739ae039.warn("Missing plugindata...");
                return;
            }
            $daf510f834517ce2$export$2e2bcd8739ae039.debug("  -- Event is coming from " + sender + " (" + plugindata["plugin"] + ")");
            let data = plugindata["data"];
            $daf510f834517ce2$export$2e2bcd8739ae039.debug(data);
            const pluginHandle = pluginHandles.get(sender);
            if (!pluginHandle) {
                $daf510f834517ce2$export$2e2bcd8739ae039.warn("This handle is not attached to this session");
                return;
            }
            let jsep = json["jsep"];
            if (jsep) {
                $daf510f834517ce2$export$2e2bcd8739ae039.debug("Handling SDP as well...");
                $daf510f834517ce2$export$2e2bcd8739ae039.debug(jsep);
            }
            let callback = pluginHandle.onmessage;
            if (callback) {
                $daf510f834517ce2$export$2e2bcd8739ae039.debug("Notifying application...");
                // Send to callback specified when attaching plugin handle
                callback(data, jsep);
            } else // Send to generic callback (?)
            $daf510f834517ce2$export$2e2bcd8739ae039.debug("No provided notification callback");
        } else if (json["janus"] === "timeout") {
            $daf510f834517ce2$export$2e2bcd8739ae039.error("Timeout on session " + sessionId);
            $daf510f834517ce2$export$2e2bcd8739ae039.debug(json);
            if (websockets) ws.close(3504, "Gateway timeout");
            return;
        } else {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Unknown message/event  '" + json["janus"] + "' on session " + sessionId);
            $daf510f834517ce2$export$2e2bcd8739ae039.debug(json);
        }
    }
    // Private helper to send keep-alive messages on WebSockets
    function keepAlive() {
        if (!server || !websockets || !connected) return;
        wsKeepaliveTimeoutId = setTimeout(keepAlive, keepAlivePeriod);
        let request = {
            "janus": "keepalive",
            "session_id": sessionId,
            "transaction": $daf510f834517ce2$export$2e2bcd8739ae039.randomString(12)
        };
        if (token) request["token"] = token;
        if (apisecret) request["apisecret"] = apisecret;
        ws.send(JSON.stringify(request));
    }
    // Private method to create a session
    function createSession(callbacks) {
        let transaction = $daf510f834517ce2$export$2e2bcd8739ae039.randomString(12);
        let request = {
            "janus": "create",
            "transaction": transaction
        };
        if (callbacks["reconnect"]) {
            // We're reconnecting, claim the session
            connected = false;
            request["janus"] = "claim";
            request["session_id"] = sessionId;
            // If we were using websockets, ignore the old connection
            if (ws) {
                ws.onopen = null;
                ws.onerror = null;
                ws.onclose = null;
                if (wsKeepaliveTimeoutId) {
                    clearTimeout(wsKeepaliveTimeoutId);
                    wsKeepaliveTimeoutId = null;
                }
            }
        }
        if (token) request["token"] = token;
        if (apisecret) request["apisecret"] = apisecret;
        if (!server && $daf510f834517ce2$export$2e2bcd8739ae039.isArray(servers)) {
            // We still need to find a working server from the list we were given
            server = servers[serversIndex];
            if (server.indexOf("ws") === 0) {
                websockets = true;
                $daf510f834517ce2$export$2e2bcd8739ae039.log("Server #" + (serversIndex + 1) + ": trying WebSockets to contact Janus (" + server + ")");
            } else {
                websockets = false;
                $daf510f834517ce2$export$2e2bcd8739ae039.log("Server #" + (serversIndex + 1) + ": trying REST API to contact Janus (" + server + ")");
            }
        }
        if (websockets) {
            ws = $daf510f834517ce2$export$2e2bcd8739ae039.newWebSocket(server, 'janus-protocol');
            wsHandlers = {
                'error': function() {
                    $daf510f834517ce2$export$2e2bcd8739ae039.error("Error connecting to the Janus WebSockets server... " + server);
                    if ($daf510f834517ce2$export$2e2bcd8739ae039.isArray(servers) && !callbacks["reconnect"]) {
                        serversIndex++;
                        if (serversIndex === servers.length) {
                            // We tried all the servers the user gave us and they all failed
                            callbacks.error("Error connecting to any of the provided Janus servers: Is the server down?");
                            return;
                        }
                        // Let's try the next server
                        server = null;
                        setTimeout(function() {
                            createSession(callbacks);
                        }, 200);
                        return;
                    }
                    callbacks.error("Error connecting to the Janus WebSockets server: Is the server down?");
                },
                'open': function() {
                    // We need to be notified about the success
                    transactions.set(transaction, function(json) {
                        $daf510f834517ce2$export$2e2bcd8739ae039.debug(json);
                        if (json["janus"] !== "success") {
                            $daf510f834517ce2$export$2e2bcd8739ae039.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME
                            callbacks.error(json["error"].reason);
                            return;
                        }
                        wsKeepaliveTimeoutId = setTimeout(keepAlive, keepAlivePeriod);
                        connected = true;
                        sessionId = json["session_id"] ? json["session_id"] : json.data["id"];
                        if (callbacks["reconnect"]) $daf510f834517ce2$export$2e2bcd8739ae039.log("Claimed session: " + sessionId);
                        else $daf510f834517ce2$export$2e2bcd8739ae039.log("Created session: " + sessionId);
                        $daf510f834517ce2$export$2e2bcd8739ae039.sessions.set(sessionId, that);
                        callbacks.success();
                    });
                    ws.send(JSON.stringify(request));
                },
                'message': function(event) {
                    handleEvent(JSON.parse(event.data));
                },
                'close': function() {
                    if (!server || !connected) return;
                    connected = false;
                    // FIXME What if this is called when the page is closed?
                    gatewayCallbacks.error("Lost connection to the server (is it down?)");
                }
            };
            for(let eventName in wsHandlers)ws.addEventListener(eventName, wsHandlers[eventName]);
            return;
        }
        $daf510f834517ce2$export$2e2bcd8739ae039.httpAPICall(server, {
            verb: 'POST',
            withCredentials: withCredentials,
            body: request,
            success: function(json) {
                $daf510f834517ce2$export$2e2bcd8739ae039.debug(json);
                if (json["janus"] !== "success") {
                    $daf510f834517ce2$export$2e2bcd8739ae039.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME
                    callbacks.error(json["error"].reason);
                    return;
                }
                connected = true;
                sessionId = json["session_id"] ? json["session_id"] : json.data["id"];
                if (callbacks["reconnect"]) $daf510f834517ce2$export$2e2bcd8739ae039.log("Claimed session: " + sessionId);
                else $daf510f834517ce2$export$2e2bcd8739ae039.log("Created session: " + sessionId);
                $daf510f834517ce2$export$2e2bcd8739ae039.sessions.set(sessionId, that);
                eventHandler();
                callbacks.success();
            },
            error: function(textStatus, errorThrown) {
                $daf510f834517ce2$export$2e2bcd8739ae039.error(textStatus + ":", errorThrown); // FIXME
                if ($daf510f834517ce2$export$2e2bcd8739ae039.isArray(servers) && !callbacks["reconnect"]) {
                    serversIndex++;
                    if (serversIndex === servers.length) {
                        // We tried all the servers the user gave us and they all failed
                        callbacks.error("Error connecting to any of the provided Janus servers: Is the server down?");
                        return;
                    }
                    // Let's try the next server
                    server = null;
                    setTimeout(function() {
                        createSession(callbacks);
                    }, 200);
                    return;
                }
                if (errorThrown === "") callbacks.error(textStatus + ": Is the server down?");
                else if (errorThrown && errorThrown.error) callbacks.error(textStatus + ": " + errorThrown.error.message);
                else callbacks.error(textStatus + ": " + errorThrown);
            }
        });
    }
    // Private method to get info on the server
    function getInfo(callbacks) {
        callbacks = callbacks || {};
        // FIXME This method triggers a success even when we fail
        callbacks.success = typeof callbacks.success == "function" ? callbacks.success : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        callbacks.error = typeof callbacks.error == "function" ? callbacks.error : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        $daf510f834517ce2$export$2e2bcd8739ae039.log("Getting info on Janus instance");
        if (!connected) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Is the server down? (connected=false)");
            callbacks.error("Is the server down? (connected=false)");
            return;
        }
        // We just need to send an "info" request
        let transaction = $daf510f834517ce2$export$2e2bcd8739ae039.randomString(12);
        let request = {
            "janus": "info",
            "transaction": transaction
        };
        if (token) request["token"] = token;
        if (apisecret) request["apisecret"] = apisecret;
        if (websockets) {
            transactions.set(transaction, function(json) {
                $daf510f834517ce2$export$2e2bcd8739ae039.log("Server info:");
                $daf510f834517ce2$export$2e2bcd8739ae039.debug(json);
                if (json["janus"] !== "server_info") $daf510f834517ce2$export$2e2bcd8739ae039.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME
                callbacks.success(json);
            });
            ws.send(JSON.stringify(request));
            return;
        }
        $daf510f834517ce2$export$2e2bcd8739ae039.httpAPICall(server, {
            verb: 'POST',
            withCredentials: withCredentials,
            body: request,
            success: function(json) {
                $daf510f834517ce2$export$2e2bcd8739ae039.log("Server info:");
                $daf510f834517ce2$export$2e2bcd8739ae039.debug(json);
                if (json["janus"] !== "server_info") $daf510f834517ce2$export$2e2bcd8739ae039.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME
                callbacks.success(json);
            },
            error: function(textStatus, errorThrown) {
                $daf510f834517ce2$export$2e2bcd8739ae039.error(textStatus + ":", errorThrown); // FIXME
                if (errorThrown === "") callbacks.error(textStatus + ": Is the server down?");
                else callbacks.error(textStatus + ": " + errorThrown);
            }
        });
    }
    // Private method to destroy a session
    function destroySession(callbacks) {
        callbacks = callbacks || {};
        // FIXME This method triggers a success even when we fail
        callbacks.success = typeof callbacks.success == "function" ? callbacks.success : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        callbacks.error = typeof callbacks.error == "function" ? callbacks.error : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        let unload = callbacks.unload === true;
        let notifyDestroyed = true;
        if (typeof callbacks.notifyDestroyed !== 'undefined' && callbacks.notifyDestroyed !== null) notifyDestroyed = callbacks.notifyDestroyed === true;
        let cleanupHandles = callbacks.cleanupHandles === true;
        $daf510f834517ce2$export$2e2bcd8739ae039.log("Destroying session " + sessionId + " (unload=" + unload + ")");
        if (!sessionId) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("No session to destroy");
            callbacks.success();
            if (notifyDestroyed) gatewayCallbacks.destroyed();
            return;
        }
        if (cleanupHandles) for (const handleId of pluginHandles.keys())destroyHandle(handleId, {
            noRequest: true
        });
        if (!connected) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Is the server down? (connected=false)");
            sessionId = null;
            callbacks.success();
            return;
        }
        // No need to destroy all handles first, Janus will do that itself
        let request = {
            "janus": "destroy",
            "transaction": $daf510f834517ce2$export$2e2bcd8739ae039.randomString(12)
        };
        if (token) request["token"] = token;
        if (apisecret) request["apisecret"] = apisecret;
        if (unload) {
            // We're unloading the page: use sendBeacon for HTTP instead,
            // or just close the WebSocket connection if we're using that
            if (websockets) {
                ws.onclose = null;
                ws.close();
                ws = null;
            } else navigator.sendBeacon(server + "/" + sessionId, JSON.stringify(request));
            $daf510f834517ce2$export$2e2bcd8739ae039.log("Destroyed session:");
            sessionId = null;
            connected = false;
            callbacks.success();
            if (notifyDestroyed) gatewayCallbacks.destroyed();
            return;
        }
        if (websockets) {
            request["session_id"] = sessionId;
            let unbindWebSocket = function() {
                for(let eventName in wsHandlers)ws.removeEventListener(eventName, wsHandlers[eventName]);
                ws.removeEventListener('message', onUnbindMessage);
                ws.removeEventListener('error', onUnbindError);
                if (wsKeepaliveTimeoutId) clearTimeout(wsKeepaliveTimeoutId);
                ws.close();
            };
            let onUnbindMessage = function(event) {
                let data = JSON.parse(event.data);
                if (data.session_id == request.session_id && data.transaction == request.transaction) {
                    unbindWebSocket();
                    callbacks.success();
                    if (notifyDestroyed) gatewayCallbacks.destroyed();
                }
            };
            let onUnbindError = function() {
                unbindWebSocket();
                callbacks.error("Failed to destroy the server: Is the server down?");
                if (notifyDestroyed) gatewayCallbacks.destroyed();
            };
            ws.addEventListener('message', onUnbindMessage);
            ws.addEventListener('error', onUnbindError);
            if (ws.readyState === 1) ws.send(JSON.stringify(request));
            else onUnbindError();
            return;
        }
        $daf510f834517ce2$export$2e2bcd8739ae039.httpAPICall(server + "/" + sessionId, {
            verb: 'POST',
            withCredentials: withCredentials,
            body: request,
            success: function(json) {
                $daf510f834517ce2$export$2e2bcd8739ae039.log("Destroyed session:");
                $daf510f834517ce2$export$2e2bcd8739ae039.debug(json);
                sessionId = null;
                connected = false;
                if (json["janus"] !== "success") $daf510f834517ce2$export$2e2bcd8739ae039.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME
                callbacks.success();
                if (notifyDestroyed) gatewayCallbacks.destroyed();
            },
            error: function(textStatus, errorThrown) {
                $daf510f834517ce2$export$2e2bcd8739ae039.error(textStatus + ":", errorThrown); // FIXME
                // Reset everything anyway
                sessionId = null;
                connected = false;
                callbacks.success();
                if (notifyDestroyed) gatewayCallbacks.destroyed();
            }
        });
    }
    // Private method to create a plugin handle
    function createHandle(callbacks) {
        callbacks = callbacks || {};
        callbacks.success = typeof callbacks.success == "function" ? callbacks.success : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        callbacks.error = typeof callbacks.error == "function" ? callbacks.error : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        callbacks.dataChannelOptions = callbacks.dataChannelOptions || {
            ordered: true
        };
        callbacks.consentDialog = typeof callbacks.consentDialog == "function" ? callbacks.consentDialog : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        callbacks.iceState = typeof callbacks.iceState == "function" ? callbacks.iceState : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        callbacks.mediaState = typeof callbacks.mediaState == "function" ? callbacks.mediaState : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        callbacks.webrtcState = typeof callbacks.webrtcState == "function" ? callbacks.webrtcState : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        callbacks.slowLink = typeof callbacks.slowLink == "function" ? callbacks.slowLink : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        callbacks.onmessage = typeof callbacks.onmessage == "function" ? callbacks.onmessage : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        callbacks.onlocaltrack = typeof callbacks.onlocaltrack == "function" ? callbacks.onlocaltrack : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        callbacks.onremotetrack = typeof callbacks.onremotetrack == "function" ? callbacks.onremotetrack : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        callbacks.ondata = typeof callbacks.ondata == "function" ? callbacks.ondata : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        callbacks.ondataopen = typeof callbacks.ondataopen == "function" ? callbacks.ondataopen : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        callbacks.oncleanup = typeof callbacks.oncleanup == "function" ? callbacks.oncleanup : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        callbacks.ondetached = typeof callbacks.ondetached == "function" ? callbacks.ondetached : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        if (!connected) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Is the server down? (connected=false)");
            callbacks.error("Is the server down? (connected=false)");
            return;
        }
        let plugin = callbacks.plugin;
        if (!plugin) {
            $daf510f834517ce2$export$2e2bcd8739ae039.error("Invalid plugin");
            callbacks.error("Invalid plugin");
            return;
        }
        let opaqueId = callbacks.opaqueId;
        let loopIndex = callbacks.loopIndex;
        let handleToken = callbacks.token ? callbacks.token : token;
        let transaction = $daf510f834517ce2$export$2e2bcd8739ae039.randomString(12);
        let request = {
            "janus": "attach",
            "plugin": plugin,
            "opaque_id": opaqueId,
            "loop_index": loopIndex,
            "transaction": transaction
        };
        if (handleToken) request["token"] = handleToken;
        if (apisecret) request["apisecret"] = apisecret;
        if (websockets) {
            transactions.set(transaction, function(json) {
                $daf510f834517ce2$export$2e2bcd8739ae039.debug(json);
                if (json["janus"] !== "success") {
                    $daf510f834517ce2$export$2e2bcd8739ae039.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME
                    callbacks.error("Ooops: " + json["error"].code + " " + json["error"].reason);
                    return;
                }
                let handleId = json.data["id"];
                $daf510f834517ce2$export$2e2bcd8739ae039.log("Created handle: " + handleId);
                let pluginHandle = {
                    session: that,
                    plugin: plugin,
                    id: handleId,
                    token: handleToken,
                    detached: false,
                    webrtcStuff: {
                        started: false,
                        myStream: null,
                        streamExternal: false,
                        mySdp: null,
                        mediaConstraints: null,
                        pc: null,
                        dataChannelOptions: callbacks.dataChannelOptions,
                        dataChannel: {},
                        dtmfSender: null,
                        trickle: true,
                        iceDone: false,
                        bitrate: {}
                    },
                    getId: function() {
                        return handleId;
                    },
                    getPlugin: function() {
                        return plugin;
                    },
                    getVolume: function(mid, result) {
                        return getVolume(handleId, mid, true, result);
                    },
                    getRemoteVolume: function(mid, result) {
                        return getVolume(handleId, mid, true, result);
                    },
                    getLocalVolume: function(mid, result) {
                        return getVolume(handleId, mid, false, result);
                    },
                    isAudioMuted: function(mid) {
                        return isMuted(handleId, mid, false);
                    },
                    muteAudio: function(mid) {
                        return mute(handleId, mid, false, true);
                    },
                    unmuteAudio: function(mid) {
                        return mute(handleId, mid, false, false);
                    },
                    isVideoMuted: function(mid) {
                        return isMuted(handleId, mid, true);
                    },
                    muteVideo: function(mid) {
                        return mute(handleId, mid, true, true);
                    },
                    unmuteVideo: function(mid) {
                        return mute(handleId, mid, true, false);
                    },
                    getBitrate: function(mid) {
                        return getBitrate(handleId, mid);
                    },
                    setMaxBitrate: function(mid, bitrate) {
                        return setBitrate(handleId, mid, bitrate);
                    },
                    send: function(callbacks) {
                        sendMessage(handleId, callbacks);
                    },
                    data: function(callbacks) {
                        sendData(handleId, callbacks);
                    },
                    dtmf: function(callbacks) {
                        sendDtmf(handleId, callbacks);
                    },
                    consentDialog: callbacks.consentDialog,
                    iceState: callbacks.iceState,
                    mediaState: callbacks.mediaState,
                    webrtcState: callbacks.webrtcState,
                    slowLink: callbacks.slowLink,
                    onmessage: callbacks.onmessage,
                    createOffer: function(callbacks) {
                        prepareWebrtc(handleId, true, callbacks);
                    },
                    createAnswer: function(callbacks) {
                        prepareWebrtc(handleId, false, callbacks);
                    },
                    handleRemoteJsep: function(callbacks) {
                        prepareWebrtcPeer(handleId, callbacks);
                    },
                    replaceTracks: function(callbacks) {
                        replaceTracks(handleId, callbacks);
                    },
                    getLocalTracks: function() {
                        return getLocalTracks(handleId);
                    },
                    getRemoteTracks: function() {
                        return getRemoteTracks(handleId);
                    },
                    onlocaltrack: callbacks.onlocaltrack,
                    onremotetrack: callbacks.onremotetrack,
                    ondata: callbacks.ondata,
                    ondataopen: callbacks.ondataopen,
                    oncleanup: callbacks.oncleanup,
                    ondetached: callbacks.ondetached,
                    hangup: function(sendRequest) {
                        cleanupWebrtc(handleId, sendRequest === true);
                    },
                    detach: function(callbacks) {
                        destroyHandle(handleId, callbacks);
                    }
                };
                pluginHandles.set(handleId, pluginHandle);
                callbacks.success(pluginHandle);
            });
            request["session_id"] = sessionId;
            ws.send(JSON.stringify(request));
            return;
        }
        $daf510f834517ce2$export$2e2bcd8739ae039.httpAPICall(server + "/" + sessionId, {
            verb: 'POST',
            withCredentials: withCredentials,
            body: request,
            success: function(json) {
                $daf510f834517ce2$export$2e2bcd8739ae039.debug(json);
                if (json["janus"] !== "success") {
                    $daf510f834517ce2$export$2e2bcd8739ae039.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME
                    callbacks.error("Ooops: " + json["error"].code + " " + json["error"].reason);
                    return;
                }
                let handleId = json.data["id"];
                $daf510f834517ce2$export$2e2bcd8739ae039.log("Created handle: " + handleId);
                let pluginHandle = {
                    session: that,
                    plugin: plugin,
                    id: handleId,
                    token: handleToken,
                    detached: false,
                    webrtcStuff: {
                        started: false,
                        myStream: null,
                        streamExternal: false,
                        mySdp: null,
                        mediaConstraints: null,
                        pc: null,
                        dataChannelOptions: callbacks.dataChannelOptions,
                        dataChannel: {},
                        dtmfSender: null,
                        trickle: true,
                        iceDone: false,
                        bitrate: {}
                    },
                    getId: function() {
                        return handleId;
                    },
                    getPlugin: function() {
                        return plugin;
                    },
                    getVolume: function(mid, result) {
                        return getVolume(handleId, mid, true, result);
                    },
                    getRemoteVolume: function(mid, result) {
                        return getVolume(handleId, mid, true, result);
                    },
                    getLocalVolume: function(mid, result) {
                        return getVolume(handleId, mid, false, result);
                    },
                    isAudioMuted: function(mid) {
                        return isMuted(handleId, mid, false);
                    },
                    muteAudio: function(mid) {
                        return mute(handleId, mid, false, true);
                    },
                    unmuteAudio: function(mid) {
                        return mute(handleId, mid, false, false);
                    },
                    isVideoMuted: function(mid) {
                        return isMuted(handleId, mid, true);
                    },
                    muteVideo: function(mid) {
                        return mute(handleId, mid, true, true);
                    },
                    unmuteVideo: function(mid) {
                        return mute(handleId, mid, true, false);
                    },
                    getBitrate: function(mid) {
                        return getBitrate(handleId, mid);
                    },
                    setMaxBitrate: function(mid, bitrate) {
                        return setBitrate(handleId, mid, bitrate);
                    },
                    send: function(callbacks) {
                        sendMessage(handleId, callbacks);
                    },
                    data: function(callbacks) {
                        sendData(handleId, callbacks);
                    },
                    dtmf: function(callbacks) {
                        sendDtmf(handleId, callbacks);
                    },
                    consentDialog: callbacks.consentDialog,
                    iceState: callbacks.iceState,
                    mediaState: callbacks.mediaState,
                    webrtcState: callbacks.webrtcState,
                    slowLink: callbacks.slowLink,
                    onmessage: callbacks.onmessage,
                    createOffer: function(callbacks) {
                        prepareWebrtc(handleId, true, callbacks);
                    },
                    createAnswer: function(callbacks) {
                        prepareWebrtc(handleId, false, callbacks);
                    },
                    handleRemoteJsep: function(callbacks) {
                        prepareWebrtcPeer(handleId, callbacks);
                    },
                    replaceTracks: function(callbacks) {
                        replaceTracks(handleId, callbacks);
                    },
                    getLocalTracks: function() {
                        return getLocalTracks(handleId);
                    },
                    getRemoteTracks: function() {
                        return getRemoteTracks(handleId);
                    },
                    onlocaltrack: callbacks.onlocaltrack,
                    onremotetrack: callbacks.onremotetrack,
                    ondata: callbacks.ondata,
                    ondataopen: callbacks.ondataopen,
                    oncleanup: callbacks.oncleanup,
                    ondetached: callbacks.ondetached,
                    hangup: function(sendRequest) {
                        cleanupWebrtc(handleId, sendRequest === true);
                    },
                    detach: function(callbacks) {
                        destroyHandle(handleId, callbacks);
                    }
                };
                pluginHandles.set(handleId, pluginHandle);
                callbacks.success(pluginHandle);
            },
            error: function(textStatus, errorThrown) {
                $daf510f834517ce2$export$2e2bcd8739ae039.error(textStatus + ":", errorThrown); // FIXME
                if (errorThrown === "") callbacks.error(textStatus + ": Is the server down?");
                else callbacks.error(textStatus + ": " + errorThrown);
            }
        });
    }
    // Private method to send a message
    function sendMessage(handleId, callbacks) {
        callbacks = callbacks || {};
        callbacks.success = typeof callbacks.success == "function" ? callbacks.success : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        callbacks.error = typeof callbacks.error == "function" ? callbacks.error : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        if (!connected) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Is the server down? (connected=false)");
            callbacks.error("Is the server down? (connected=false)");
            return;
        }
        let pluginHandle = pluginHandles.get(handleId);
        if (!pluginHandle || !pluginHandle.webrtcStuff) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Invalid handle");
            callbacks.error("Invalid handle");
            return;
        }
        let message = callbacks.message;
        let jsep = callbacks.jsep;
        let transaction = $daf510f834517ce2$export$2e2bcd8739ae039.randomString(12);
        let request = {
            "janus": "message",
            "body": message,
            "transaction": transaction
        };
        if (pluginHandle.token) request["token"] = pluginHandle.token;
        if (apisecret) request["apisecret"] = apisecret;
        if (jsep) {
            request.jsep = {
                type: jsep.type,
                sdp: jsep.sdp
            };
            if (jsep.e2ee) request.jsep.e2ee = true;
            if (jsep.rid_order === "hml" || jsep.rid_order === "lmh") request.jsep.rid_order = jsep.rid_order;
            if (jsep.force_relay) request.jsep.force_relay = true;
            // Check if there's SVC video streams to tell Janus about
            let svc = null;
            let config = pluginHandle.webrtcStuff;
            if (config.pc) {
                let transceivers = config.pc.getTransceivers();
                if (transceivers && transceivers.length > 0) for(let mindex in transceivers){
                    let tr = transceivers[mindex];
                    if (tr && tr.sender && tr.sender.track && tr.sender.track.kind === 'video') {
                        let params = tr.sender.getParameters();
                        if (params && params.encodings && params.encodings[0] && params.encodings[0].scalabilityMode) {
                            // This video stream uses SVC
                            if (!svc) svc = [];
                            svc.push({
                                mindex: parseInt(mindex),
                                mid: tr.mid,
                                svc: params.encodings[0].scalabilityMode
                            });
                        }
                    }
                }
            }
            if (svc) request.jsep.svc = svc;
        }
        $daf510f834517ce2$export$2e2bcd8739ae039.debug("Sending message to plugin (handle=" + handleId + "):");
        $daf510f834517ce2$export$2e2bcd8739ae039.debug(request);
        if (websockets) {
            request["session_id"] = sessionId;
            request["handle_id"] = handleId;
            transactions.set(transaction, function(json) {
                $daf510f834517ce2$export$2e2bcd8739ae039.debug("Message sent!");
                $daf510f834517ce2$export$2e2bcd8739ae039.debug(json);
                if (json["janus"] === "success") {
                    // We got a success, must have been a synchronous transaction
                    let plugindata = json["plugindata"];
                    if (!plugindata) {
                        $daf510f834517ce2$export$2e2bcd8739ae039.warn("Request succeeded, but missing plugindata...");
                        callbacks.success();
                        return;
                    }
                    $daf510f834517ce2$export$2e2bcd8739ae039.log("Synchronous transaction successful (" + plugindata["plugin"] + ")");
                    let data = plugindata["data"];
                    $daf510f834517ce2$export$2e2bcd8739ae039.debug(data);
                    callbacks.success(data);
                    return;
                } else if (json["janus"] !== "ack") {
                    // Not a success and not an ack, must be an error
                    if (json["error"]) {
                        $daf510f834517ce2$export$2e2bcd8739ae039.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME
                        callbacks.error(json["error"].code + " " + json["error"].reason);
                    } else {
                        $daf510f834517ce2$export$2e2bcd8739ae039.error("Unknown error"); // FIXME
                        callbacks.error("Unknown error");
                    }
                    return;
                }
                // If we got here, the plugin decided to handle the request asynchronously
                callbacks.success();
            });
            ws.send(JSON.stringify(request));
            return;
        }
        $daf510f834517ce2$export$2e2bcd8739ae039.httpAPICall(server + "/" + sessionId + "/" + handleId, {
            verb: 'POST',
            withCredentials: withCredentials,
            body: request,
            success: function(json) {
                $daf510f834517ce2$export$2e2bcd8739ae039.debug("Message sent!");
                $daf510f834517ce2$export$2e2bcd8739ae039.debug(json);
                if (json["janus"] === "success") {
                    // We got a success, must have been a synchronous transaction
                    let plugindata = json["plugindata"];
                    if (!plugindata) {
                        $daf510f834517ce2$export$2e2bcd8739ae039.warn("Request succeeded, but missing plugindata...");
                        callbacks.success();
                        return;
                    }
                    $daf510f834517ce2$export$2e2bcd8739ae039.log("Synchronous transaction successful (" + plugindata["plugin"] + ")");
                    let data = plugindata["data"];
                    $daf510f834517ce2$export$2e2bcd8739ae039.debug(data);
                    callbacks.success(data);
                    return;
                } else if (json["janus"] !== "ack") {
                    // Not a success and not an ack, must be an error
                    if (json["error"]) {
                        $daf510f834517ce2$export$2e2bcd8739ae039.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME
                        callbacks.error(json["error"].code + " " + json["error"].reason);
                    } else {
                        $daf510f834517ce2$export$2e2bcd8739ae039.error("Unknown error"); // FIXME
                        callbacks.error("Unknown error");
                    }
                    return;
                }
                // If we got here, the plugin decided to handle the request asynchronously
                callbacks.success();
            },
            error: function(textStatus, errorThrown) {
                $daf510f834517ce2$export$2e2bcd8739ae039.error(textStatus + ":", errorThrown); // FIXME
                callbacks.error(textStatus + ": " + errorThrown);
            }
        });
    }
    // Private method to send a trickle candidate
    function sendTrickleCandidate(handleId, candidate) {
        if (!connected) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Is the server down? (connected=false)");
            return;
        }
        let pluginHandle = pluginHandles.get(handleId);
        if (!pluginHandle || !pluginHandle.webrtcStuff) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Invalid handle");
            return;
        }
        let request = {
            "janus": "trickle",
            "candidate": candidate,
            "transaction": $daf510f834517ce2$export$2e2bcd8739ae039.randomString(12)
        };
        if (pluginHandle.token) request["token"] = pluginHandle.token;
        if (apisecret) request["apisecret"] = apisecret;
        $daf510f834517ce2$export$2e2bcd8739ae039.vdebug("Sending trickle candidate (handle=" + handleId + "):");
        $daf510f834517ce2$export$2e2bcd8739ae039.vdebug(request);
        if (websockets) {
            request["session_id"] = sessionId;
            request["handle_id"] = handleId;
            ws.send(JSON.stringify(request));
            return;
        }
        $daf510f834517ce2$export$2e2bcd8739ae039.httpAPICall(server + "/" + sessionId + "/" + handleId, {
            verb: 'POST',
            withCredentials: withCredentials,
            body: request,
            success: function(json) {
                $daf510f834517ce2$export$2e2bcd8739ae039.vdebug("Candidate sent!");
                $daf510f834517ce2$export$2e2bcd8739ae039.vdebug(json);
                if (json["janus"] !== "ack") {
                    $daf510f834517ce2$export$2e2bcd8739ae039.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME
                    return;
                }
            },
            error: function(textStatus, errorThrown) {
                $daf510f834517ce2$export$2e2bcd8739ae039.error(textStatus + ":", errorThrown); // FIXME
            }
        });
    }
    // Private method to create a data channel
    function createDataChannel(handleId, dclabel, dcprotocol, incoming, pendingData) {
        let pluginHandle = pluginHandles.get(handleId);
        if (!pluginHandle || !pluginHandle.webrtcStuff) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Invalid handle");
            return;
        }
        let config = pluginHandle.webrtcStuff;
        if (!config.pc) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Invalid PeerConnection");
            return;
        }
        let onDataChannelMessage = function(event) {
            $daf510f834517ce2$export$2e2bcd8739ae039.log('Received message on data channel:', event);
            let label = event.target.label;
            pluginHandle.ondata(event.data, label);
        };
        let onDataChannelStateChange = function(event) {
            $daf510f834517ce2$export$2e2bcd8739ae039.log('Received state change on data channel:', event);
            let label = event.target.label;
            let protocol = event.target.protocol;
            let dcState = config.dataChannel[label] ? config.dataChannel[label].readyState : "null";
            $daf510f834517ce2$export$2e2bcd8739ae039.log('State change on <' + label + '> data channel: ' + dcState);
            if (dcState === 'open') {
                // Any pending messages to send?
                if (config.dataChannel[label].pending && config.dataChannel[label].pending.length > 0) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.log("Sending pending messages on <" + label + ">:", config.dataChannel[label].pending.length);
                    for (let data of config.dataChannel[label].pending){
                        $daf510f834517ce2$export$2e2bcd8739ae039.log("Sending data on data channel <" + label + ">");
                        $daf510f834517ce2$export$2e2bcd8739ae039.debug(data);
                        config.dataChannel[label].send(data);
                    }
                    config.dataChannel[label].pending = [];
                }
                // Notify the open data channel
                pluginHandle.ondataopen(label, protocol);
            }
        };
        let onDataChannelError = function(error) {
            $daf510f834517ce2$export$2e2bcd8739ae039.error('Got error on data channel:', error);
        // TODO
        };
        if (!incoming) {
            // FIXME Add options (ordered, maxRetransmits, etc.)
            let dcoptions = config.dataChannelOptions;
            if (dcprotocol) dcoptions.protocol = dcprotocol;
            config.dataChannel[dclabel] = config.pc.createDataChannel(dclabel, dcoptions);
        } else // The channel was created by Janus
        config.dataChannel[dclabel] = incoming;
        config.dataChannel[dclabel].onmessage = onDataChannelMessage;
        config.dataChannel[dclabel].onopen = onDataChannelStateChange;
        config.dataChannel[dclabel].onclose = onDataChannelStateChange;
        config.dataChannel[dclabel].onerror = onDataChannelError;
        config.dataChannel[dclabel].pending = [];
        if (pendingData) config.dataChannel[dclabel].pending.push(pendingData);
    }
    // Private method to send a data channel message
    function sendData(handleId, callbacks) {
        callbacks = callbacks || {};
        callbacks.success = typeof callbacks.success == "function" ? callbacks.success : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        callbacks.error = typeof callbacks.error == "function" ? callbacks.error : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        let pluginHandle = pluginHandles.get(handleId);
        if (!pluginHandle || !pluginHandle.webrtcStuff) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Invalid handle");
            callbacks.error("Invalid handle");
            return;
        }
        let config = pluginHandle.webrtcStuff;
        let data = callbacks.text || callbacks.data;
        if (!data) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Invalid data");
            callbacks.error("Invalid data");
            return;
        }
        let label = callbacks.label ? callbacks.label : $daf510f834517ce2$export$2e2bcd8739ae039.dataChanDefaultLabel;
        if (!config.dataChannel[label]) {
            // Create new data channel and wait for it to open
            createDataChannel(handleId, label, callbacks.protocol, false, data, callbacks.protocol);
            callbacks.success();
            return;
        }
        if (config.dataChannel[label].readyState !== "open") {
            config.dataChannel[label].pending.push(data);
            callbacks.success();
            return;
        }
        $daf510f834517ce2$export$2e2bcd8739ae039.log("Sending data on data channel <" + label + ">");
        $daf510f834517ce2$export$2e2bcd8739ae039.debug(data);
        config.dataChannel[label].send(data);
        callbacks.success();
    }
    // Private method to send a DTMF tone
    function sendDtmf(handleId, callbacks) {
        callbacks = callbacks || {};
        callbacks.success = typeof callbacks.success == "function" ? callbacks.success : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        callbacks.error = typeof callbacks.error == "function" ? callbacks.error : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        let pluginHandle = pluginHandles.get(handleId);
        if (!pluginHandle || !pluginHandle.webrtcStuff) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Invalid handle");
            callbacks.error("Invalid handle");
            return;
        }
        let config = pluginHandle.webrtcStuff;
        if (!config.dtmfSender) {
            // Create the DTMF sender the proper way, if possible
            if (config.pc) {
                let senders = config.pc.getSenders();
                let audioSender = senders.find(function(sender) {
                    return sender.track && sender.track.kind === 'audio';
                });
                if (!audioSender) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.warn("Invalid DTMF configuration (no audio track)");
                    callbacks.error("Invalid DTMF configuration (no audio track)");
                    return;
                }
                config.dtmfSender = audioSender.dtmf;
                if (config.dtmfSender) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.log("Created DTMF Sender");
                    config.dtmfSender.ontonechange = function(tone) {
                        $daf510f834517ce2$export$2e2bcd8739ae039.debug("Sent DTMF tone: " + tone.tone);
                    };
                }
            }
            if (!config.dtmfSender) {
                $daf510f834517ce2$export$2e2bcd8739ae039.warn("Invalid DTMF configuration");
                callbacks.error("Invalid DTMF configuration");
                return;
            }
        }
        let dtmf = callbacks.dtmf;
        if (!dtmf) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Invalid DTMF parameters");
            callbacks.error("Invalid DTMF parameters");
            return;
        }
        let tones = dtmf.tones;
        if (!tones) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Invalid DTMF string");
            callbacks.error("Invalid DTMF string");
            return;
        }
        let duration = typeof dtmf.duration === 'number' ? dtmf.duration : 500; // We choose 500ms as the default duration for a tone
        let gap = typeof dtmf.gap === 'number' ? dtmf.gap : 50; // We choose 50ms as the default gap between tones
        $daf510f834517ce2$export$2e2bcd8739ae039.debug("Sending DTMF string " + tones + " (duration " + duration + "ms, gap " + gap + "ms)");
        config.dtmfSender.insertDTMF(tones, duration, gap);
        callbacks.success();
    }
    // Private method to destroy a plugin handle
    function destroyHandle(handleId, callbacks) {
        callbacks = callbacks || {};
        callbacks.success = typeof callbacks.success == "function" ? callbacks.success : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        callbacks.error = typeof callbacks.error == "function" ? callbacks.error : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        let noRequest = callbacks.noRequest === true;
        $daf510f834517ce2$export$2e2bcd8739ae039.log("Destroying handle " + handleId + " (only-locally=" + noRequest + ")");
        cleanupWebrtc(handleId);
        let pluginHandle = pluginHandles.get(handleId);
        if (!pluginHandle || pluginHandle.detached) {
            // Plugin was already detached by Janus, calling detach again will return a handle not found error, so just exit here
            pluginHandles.delete(handleId);
            callbacks.success();
            return;
        }
        pluginHandle.detached = true;
        if (noRequest) {
            // We're only removing the handle locally
            pluginHandles.delete(handleId);
            callbacks.success();
            return;
        }
        if (!connected) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Is the server down? (connected=false)");
            callbacks.error("Is the server down? (connected=false)");
            return;
        }
        let request = {
            "janus": "detach",
            "transaction": $daf510f834517ce2$export$2e2bcd8739ae039.randomString(12)
        };
        if (pluginHandle.token) request["token"] = pluginHandle.token;
        if (apisecret) request["apisecret"] = apisecret;
        if (websockets) {
            request["session_id"] = sessionId;
            request["handle_id"] = handleId;
            ws.send(JSON.stringify(request));
            pluginHandles.delete(handleId);
            callbacks.success();
            return;
        }
        $daf510f834517ce2$export$2e2bcd8739ae039.httpAPICall(server + "/" + sessionId + "/" + handleId, {
            verb: 'POST',
            withCredentials: withCredentials,
            body: request,
            success: function(json) {
                $daf510f834517ce2$export$2e2bcd8739ae039.log("Destroyed handle:");
                $daf510f834517ce2$export$2e2bcd8739ae039.debug(json);
                if (json["janus"] !== "success") $daf510f834517ce2$export$2e2bcd8739ae039.error("Ooops: " + json["error"].code + " " + json["error"].reason); // FIXME
                pluginHandles.delete(handleId);
                callbacks.success();
            },
            error: function(textStatus, errorThrown) {
                $daf510f834517ce2$export$2e2bcd8739ae039.error(textStatus + ":", errorThrown); // FIXME
                // We cleanup anyway
                pluginHandles.delete(handleId);
                callbacks.success();
            }
        });
    }
    // WebRTC stuff
    // Helper function to create a new PeerConnection, if we need one
    function createPeerconnectionIfNeeded(handleId, callbacks) {
        let pluginHandle = pluginHandles.get(handleId);
        if (!pluginHandle || !pluginHandle.webrtcStuff) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Invalid handle");
            throw "Invalid handle";
        }
        let config = pluginHandle.webrtcStuff;
        if (config.pc) // Nothing to do, we have a PeerConnection already
        return;
        let pc_config = {
            iceServers: iceServers,
            iceTransportPolicy: iceTransportPolicy,
            bundlePolicy: bundlePolicy
        };
        pc_config.sdpSemantics = 'unified-plan';
        // Check if a sender or receiver transform has been provided
        let insertableStreams = false;
        if (callbacks.tracks) {
            for (let track of callbacks.tracks)if (track.transforms && (track.transforms.sender || track.transforms.receiver)) {
                insertableStreams = true;
                break;
            }
        }
        if (RTCRtpSender && (RTCRtpSender.prototype.createEncodedStreams || RTCRtpSender.prototype.createEncodedAudioStreams && RTCRtpSender.prototype.createEncodedVideoStreams) && insertableStreams) {
            config.insertableStreams = true;
            pc_config.forceEncodedAudioInsertableStreams = true;
            pc_config.forceEncodedVideoInsertableStreams = true;
            pc_config.encodedInsertableStreams = true;
        }
        $daf510f834517ce2$export$2e2bcd8739ae039.log('Creating PeerConnection');
        config.pc = new RTCPeerConnection(pc_config);
        $daf510f834517ce2$export$2e2bcd8739ae039.debug(config.pc);
        if (config.pc.getStats) {
            config.volume = {};
            config.bitrate.value = '0 kbits/sec';
        }
        $daf510f834517ce2$export$2e2bcd8739ae039.log('Preparing local SDP and gathering candidates (trickle=' + config.trickle + ')');
        config.pc.oniceconnectionstatechange = function() {
            if (config.pc) pluginHandle.iceState(config.pc.iceConnectionState);
        };
        config.pc.onicecandidate = function(event) {
            if (!event.candidate || event.candidate.candidate && event.candidate.candidate.indexOf('endOfCandidates') > 0) {
                $daf510f834517ce2$export$2e2bcd8739ae039.log('End of candidates.');
                config.iceDone = true;
                if (config.trickle === true) // Notify end of candidates
                sendTrickleCandidate(handleId, {
                    completed: true
                });
                else // No trickle, time to send the complete SDP (including all candidates)
                sendSDP(handleId, callbacks);
            } else {
                // JSON.stringify doesn't work on some WebRTC objects anymore
                // See https://code.google.com/p/chromium/issues/detail?id=467366
                let candidate = {
                    candidate: event.candidate.candidate,
                    sdpMid: event.candidate.sdpMid,
                    sdpMLineIndex: event.candidate.sdpMLineIndex
                };
                if (config.trickle === true) // Send candidate
                sendTrickleCandidate(handleId, candidate);
            }
        };
        config.pc.ontrack = function(event) {
            $daf510f834517ce2$export$2e2bcd8739ae039.log('Handling Remote Track', event);
            if (!event.streams) return;
            if (!event.track) return;
            // Notify about the new track event
            let mid = event.transceiver ? event.transceiver.mid : event.track.id;
            try {
                pluginHandle.onremotetrack(event.track, mid, true, {
                    reason: 'created'
                });
            } catch (e) {
                $daf510f834517ce2$export$2e2bcd8739ae039.error("Error calling onremotetrack", e);
            }
            if (event.track.onended) return;
            let trackMutedTimeoutId = null;
            $daf510f834517ce2$export$2e2bcd8739ae039.log('Adding onended callback to track:', event.track);
            event.track.onended = function(ev) {
                $daf510f834517ce2$export$2e2bcd8739ae039.log('Remote track removed:', ev);
                clearTimeout(trackMutedTimeoutId);
                // Notify the application
                let transceivers = config.pc ? config.pc.getTransceivers() : null;
                let transceiver = transceivers ? transceivers.find((t)=>t.receiver.track === ev.target) : null;
                let mid = transceiver ? transceiver.mid : ev.target.id;
                try {
                    pluginHandle.onremotetrack(ev.target, mid, false, {
                        reason: 'ended'
                    });
                } catch (e) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.error("Error calling onremotetrack on removal", e);
                }
            };
            event.track.onmute = function(ev) {
                $daf510f834517ce2$export$2e2bcd8739ae039.log('Remote track muted:', ev);
                if (!trackMutedTimeoutId) trackMutedTimeoutId = setTimeout(function() {
                    $daf510f834517ce2$export$2e2bcd8739ae039.log('Removing remote track');
                    // Notify the application the track is gone
                    let transceivers = config.pc ? config.pc.getTransceivers() : null;
                    let transceiver = transceivers ? transceivers.find((t)=>t.receiver.track === ev.target) : null;
                    let mid = transceiver ? transceiver.mid : ev.target.id;
                    try {
                        pluginHandle.onremotetrack(ev.target, mid, false, {
                            reason: 'mute'
                        });
                    } catch (e) {
                        $daf510f834517ce2$export$2e2bcd8739ae039.error("Error calling onremotetrack on mute", e);
                    }
                    trackMutedTimeoutId = null;
                // Chrome seems to raise mute events only at multiples of 834ms;
                // we set the timeout to three times this value (rounded to 840ms)
                }, 2520);
            };
            event.track.onunmute = function(ev) {
                $daf510f834517ce2$export$2e2bcd8739ae039.log('Remote track flowing again:', ev);
                if (trackMutedTimeoutId != null) {
                    clearTimeout(trackMutedTimeoutId);
                    trackMutedTimeoutId = null;
                } else try {
                    // Notify the application the track is back
                    let transceivers = config.pc ? config.pc.getTransceivers() : null;
                    let transceiver = transceivers ? transceivers.find((t)=>t.receiver.track === ev.target) : null;
                    let mid = transceiver ? transceiver.mid : ev.target.id;
                    pluginHandle.onremotetrack(ev.target, mid, true, {
                        reason: 'unmute'
                    });
                } catch (e) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.error("Error calling onremotetrack on unmute", e);
                }
            };
        };
    }
    // Helper function used when creating either an offer or answer: it
    // prepares what needs to be prepared, including creating a new
    // PeerConnection (if needed) and updating the tracks configuration,
    // before invoking the function to actually generate the offer/answer
    async function prepareWebrtc(handleId, offer, callbacks) {
        callbacks = callbacks || {};
        callbacks.success = typeof callbacks.success == "function" ? callbacks.success : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        callbacks.error = typeof callbacks.error == "function" ? callbacks.error : webrtcError;
        let jsep = callbacks.jsep;
        if (offer && jsep) {
            $daf510f834517ce2$export$2e2bcd8739ae039.error("Provided a JSEP to a createOffer");
            callbacks.error("Provided a JSEP to a createOffer");
            return;
        } else if (!offer && (!jsep || !jsep.type || !jsep.sdp)) {
            $daf510f834517ce2$export$2e2bcd8739ae039.error("A valid JSEP is required for createAnswer");
            callbacks.error("A valid JSEP is required for createAnswer");
            return;
        }
        // If the deprecated media was provided instead of tracks, translate it
        if (callbacks.media && !callbacks.tracks) {
            callbacks.tracks = $daf510f834517ce2$export$2e2bcd8739ae039.mediaToTracks(callbacks.media);
            if (callbacks.simulcast === true || callbacks.simulcast2 === true || callbacks.svc) {
                // Find the video track and add simulcast/SVC info there
                for (let track of callbacks.tracks)if (track.type === 'video') {
                    if (callbacks.simulcast === true || callbacks.simulcast2 === true) track.simulcast = true;
                    else if (callbacks.svc) track.svc = callbacks.svc;
                    break;
                }
            }
            $daf510f834517ce2$export$2e2bcd8739ae039.warn('Deprecated media object passed, use tracks instead. Automatically translated to:', callbacks.tracks);
        }
        // Check that callbacks.array is a valid array
        if (callbacks.tracks && !Array.isArray(callbacks.tracks)) {
            $daf510f834517ce2$export$2e2bcd8739ae039.error("Tracks must be an array");
            callbacks.error("Tracks must be an array");
            return;
        }
        // Get the plugin handle
        let pluginHandle = pluginHandles.get(handleId);
        if (!pluginHandle || !pluginHandle.webrtcStuff) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Invalid handle");
            callbacks.error("Invalid handle");
            return;
        }
        let config = pluginHandle.webrtcStuff;
        config.trickle = isTrickleEnabled(callbacks.trickle);
        try {
            // Create a PeerConnection, if needed
            createPeerconnectionIfNeeded(handleId, callbacks);
            if (offer) // Capture devices and setup tracks, if needed
            await captureDevices(handleId, callbacks);
            // Create offer or answer now (depending on the context)
            if (!jsep) {
                let offer = await createOffer(handleId, callbacks);
                callbacks.success(offer);
            } else {
                await config.pc.setRemoteDescription(jsep);
                $daf510f834517ce2$export$2e2bcd8739ae039.log("Remote description accepted!");
                config.remoteSdp = jsep.sdp;
                // Any trickle candidate we cached?
                if (config.candidates && config.candidates.length > 0) {
                    for(let i = 0; i < config.candidates.length; i++){
                        let candidate = config.candidates[i];
                        $daf510f834517ce2$export$2e2bcd8739ae039.debug("Adding remote candidate:", candidate);
                        if (!candidate || candidate.completed === true) // end-of-candidates
                        config.pc.addIceCandidate($daf510f834517ce2$export$2e2bcd8739ae039.endOfCandidates);
                        else // New candidate
                        config.pc.addIceCandidate(candidate);
                    }
                    config.candidates = [];
                }
                // Capture devices and setup tracks, if needed
                await captureDevices(handleId, callbacks);
                // Create the answer now
                let answer = await createAnswer(handleId, callbacks);
                callbacks.success(answer);
            }
        } catch (err) {
            $daf510f834517ce2$export$2e2bcd8739ae039.error(err);
            callbacks.error(err);
        }
    }
    function prepareWebrtcPeer(handleId, callbacks) {
        callbacks = callbacks || {};
        callbacks.success = typeof callbacks.success == "function" ? callbacks.success : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        callbacks.error = typeof callbacks.error == "function" ? callbacks.error : webrtcError;
        callbacks.customizeSdp = typeof callbacks.customizeSdp == "function" ? callbacks.customizeSdp : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        let jsep = callbacks.jsep;
        let pluginHandle = pluginHandles.get(handleId);
        if (!pluginHandle || !pluginHandle.webrtcStuff) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Invalid handle");
            callbacks.error("Invalid handle");
            return;
        }
        let config = pluginHandle.webrtcStuff;
        if (jsep) {
            if (!config.pc) {
                $daf510f834517ce2$export$2e2bcd8739ae039.warn("Wait, no PeerConnection?? if this is an answer, use createAnswer and not handleRemoteJsep");
                callbacks.error("No PeerConnection: if this is an answer, use createAnswer and not handleRemoteJsep");
                return;
            }
            callbacks.customizeSdp(jsep);
            config.pc.setRemoteDescription(jsep).then(function() {
                $daf510f834517ce2$export$2e2bcd8739ae039.log("Remote description accepted!");
                config.remoteSdp = jsep.sdp;
                // Any trickle candidate we cached?
                if (config.candidates && config.candidates.length > 0) {
                    for(let i = 0; i < config.candidates.length; i++){
                        let candidate = config.candidates[i];
                        $daf510f834517ce2$export$2e2bcd8739ae039.debug("Adding remote candidate:", candidate);
                        if (!candidate || candidate.completed === true) // end-of-candidates
                        config.pc.addIceCandidate($daf510f834517ce2$export$2e2bcd8739ae039.endOfCandidates);
                        else // New candidate
                        config.pc.addIceCandidate(candidate);
                    }
                    config.candidates = [];
                }
                // Done
                callbacks.success();
            }, callbacks.error);
        } else callbacks.error("Invalid JSEP");
    }
    async function createOffer(handleId, callbacks) {
        callbacks = callbacks || {};
        callbacks.customizeSdp = typeof callbacks.customizeSdp == "function" ? callbacks.customizeSdp : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        let pluginHandle = pluginHandles.get(handleId);
        if (!pluginHandle || !pluginHandle.webrtcStuff) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Invalid handle");
            throw "Invalid handle";
        }
        let config = pluginHandle.webrtcStuff;
        $daf510f834517ce2$export$2e2bcd8739ae039.log("Creating offer (iceDone=" + config.iceDone + ")");
        // https://code.google.com/p/webrtc/issues/detail?id=3508
        let mediaConstraints = {};
        let iceRestart = callbacks.iceRestart === true;
        // If we need an ICE restart, set the related constraint
        if (iceRestart) mediaConstraints.iceRestart = true;
        $daf510f834517ce2$export$2e2bcd8739ae039.debug(mediaConstraints);
        let offer = await config.pc.createOffer(mediaConstraints);
        $daf510f834517ce2$export$2e2bcd8739ae039.debug(offer);
        // JSON.stringify doesn't work on some WebRTC objects anymore
        // See https://code.google.com/p/chromium/issues/detail?id=467366
        let jsep = {
            type: 'offer',
            sdp: offer.sdp
        };
        callbacks.customizeSdp(jsep);
        offer.sdp = jsep.sdp;
        $daf510f834517ce2$export$2e2bcd8739ae039.log("Setting local description");
        config.mySdp = {
            type: 'offer',
            sdp: offer.sdp
        };
        await config.pc.setLocalDescription(offer);
        config.mediaConstraints = mediaConstraints;
        if (!config.iceDone && !config.trickle) {
            // FIXME Don't do anything until we have all candidates
            $daf510f834517ce2$export$2e2bcd8739ae039.log("Waiting for all candidates...");
            return null;
        }
        // If transforms are present, notify Janus that the media is end-to-end encrypted
        if (config.insertableStreams) offer.e2ee = true;
        return offer;
    }
    async function createAnswer(handleId, callbacks) {
        callbacks = callbacks || {};
        callbacks.customizeSdp = typeof callbacks.customizeSdp == "function" ? callbacks.customizeSdp : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        let pluginHandle = pluginHandles.get(handleId);
        if (!pluginHandle || !pluginHandle.webrtcStuff) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Invalid handle");
            throw "Invalid handle";
        }
        let config = pluginHandle.webrtcStuff;
        $daf510f834517ce2$export$2e2bcd8739ae039.log("Creating answer (iceDone=" + config.iceDone + ")");
        let answer = await config.pc.createAnswer();
        $daf510f834517ce2$export$2e2bcd8739ae039.debug(answer);
        // JSON.stringify doesn't work on some WebRTC objects anymore
        // See https://code.google.com/p/chromium/issues/detail?id=467366
        let jsep = {
            type: 'answer',
            sdp: answer.sdp
        };
        callbacks.customizeSdp(jsep);
        answer.sdp = jsep.sdp;
        $daf510f834517ce2$export$2e2bcd8739ae039.log("Setting local description");
        config.mySdp = {
            type: 'answer',
            sdp: answer.sdp
        };
        await config.pc.setLocalDescription(answer);
        if (!config.iceDone && !config.trickle) {
            // FIXME Don't do anything until we have all candidates
            $daf510f834517ce2$export$2e2bcd8739ae039.log("Waiting for all candidates...");
            return null;
        }
        // If transforms are present, notify Janus that the media is end-to-end encrypted
        if (config.insertableStreams) answer.e2ee = true;
        return answer;
    }
    function sendSDP(handleId, callbacks) {
        callbacks = callbacks || {};
        callbacks.success = typeof callbacks.success == "function" ? callbacks.success : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        callbacks.error = typeof callbacks.error == "function" ? callbacks.error : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        let pluginHandle = pluginHandles.get(handleId);
        if (!pluginHandle || !pluginHandle.webrtcStuff) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Invalid handle, not sending anything");
            return;
        }
        let config = pluginHandle.webrtcStuff;
        $daf510f834517ce2$export$2e2bcd8739ae039.log("Sending offer/answer SDP...");
        if (!config.mySdp) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Local SDP instance is invalid, not sending anything...");
            return;
        }
        config.mySdp = {
            type: config.pc.localDescription.type,
            sdp: config.pc.localDescription.sdp
        };
        if (config.trickle === false) config.mySdp["trickle"] = false;
        $daf510f834517ce2$export$2e2bcd8739ae039.debug(callbacks);
        config.sdpSent = true;
        callbacks.success(config.mySdp);
    }
    async function replaceTracks(handleId, callbacks) {
        callbacks = callbacks || {};
        callbacks.success = typeof callbacks.success == 'function' ? callbacks.success : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        callbacks.error = typeof callbacks.error == 'function' ? callbacks.error : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        // Check that callbacks.array is a valid array
        if (callbacks.tracks && !Array.isArray(callbacks.tracks)) {
            $daf510f834517ce2$export$2e2bcd8739ae039.error('Tracks must be an array');
            callbacks.error('Tracks must be an array');
            return;
        }
        // Add the replace:true if it's missing
        for (let track of callbacks.tracks)if (track.add || !track.replace && !track.remove) track.replace = true;
        try {
            await captureDevices(handleId, callbacks);
            callbacks.success();
        } catch (err) {
            $daf510f834517ce2$export$2e2bcd8739ae039.error(err);
            callbacks.error(err);
        }
    }
    async function captureDevices(handleId, callbacks) {
        let pluginHandle = pluginHandles.get(handleId);
        if (!pluginHandle || !pluginHandle.webrtcStuff) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn('Invalid handle, not sending anything');
            throw 'Invalid handle';
        }
        let config = pluginHandle.webrtcStuff;
        if (!config.pc) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn('Invalid PeerConnection');
            throw 'Invalid PeerConnection';
        }
        let tracks = callbacks.tracks;
        if (!tracks || !Array.isArray(tracks) || tracks.length === 0) // Nothing to do
        return;
        let openedConsentDialog = false;
        // Check if we can/should group getUserMedia calls
        let groups = {};
        for (let track of tracks){
            delete track.gumGroup;
            if (!track.type || ![
                'audio',
                'video'
            ].includes(track.type)) continue;
            if (!track.capture || track.capture instanceof MediaStreamTrack) continue;
            let group = track.group ? track.group : 'default';
            if (!groups[group]) groups[group] = {};
            if (groups[group][track.type]) continue;
            track.gumGroup = group;
            groups[group][track.type] = track;
        }
        let keys = Object.keys(groups);
        for (let key of keys){
            let group = groups[key];
            if (!group.audio || !group.video) {
                if (group.audio) delete group.audio.gumGroup;
                if (group.video) delete group.video.gumGroup;
                delete groups[key];
            }
        }
        let answer = callbacks.jsep ? true : false;
        for (let track of tracks){
            if (!track.type) {
                $daf510f834517ce2$export$2e2bcd8739ae039.warn('Missing track type:', track);
                continue;
            }
            if (track.type === 'data') {
                // Easy enough: create a datachannel if we don't have one already
                if (config.pc.ondatachannel) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.warn('Data channel exists already, not creating another one');
                    continue;
                }
                $daf510f834517ce2$export$2e2bcd8739ae039.log('Creating default data channel');
                createDataChannel(handleId, $daf510f834517ce2$export$2e2bcd8739ae039.dataChanDefaultLabel, null, false);
                config.pc.ondatachannel = function(event) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.log('Data channel created by Janus:', event);
                    createDataChannel(handleId, event.channel.label, event.channel.protocol, event.channel);
                };
                continue;
            }
            if ((typeof track.add === 'undefined' || track.add === null) && (typeof track.remove === 'undefined' || track.remove === null) && (typeof track.replace === 'undefined' || track.replace === null)) // Let's default to 'add'
            track.add = true;
            if (track.add && track.remove || track.add && track.remove && track.replace) {
                $daf510f834517ce2$export$2e2bcd8739ae039.warn('Conflicting actions for track, ignoring:', track);
                continue;
            }
            if (track.add && track.replace) {
                $daf510f834517ce2$export$2e2bcd8739ae039.warn('Both add and replace provided, falling back to replace:', track);
                delete track.add;
            } else if (track.remove && track.replace) {
                $daf510f834517ce2$export$2e2bcd8739ae039.warn('Both remove and replace provided, falling back to remove:', track);
                delete track.replace;
            }
            let kind = track.type;
            if (track.type === 'screen') kind = 'video'; // FIXME
            let transceiver = null, sender = null;
            if (track.mid) // Search by mid
            transceiver = config.pc.getTransceivers().find((t)=>t.mid === track.mid && t.receiver.track.kind === kind);
            else // Find the first track of this type
            transceiver = config.pc.getTransceivers().find((t)=>t.receiver.track.kind === kind);
            if (track.replace || track.remove) {
                if (!transceiver) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.warn("Couldn't find a transceiver for track:", track);
                    continue;
                }
                if (!transceiver.sender) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.warn('No sender in the transceiver for track:', track);
                    continue;
                }
                sender = transceiver.sender;
            }
            if (answer && !transceiver) {
                transceiver = config.pc.getTransceivers().find((t)=>t.receiver.track.kind === kind);
                if (!transceiver) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.warn("Couldn't find a transceiver for track:", track);
                    continue;
                }
            }
            // Capture the new track, if we need to
            let nt = null, trackId = null;
            if (track.remove || track.replace) {
                $daf510f834517ce2$export$2e2bcd8739ae039.log('Removing track from PeerConnection', track);
                trackId = sender.track ? sender.track.id : null;
                await sender.replaceTrack(null);
                // Get rid of the old track
                if (trackId && config.myStream) {
                    let rt = null;
                    if (kind === 'audio' && config.myStream.getAudioTracks() && config.myStream.getAudioTracks().length) {
                        for (let t of config.myStream.getAudioTracks())if (t.id === trackId) {
                            rt = t;
                            $daf510f834517ce2$export$2e2bcd8739ae039.log('Removing audio track:', rt);
                        }
                    } else if (kind === 'video' && config.myStream.getVideoTracks() && config.myStream.getVideoTracks().length) {
                        for (let t of config.myStream.getVideoTracks())if (t.id === trackId) {
                            rt = t;
                            $daf510f834517ce2$export$2e2bcd8739ae039.log('Removing video track:', rt);
                        }
                    }
                    if (rt) {
                        // Remove the track and notify the application
                        try {
                            config.myStream.removeTrack(rt);
                            pluginHandle.onlocaltrack(rt, false);
                        } catch (e) {
                            $daf510f834517ce2$export$2e2bcd8739ae039.error("Error calling onlocaltrack on removal for renegotiation", e);
                        }
                        // Close the old track (unless we've been asked not to)
                        if (rt.dontStop !== true) try {
                            rt.stop();
                        } catch (e) {}
                    }
                }
            }
            if (track.capture) {
                if (track.gumGroup && groups[track.gumGroup] && groups[track.gumGroup].stream) {
                    // We did a getUserMedia before already
                    let stream = groups[track.gumGroup].stream;
                    nt = track.type === 'audio' ? stream.getAudioTracks()[0] : stream.getVideoTracks()[0];
                    delete groups[track.gumGroup].stream;
                    delete groups[track.gumGroup];
                    delete track.gumGroup;
                } else if (track.capture instanceof MediaStreamTrack) // An external track was provided, use that
                nt = track.capture;
                else {
                    if (!openedConsentDialog) {
                        openedConsentDialog = true;
                        pluginHandle.consentDialog(true);
                    }
                    let constraints = $daf510f834517ce2$export$2e2bcd8739ae039.trackConstraints(track), stream = null;
                    if (track.type === 'audio' || track.type === 'video') {
                        // Use getUserMedia: check if we need to group audio and video together
                        if (track.gumGroup) {
                            let otherType = track.type === 'audio' ? 'video' : 'audio';
                            if (groups[track.gumGroup] && groups[track.gumGroup][otherType]) {
                                let otherTrack = groups[track.gumGroup][otherType];
                                let otherConstraints = $daf510f834517ce2$export$2e2bcd8739ae039.trackConstraints(otherTrack);
                                constraints[otherType] = otherConstraints[otherType];
                            }
                        }
                        stream = await navigator.mediaDevices.getUserMedia(constraints);
                        if (track.gumGroup && constraints.audio && constraints.video) {
                            // We just performed a grouped getUserMedia, keep track of the
                            // stream so that we can immediately assign the track later
                            groups[track.gumGroup].stream = stream;
                            delete track.gumGroup;
                        }
                    } else // Use getDisplayMedia
                    stream = await navigator.mediaDevices.getDisplayMedia(constraints);
                    nt = track.type === 'audio' ? stream.getAudioTracks()[0] : stream.getVideoTracks()[0];
                }
                if (track.replace) {
                    // Replace the track
                    await sender.replaceTrack(nt);
                    // Update the transceiver direction
                    let newDirection = 'sendrecv';
                    if (track.recv === false || transceiver.direction === 'inactive' || transceiver.direction === 'sendonly') newDirection = 'sendonly';
                    if (transceiver.setDirection) transceiver.setDirection(newDirection);
                    else transceiver.direction = newDirection;
                } else {
                    // FIXME Add as a new track
                    if (!config.myStream) config.myStream = new MediaStream();
                    if (kind === 'audio' || !track.simulcast && !track.svc) {
                        sender = config.pc.addTrack(nt, config.myStream);
                        transceiver = config.pc.getTransceivers().find((t)=>t.sender === sender);
                    } else if (track.simulcast) {
                        if ($daf510f834517ce2$export$2e2bcd8739ae039.webRTCAdapter.browserDetails.browser !== 'firefox') {
                            // Standard RID
                            $daf510f834517ce2$export$2e2bcd8739ae039.log('Enabling rid-based simulcasting:', nt);
                            let maxBitrates = getMaxBitrates(track.simulcastMaxBitrates);
                            transceiver = config.pc.addTransceiver(nt, {
                                direction: 'sendrecv',
                                streams: [
                                    config.myStream
                                ],
                                sendEncodings: track.sendEncodings || [
                                    {
                                        rid: 'h',
                                        active: true,
                                        scalabilityMode: 'L1T2',
                                        maxBitrate: maxBitrates.high
                                    },
                                    {
                                        rid: 'm',
                                        active: true,
                                        scalabilityMode: 'L1T2',
                                        maxBitrate: maxBitrates.medium,
                                        scaleResolutionDownBy: 2
                                    },
                                    {
                                        rid: 'l',
                                        active: true,
                                        scalabilityMode: 'L1T2',
                                        maxBitrate: maxBitrates.low,
                                        scaleResolutionDownBy: 4
                                    }
                                ]
                            });
                        } else {
                            // Firefox-based RID, based on https://gist.github.com/voluntas/088bc3cc62094730647b
                            $daf510f834517ce2$export$2e2bcd8739ae039.log('Enabling Simulcasting for Firefox (RID)');
                            transceiver = config.pc.addTransceiver(nt, {
                                direction: 'sendrecv',
                                streams: [
                                    config.myStream
                                ]
                            });
                            sender = transceiver ? transceiver.sender : null;
                            if (sender) {
                                let parameters = sender.getParameters();
                                if (!parameters) parameters = {};
                                let maxBitrates = getMaxBitrates(track.simulcastMaxBitrates);
                                parameters.encodings = track.sendEncodings || [
                                    {
                                        rid: 'h',
                                        active: true,
                                        maxBitrate: maxBitrates.high
                                    },
                                    {
                                        rid: 'm',
                                        active: true,
                                        maxBitrate: maxBitrates.medium,
                                        scaleResolutionDownBy: 2
                                    },
                                    {
                                        rid: 'l',
                                        active: true,
                                        maxBitrate: maxBitrates.low,
                                        scaleResolutionDownBy: 4
                                    }
                                ];
                                sender.setParameters(parameters);
                            }
                        }
                    } else {
                        $daf510f834517ce2$export$2e2bcd8739ae039.log('Enabling SVC (' + track.svc + '):', nt);
                        transceiver = config.pc.addTransceiver(nt, {
                            direction: 'sendrecv',
                            streams: [
                                config.myStream
                            ],
                            sendEncodings: [
                                {
                                    scalabilityMode: track.svc
                                }
                            ]
                        });
                    }
                    if (!sender) sender = transceiver ? transceiver.sender : null;
                    // Check if we need to override some settings
                    if (track.codec) {
                        if ($daf510f834517ce2$export$2e2bcd8739ae039.webRTCAdapter.browserDetails.browser === 'firefox') $daf510f834517ce2$export$2e2bcd8739ae039.warn('setCodecPreferences not supported in Firefox, ignoring codec for track:', track);
                        else if (typeof track.codec !== 'string') $daf510f834517ce2$export$2e2bcd8739ae039.warn('Invalid codec value, ignoring for track:', track);
                        else {
                            let mimeType = kind + '/' + track.codec.toLowerCase();
                            let codecs = RTCRtpReceiver.getCapabilities(kind).codecs.filter(function(codec) {
                                return codec.mimeType.toLowerCase() === mimeType;
                            });
                            if (!codecs || codecs.length === 0) $daf510f834517ce2$export$2e2bcd8739ae039.warn('Codec not supported in this browser for this track, ignoring:', track);
                            else if (transceiver) try {
                                transceiver.setCodecPreferences(codecs);
                            } catch (err) {
                                $daf510f834517ce2$export$2e2bcd8739ae039.warn('Failed enforcing codec for this ' + kind + ' track:', err);
                            }
                        }
                    }
                    if (track.bitrate) {
                        // Override maximum bitrate
                        if (track.simulcast || track.svc) $daf510f834517ce2$export$2e2bcd8739ae039.warn('Ignoring bitrate for simulcast/SVC track, use sendEncodings for that');
                        else if (isNaN(track.bitrate) || track.bitrate < 0) $daf510f834517ce2$export$2e2bcd8739ae039.warn('Ignoring invalid bitrate for track:', track);
                        else if (sender) {
                            let params = sender.getParameters();
                            if (!params || !params.encodings || params.encodings.length === 0) $daf510f834517ce2$export$2e2bcd8739ae039.warn('No encodings in the sender parameters, ignoring bitrate for track:', track);
                            else {
                                params.encodings[0].maxBitrate = track.bitrate;
                                await sender.setParameters(params);
                            }
                        }
                    }
                    if (kind === 'video' && track.framerate) {
                        // Override maximum framerate
                        if (track.simulcast || track.svc) $daf510f834517ce2$export$2e2bcd8739ae039.warn('Ignoring framerate for simulcast/SVC track, use sendEncodings for that');
                        else if (isNaN(track.framerate) || track.framerate < 0) $daf510f834517ce2$export$2e2bcd8739ae039.warn('Ignoring invalid framerate for track:', track);
                        else if (sender) {
                            let params = sender.getParameters();
                            if (!params || !params.encodings || params.encodings.length === 0) $daf510f834517ce2$export$2e2bcd8739ae039.warn('No encodings in the sender parameters, ignoring framerate for track:', track);
                            else {
                                params.encodings[0].maxFramerate = track.framerate;
                                await sender.setParameters(params);
                            }
                        }
                    }
                    // Check if insertable streams are involved
                    if (track.transforms) {
                        if (sender && track.transforms.sender) {
                            // There's a sender transform, set it on the transceiver sender
                            let senderStreams = null;
                            if (RTCRtpSender.prototype.createEncodedStreams) senderStreams = sender.createEncodedStreams();
                            else if (RTCRtpSender.prototype.createAudioEncodedStreams || RTCRtpSender.prototype.createEncodedVideoStreams) {
                                if (kind === 'audio') senderStreams = sender.createEncodedAudioStreams();
                                else if (kind === 'video') senderStreams = sender.createEncodedVideoStreams();
                            }
                            if (senderStreams) {
                                if (senderStreams.readableStream && senderStreams.writableStream) senderStreams.readableStream.pipeThrough(track.transforms.sender).pipeTo(senderStreams.writableStream);
                                else if (senderStreams.readable && senderStreams.writable) senderStreams.readable.pipeThrough(track.transforms.sender).pipeTo(senderStreams.writable);
                            }
                        }
                        if (transceiver && transceiver.receiver && track.transforms.receiver) {
                            // There's a receiver transform, set it on the transceiver receiver
                            let receiverStreams = null;
                            if (RTCRtpReceiver.prototype.createEncodedStreams) receiverStreams = transceiver.receiver.createEncodedStreams();
                            else if (RTCRtpReceiver.prototype.createAudioEncodedStreams || RTCRtpReceiver.prototype.createEncodedVideoStreams) {
                                if (kind === 'audio') receiverStreams = transceiver.receiver.createEncodedAudioStreams();
                                else if (kind === 'video') receiverStreams = transceiver.receiver.createEncodedVideoStreams();
                            }
                            if (receiverStreams) {
                                if (receiverStreams.readableStream && receiverStreams.writableStream) receiverStreams.readableStream.pipeThrough(track.transforms.receiver).pipeTo(receiverStreams.writableStream);
                                else if (receiverStreams.readable && receiverStreams.writable) receiverStreams.readable.pipeThrough(track.transforms.receiver).pipeTo(receiverStreams.writable);
                            }
                        }
                    }
                }
                if (nt && track.dontStop === true) nt.dontStop = true;
            } else if (track.recv) {
                // Maybe a new recvonly track
                if (!transceiver) transceiver = config.pc.addTransceiver(kind);
                if (transceiver) {
                    // Check if we need to override some settings
                    if (track.codec) {
                        if ($daf510f834517ce2$export$2e2bcd8739ae039.webRTCAdapter.browserDetails.browser === 'firefox') $daf510f834517ce2$export$2e2bcd8739ae039.warn('setCodecPreferences not supported in Firefox, ignoring codec for track:', track);
                        else if (typeof track.codec !== 'string') $daf510f834517ce2$export$2e2bcd8739ae039.warn('Invalid codec value, ignoring for track:', track);
                        else {
                            let mimeType = kind + '/' + track.codec.toLowerCase();
                            let codecs = RTCRtpReceiver.getCapabilities(kind).codecs.filter(function(codec) {
                                return codec.mimeType.toLowerCase() === mimeType;
                            });
                            if (!codecs || codecs.length === 0) $daf510f834517ce2$export$2e2bcd8739ae039.warn('Codec not supported in this browser for this track, ignoring:', track);
                            else try {
                                transceiver.setCodecPreferences(codecs);
                            } catch (err) {
                                $daf510f834517ce2$export$2e2bcd8739ae039.warn('Failed enforcing codec for this ' + kind + ' track:', err);
                            }
                        }
                    }
                    // Check if insertable streams are involved
                    if (transceiver.receiver && track.transforms && track.transforms.receiver) {
                        // There's a receiver transform, set it on the transceiver receiver
                        let receiverStreams = null;
                        if (RTCRtpReceiver.prototype.createEncodedStreams) receiverStreams = transceiver.receiver.createEncodedStreams();
                        else if (RTCRtpReceiver.prototype.createAudioEncodedStreams || RTCRtpReceiver.prototype.createEncodedVideoStreams) {
                            if (kind === 'audio') receiverStreams = transceiver.receiver.createEncodedAudioStreams();
                            else if (kind === 'video') receiverStreams = transceiver.receiver.createEncodedVideoStreams();
                        }
                        if (receiverStreams) {
                            if (receiverStreams.readableStream && receiverStreams.writableStream) receiverStreams.readableStream.pipeThrough(track.transforms.receiver).pipeTo(receiverStreams.writableStream);
                            else if (receiverStreams.readable && receiverStreams.writable) receiverStreams.readable.pipeThrough(track.transforms.receiver).pipeTo(receiverStreams.writable);
                        }
                    }
                }
            }
            if (nt) {
                // FIXME Add the new track locally
                config.myStream.addTrack(nt);
                // Notify the application about the new local track, if any
                nt.onended = function(ev) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.log('Local track removed:', ev);
                    try {
                        pluginHandle.onlocaltrack(ev.target, false);
                    } catch (e) {
                        $daf510f834517ce2$export$2e2bcd8739ae039.error("Error calling onlocaltrack following end", e);
                    }
                };
                try {
                    pluginHandle.onlocaltrack(nt, true);
                } catch (e) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.error("Error calling onlocaltrack for track add", e);
                }
            }
            // Update the direction of the transceiver
            if (transceiver) {
                let curdir = transceiver.direction, newdir = null;
                let send = nt && transceiver.sender.track, recv = track.recv !== false && transceiver.receiver.track;
                if (send && recv) newdir = 'sendrecv';
                else if (send && !recv) newdir = 'sendonly';
                else if (!send && recv) newdir = 'recvonly';
                else if (!send && !recv) newdir = 'inactive';
                if (newdir && newdir !== curdir) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.warn('Changing direction of transceiver to ' + newdir + ' (was ' + curdir + ')', track);
                    if (transceiver.setDirection) transceiver.setDirection(newdir);
                    else transceiver.direction = newdir;
                }
            }
        }
        if (openedConsentDialog) pluginHandle.consentDialog(false);
    }
    function getLocalTracks(handleId) {
        let pluginHandle = pluginHandles.get(handleId);
        if (!pluginHandle || !pluginHandle.webrtcStuff) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn('Invalid handle');
            return null;
        }
        let config = pluginHandle.webrtcStuff;
        if (!config.pc) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn('Invalid PeerConnection');
            return null;
        }
        let tracks = [];
        let transceivers = config.pc.getTransceivers();
        for (let tr of transceivers){
            let track = null;
            if (tr.sender && tr.sender.track) {
                track = {
                    mid: tr.mid
                };
                track.type = tr.sender.track.kind;
                track.id = tr.sender.track.id;
                track.label = tr.sender.track.label;
            }
            if (track) tracks.push(track);
        }
        return tracks;
    }
    function getRemoteTracks(handleId) {
        let pluginHandle = pluginHandles.get(handleId);
        if (!pluginHandle || !pluginHandle.webrtcStuff) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn('Invalid handle');
            return null;
        }
        let config = pluginHandle.webrtcStuff;
        if (!config.pc) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn('Invalid PeerConnection');
            return null;
        }
        let tracks = [];
        let transceivers = config.pc.getTransceivers();
        for (let tr of transceivers){
            let track = null;
            if (tr.receiver && tr.receiver.track) {
                track = {
                    mid: tr.mid
                };
                track.type = tr.receiver.track.kind;
                track.id = tr.receiver.track.id;
                track.label = tr.receiver.track.label;
            }
            if (track) tracks.push(track);
        }
        return tracks;
    }
    function getVolume(handleId, mid, remote, result) {
        result = typeof result == "function" ? result : $daf510f834517ce2$export$2e2bcd8739ae039.noop;
        let pluginHandle = pluginHandles.get(handleId);
        if (!pluginHandle || !pluginHandle.webrtcStuff) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Invalid handle");
            result(0);
            return;
        }
        let stream = remote ? "remote" : "local";
        let config = pluginHandle.webrtcStuff;
        if (!config.volume[stream]) config.volume[stream] = {
            value: 0
        };
        // Start getting the volume, if audioLevel in getStats is supported (apparently
        // they're only available in Chrome/Safari right now: https://webrtc-stats.callstats.io/)
        if (config.pc && config.pc.getStats && ($daf510f834517ce2$export$2e2bcd8739ae039.webRTCAdapter.browserDetails.browser === "chrome" || $daf510f834517ce2$export$2e2bcd8739ae039.webRTCAdapter.browserDetails.browser === "safari")) {
            // Are we interested in a mid in particular?
            let query = config.pc;
            if (mid) {
                let transceiver = config.pc.getTransceivers().find((t)=>t.mid === mid && t.receiver.track.kind === "audio");
                if (!transceiver) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.warn("No audio transceiver with mid " + mid);
                    result(0);
                    return;
                }
                if (remote && !transceiver.receiver) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.warn("Remote transceiver track unavailable");
                    result(0);
                    return;
                } else if (!remote && !transceiver.sender) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.warn("Local transceiver track unavailable");
                    result(0);
                    return;
                }
                query = remote ? transceiver.receiver : transceiver.sender;
            }
            query.getStats().then(function(stats) {
                stats.forEach(function(res) {
                    if (!res || res.kind !== "audio") return;
                    if (remote && !res.remoteSource || !remote && res.type !== "media-source") return;
                    result(res.audioLevel ? res.audioLevel : 0);
                });
            });
            return config.volume[stream].value;
        } else {
            // audioInputLevel and audioOutputLevel seem only available in Chrome? audioLevel
            // seems to be available on Chrome and Firefox, but they don't seem to work
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Getting the " + stream + " volume unsupported by browser");
            result(0);
            return;
        }
    }
    function isMuted(handleId, mid, video) {
        let pluginHandle = pluginHandles.get(handleId);
        if (!pluginHandle || !pluginHandle.webrtcStuff) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Invalid handle");
            return true;
        }
        let config = pluginHandle.webrtcStuff;
        if (!config.pc) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Invalid PeerConnection");
            return true;
        }
        if (!config.myStream) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Invalid local MediaStream");
            return true;
        }
        if (video) {
            // Check video track
            if (!config.myStream.getVideoTracks() || config.myStream.getVideoTracks().length === 0) {
                $daf510f834517ce2$export$2e2bcd8739ae039.warn("No video track");
                return true;
            }
            if (mid) {
                let transceiver = config.pc.getTransceivers().find((t)=>t.mid === mid && t.receiver.track.kind === "video");
                if (!transceiver) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.warn("No video transceiver with mid " + mid);
                    return true;
                }
                if (!transceiver.sender || !transceiver.sender.track) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.warn("No video sender with mid " + mid);
                    return true;
                }
                return !transceiver.sender.track.enabled;
            } else return !config.myStream.getVideoTracks()[0].enabled;
        } else {
            // Check audio track
            if (!config.myStream.getAudioTracks() || config.myStream.getAudioTracks().length === 0) {
                $daf510f834517ce2$export$2e2bcd8739ae039.warn("No audio track");
                return true;
            }
            if (mid) {
                let transceiver = config.pc.getTransceivers().find((t)=>t.mid === mid && t.receiver.track.kind === "audio");
                if (!transceiver) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.warn("No audio transceiver with mid " + mid);
                    return true;
                }
                if (!transceiver.sender || !transceiver.sender.track) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.warn("No audio sender with mid " + mid);
                    return true;
                }
                return !transceiver.sender.track.enabled;
            } else return !config.myStream.getAudioTracks()[0].enabled;
        }
    }
    function mute(handleId, mid, video, mute) {
        let pluginHandle = pluginHandles.get(handleId);
        if (!pluginHandle || !pluginHandle.webrtcStuff) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Invalid handle");
            return false;
        }
        let config = pluginHandle.webrtcStuff;
        if (!config.pc) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Invalid PeerConnection");
            return false;
        }
        if (!config.myStream) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Invalid local MediaStream");
            return false;
        }
        if (video) {
            // Mute/unmute video track
            if (!config.myStream.getVideoTracks() || config.myStream.getVideoTracks().length === 0) {
                $daf510f834517ce2$export$2e2bcd8739ae039.warn("No video track");
                return false;
            }
            if (mid) {
                let transceiver = config.pc.getTransceivers().find((t)=>t.mid === mid && t.receiver.track.kind === "video");
                if (!transceiver) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.warn("No video transceiver with mid " + mid);
                    return false;
                }
                if (!transceiver.sender || !transceiver.sender.track) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.warn("No video sender with mid " + mid);
                    return false;
                }
                transceiver.sender.track.enabled = mute ? false : true;
            } else for (const videostream of config.myStream.getVideoTracks())videostream.enabled = !mute;
        } else {
            // Mute/unmute audio track
            if (!config.myStream.getAudioTracks() || config.myStream.getAudioTracks().length === 0) {
                $daf510f834517ce2$export$2e2bcd8739ae039.warn("No audio track");
                return false;
            }
            if (mid) {
                let transceiver = config.pc.getTransceivers().find((t)=>t.mid === mid && t.receiver.track.kind === "audio");
                if (!transceiver) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.warn("No audio transceiver with mid " + mid);
                    return false;
                }
                if (!transceiver.sender || !transceiver.sender.track) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.warn("No audio sender with mid " + mid);
                    return false;
                }
                transceiver.sender.track.enabled = mute ? false : true;
            } else for (const audiostream of config.myStream.getAudioTracks())audiostream.enabled = !mute;
        }
        return true;
    }
    function getBitrate(handleId, mid) {
        let pluginHandle = pluginHandles.get(handleId);
        if (!pluginHandle || !pluginHandle.webrtcStuff) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Invalid handle");
            return "Invalid handle";
        }
        let config = pluginHandle.webrtcStuff;
        if (!config.pc) return "Invalid PeerConnection";
        // Start getting the bitrate, if getStats is supported
        if (config.pc.getStats) {
            let query = config.pc;
            let target = mid ? mid : "default";
            if (mid) {
                let transceiver = config.pc.getTransceivers().find((t)=>t.mid === mid && t.receiver.track.kind === "video");
                if (!transceiver) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.warn("No video transceiver with mid " + mid);
                    return "No video transceiver with mid " + mid;
                }
                if (!transceiver.receiver) {
                    $daf510f834517ce2$export$2e2bcd8739ae039.warn("No video receiver with mid " + mid);
                    return "No video receiver with mid " + mid;
                }
                query = transceiver.receiver;
            }
            if (!config.bitrate[target]) config.bitrate[target] = {
                timer: null,
                bsnow: null,
                bsbefore: null,
                tsnow: null,
                tsbefore: null,
                value: "0 kbits/sec"
            };
            if (!config.bitrate[target].timer) {
                $daf510f834517ce2$export$2e2bcd8739ae039.log("Starting bitrate timer" + (mid ? " for mid " + mid : "") + " (via getStats)");
                config.bitrate[target].timer = setInterval(function() {
                    query.getStats().then(function(stats) {
                        stats.forEach(function(res) {
                            if (!res) return;
                            let inStats = false;
                            // Check if these are statistics on incoming media
                            if ((res.mediaType === "video" || res.id.toLowerCase().indexOf("video") > -1) && res.type === "inbound-rtp" && res.id.indexOf("rtcp") < 0) // New stats
                            inStats = true;
                            else if (res.type == 'ssrc' && res.bytesReceived && (res.googCodecName === "VP8" || res.googCodecName === "")) // Older Chromer versions
                            inStats = true;
                            // Parse stats now
                            if (inStats) {
                                config.bitrate[target].bsnow = res.bytesReceived;
                                config.bitrate[target].tsnow = res.timestamp;
                                if (config.bitrate[target].bsbefore === null || config.bitrate[target].tsbefore === null) {
                                    // Skip this round
                                    config.bitrate[target].bsbefore = config.bitrate[target].bsnow;
                                    config.bitrate[target].tsbefore = config.bitrate[target].tsnow;
                                } else {
                                    // Calculate bitrate
                                    let timePassed = config.bitrate[target].tsnow - config.bitrate[target].tsbefore;
                                    if ($daf510f834517ce2$export$2e2bcd8739ae039.webRTCAdapter.browserDetails.browser === "safari") timePassed = timePassed / 1000; // Apparently the timestamp is in microseconds, in Safari
                                    let bitRate = Math.round((config.bitrate[target].bsnow - config.bitrate[target].bsbefore) * 8 / timePassed);
                                    if ($daf510f834517ce2$export$2e2bcd8739ae039.webRTCAdapter.browserDetails.browser === "safari") bitRate = parseInt(bitRate / 1000);
                                    config.bitrate[target].value = bitRate + ' kbits/sec';
                                    //~ Janus.log("Estimated bitrate is " + config.bitrate.value);
                                    config.bitrate[target].bsbefore = config.bitrate[target].bsnow;
                                    config.bitrate[target].tsbefore = config.bitrate[target].tsnow;
                                }
                            }
                        });
                    });
                }, 1000);
                return "0 kbits/sec"; // We don't have a bitrate value yet
            }
            return config.bitrate[target].value;
        } else {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn("Getting the video bitrate unsupported by browser");
            return "Feature unsupported by browser";
        }
    }
    function setBitrate(handleId, mid, bitrate) {
        let pluginHandle = pluginHandles.get(handleId);
        if (!pluginHandle || !pluginHandle.webrtcStuff) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn('Invalid handle');
            return;
        }
        let config = pluginHandle.webrtcStuff;
        if (!config.pc) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn('Invalid PeerConnection');
            return;
        }
        let transceiver = config.pc.getTransceivers().find((t)=>t.mid === mid);
        if (!transceiver) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn('No transceiver with mid', mid);
            return;
        }
        if (!transceiver.sender) {
            $daf510f834517ce2$export$2e2bcd8739ae039.warn('No sender for transceiver with mid', mid);
            return;
        }
        let params = transceiver.sender.getParameters();
        if (!params || !params.encodings || params.encodings.length === 0) $daf510f834517ce2$export$2e2bcd8739ae039.warn('No parameters encodings');
        else if (params.encodings.length > 1) $daf510f834517ce2$export$2e2bcd8739ae039.warn('Ignoring bitrate for simulcast track, use sendEncodings for that');
        else if (isNaN(bitrate) || bitrate < 0) $daf510f834517ce2$export$2e2bcd8739ae039.warn('Invalid bitrate (must be a positive integer)');
        else {
            params.encodings[0].maxBitrate = bitrate;
            transceiver.sender.setParameters(params);
        }
    }
    function webrtcError(error) {
        $daf510f834517ce2$export$2e2bcd8739ae039.error("WebRTC error:", error);
    }
    function cleanupWebrtc(handleId, hangupRequest) {
        $daf510f834517ce2$export$2e2bcd8739ae039.log("Cleaning WebRTC stuff");
        let pluginHandle = pluginHandles.get(handleId);
        if (!pluginHandle) // Nothing to clean
        return;
        let config = pluginHandle.webrtcStuff;
        if (config) {
            if (hangupRequest === true) {
                // Send a hangup request (we don't really care about the response)
                let request = {
                    "janus": "hangup",
                    "transaction": $daf510f834517ce2$export$2e2bcd8739ae039.randomString(12)
                };
                if (pluginHandle.token) request["token"] = pluginHandle.token;
                if (apisecret) request["apisecret"] = apisecret;
                $daf510f834517ce2$export$2e2bcd8739ae039.debug("Sending hangup request (handle=" + handleId + "):");
                $daf510f834517ce2$export$2e2bcd8739ae039.debug(request);
                if (websockets) {
                    request["session_id"] = sessionId;
                    request["handle_id"] = handleId;
                    ws.send(JSON.stringify(request));
                } else $daf510f834517ce2$export$2e2bcd8739ae039.httpAPICall(server + "/" + sessionId + "/" + handleId, {
                    verb: 'POST',
                    withCredentials: withCredentials,
                    body: request
                });
            }
            // Cleanup stack
            if (config.volume) {
                if (config.volume["local"] && config.volume["local"].timer) clearInterval(config.volume["local"].timer);
                if (config.volume["remote"] && config.volume["remote"].timer) clearInterval(config.volume["remote"].timer);
            }
            for(let i in config.bitrate)if (config.bitrate[i].timer) clearInterval(config.bitrate[i].timer);
            config.bitrate = {};
            if (!config.streamExternal && config.myStream) {
                $daf510f834517ce2$export$2e2bcd8739ae039.log("Stopping local stream tracks");
                $daf510f834517ce2$export$2e2bcd8739ae039.stopAllTracks(config.myStream);
            }
            config.streamExternal = false;
            config.myStream = null;
            // Close PeerConnection
            try {
                config.pc.close();
            } catch (e) {
            // Do nothing
            }
            config.pc = null;
            config.candidates = null;
            config.mySdp = null;
            config.remoteSdp = null;
            config.iceDone = false;
            config.dataChannel = {};
            config.dtmfSender = null;
            config.insertableStreams = false;
        }
        pluginHandle.oncleanup();
    }
    function isTrickleEnabled(trickle) {
        $daf510f834517ce2$export$2e2bcd8739ae039.debug("isTrickleEnabled:", trickle);
        return trickle === false ? false : true;
    }
}


const $100e4ce74f810de6$export$ad206ce4dbda264c = {
    Incomingcall: 'incomingcall',
    RegistrationFailed: 'registration_failed',
    Registered: 'registered',
    Calling: 'calling',
    Accepting: 'accepting',
    Progress: 'progress',
    Accepted: 'accepted',
    Transfer: 'transfer',
    Hangup: 'hangup',
    Reject: 'reject',
    EmployerHangup: 'employer_hangup',
    CustomerHangup: 'customer_hangup',
    Missed: 'missed',
    Holding: 'holding',
    Unholding: 'unholding',
    Error: 'error',
    Destroyed: 'destroyed',
    ServerDown: 'server_down',
    Closing: 'closing'
};
const $100e4ce74f810de6$export$29528a89974a5514 = {
    BusyHere: 'Busy Here',
    ToBye: 'to BYE',
    SessionTerminated: 'Session Terminated',
    RequestTerminated: 'Request Terminated'
};
String.prototype.toEventSipGateWay = function() {
    return Object.values($100e4ce74f810de6$export$ad206ce4dbda264c).find((value)=>value === this);
};


var $4eae0a726ab50395$exports = {};
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof $4eae0a726ab50395$exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    $4eae0a726ab50395$exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : $4eae0a726ab50395$exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});


class $ca52eec7d4a3410f$export$41258f2d70482113 {
    constructor(){
        this.server = this._setServer();
        this.iceServers = null;
        this.janus = null;
        this.sipHandle = null;
        this.sipcall = null;
        this.sipcallHelper = null;
        this.opaqueId = "siptest-" + (0, $daf510f834517ce2$export$2e2bcd8739ae039).randomString(12);
        this.localTracks = {};
        this.remoteTracks = {};
        this.registered = false;
        this.registeredHelper = false;
        this.helpers = {};
        this.helpersCount = 0;
        this.checkHold = null;
        this.checkHoldHelper = null;
        this.ip;
        this.doAudio = true;
        this.dataJsep;
        this.dataJsepHelper;
        this.offerlessInvite = false;
        this.checkRegistered;
        this.checkRegisteredHelper;
        this.checkDevice = true;
        this.referId;
        this.referIdHelper;
        this.statusCallCurrent = null;
        this.debug = "false";
    }
    _setServer() {
        const rndInt = Math.floor(Math.random() * 100) + 1;
        return rndInt % 2 === 0 ? "https://janus.voip24h.vn/janus" : "https://janus2.voip24h.vn/janus";
    }
    static getInstance(debug2) {
        if (!$ca52eec7d4a3410f$export$41258f2d70482113.instance) $ca52eec7d4a3410f$export$41258f2d70482113.instance = new $ca52eec7d4a3410f$export$41258f2d70482113();
        $ca52eec7d4a3410f$export$41258f2d70482113.instance.debug = debug2;
        return $ca52eec7d4a3410f$export$41258f2d70482113.instance;
    }
    async initializeModule() {
        return new Promise((resolve, reject)=>{
            (0, $daf510f834517ce2$export$2e2bcd8739ae039).init({
                debug: this.debug,
                callback: ()=>{
                    if (!(0, $daf510f834517ce2$export$2e2bcd8739ae039).isWebrtcSupported()) return;
                    const iOS = [
                        'iPad',
                        'iPhone',
                        'iPod'
                    ].indexOf(navigator.platform) >= 0;
                    const eventName = iOS ? 'pagehide' : 'beforeunload';
                    const oldOBF = window["on" + eventName];
                    window.addEventListener(eventName, ()=>{
                        for(let s in (0, $daf510f834517ce2$export$2e2bcd8739ae039).sessions)if ((0, $daf510f834517ce2$export$2e2bcd8739ae039).sessions[s] && (0, $daf510f834517ce2$export$2e2bcd8739ae039).sessions[s].destroyOnUnload) {
                            (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("Destroying session " + s);
                            (0, $daf510f834517ce2$export$2e2bcd8739ae039).sessions[s].destroy({
                                unload: true,
                                notifyDestroyed: false
                            });
                        }
                        if (oldOBF && typeof oldOBF === "function") oldOBF();
                    });
                    this.janus = new (0, $daf510f834517ce2$export$2e2bcd8739ae039)({
                        server: this.server,
                        iceServers: this.iceServers,
                        success: ()=>this._attachPlugin(resolve, reject),
                        error: (error)=>{
                            (0, $daf510f834517ce2$export$2e2bcd8739ae039).error(error);
                            this._handleJanusError(error);
                            reject(error);
                        },
                        destroyed: ()=>this._handleJanusDestroyed()
                    });
                }
            });
        });
    }
    _attachPlugin(resolve, reject) {
        this.janus.attach({
            plugin: "janus.plugin.sip",
            opaqueId: this.opaqueId,
            success: (pluginHandle)=>{
                this.sipcall = pluginHandle;
                (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("Plugin attached! (" + this.sipcall.getPlugin() + ", id=" + this.sipcall.getId() + ")");
                resolve();
            },
            error: (error)=>{
                (0, $daf510f834517ce2$export$2e2bcd8739ae039).error("  -- Error attaching plugin...", error);
                reject(error);
            },
            consentDialog: (on)=>{
                (0, $daf510f834517ce2$export$2e2bcd8739ae039).debug("Consent dialog should be " + (on ? "on" : "off") + " now");
            },
            iceState: (state)=>{
                (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("ICE state changed to " + state);
            },
            mediaState: (medium, on, mid)=>{
                (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("Janus " + (on ? "started" : "stopped") + " receiving our " + medium + " (mid=" + mid + ")");
            },
            webrtcState: (on)=>{
                (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("Janus says our WebRTC PeerConnection is " + (on ? "up" : "down") + " now");
            },
            slowLink: (uplink, lost, mid)=>{
                (0, $daf510f834517ce2$export$2e2bcd8739ae039).warn("Janus reports problems " + (uplink ? "sending" : "receiving") + " packets on mid " + mid + " (" + lost + " lost packets)");
            },
            onmessage: (msg, jsep)=>this._handleOnMessage(msg, jsep),
            onlocaltrack: (track, on)=>this._handleOnLocalTrack(track, on),
            onremotetrack: (track, mid, on)=>this._handleOnRemoteTrack(track, mid, on),
            oncleanup: ()=>this._handleOnCleanup()
        });
    }
    _handleOnMessage(msg, jsep) {
        (0, $daf510f834517ce2$export$2e2bcd8739ae039).debug(" ::: Got a message :::", msg);
        const error = msg["error"];
        if (error) {
            if (this.registered) this.sipcall.hangup();
            return;
        }
        const callId = msg["call_id"];
        const result = msg["result"];
        const dataCallback = {};
        let pushEvent = this.statusCallCurrent?.onmessageOutSide;
        if (result && result["event"]) {
            let event = result["event"];
            switch(event){
                case (0, $100e4ce74f810de6$export$ad206ce4dbda264c).RegistrationFailed:
                    this.checkRegistered = "";
                    event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).RegistrationFailed;
                    (0, $daf510f834517ce2$export$2e2bcd8739ae039).warn("Registration failed: " + result["code"] + " " + result["reason"]);
                    break;
                case (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Registered:
                    event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Registered;
                    this._handleRegistered(result, jsep);
                    break;
                case (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Calling:
                    (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Calling;
                    (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("Waiting for the peer to answer...");
                    break;
                case (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Incomingcall:
                    this._handleIncomingCall(result, jsep, callId, dataCallback);
                    return;
                case (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Accepting:
                    return;
                case (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Progress:
                    event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Progress;
                    this._handleProgress(result, jsep);
                    break;
                case (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Accepted:
                    event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Accepted;
                    this._handleAccepted(result, jsep, callId);
                    break;
                case (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Transfer:
                    event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Transfer;
                    this._handleTransfer(result);
                    break;
                case (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Hangup:
                    this._handleHangup(result);
                    return;
                case (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Holding:
                    this.checkHold = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Holding;
                    event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Holding;
                    break;
                default:
                    this.checkHold = "";
                    event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Unholding;
            }
            pushEvent(event.toEventSipGateWay(), dataCallback);
        }
    }
    _handleRegistered(result, jsep) {
        this.checkRegistered = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Registered;
        (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("Successfully registered as " + result["username"] + "!");
        this.registered = true;
        this.master_id = result["master_id"];
        const div1 = document.createElement('div');
        div1.innerHTML = `<div class="hide" id="audiostream"></div>`;
        document.body.insertAdjacentElement('afterbegin', div1);
    }
    _handleIncomingCall(result, jsep, callId, dataCallback) {
        (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("Incoming call from " + result["username"] + "!");
        this.sipcall.callId = callId;
        const parts = result["username"].split(":");
        const partsPhone = parts[1].split("@");
        const phoneNumber = partsPhone[0];
        this.doAudio = true;
        if (jsep) {
            this.doAudio = jsep.sdp.indexOf("m=audio ") > -1;
            (0, $daf510f834517ce2$export$2e2bcd8739ae039).debug("Audio " + (this.doAudio ? "has" : "has NOT") + " been negotiated");
        } else {
            (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("This call doesn't contain an offer... we'll need to provide one ourselves");
            this.offerlessInvite = true;
        }
        let transfer = "";
        const referredBy = result["referred_by"];
        if (referredBy) {
            transfer = " (referred by " + referredBy + ")";
            transfer = transfer.replace(new RegExp('<', 'g'), '&lt');
            transfer = transfer.replace(new RegExp('>', 'g'), '&gt');
        }
        let rtpType = "";
        const srtp = result["srtp"];
        if (srtp === "sdes_optional") rtpType = " (SDES-SRTP offered)";
        else if (srtp === "sdes_mandatory") rtpType = " (SDES-SRTP mandatory)";
        let extra = "";
        if (this.offerlessInvite) extra = " (no SDP offer provided)";
        this.dataJsep = jsep;
        // dataCallback = { 'phonenumber': phoneNumber }
        let pushEvent = this.statusCallCurrent?.onmessageOutSide;
        dataCallback.phonenumber = phoneNumber;
        const event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Incomingcall;
        if (pushEvent) pushEvent(event.toEventSipGateWay(), dataCallback);
    }
    _handleProgress(result, jsep) {
        (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("There's early media from " + result["username"] + ", waiting for the call!", jsep);
        if (jsep) this.sipcall.handleRemoteJsep({
            jsep: jsep,
            error: ()=>{
                const hangup = {
                    request: "hangup"
                };
                this.sipcall.send({
                    message: hangup
                });
                this.sipcall.hangup();
            }
        });
    }
    _handleAccepted(result, jsep, callId) {
        this.sipcall.callId = callId;
        (0, $daf510f834517ce2$export$2e2bcd8739ae039).log(result["username"] + " accepted the call!", jsep);
        if (jsep) this.sipcall.handleRemoteJsep({
            jsep: jsep,
            error: ()=>{
                const hangup = {
                    request: "hangup"
                };
                this.sipcall.send({
                    message: hangup
                });
                this.sipcall.hangup();
            }
        });
    }
    _handleTransfer(result) {
        (0, $daf510f834517ce2$export$2e2bcd8739ae039).log(result["username"] + " is being transferred!", result);
    }
    _handleHangup(result) {
        (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("Call hung up (" + result["code"] + " " + result["reason"] + ")!");
        this.dataJsep = "";
        this.sipcall.hangup();
        this.sipcall.callId = null;
        this.doAudio = true;
        this.offerlessInvite = false;
        const dataCallback = {};
        let event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Hangup;
        const reasonHangup = result["reason"];
        switch(reasonHangup){
            case (0, $100e4ce74f810de6$export$29528a89974a5514).BusyHere:
                event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Reject;
                dataCallback.message = reasonHangup;
                break;
            case (0, $100e4ce74f810de6$export$29528a89974a5514).ToBye:
                event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).EmployerHangup;
                break;
            case (0, $100e4ce74f810de6$export$29528a89974a5514).SessionTerminated:
                event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).CustomerHangup;
                break;
            case (0, $100e4ce74f810de6$export$29528a89974a5514).RequestTerminated:
                event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Missed;
                break;
            default:
                event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Hangup;
        }
        let pushEvent = this.statusCallCurrent?.onmessageOutSide;
        if (pushEvent) pushEvent(event.toEventSipGateWay(), dataCallback);
    }
    _handleOnLocalTrack(track, on) {
        (0, $daf510f834517ce2$export$2e2bcd8739ae039).debug("Local track " + (on ? "added" : "removed") + ":", track);
        var trackId = track.id.replace(/[{}]/g, "");
        if (!on) {
            // Track removed, get rid of the stream and the rendering
            var stream = this.localTracks[trackId];
            if (stream) try {
                var tracks = stream.getTracks();
                for(var i in tracks){
                    var mst = tracks[i];
                    if (mst) mst.stop();
                }
            } catch (e) {}
            delete this.localTracks[trackId];
            return;
        }
        // If we're here, a new track was added
        var stream = this.localTracks[trackId];
        if (stream) // We've been here already
        return;
        track.kind;
        this.sipcall.webrtcStuff.pc.iceConnectionState !== "completed" && this.sipcall.webrtcStuff.pc.iceConnectionState;
    }
    _handleOnRemoteTrack(track, mid, on) {
        (0, $daf510f834517ce2$export$2e2bcd8739ae039).debug("Remote track (mid=" + mid + ") " + (on ? "added" : "removed") + ":", track);
        if (!on) {
            // Track removed, get rid of the stream and the rendering
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('#peervideom' + mid).remove();
            delete this.remoteTracks[mid];
            return;
        }
        // If we're here, a new track was added
        if (track.kind === "audio") {
            // New audio track: create a stream out of it, and use a hidden <audio> element
            const stream = new MediaStream([
                track
            ]);
            this.remoteTracks[mid] = stream;
            (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("Created remote audio stream:", stream);
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('#audiostream').append('<audio class="hide" id="peervideom' + mid + '" autoplay playsinline/>');
            (0, $daf510f834517ce2$export$2e2bcd8739ae039).attachMediaStream((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('#peervideom' + mid).get(0), stream);
        }
    }
    _handleOnCleanup() {
        (0, $daf510f834517ce2$export$2e2bcd8739ae039).log(" ::: Got a cleanup notification :::");
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('#audiostream').empty();
        if (this.sipcall) {
            delete this.sipcall.callId;
            delete this.sipcall.doAudio;
        }
        this.localTracks = {};
        this.remoteTracks = {};
    }
    _handleJanusError(error) {
        if (this.checkDevice) {
            (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("check device");
            return;
        }
        const userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf("android") > -1 || userAgent.indexOf("iphone") > -1) {
            console.error("Janus error, missing permission", error);
            return;
        }
        this.checkDevice = true;
        let pushEvent = this.statusCallCurrent?.onmessageOutSide;
        if (pushEvent) pushEvent(error, error);
    // this.initializeModule();
    }
    _handleJanusDestroyed() {
        window.location.reload();
    }
    pushEventToSide = (callbackToOutSide)=>{
        this.statusCallCurrent = typeof callbackToOutSide.onmessageOutSide == "function" ? callbackToOutSide : ()=>{};
        callbackToOutSide.onmessageOutSide = typeof callbackToOutSide.onmessageOutSide == "function" ? callbackToOutSide.onmessageOutSide : ()=>{};
        this.onmessageOutSide = callbackToOutSide.onmessageOutSide;
    };
    hangUp() {
        (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("Hanging up call");
        var hangup = {
            request: "hangup"
        };
        this.sipcall.send({
            message: hangup
        });
        this.sipcall.hangup();
    }
    registerSip = async (ipSip, sip, secret)=>{
        var sipserver = null;
        var username = null;
        var password = null;
        var register = null;
        this.ip = ipSip;
        sipserver = "sip:" + ipSip;
        username = "sip:" + sip + "@" + ipSip;
        password = secret;
        register = {
            request: "register",
            username: username
        };
        var authuser = sip;
        if (authuser !== "") register.authuser = authuser;
        var displayname = sip;
        if (displayname !== "") register.display_name = displayname;
        register["secret"] = password;
        register["proxy"] = sipserver;
        this.sipcall?.send({
            message: register
        });
    };
    isRegistered() {
        return this.checkRegistered == (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Registered;
    }
    call = async (phonenumber)=>{
        if (this.isRegistered() === true) {
            // this.hangUp();
            const helperId = null;
            const handle = helperId ? helpers[helperId].sipcall : this.sipcall;
            const prefix = helperId ? `[Helper #${helperId}]` : "";
            const usernameAc = `sip:${phonenumber}@${this.ip}`;
            handle.doAudio = true;
            const tracks = [
                {
                    type: "audio",
                    capture: true,
                    recv: true
                }
            ];
            return new Promise((resolve)=>{
                handle.createOffer({
                    tracks: tracks,
                    success: (jsep)=>{
                        (0, $daf510f834517ce2$export$2e2bcd8739ae039).debug("Got SDP!", jsep);
                        const body = {
                            request: "call",
                            uri: usernameAc,
                            autoaccept_reinvites: false
                        };
                        handle.send({
                            message: body,
                            jsep: jsep
                        });
                        resolve(true);
                    },
                    error: (error)=>{
                        (0, $daf510f834517ce2$export$2e2bcd8739ae039).error(`${prefix} WebRTC error...`, error);
                        if (String(error).includes("Requested device not found")) {
                            this.checkDevice = false;
                            resolve("DEVICE_NOT_FOUND");
                        }
                        resolve(false);
                    }
                });
            });
        } else {
            (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("You must be registered with SIP before calling!");
            return false;
        }
    };
    call_ext = async (phonenumber)=>{
        if (this.isRegistered() === true) {
            // this.hangUp();
            const helperId = null;
            const handle = helperId ? helpers[helperId].sipcall : this.sipcall;
            const prefix = helperId ? `[Helper #${helperId}]` : "";
            const usernameAc = `sip:${phonenumber}@${this.ip}`;
            handle.doAudio = true;
            const tracks = [
                {
                    type: "audio",
                    capture: true,
                    recv: true
                }
            ];
            handle.createOffer({
                tracks: tracks,
                success: (jsep)=>{
                    (0, $daf510f834517ce2$export$2e2bcd8739ae039).debug("Got SDP!", jsep);
                    const body = {
                        request: "call",
                        uri: usernameAc,
                        autoaccept_reinvites: false
                    };
                    handle.send({
                        message: body,
                        jsep: jsep
                    });
                },
                error: (error)=>{
                    (0, $daf510f834517ce2$export$2e2bcd8739ae039).error(`${prefix} WebRTC error...`, error);
                    if (String(error).includes("Requested device not found")) this.checkDevice = false;
                }
            });
        } else {
            (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("You must be registered with SIP before calling!");
            return false;
        }
    };
    reject = async ()=>{
        var body = {
            request: "decline"
        };
        this.sipcall.send({
            message: body
        });
    };
    answer = async ()=>{
        var sipcallAction = this.offerlessInvite ? this.sipcall.createOffer : this.sipcall.createAnswer;
        console.log(sipcallAction);
        let tracks = [];
        var sipcall = this.sipcall;
        if (this.doAudio) {
            var doAudio = true;
            tracks.push({
                type: 'audio',
                capture: true,
                recv: true
            });
            sipcallAction({
                jsep: this.dataJsep,
                tracks: tracks,
                success: function(dataJsep) {
                    (0, $daf510f834517ce2$export$2e2bcd8739ae039).debug("Got SDP " + dataJsep.type + "! audio=" + doAudio + ":", dataJsep);
                    sipcall.doAudio = doAudio;
                    var body = {
                        request: "accept"
                    };
                    body["autoaccept_reinvites"] = false;
                    sipcall.send({
                        message: body,
                        jsep: dataJsep
                    });
                },
                error: function(error) {
                    (0, $daf510f834517ce2$export$2e2bcd8739ae039).error("WebRTC error:", error);
                    var body = {
                        request: "decline",
                        code: 480
                    };
                    sipcall.send({
                        message: body
                    });
                }
            });
        }
    };
    toggleHold = ()=>{
        if (this.checkHold != (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Holding) {
            var holdaction = {
                request: "hold",
                direction: "sendonly"
            };
            this.sipcall.send({
                message: holdaction
            });
        } else {
            var unholdaction = {
                request: "unhold"
            };
            this.sipcall.send({
                message: unholdaction
            });
        }
    };
    toggleMute = ()=>{
        let muted = this.sipcall.isAudioMuted();
        (0, $daf510f834517ce2$export$2e2bcd8739ae039).log((muted ? "Unmuting" : "Muting") + " local stream...");
        if (muted) this.sipcall.unmuteAudio();
        else this.sipcall.muteAudio();
        muted = this.sipcall.isAudioMuted();
    };
    transfer = (transferToNumber)=>{
        var address = "sip:" + transferToNumber + "@" + this.ip;
        if (address === '') return;
        var msg = {
            request: "transfer",
            uri: address
        };
        this.sipcall.send({
            message: msg
        });
        var sipcall = this.sipcall;
        setTimeout(function() {
            sipcall.hangup();
        }, 2000);
    };
    sendDtmf = (number)=>{
        this.sipcall.dtmf({
            dtmf: {
                tones: number
            }
        });
    };
    isMute = ()=>{
        return this.sipcall.isAudioMuted();
    };
    isHold = ()=>{
        return this.checkHold == (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Holding;
    };
    hasCheckDevice = ()=>{
        var checkDevice = this.checkDevice;
        return new Promise(function(resolve, reject) {
            setTimeout(function() {
                resolve(checkDevice);
            }, 500);
        });
    };
    release = ()=>{
        this.janus.destroy();
        this.server = "";
        this.iceServers = "";
        this.janus = "";
        this.sipcall = "";
        this.opaqueId = "";
        this.localTracks = {};
        this.remoteTracks = {};
        this.registered = false;
        this.helpers = {};
        this.helpersCount = 0;
        this.incoming = "";
        this.checkHold = "";
        this.ip = "";
        this.doAudio = "";
        this.dataJsep = "";
        this.offerlessInvite = "";
        this.checkRegistered = "";
        return;
    };
    //Actions call waiting by add new a session helper
    addHelperForCallWaiting = (sip)=>{
        if (this.helpersCount == 0) {
            this.helpersCount++;
            this.sipHandle = new (0, $daf510f834517ce2$export$2e2bcd8739ae039)({
                server: this.server,
                success: ()=>{
                    // Attach to the SIP plugin
                    this.sipHandle.attach({
                        plugin: "janus.plugin.sip",
                        success: (pluginHandle)=>{
                            this.sipcallHelper = pluginHandle;
                            this.sipcallHelper.send({
                                message: {
                                    request: "register",
                                    username: "sip:" + sip + "@" + this.ip,
                                    // secret: secret,
                                    // display_name: sip,
                                    type: "helper",
                                    master_id: this.master_id
                                },
                                success: (response)=>{
                                    (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("Helper session registered:", "success");
                                },
                                error: (error)=>{
                                    (0, $daf510f834517ce2$export$2e2bcd8739ae039).error("Helper session registration failed:", error);
                                }
                            });
                        },
                        error: (error)=>{
                            (0, $daf510f834517ce2$export$2e2bcd8739ae039).error("Helper session attach failed:", error);
                        },
                        onmessage: (msg, jsep)=>this._handleOnMessageHelper(msg, jsep),
                        onlocaltrack: (track, on)=>this._handleOnLocalTrackHelper(track, on),
                        onremotetrack: (track, mid, on)=>this._handleOnRemoteTrackHelper(track, mid, on),
                        oncleanup: ()=>this._handleOnCleanupHelper()
                    });
                },
                error: (error)=>{
                    (0, $daf510f834517ce2$export$2e2bcd8739ae039).error("SIP session attach failed:", error);
                },
                destroyed: ()=>{
                    (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("SIP session destroyed");
                }
            });
        }
    };
    _handleOnMessageHelper(msg, jsep) {
        (0, $daf510f834517ce2$export$2e2bcd8739ae039).debug(" ::: Got a message :::", msg);
        const error = msg["error"];
        if (error) {
            if (this.registeredHelper) this.sipcallHelper.hangup();
            return;
        }
        const callId = msg["call_id"];
        const result = msg["result"];
        const dataCallback = {};
        let pushEvent = this.statusCallCurrent?.onmessageOutSide;
        if (result && result["event"]) {
            let event = result["event"];
            switch(event){
                case (0, $100e4ce74f810de6$export$ad206ce4dbda264c).RegistrationFailed:
                    this.checkRegisteredHelper = "";
                    event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).RegistrationFailed;
                    (0, $daf510f834517ce2$export$2e2bcd8739ae039).warn("Registration helper failed: " + result["code"] + " " + result["reason"]);
                    break;
                case (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Registered:
                    event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Registered;
                    this._handleRegisteredHelper(result, jsep);
                    break;
                case (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Calling:
                    (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Calling;
                    (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("Waiting for the peer to answer...");
                    break;
                case (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Incomingcall:
                    this._handleIncomingCallHelper(result, jsep, callId, dataCallback);
                    return;
                case (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Accepting:
                    return;
                case (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Progress:
                    event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Progress;
                    this._handleProgressHelper(result, jsep);
                    break;
                case (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Accepted:
                    event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Accepted;
                    this._handleAcceptedHelper(result, jsep, callId);
                    break;
                case (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Transfer:
                    event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Transfer;
                    this._handleTransferHelper(result);
                    break;
                case (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Hangup:
                    this._handleHangupHelper(result);
                    return;
                case (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Holding:
                    this.checkHoldHelper = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Holding;
                    event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Holding;
                    break;
                default:
                    this.checkHoldHelper = "";
                    event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Unholding;
            }
            pushEvent(event.toEventSipGateWay(), dataCallback);
        }
    }
    _handleRegisteredHelper(result, jsep) {
        this.checkRegisteredHelper = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Registered;
        (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("Successfully registered helper as " + result["username"] + "!");
        this.registeredHelper = true;
    // const div1 = document.createElement('div');
    // div1.innerHTML = `<div class="hide" id="audiostream"></div>`;
    // document.body.insertAdjacentElement('afterbegin', div1);
    }
    _handleIncomingCallHelper(result, jsep, callId, dataCallback) {
        (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("Incoming call helper from " + result["username"] + "!");
        this.sipcallHelper.callId = callId;
        const parts = result["username"].split(":");
        const partsPhone = parts[1].split("@");
        const phoneNumber = partsPhone[0];
        this.doAudio = true;
        if (jsep) {
            this.doAudio = jsep.sdp.indexOf("m=audio ") > -1;
            (0, $daf510f834517ce2$export$2e2bcd8739ae039).debug("Audio " + (this.doAudio ? "has" : "has NOT") + " been negotiated");
        } else {
            (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("This call doesn't contain an offer... we'll need to provide one ourselves");
            this.offerlessInvite = true;
        }
        let transfer = "";
        const referredBy = result["referred_by"];
        if (referredBy) {
            transfer = " (referred by " + referredBy + ")";
            transfer = transfer.replace(new RegExp('<', 'g'), '&lt');
            transfer = transfer.replace(new RegExp('>', 'g'), '&gt');
        }
        let rtpType = "";
        const srtp = result["srtp"];
        if (srtp === "sdes_optional") rtpType = " (SDES-SRTP offered)";
        else if (srtp === "sdes_mandatory") rtpType = " (SDES-SRTP mandatory)";
        let extra = "";
        if (this.offerlessInvite) extra = " (no SDP offer provided)";
        this.dataJsepHelper = jsep;
        // dataCallback = { 'phonenumber': phoneNumber }
        let pushEvent = this.statusCallCurrent?.onmessageOutSide;
        dataCallback.phonenumberHelper = phoneNumber;
        const event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Incomingcall;
        if (pushEvent) pushEvent(event.toEventSipGateWay(), dataCallback);
    }
    _handleProgressHelper(result, jsep) {
        (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("There's early media from " + result["username"] + ", waiting for the call!", jsep);
        if (jsep) this.sipcallHelper.handleRemoteJsep({
            jsep: jsep,
            error: ()=>{
                const hangup = {
                    request: "hangup"
                };
                this.sipcallHelper.send({
                    message: hangup
                });
                this.sipcallHelper.hangup();
            }
        });
    }
    _handleAcceptedHelper(result, jsep, callId) {
        this.sipcallHelper.callId = callId;
        (0, $daf510f834517ce2$export$2e2bcd8739ae039).log(result["username"] + " accepted the call!", jsep);
        if (jsep) this.sipcallHelper.handleRemoteJsep({
            jsep: jsep,
            error: ()=>{
                const hangup = {
                    request: "hangup"
                };
                this.sipcallHelper.send({
                    message: hangup
                });
                this.sipcallHelper.hangup();
            }
        });
    }
    _handleTransferHelper(result) {
        (0, $daf510f834517ce2$export$2e2bcd8739ae039).log(result["username"] + " is being transferred!", result);
    }
    _handleHangupHelper(result) {
        (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("Call hung up (" + result["code"] + " " + result["reason"] + ")!");
        this.dataJsepHelper = "";
        this.sipcallHelper.hangup();
        this.sipcallHelper.callId = null;
        this.doAudio = true;
        this.offerlessInvite = false;
        const dataCallback = {};
        let event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Hangup;
        const reasonHangup = result["reason"];
        switch(reasonHangup){
            case (0, $100e4ce74f810de6$export$29528a89974a5514).BusyHere:
                event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Reject;
                dataCallback.message = reasonHangup;
                break;
            case (0, $100e4ce74f810de6$export$29528a89974a5514).ToBye:
                event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).EmployerHangup;
                break;
            case (0, $100e4ce74f810de6$export$29528a89974a5514).SessionTerminated:
                event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).CustomerHangup;
                break;
            case (0, $100e4ce74f810de6$export$29528a89974a5514).RequestTerminated:
                event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Missed;
                break;
            default:
                event = (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Hangup;
        }
        let pushEvent = this.statusCallCurrent?.onmessageOutSide;
        if (pushEvent) pushEvent(event.toEventSipGateWay(), dataCallback);
    }
    _handleOnLocalTrackHelper(track, on) {
        (0, $daf510f834517ce2$export$2e2bcd8739ae039).debug("Local track " + (on ? "added" : "removed") + ":", track);
        var trackId = track.id.replace(/[{}]/g, "");
        if (!on) {
            // Track removed, get rid of the stream and the rendering
            var stream = this.localTracks[trackId];
            if (stream) try {
                var tracks = stream.getTracks();
                for(var i in tracks){
                    var mst = tracks[i];
                    if (mst) mst.stop();
                }
            } catch (e) {}
            delete this.localTracks[trackId];
            return;
        }
        // If we're here, a new track was added
        var stream = this.localTracks[trackId];
        if (stream) // We've been here already
        return;
        track.kind;
        this.sipcallHelper.webrtcStuff.pc.iceConnectionState !== "completed" && this.sipcallHelper.webrtcStuff.pc.iceConnectionState;
    }
    _handleOnRemoteTrackHelper(track, mid, on) {
        (0, $daf510f834517ce2$export$2e2bcd8739ae039).debug("Remote track (mid=" + mid + ") " + (on ? "added" : "removed") + ":", track);
        if (!on) {
            // Track removed, get rid of the stream and the rendering
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('#peervideom' + mid).remove();
            delete this.remoteTracks[mid];
            return;
        }
        // If we're here, a new track was added
        if (track.kind === "audio") {
            // New audio track: create a stream out of it, and use a hidden <audio> element
            const stream = new MediaStream([
                track
            ]);
            this.remoteTracks[mid] = stream;
            (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("Created remote audio stream:", stream);
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('#audiostream').append('<audio class="hide" id="peervideom' + mid + '" autoplay playsinline/>');
            (0, $daf510f834517ce2$export$2e2bcd8739ae039).attachMediaStream((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('#peervideom' + mid).get(0), stream);
        }
    }
    _handleOnCleanupHelper() {
        (0, $daf510f834517ce2$export$2e2bcd8739ae039).log(" ::: Got a cleanup notification :::");
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('#audiostream').empty();
        if (this.sipcallHelper) {
            delete this.sipcallHelper.callId;
            delete this.sipcallHelper.doAudio;
        }
        this.localTracks = {};
        this.remoteTracks = {};
    }
    _handleJanusErrorHelper(error) {
        if (this.checkDevice) {
            (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("check device");
            return;
        }
        const userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf("android") > -1 || userAgent.indexOf("iphone") > -1) {
            console.error("Janus error, missing permission", error);
            return;
        }
        this.checkDevice = true;
    // this.initializeModule();
    }
    _handleJanusDestroyedHelper() {
        window.location.reload();
    }
    hangUpHelper() {
        (0, $daf510f834517ce2$export$2e2bcd8739ae039).log("Hanging up call");
        this.sipcallHelper.hangup();
    }
    isRegisteredHelper() {
        return this.checkRegistered == (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Registered;
    }
    rejectHelper = async ()=>{
        var body = {
            request: "decline"
        };
        this.sipcallHelper.send({
            message: body
        });
    };
    answerHelper = async ()=>{
        var sipcallAction = this.offerlessInvite ? this.sipcallHelper.createOffer : this.sipcallHelper.createAnswer;
        let tracks = [];
        var sipcall = this.sipcallHelper;
        if (this.doAudio) {
            var doAudio = true;
            tracks.push({
                type: 'audio',
                capture: true,
                recv: true
            });
            sipcallAction({
                jsep: this.dataJsepHelper,
                tracks: tracks,
                success: function(dataJsepHelper) {
                    (0, $daf510f834517ce2$export$2e2bcd8739ae039).debug("Got SDP " + dataJsepHelper.type + "! audio=" + doAudio + ":", dataJsepHelper);
                    sipcall.doAudio = doAudio;
                    var body = {
                        request: "accept"
                    };
                    body["autoaccept_reinvites"] = false;
                    sipcall.send({
                        message: body,
                        jsep: dataJsepHelper
                    });
                },
                error: function(error) {
                    (0, $daf510f834517ce2$export$2e2bcd8739ae039).error("WebRTC error:", error);
                    var body = {
                        request: "decline",
                        code: 480
                    };
                    sipcall.send({
                        message: body
                    });
                }
            });
        }
    };
    toggleHoldHelper = ()=>{
        if (this.checkHoldHelper != (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Holding) {
            var holdaction = {
                request: "hold",
                direction: "sendonly"
            };
            this.sipcallHelper.send({
                message: holdaction
            });
        } else {
            var unholdaction = {
                request: "unhold"
            };
            this.sipcallHelper.send({
                message: unholdaction
            });
        }
    };
    toggleMuteHelper = ()=>{
        let muted = this.sipcallHelper.isAudioMuted();
        (0, $daf510f834517ce2$export$2e2bcd8739ae039).log((muted ? "Unmuting" : "Muting") + " local stream...");
        if (muted) this.sipcallHelper.unmuteAudio();
        else this.sipcallHelper.muteAudio();
        muted = this.sipcallHelper.isAudioMuted();
    };
    transferHelper = (transferToNumber)=>{
        var address = "sip:" + transferToNumber + "@" + this.ip;
        if (address === '') return;
        var msg = {
            request: "transfer",
            uri: address
        };
        this.sipcallHelper.send({
            message: msg
        });
        var sipcall = this.sipcallHelper;
        setTimeout(function() {
            sipcall.hangup();
        }, 2000);
    };
    sendDtmfHelper = (number)=>{
        this.sipcallHelper.dtmf({
            dtmf: {
                tones: number
            }
        });
    };
    isMuteHelper = ()=>{
        return this.sipcallHelper.isAudioMuted();
    };
    isHoldHelper = ()=>{
        return this.checkHoldHelper == (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Holding;
    };
    releaseSessionHelper = ()=>{
        this.sipHandle.destroy();
    };
}


// src/background.js
// Toàn bộ mã JavaScript của hiệu ứng nền (canvas, particles, ripples, mouse, init, animate, Particle class, v.v.)
// đã từng nằm trong thẻ <script> của index.html.txt
const $ddc984d9440f81ec$var$canvas = document.getElementById('background-canvas');
const $ddc984d9440f81ec$var$ctx = $ddc984d9440f81ec$var$canvas.getContext('2d');
$ddc984d9440f81ec$var$canvas.width = window.innerWidth;
$ddc984d9440f81ec$var$canvas.height = window.innerHeight;
let $ddc984d9440f81ec$var$particlesArray = [];
let $ddc984d9440f81ec$var$ripplesArray = [];
const $ddc984d9440f81ec$var$mouse = {
    x: null,
    y: null,
    radius: 150
};
window.addEventListener('mousemove', function(event) {
    $ddc984d9440f81ec$var$mouse.x = event.x;
    $ddc984d9440f81ec$var$mouse.y = event.y;
});
window.addEventListener('mouseout', function() {
    $ddc984d9440f81ec$var$mouse.x = null;
    $ddc984d9440f81ec$var$mouse.y = null;
});
window.addEventListener('click', function(event) {
    $ddc984d9440f81ec$var$mouse.x = event.x;
    $ddc984d9440f81ec$var$mouse.y = event.y;
    $ddc984d9440f81ec$var$ripplesArray.push({
        x: $ddc984d9440f81ec$var$mouse.x,
        y: $ddc984d9440f81ec$var$mouse.y,
        radius: 5,
        maxRadius: 100,
        speed: 0.8,
        opacity: 1,
        lineWidth: 3
    });
});
class $ddc984d9440f81ec$var$Particle {
    constructor(x, y, directionX, directionY, size, color){
        this.x = x;
        this.y = y;
        this.directionX = directionX;
        this.directionY = directionY;
        this.size = size;
        this.color = color;
    }
    draw() {
        $ddc984d9440f81ec$var$ctx.beginPath();
        $ddc984d9440f81ec$var$ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2, false);
        $ddc984d9440f81ec$var$ctx.fillStyle = this.color;
        $ddc984d9440f81ec$var$ctx.fill();
    }
    update() {
        if (this.x > $ddc984d9440f81ec$var$canvas.width || this.x < 0) this.directionX = -this.directionX;
        if (this.y > $ddc984d9440f81ec$var$canvas.height || this.y < 0) this.directionY = -this.directionY;
        this.x += this.directionX;
        this.y += this.directionY;
        this.draw();
    }
}
function $ddc984d9440f81ec$var$initBackgroundParticles() {
    $ddc984d9440f81ec$var$particlesArray = [];
    let numberOfParticles = $ddc984d9440f81ec$var$canvas.height * $ddc984d9440f81ec$var$canvas.width / 3500;
    for(let i = 0; i < numberOfParticles; i++){
        let size = Math.random() * 2 + 1;
        let x = Math.random() * (innerWidth - size * 2 - size * 2) + size * 2;
        let y = Math.random() * (innerHeight - size * 2 - size * 2) + size * 2;
        let directionX = Math.random() * 0.4 - 0.2;
        let directionY = Math.random() * 0.4 - 0.2;
        let color = 'rgba(60, 72, 88, 0.7)';
        $ddc984d9440f81ec$var$particlesArray.push(new $ddc984d9440f81ec$var$Particle(x, y, directionX, directionY, size, color));
    }
}
function $ddc984d9440f81ec$var$connectParticles() {
    let opacityValue = 1;
    const connectDistSquare = 12100;
    const mouseRadiusSquare = $ddc984d9440f81ec$var$mouse.radius * $ddc984d9440f81ec$var$mouse.radius;
    for(let a = 0; a < $ddc984d9440f81ec$var$particlesArray.length; a++){
        if ($ddc984d9440f81ec$var$mouse.x != null && $ddc984d9440f81ec$var$mouse.y != null) {
            let distanceToMouse = ($ddc984d9440f81ec$var$particlesArray[a].x - $ddc984d9440f81ec$var$mouse.x) * ($ddc984d9440f81ec$var$particlesArray[a].x - $ddc984d9440f81ec$var$mouse.x) + ($ddc984d9440f81ec$var$particlesArray[a].y - $ddc984d9440f81ec$var$mouse.y) * ($ddc984d9440f81ec$var$particlesArray[a].y - $ddc984d9440f81ec$var$mouse.y);
            if (distanceToMouse < mouseRadiusSquare) {
                opacityValue = 1 - distanceToMouse / mouseRadiusSquare;
                $ddc984d9440f81ec$var$ctx.strokeStyle = `rgba(0, 123, 255, ${opacityValue})`;
                $ddc984d9440f81ec$var$ctx.lineWidth = 1.5;
                $ddc984d9440f81ec$var$ctx.beginPath();
                $ddc984d9440f81ec$var$ctx.moveTo($ddc984d9440f81ec$var$particlesArray[a].x, $ddc984d9440f81ec$var$particlesArray[a].y);
                $ddc984d9440f81ec$var$ctx.lineTo($ddc984d9440f81ec$var$mouse.x, $ddc984d9440f81ec$var$mouse.y);
                $ddc984d9440f81ec$var$ctx.stroke();
            }
        }
        for(let b = a; b < $ddc984d9440f81ec$var$particlesArray.length; b++){
            let distance = ($ddc984d9440f81ec$var$particlesArray[a].x - $ddc984d9440f81ec$var$particlesArray[b].x) * ($ddc984d9440f81ec$var$particlesArray[a].x - $ddc984d9440f81ec$var$particlesArray[b].x) + ($ddc984d9440f81ec$var$particlesArray[a].y - $ddc984d9440f81ec$var$particlesArray[b].y) * ($ddc984d9440f81ec$var$particlesArray[a].y - $ddc984d9440f81ec$var$particlesArray[b].y);
            if (distance < connectDistSquare) {
                opacityValue = 1 - distance / connectDistSquare;
                $ddc984d9440f81ec$var$ctx.strokeStyle = `rgba(60, 72, 88, ${opacityValue})`;
                $ddc984d9440f81ec$var$ctx.lineWidth = 0.8;
                $ddc984d9440f81ec$var$ctx.beginPath();
                $ddc984d9440f81ec$var$ctx.moveTo($ddc984d9440f81ec$var$particlesArray[a].x, $ddc984d9440f81ec$var$particlesArray[a].y);
                $ddc984d9440f81ec$var$ctx.lineTo($ddc984d9440f81ec$var$particlesArray[b].x, $ddc984d9440f81ec$var$particlesArray[b].y);
                $ddc984d9440f81ec$var$ctx.stroke();
            }
        }
    }
}
function $ddc984d9440f81ec$var$handleBackgroundRipples() {
    for(let i = $ddc984d9440f81ec$var$ripplesArray.length - 1; i >= 0; i--){
        const r = $ddc984d9440f81ec$var$ripplesArray[i];
        r.radius += r.speed;
        r.lineWidth -= 0.04;
        if (r.radius > r.maxRadius || r.lineWidth <= 0) $ddc984d9440f81ec$var$ripplesArray.splice(i, 1);
        else {
            $ddc984d9440f81ec$var$ctx.beginPath();
            $ddc984d9440f81ec$var$ctx.arc(r.x, r.y, r.radius, 0, Math.PI * 2);
            const opacity = 1 - r.radius / r.maxRadius;
            $ddc984d9440f81ec$var$ctx.strokeStyle = `rgba(0, 191, 255, ${opacity})`;
            $ddc984d9440f81ec$var$ctx.lineWidth = r.lineWidth;
            $ddc984d9440f81ec$var$ctx.stroke();
        }
    }
}
function $ddc984d9440f81ec$var$drawBackgroundMouseGlow() {
    if ($ddc984d9440f81ec$var$mouse.x === null) return;
    const glowRadius = 70;
    const gradient = $ddc984d9440f81ec$var$ctx.createRadialGradient($ddc984d9440f81ec$var$mouse.x, $ddc984d9440f81ec$var$mouse.y, 0, $ddc984d9440f81ec$var$mouse.x, $ddc984d9440f81ec$var$mouse.y, glowRadius);
    gradient.addColorStop(0, 'rgba(0, 191, 255, 0.25)');
    gradient.addColorStop(1, 'rgba(0, 191, 255, 0)');
    $ddc984d9440f81ec$var$ctx.beginPath();
    $ddc984d9440f81ec$var$ctx.arc($ddc984d9440f81ec$var$mouse.x, $ddc984d9440f81ec$var$mouse.y, glowRadius, 0, Math.PI * 2);
    $ddc984d9440f81ec$var$ctx.fillStyle = gradient;
    $ddc984d9440f81ec$var$ctx.fill();
}
function $ddc984d9440f81ec$var$animateBackground() {
    requestAnimationFrame($ddc984d9440f81ec$var$animateBackground);
    $ddc984d9440f81ec$var$ctx.clearRect(0, 0, innerWidth, innerHeight);
    for(let i = 0; i < $ddc984d9440f81ec$var$particlesArray.length; i++)$ddc984d9440f81ec$var$particlesArray[i].update();
    $ddc984d9440f81ec$var$connectParticles();
    $ddc984d9440f81ec$var$drawBackgroundMouseGlow();
    $ddc984d9440f81ec$var$handleBackgroundRipples();
}
function $ddc984d9440f81ec$export$f9606e15a6ee4049() {
    // Thêm listener cho resize ở đây
    window.addEventListener('resize', function() {
        $ddc984d9440f81ec$var$canvas.width = innerWidth;
        $ddc984d9440f81ec$var$canvas.height = innerHeight;
        $ddc984d9440f81ec$var$initBackgroundParticles();
    });
    $ddc984d9440f81ec$var$initBackgroundParticles();
    $ddc984d9440f81ec$var$animateBackground();
}


let $efd3ba4ec2608b1d$var$voip24hModuleInstance;
// === KHAI BÁO BIẾN DOM VÀ BIẾN TOÀN CỤC ===
let $efd3ba4ec2608b1d$var$logContainer, $efd3ba4ec2608b1d$var$logOutput, $efd3ba4ec2608b1d$var$phoneNumberField, $efd3ba4ec2608b1d$var$statusDiv, $efd3ba4ec2608b1d$var$tokenStatusDiv, $efd3ba4ec2608b1d$var$hangupStatusDiv, $efd3ba4ec2608b1d$var$mainContentContainer, $efd3ba4ec2608b1d$var$tokenEntryContainer, $efd3ba4ec2608b1d$var$ipRestrictionMessageDiv, $efd3ba4ec2608b1d$var$callButton, $efd3ba4ec2608b1d$var$hangupButton, $efd3ba4ec2608b1d$var$extensionDisplay, $efd3ba4ec2608b1d$var$controlExtensionDisplay, $efd3ba4ec2608b1d$var$tokenInput, $efd3ba4ec2608b1d$var$appLogo, $efd3ba4ec2608b1d$var$appContainer, $efd3ba4ec2608b1d$var$callControlContainer, $efd3ba4ec2608b1d$var$contactListContainer, $efd3ba4ec2608b1d$var$tokenEntryVersionSpan, $efd3ba4ec2608b1d$var$callControlVersionSpan, $efd3ba4ec2608b1d$var$appVersionSpan, $efd3ba4ec2608b1d$var$contactsVersionSpan, $efd3ba4ec2608b1d$var$peerStatusVersionSpan, $efd3ba4ec2608b1d$var$tokenEntrySupportPhoneSpan, $efd3ba4ec2608b1d$var$tokenEntrySupportNameSpan, $efd3ba4ec2608b1d$var$callControlSupportPhoneSpan, $efd3ba4ec2608b1d$var$callControlSupportNameSpan, $efd3ba4ec2608b1d$var$appSupportPhoneSpan, $efd3ba4ec2608b1d$var$appSupportNameSpan, $efd3ba4ec2608b1d$var$contactsSupportPhoneSpan, $efd3ba4ec2608b1d$var$contactsSupportNameSpan, $efd3ba4ec2608b1d$var$peerStatusSupportPhoneSpan, $efd3ba4ec2608b1d$var$peerStatusSupportNameSpan, $efd3ba4ec2608b1d$var$webrtcCallPopup, $efd3ba4ec2608b1d$var$callPopupTime, $efd3ba4ec2608b1d$var$callPopupAvatar, $efd3ba4ec2608b1d$var$callPopupName, $efd3ba4ec2608b1d$var$callPopupNumber, $efd3ba4ec2608b1d$var$callPopupTimer, $efd3ba4ec2608b1d$var$webrtcSpeakerButton, $efd3ba4ec2608b1d$var$webrtcKeypadButton, $efd3ba4ec2608b1d$var$webrtcMuteButton, $efd3ba4ec2608b1d$var$webrtcHoldButton, $efd3ba4ec2608b1d$var$webrtcAnswerButton, $efd3ba4ec2608b1d$var$webrtcDeclineButton, $efd3ba4ec2608b1d$var$webrtcHangupButton, $efd3ba4ec2608b1d$var$webRtcCallButton, $efd3ba4ec2608b1d$var$tokenSubmitButton, $efd3ba4ec2608b1d$var$callPopupStatus;
let $efd3ba4ec2608b1d$var$peerStatusList, $efd3ba4ec2608b1d$var$peerStatusInterval = null, $efd3ba4ec2608b1d$var$peerStatusTimestamp;
// Biến DOM cho Zalo
let $efd3ba4ec2608b1d$var$zaloMessagesContainer, $efd3ba4ec2608b1d$var$zaloMessageList, $efd3ba4ec2608b1d$var$openZaloBtn, $efd3ba4ec2608b1d$var$closeZaloBtn, $efd3ba4ec2608b1d$var$zaloVersionSpan, $efd3ba4ec2608b1d$var$zaloSupportPhoneSpan, $efd3ba4ec2608b1d$var$zaloSupportNameSpan, $efd3ba4ec2608b1d$var$zaloNotificationModal, $efd3ba4ec2608b1d$var$zaloModalConfirmBtn;
// === CÁC BIẾN TRẠNG THÁI VÀ CẤU HÌNH ===
const $efd3ba4ec2608b1d$var$nonNumericInputErrorMsg = "Ch\u1EC9 h\u1ED7 tr\u1EE3 nh\u1EADp s\u1ED1. Vui l\xf2ng kh\xf4ng nh\u1EADp ch\u1EEF ho\u1EB7c k\xfd t\u1EF1.";
let $efd3ba4ec2608b1d$var$statusClearTimer = null;
let $efd3ba4ec2608b1d$var$currentActiveExtension = null;
let $efd3ba4ec2608b1d$var$currentEmployeeName = null;
let $efd3ba4ec2608b1d$var$currentSipPassword = null;
let $efd3ba4ec2608b1d$var$currentAppVersion = "\u0110ang t\u1EA3i...";
let $efd3ba4ec2608b1d$var$currentSupportPhone = "\u0110ang t\u1EA3i...";
let $efd3ba4ec2608b1d$var$currentSupportPersonName = "\u0110ang t\u1EA3i...";
const $efd3ba4ec2608b1d$var$SAVED_TOKEN_KEY = 'gasLongHoaSavedExtensionToken';
let $efd3ba4ec2608b1d$var$savedActualToken = null;
let $efd3ba4ec2608b1d$var$ipCheckIntervalId = null;
let $efd3ba4ec2608b1d$var$fastIpCheckIntervalId = null;
let $efd3ba4ec2608b1d$var$isAttemptingAutoLogin = false;
let $efd3ba4ec2608b1d$var$isSipRegistered = false;
let $efd3ba4ec2608b1d$var$isCallActive = false;
let $efd3ba4ec2608b1d$var$isProcessingAction = false;
let $efd3ba4ec2608b1d$var$latestPeerStatusData = [];
let $efd3ba4ec2608b1d$var$lastPeerStatusTimestamp = null;
const $efd3ba4ec2608b1d$var$WORKER_BASE_URL = 'https://wktest.minhduy4545.workers.dev';
const $efd3ba4ec2608b1d$var$PHONE_RINGING_SOUND_URL = 'https://github.com/minh-duy-hoang/gaslonghoa-assets/raw/refs/heads/main/Nh%E1%BA%A1c%20chu%C3%B4ng%20cu%E1%BB%99c%20g%E1%BB%8Di%20%C4%91%E1%BA%BFn%20con%20g%E1%BA%A5u.mp3';
const $efd3ba4ec2608b1d$var$HANGUP_SOUND_URL = "https://github.com/minh-duy-hoang/gaslonghoa-assets/raw/refs/heads/main/Am%20thanh%20ket%20thuc%20cuoc%20goi.mp3";
let $efd3ba4ec2608b1d$var$currentAudio = null;
let $efd3ba4ec2608b1d$var$callTimerInterval = null;
let $efd3ba4ec2608b1d$var$callStartTime = 0;
let $efd3ba4ec2608b1d$var$dynamicContacts = [];
let $efd3ba4ec2608b1d$var$forwardingExtensions = [];
let $efd3ba4ec2608b1d$var$workerConnectionFailures = 0;
const $efd3ba4ec2608b1d$var$MAX_CONNECTION_FAILURES = 3;
let $efd3ba4ec2608b1d$var$networkCheckInterval = null;
let $efd3ba4ec2608b1d$var$isFirstTransferModalRender = true;
const $efd3ba4ec2608b1d$var$SECRET_KEY = "minh-duy-hoang-nguyen-gaslonghoa-secret-key-16-06-2025-19-17-10";
// Biến cho Zalo
const $efd3ba4ec2608b1d$var$ZALO_ALERT_SOUND_URL = 'https://github.com/minh-duy-hoang/gaslonghoa-assets/raw/refs/heads/main/Am%20thanh%20canh%20bao%20khi%20co%20tin%20nhan%20zalo.mp3'; // Âm thanh báo thức mới
let $efd3ba4ec2608b1d$var$zaloAlertAudio = null;
let $efd3ba4ec2608b1d$var$isZaloAlertPlaying = false;
let $efd3ba4ec2608b1d$var$wasZaloAlertPausedForCall = false;
// === BIẾN TRẠNG THÁI CUỘC GỌI THỜI GIAN THỰC ===
let $efd3ba4ec2608b1d$var$activeCallStates = {};
function $efd3ba4ec2608b1d$var$xorCipher(str, key) {
    let output = '';
    for(let i = 0; i < str.length; i++)output += String.fromCharCode(str.charCodeAt(i) ^ key.charCodeAt(i % key.length));
    return output;
}
// === CÁC HÀM TRỢ GIÚP (HELPER FUNCTIONS) ===
function $efd3ba4ec2608b1d$var$appendLog(message) {
    if ($efd3ba4ec2608b1d$var$logOutput) {
        const now = new Date();
        $efd3ba4ec2608b1d$var$logOutput.textContent += `[${now.toLocaleTimeString()}] ${message}\n`;
        $efd3ba4ec2608b1d$var$logOutput.scrollTop = $efd3ba4ec2608b1d$var$logOutput.scrollHeight;
    } else console.log(`[Pending Log - Console Only] ${message}`);
}
async function $efd3ba4ec2608b1d$var$pickupCall(extensionIn) {
    $efd3ba4ec2608b1d$var$appendLog(`\u{110}ang y\xeau c\u{1EA7}u r\u{1B0}\u{1EDB}c cu\u{1ED9}c g\u{1ECD}i cho m\xe1y nh\xe1nh: ${extensionIn}`);
    if (!$efd3ba4ec2608b1d$var$savedActualToken || !$efd3ba4ec2608b1d$var$currentActiveExtension) {
        $efd3ba4ec2608b1d$var$displayStatus("L\u1ED7i: Kh\xf4ng t\xecm th\u1EA5y token ho\u1EB7c m\xe1y nh\xe1nh hi\u1EC7n t\u1EA1i. Vui l\xf2ng \u0111\u0103ng nh\u1EADp l\u1EA1i.", 'error', 5000, $efd3ba4ec2608b1d$var$statusDiv);
        return;
    }
    if (extensionIn === $efd3ba4ec2608b1d$var$currentActiveExtension) {
        $efd3ba4ec2608b1d$var$displayStatus("B\u1EA1n kh\xf4ng th\u1EC3 t\u1EF1 r\u01B0\u1EDBc m\xe1y c\u1EE7a ch\xednh m\xecnh.", 'error', 3000, $efd3ba4ec2608b1d$var$statusDiv);
        return;
    }
    const pickupButton = document.querySelector(`.pickup-btn[data-extension-in="${extensionIn}"]`);
    if (pickupButton) {
        pickupButton.disabled = true;
        pickupButton.innerHTML = `<span>\u{110}ang r\u{1B0}\u{1EDB}c...</span>`;
    }
    const workerPickupUrl = `${$efd3ba4ec2608b1d$var$WORKER_BASE_URL}/pickup`;
    const formData = new URLSearchParams({
        token: $efd3ba4ec2608b1d$var$savedActualToken,
        extensionIn: extensionIn
    });
    try {
        const response = await fetch(workerPickupUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: formData
        });
        const responseData = await response.json();
        $efd3ba4ec2608b1d$var$appendLog(`Pickup worker response: ${response.status}, data: ${JSON.stringify(responseData)}`);
        if (response.ok && responseData.status) $efd3ba4ec2608b1d$var$displayStatus(`\u{110}\xe3 g\u{1EED}i y\xeau c\u{1EA7}u r\u{1B0}\u{1EDB}c m\xe1y ${extensionIn} th\xe0nh c\xf4ng!`, 'success', 5000, $efd3ba4ec2608b1d$var$statusDiv);
        else {
            $efd3ba4ec2608b1d$var$displayStatus(`L\u{1ED7}i khi r\u{1B0}\u{1EDB}c m\xe1y: ${responseData.message || "Kh\xf4ng th\u1EC3 th\u1EF1c hi\u1EC7n"}`, 'error', 7000, $efd3ba4ec2608b1d$var$statusDiv);
            if (pickupButton) {
                pickupButton.disabled = false;
                $efd3ba4ec2608b1d$var$renderPeerStatus($efd3ba4ec2608b1d$var$latestPeerStatusData);
            }
        }
    } catch (error) {
        $efd3ba4ec2608b1d$var$appendLog(`Error during pickup fetch: ${error}`);
        $efd3ba4ec2608b1d$var$displayStatus("L\u1ED7i k\u1EBFt n\u1ED1i \u0111\u1EBFn d\u1ECBch v\u1EE5 r\u01B0\u1EDBc m\xe1y.", 'error', 7000, $efd3ba4ec2608b1d$var$statusDiv);
        if (pickupButton) {
            pickupButton.disabled = false;
            $efd3ba4ec2608b1d$var$renderPeerStatus($efd3ba4ec2608b1d$var$latestPeerStatusData);
        }
    }
}
function $efd3ba4ec2608b1d$var$renderPeerStatus(peers) {
    if (!$efd3ba4ec2608b1d$var$peerStatusList) return;
    const peerStatusContainer = document.getElementById('peer-status-container');
    const summaryContainer = document.getElementById('peer-status-summary');
    if (!peers || peers.length === 0) {
        if (peerStatusContainer) peerStatusContainer.style.display = 'none';
        return;
    }
    if (peerStatusContainer) peerStatusContainer.style.display = 'block';
    $efd3ba4ec2608b1d$var$peerStatusList.innerHTML = '';
    let onlineCount = 0;
    let busyCount = 0;
    peers.forEach((peer)=>{
        const peerExtension = peer.extension;
        const statusMessage = peer.statusData?.data?.messageExt;
        const isOnline = statusMessage === 'online';
        if (isOnline) onlineCount++;
        const isBusy = !!$efd3ba4ec2608b1d$var$activeCallStates[peerExtension];
        if (isBusy) busyCount++;
        const statusClass = isOnline ? 'online' : 'offline';
        const statusTitle = isOnline ? 'Online' : `Offline (${statusMessage || 'N/A'})`;
        const peerElement = document.createElement('div');
        peerElement.className = 'peer-item';
        const mainInfoContainer = document.createElement('div');
        mainInfoContainer.style.display = 'flex';
        mainInfoContainer.style.alignItems = 'center';
        mainInfoContainer.style.flexGrow = '1';
        mainInfoContainer.innerHTML = `
            <span class="status-dot ${statusClass}" title="${statusTitle}"></span>
            <div class="peer-info">
                <div class="peer-name">${peer.name}</div>
                <div class="peer-extension">M\xe1y nh\xe1nh: ${peer.extension}</div>
            </div>
        `;
        peerElement.appendChild(mainInfoContainer);
        const callState = $efd3ba4ec2608b1d$var$activeCallStates[peerExtension];
        if (callState) {
            peerElement.classList.add(callState.status);
            const peerName = $efd3ba4ec2608b1d$var$latestPeerStatusData.find((p)=>p.extension === callState.peer)?.name || callState.peer;
            if (callState.status === 'ringing') {
                peerElement.title = `\u{110}ang nh\u{1EAD}n cu\u{1ED9}c g\u{1ECD}i t\u{1EEB}: ${peerName} (${callState.peer})`;
                if (peerExtension !== $efd3ba4ec2608b1d$var$currentActiveExtension) {
                    const pickupButton = document.createElement('button');
                    pickupButton.className = 'pickup-btn';
                    pickupButton.dataset.extensionIn = peerExtension;
                    pickupButton.innerHTML = `
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                        <span>R\u{1B0}\u{1EDB}c M\xe1y</span>
                    `;
                    pickupButton.onclick = (e)=>{
                        e.stopPropagation();
                        $efd3ba4ec2608b1d$var$pickupCall(peerExtension);
                    };
                    peerElement.appendChild(pickupButton);
                }
            } else if (callState.status === 'in-call') peerElement.title = `\u{110}ang trong cu\u{1ED9}c g\u{1ECD}i v\u{1EDB}i: ${peerName} (${callState.peer})`;
            else if (callState.status === 'calling-out') peerElement.title = `\u{110}ang g\u{1ECD}i \u{111}i \u{111}\u{1EBF}n: ${peerName} (${callState.peer})`;
        }
        $efd3ba4ec2608b1d$var$peerStatusList.appendChild(peerElement);
    });
    if (summaryContainer) summaryContainer.innerHTML = `
            <div class="summary-item">
                <span class="count count-total">${peers.length}</span>
                <span class="label">T\u{1ED5}ng</span>
            </div>
            <div class="summary-item">
                <span class="count count-online">${onlineCount}</span>
                <span class="label">Online</span>
            </div>
            <div class="summary-item">
                <span class="count count-busy">${busyCount}</span>
                <span class="label">\u{110}ang b\u{1EAD}n</span>
            </div>
            <div class="summary-item">
                <span class="count count-offline">${peers.length - onlineCount}</span>
                <span class="label">Offline</span>
            </div>
        `;
    if ($efd3ba4ec2608b1d$var$peerStatusTimestamp) {
        const now = $efd3ba4ec2608b1d$var$lastPeerStatusTimestamp || new Date();
        const formattedTime = now.toLocaleString('vi-VN', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
        $efd3ba4ec2608b1d$var$peerStatusTimestamp.textContent = `C\u{1EAD}p nh\u{1EAD}t l\u{1EA7}n cu\u{1ED1}i: ${formattedTime}`;
    }
}
async function $efd3ba4ec2608b1d$var$fetchAndRenderPeerStatus() {
    if (!$efd3ba4ec2608b1d$var$savedActualToken) {
        if ($efd3ba4ec2608b1d$var$peerStatusInterval) clearInterval($efd3ba4ec2608b1d$var$peerStatusInterval);
        return;
    }
    try {
        const response = await fetch(`${$efd3ba4ec2608b1d$var$WORKER_BASE_URL}/get-peer-status`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams({
                token: $efd3ba4ec2608b1d$var$savedActualToken
            })
        });
        if (response.ok) {
            const peersData = await response.json();
            $efd3ba4ec2608b1d$var$latestPeerStatusData = peersData;
            $efd3ba4ec2608b1d$var$lastPeerStatusTimestamp = new Date();
            $efd3ba4ec2608b1d$var$renderPeerStatus(peersData);
            const transferModal = document.getElementById('transfer-modal');
            if (transferModal && transferModal.style.display === 'flex') $efd3ba4ec2608b1d$var$renderTransferModalList(false);
            if (Array.isArray(peersData) && peersData.length === 0) {
                const peerStatusContainer = document.getElementById('peer-status-container');
                if (peerStatusContainer) peerStatusContainer.style.display = 'none';
            }
        } else {
            console.error("L\u1ED7i khi l\u1EA5y tr\u1EA1ng th\xe1i m\xe1y nh\xe1nh:", response.status);
            if (response.status === 401 || response.status === 403 || response.status >= 500) {
                if ($efd3ba4ec2608b1d$var$peerStatusInterval) clearInterval($efd3ba4ec2608b1d$var$peerStatusInterval);
                const peerStatusContainer = document.getElementById('peer-status-container');
                if (peerStatusContainer) peerStatusContainer.style.display = 'none';
            }
        }
    } catch (error) {
        console.error("L\u1ED7i m\u1EA1ng khi l\u1EA5y tr\u1EA1ng th\xe1i m\xe1y nh\xe1nh:", error);
    }
}
async function $efd3ba4ec2608b1d$var$fetchContactList() {
    if (!$efd3ba4ec2608b1d$var$savedActualToken) {
        $efd3ba4ec2608b1d$var$appendLog("Kh\xf4ng c\xf3 token, kh\xf4ng th\u1EC3 l\u1EA5y danh b\u1EA1.");
        return;
    }
    try {
        const contactsUrl = `${$efd3ba4ec2608b1d$var$WORKER_BASE_URL}/get-contacts`;
        const formData = new URLSearchParams({
            token: $efd3ba4ec2608b1d$var$savedActualToken
        });
        const response = await fetch(contactsUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: formData
        });
        if (response.ok) {
            const data = await response.json();
            $efd3ba4ec2608b1d$var$dynamicContacts = data;
            $efd3ba4ec2608b1d$var$appendLog(`\u{110}\xe3 t\u{1EA3}i th\xe0nh c\xf4ng ${$efd3ba4ec2608b1d$var$dynamicContacts.length} li\xean h\u{1EC7} t\u{1EEB} server.`);
        } else {
            $efd3ba4ec2608b1d$var$appendLog(`L\u{1ED7}i khi t\u{1EA3}i danh b\u{1EA1}: ${response.status}`);
            $efd3ba4ec2608b1d$var$dynamicContacts = [];
        }
    } catch (error) {
        $efd3ba4ec2608b1d$var$appendLog(`L\u{1ED7}i m\u{1EA1}ng khi t\u{1EA3}i danh b\u{1EA1}: ${error}`);
        $efd3ba4ec2608b1d$var$dynamicContacts = [];
    }
}
async function $efd3ba4ec2608b1d$var$fetchForwardingExtensions() {
    if (!$efd3ba4ec2608b1d$var$savedActualToken) {
        $efd3ba4ec2608b1d$var$appendLog("Kh\xf4ng c\xf3 token, kh\xf4ng th\u1EC3 l\u1EA5y danh s\xe1ch m\xe1y nh\xe1nh chuy\u1EC3n ti\u1EBFp.");
        return;
    }
    try {
        const extensionsUrl = `${$efd3ba4ec2608b1d$var$WORKER_BASE_URL}/extensions`;
        const formData = new URLSearchParams({
            token: $efd3ba4ec2608b1d$var$savedActualToken
        });
        const response = await fetch(extensionsUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: formData
        });
        if (response.ok) {
            const data = await response.json();
            $efd3ba4ec2608b1d$var$forwardingExtensions = data;
            $efd3ba4ec2608b1d$var$appendLog(`\u{110}\xe3 t\u{1EA3}i th\xe0nh c\xf4ng ${$efd3ba4ec2608b1d$var$forwardingExtensions.length} m\xe1y nh\xe1nh \u{111}\u{1EC3} chuy\u{1EC3}n ti\u{1EBF}p (t\u{129}nh).`);
        } else {
            $efd3ba4ec2608b1d$var$appendLog(`L\u{1ED7}i khi t\u{1EA3}i danh s\xe1ch m\xe1y nh\xe1nh chuy\u{1EC3}n ti\u{1EBF}p: ${response.status}`);
            $efd3ba4ec2608b1d$var$forwardingExtensions = [];
        }
    } catch (error) {
        $efd3ba4ec2608b1d$var$appendLog(`L\u{1ED7}i m\u{1EA1}ng khi t\u{1EA3}i danh s\xe1ch m\xe1y nh\xe1nh chuy\u{1EC3}n ti\u{1EBF}p: ${error}`);
        $efd3ba4ec2608b1d$var$forwardingExtensions = [];
    }
}
function $efd3ba4ec2608b1d$var$unlockAudioContext() {
    const audio = new Audio('data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA');
    audio.volume = 0;
    audio.play().catch(()=>{});
    $efd3ba4ec2608b1d$var$appendLog('Audio context unlock attempted.');
}
function $efd3ba4ec2608b1d$var$playSound(soundUrl, loop = false) {
    if ($efd3ba4ec2608b1d$var$currentAudio) {
        $efd3ba4ec2608b1d$var$currentAudio.pause();
        $efd3ba4ec2608b1d$var$currentAudio.currentTime = 0;
    }
    $efd3ba4ec2608b1d$var$currentAudio = new Audio(soundUrl);
    $efd3ba4ec2608b1d$var$currentAudio.loop = loop;
    $efd3ba4ec2608b1d$var$currentAudio.play().catch((e)=>{
        console.error("L\u1ED7i kh\xf4ng th\u1EC3 ph\xe1t \xe2m thanh:", e);
        if (e.name === 'NotAllowedError') $efd3ba4ec2608b1d$var$displayStatus("L\u1ED7i \xe2m thanh: Vui l\xf2ng click v\xe0o trang \u0111\u1EC3 cho ph\xe9p ph\xe1t nh\u1EA1c chu\xf4ng.", 'error', 5000);
    });
}
function $efd3ba4ec2608b1d$var$stopSound() {
    if ($efd3ba4ec2608b1d$var$currentAudio) {
        $efd3ba4ec2608b1d$var$currentAudio.pause();
        $efd3ba4ec2608b1d$var$currentAudio.currentTime = 0;
        $efd3ba4ec2608b1d$var$currentAudio = null;
    }
}
function $efd3ba4ec2608b1d$var$startCallTimer() {
    $efd3ba4ec2608b1d$var$callStartTime = Date.now();
    $efd3ba4ec2608b1d$var$callTimerInterval = setInterval(()=>{
        const elapsed = Date.now() - $efd3ba4ec2608b1d$var$callStartTime;
        const minutes = Math.floor(elapsed / 60000);
        const seconds = Math.floor(elapsed % 60000 / 1000);
        if ($efd3ba4ec2608b1d$var$callPopupTimer) $efd3ba4ec2608b1d$var$callPopupTimer.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }, 1000);
}
function $efd3ba4ec2608b1d$var$stopCallTimer() {
    clearInterval($efd3ba4ec2608b1d$var$callTimerInterval);
    if ($efd3ba4ec2608b1d$var$callPopupTimer) $efd3ba4ec2608b1d$var$callPopupTimer.textContent = '00:00';
}
function $efd3ba4ec2608b1d$var$formatPhoneNumber(phone) {
    if (!phone) return '';
    if (phone.length === 10 && phone.startsWith('0')) return `${phone.substring(0, 4)}.${phone.substring(4, 7)}.${phone.substring(7)}`;
    else if (phone.length === 11 && phone.startsWith('0')) return `${phone.substring(0, 4)}.${phone.substring(4, 8)}.${phone.substring(8)}`;
    return phone;
}
function $efd3ba4ec2608b1d$var$updateVersionDisplay(version) {
    if ($efd3ba4ec2608b1d$var$tokenEntryVersionSpan) $efd3ba4ec2608b1d$var$tokenEntryVersionSpan.textContent = version;
    if ($efd3ba4ec2608b1d$var$callControlVersionSpan) $efd3ba4ec2608b1d$var$callControlVersionSpan.textContent = version;
    if ($efd3ba4ec2608b1d$var$appVersionSpan) $efd3ba4ec2608b1d$var$appVersionSpan.textContent = version;
    if ($efd3ba4ec2608b1d$var$zaloVersionSpan) $efd3ba4ec2608b1d$var$zaloVersionSpan.textContent = version;
    if ($efd3ba4ec2608b1d$var$contactsVersionSpan) $efd3ba4ec2608b1d$var$contactsVersionSpan.textContent = version;
    if ($efd3ba4ec2608b1d$var$peerStatusVersionSpan) $efd3ba4ec2608b1d$var$peerStatusVersionSpan.textContent = version;
    $efd3ba4ec2608b1d$var$currentAppVersion = version;
}
function $efd3ba4ec2608b1d$var$updateSupportInfoDisplay(phone, name) {
    $efd3ba4ec2608b1d$var$currentSupportPhone = phone;
    $efd3ba4ec2608b1d$var$currentSupportPersonName = name;
    const formattedPhone = $efd3ba4ec2608b1d$var$formatPhoneNumber(phone);
    if ($efd3ba4ec2608b1d$var$tokenEntrySupportPhoneSpan) {
        $efd3ba4ec2608b1d$var$tokenEntrySupportPhoneSpan.textContent = formattedPhone;
        $efd3ba4ec2608b1d$var$tokenEntrySupportPhoneSpan.href = `tel:${phone}`;
    }
    if ($efd3ba4ec2608b1d$var$tokenEntrySupportNameSpan) $efd3ba4ec2608b1d$var$tokenEntrySupportNameSpan.textContent = name;
    if ($efd3ba4ec2608b1d$var$callControlSupportPhoneSpan) {
        $efd3ba4ec2608b1d$var$callControlSupportPhoneSpan.textContent = formattedPhone;
        $efd3ba4ec2608b1d$var$callControlSupportPhoneSpan.href = `tel:${phone}`;
    }
    if ($efd3ba4ec2608b1d$var$callControlSupportNameSpan) $efd3ba4ec2608b1d$var$callControlSupportNameSpan.textContent = name;
    if ($efd3ba4ec2608b1d$var$appSupportPhoneSpan) {
        $efd3ba4ec2608b1d$var$appSupportPhoneSpan.textContent = formattedPhone;
        $efd3ba4ec2608b1d$var$appSupportPhoneSpan.onclick = ()=>$efd3ba4ec2608b1d$var$phoneNumberField.value = phone;
    }
    if ($efd3ba4ec2608b1d$var$appSupportNameSpan) $efd3ba4ec2608b1d$var$appSupportNameSpan.textContent = name;
    if ($efd3ba4ec2608b1d$var$contactsSupportPhoneSpan) {
        $efd3ba4ec2608b1d$var$contactsSupportPhoneSpan.textContent = formattedPhone;
        $efd3ba4ec2608b1d$var$contactsSupportPhoneSpan.onclick = ()=>$efd3ba4ec2608b1d$var$phoneNumberField.value = phone;
    }
    if ($efd3ba4ec2608b1d$var$contactsSupportNameSpan) $efd3ba4ec2608b1d$var$contactsSupportNameSpan.textContent = name;
    if ($efd3ba4ec2608b1d$var$peerStatusSupportPhoneSpan) {
        $efd3ba4ec2608b1d$var$peerStatusSupportPhoneSpan.textContent = formattedPhone;
        $efd3ba4ec2608b1d$var$peerStatusSupportPhoneSpan.href = `tel:${phone}`;
    }
    if ($efd3ba4ec2608b1d$var$peerStatusSupportNameSpan) $efd3ba4ec2608b1d$var$peerStatusSupportNameSpan.textContent = name;
    if ($efd3ba4ec2608b1d$var$zaloSupportPhoneSpan) {
        $efd3ba4ec2608b1d$var$zaloSupportPhoneSpan.textContent = formattedPhone;
        $efd3ba4ec2608b1d$var$zaloSupportPhoneSpan.href = `tel:${phone}`;
    }
    if ($efd3ba4ec2608b1d$var$zaloSupportNameSpan) $efd3ba4ec2608b1d$var$zaloSupportNameSpan.textContent = name;
}
function $efd3ba4ec2608b1d$var$renderContactList() {
    const contactsDiv = document.getElementById('contacts');
    if (!contactsDiv) return;
    contactsDiv.innerHTML = '';
    if ($efd3ba4ec2608b1d$var$dynamicContacts.length === 0) {
        contactsDiv.innerHTML = '<p class="empty-list-message">Kh\xf4ng c\xf3 danh b\u1EA1 ho\u1EB7c kh\xf4ng th\u1EC3 t\u1EA3i.</p>';
        return;
    }
    $efd3ba4ec2608b1d$var$dynamicContacts.forEach((contact)=>{
        const validExt = contact.ext?.filter((e)=>e) || [];
        const validMobile = contact.mobile?.filter((m)=>m) || [];
        const totalNumbers = validExt.length + validMobile.length;
        if (totalNumbers === 0) return;
        if (totalNumbers === 1) {
            const singleNumber = validExt[0] || validMobile[0];
            const contactItem = document.createElement('div');
            contactItem.className = 'contact-item';
            contactItem.innerHTML = `
                <img src="${contact.avatar}" alt="Avatar" class="contact-avatar" onerror="this.src='https://i.pravatar.cc/150?u=${singleNumber}'">
                <span class="contact-name">${contact.name}</span>
            `;
            contactItem.style.cursor = 'pointer';
            contactItem.onclick = ()=>{
                if ($efd3ba4ec2608b1d$var$phoneNumberField) {
                    $efd3ba4ec2608b1d$var$phoneNumberField.value = singleNumber;
                    if (window.innerWidth < 800) $efd3ba4ec2608b1d$var$showAppView();
                    $efd3ba4ec2608b1d$var$displayStatus(`\u{110}\xe3 ch\u{1ECD}n s\u{1ED1} <span class="phone-highlight">${singleNumber}</span>. S\u{1EB5}n s\xe0ng g\u{1ECD}i.`, '', 3000);
                }
            };
            contactsDiv.appendChild(contactItem);
        } else {
            const contactGroup = document.createElement('div');
            contactGroup.className = 'contact-group';
            const mainContactElement = document.createElement('div');
            mainContactElement.className = 'contact-item expandable';
            mainContactElement.innerHTML = `
                <img src="${contact.avatar}" alt="Avatar" class="contact-avatar" onerror="this.src='https://i.pravatar.cc/150?u=${contact.name}'">
                <span class="contact-name">${contact.name}</span>
                <div class="expand-icon">
                    <svg viewBox="0 0 24 24">
                        <path class="vert" d="M12 5V19" />
                        <path class="horz" d="M5 12H19" />
                    </svg>
                </div>
            `;
            const subList = document.createElement('div');
            subList.className = 'sub-contact-list';
            const createSubItemHTML = (number, type)=>{
                const icon = type === 'ext' ? 'https://api.iconify.design/material-symbols:phone-in-talk.svg' : 'https://api.iconify.design/material-symbols:smartphone.svg';
                const label = type === 'ext' ? "M\xe1y nh\xe1nh" : "Di \u0111\u1ED9ng";
                return `<div class="sub-contact-item" data-number="${number}">
                            <img src="${icon}" class="sub-contact-icon" alt="${type}">
                            <span>${label}: ${number}</span>
                        </div>`;
            };
            let subListHTML = '';
            validExt.forEach((extNum)=>subListHTML += createSubItemHTML(extNum, 'ext'));
            validMobile.forEach((mobileNum)=>subListHTML += createSubItemHTML(mobileNum, 'mobile'));
            subList.innerHTML = subListHTML;
            contactGroup.appendChild(mainContactElement);
            contactGroup.appendChild(subList);
            mainContactElement.onclick = ()=>{
                contactGroup.classList.toggle('expanded');
            };
            subList.querySelectorAll('.sub-contact-item').forEach((item, index)=>{
                item.style.animationDelay = `${index * 0.05}s`;
                item.onclick = (e)=>{
                    e.stopPropagation();
                    const numberToCall = item.dataset.number;
                    if ($efd3ba4ec2608b1d$var$phoneNumberField) {
                        $efd3ba4ec2608b1d$var$phoneNumberField.value = numberToCall;
                        if (window.innerWidth < 800) $efd3ba4ec2608b1d$var$showAppView();
                        $efd3ba4ec2608b1d$var$displayStatus(`\u{110}\xe3 ch\u{1ECD}n s\u{1ED1} <span class="phone-highlight">${numberToCall}</span>. S\u{1EB5}n s\xe0ng g\u{1ECD}i.`, '', 3000);
                    }
                };
            });
            contactsDiv.appendChild(contactGroup);
        }
    });
    if (contactsDiv.childElementCount === 0) contactsDiv.innerHTML = '<p class="empty-list-message">Kh\xf4ng c\xf3 li\xean h\u1EC7 n\xe0o c\xf3 s\u1ED1 \u0111i\u1EC7n tho\u1EA1i.</p>';
}
function $efd3ba4ec2608b1d$var$showWebRTCCallPopup(callType, callerInfo, direction = 'Outgoing') {
    if ($efd3ba4ec2608b1d$var$isZaloAlertPlaying) {
        $efd3ba4ec2608b1d$var$stopZaloAlert();
        $efd3ba4ec2608b1d$var$wasZaloAlertPausedForCall = true;
        $efd3ba4ec2608b1d$var$appendLog("\u0110\xe3 t\u1EA1m d\u1EEBng \xe2m thanh Zalo do c\xf3 cu\u1ED9c g\u1ECDi.");
    }
    $efd3ba4ec2608b1d$var$isCallActive = true;
    if ($efd3ba4ec2608b1d$var$webrtcCallPopup) $efd3ba4ec2608b1d$var$webrtcCallPopup.style.display = 'flex';
    if ($efd3ba4ec2608b1d$var$mainContentContainer) $efd3ba4ec2608b1d$var$mainContentContainer.style.display = 'none';
    if ($efd3ba4ec2608b1d$var$logContainer) $efd3ba4ec2608b1d$var$logContainer.style.display = 'none';
    if ($efd3ba4ec2608b1d$var$callPopupTime) $efd3ba4ec2608b1d$var$callPopupTime.textContent = new Date().toLocaleTimeString('vi-VN');
    if ($efd3ba4ec2608b1d$var$callPopupName) $efd3ba4ec2608b1d$var$callPopupName.textContent = callerInfo.name || callerInfo.phone || 'Unknown';
    if ($efd3ba4ec2608b1d$var$callPopupNumber) $efd3ba4ec2608b1d$var$callPopupNumber.textContent = $efd3ba4ec2608b1d$var$formatPhoneNumber(callerInfo.phone);
    if ($efd3ba4ec2608b1d$var$callPopupAvatar) {
        $efd3ba4ec2608b1d$var$callPopupAvatar.src = callerInfo.avatar || `https://i.pravatar.cc/150?u=${callerInfo.phone}`;
        $efd3ba4ec2608b1d$var$callPopupAvatar.onerror = function() {
            this.src = 'https://i.pravatar.cc/150?u=default';
        };
    }
    const networkStatus = document.getElementById('network-status');
    if (callType === 'incoming') {
        if ($efd3ba4ec2608b1d$var$webrtcSpeakerButton) $efd3ba4ec2608b1d$var$webrtcSpeakerButton.style.display = 'none';
        if ($efd3ba4ec2608b1d$var$webrtcKeypadButton) $efd3ba4ec2608b1d$var$webrtcKeypadButton.style.display = 'none';
        if ($efd3ba4ec2608b1d$var$webrtcMuteButton) $efd3ba4ec2608b1d$var$webrtcMuteButton.style.display = 'none';
        if ($efd3ba4ec2608b1d$var$webrtcHoldButton) $efd3ba4ec2608b1d$var$webrtcHoldButton.style.display = 'none';
        if (networkStatus) networkStatus.style.display = 'none';
        if ($efd3ba4ec2608b1d$var$webrtcAnswerButton) $efd3ba4ec2608b1d$var$webrtcAnswerButton.style.display = 'flex';
        if ($efd3ba4ec2608b1d$var$webrtcDeclineButton) $efd3ba4ec2608b1d$var$webrtcDeclineButton.style.display = 'flex';
        if ($efd3ba4ec2608b1d$var$webrtcHangupButton) $efd3ba4ec2608b1d$var$webrtcHangupButton.style.display = 'none';
        if ($efd3ba4ec2608b1d$var$webrtcCallPopup && $efd3ba4ec2608b1d$var$webrtcCallPopup.querySelector('.call-type')) $efd3ba4ec2608b1d$var$webrtcCallPopup.querySelector('.call-type').textContent = "Cu\u1ED9c g\u1ECDi \u0111\u1EBFn";
        if ($efd3ba4ec2608b1d$var$webrtcCallPopup && $efd3ba4ec2608b1d$var$webrtcCallPopup.querySelector('.call-direction')) $efd3ba4ec2608b1d$var$webrtcCallPopup.querySelector('.call-direction').textContent = '';
        if ($efd3ba4ec2608b1d$var$callPopupStatus) {
            $efd3ba4ec2608b1d$var$callPopupStatus.textContent = '';
            $efd3ba4ec2608b1d$var$callPopupStatus.className = 'call-status';
        }
        $efd3ba4ec2608b1d$var$playSound($efd3ba4ec2608b1d$var$PHONE_RINGING_SOUND_URL, true);
    } else {
        if ($efd3ba4ec2608b1d$var$webrtcSpeakerButton) $efd3ba4ec2608b1d$var$webrtcSpeakerButton.style.display = 'flex';
        if ($efd3ba4ec2608b1d$var$webrtcKeypadButton) {
            $efd3ba4ec2608b1d$var$webrtcKeypadButton.style.display = 'flex';
            $efd3ba4ec2608b1d$var$webrtcKeypadButton.disabled = true;
            $efd3ba4ec2608b1d$var$webrtcKeypadButton.style.opacity = '0.5';
            $efd3ba4ec2608b1d$var$webrtcKeypadButton.style.cursor = 'not-allowed';
            $efd3ba4ec2608b1d$var$webrtcKeypadButton.title = "Ch\u1EE9c n\u0103ng s\u1EBD c\xf3 khi cu\u1ED9c g\u1ECDi \u0111\u01B0\u1EE3c k\u1EBFt n\u1ED1i";
        }
        if ($efd3ba4ec2608b1d$var$webrtcMuteButton) $efd3ba4ec2608b1d$var$webrtcMuteButton.style.display = 'flex';
        if ($efd3ba4ec2608b1d$var$webrtcHoldButton) $efd3ba4ec2608b1d$var$webrtcHoldButton.style.display = 'flex';
        if (networkStatus) networkStatus.style.display = 'flex';
        if ($efd3ba4ec2608b1d$var$webrtcAnswerButton) $efd3ba4ec2608b1d$var$webrtcAnswerButton.style.display = 'none';
        if ($efd3ba4ec2608b1d$var$webrtcDeclineButton) $efd3ba4ec2608b1d$var$webrtcDeclineButton.style.display = 'none';
        if ($efd3ba4ec2608b1d$var$webrtcHangupButton) $efd3ba4ec2608b1d$var$webrtcHangupButton.style.display = 'flex';
        if ($efd3ba4ec2608b1d$var$webrtcCallPopup && $efd3ba4ec2608b1d$var$webrtcCallPopup.querySelector('.call-type')) $efd3ba4ec2608b1d$var$webrtcCallPopup.querySelector('.call-type').textContent = "\u0110ang g\u1ECDi";
        if ($efd3ba4ec2608b1d$var$webrtcCallPopup && $efd3ba4ec2608b1d$var$webrtcCallPopup.querySelector('.call-direction')) $efd3ba4ec2608b1d$var$webrtcCallPopup.querySelector('.call-direction').textContent = direction === 'Outgoing' ? "G\u1ECDi \u0111i" : '';
        if ($efd3ba4ec2608b1d$var$callPopupStatus) {
            $efd3ba4ec2608b1d$var$callPopupStatus.textContent = "\u0110ang g\u1ECDi...";
            $efd3ba4ec2608b1d$var$callPopupStatus.className = 'call-status calling';
        }
        $efd3ba4ec2608b1d$var$stopSound();
    }
}
function $efd3ba4ec2608b1d$var$hideWebRTCCallPopup() {
    $efd3ba4ec2608b1d$var$isCallActive = false;
    if ($efd3ba4ec2608b1d$var$networkCheckInterval) {
        clearInterval($efd3ba4ec2608b1d$var$networkCheckInterval);
        $efd3ba4ec2608b1d$var$networkCheckInterval = null;
    }
    if ($efd3ba4ec2608b1d$var$webrtcCallPopup) $efd3ba4ec2608b1d$var$webrtcCallPopup.style.display = 'none';
    // Sửa lỗi màn hình chính không hiện lại
    if ($efd3ba4ec2608b1d$var$tokenEntryContainer && $efd3ba4ec2608b1d$var$tokenEntryContainer.style.display === 'none' && $efd3ba4ec2608b1d$var$ipRestrictionMessageDiv && $efd3ba4ec2608b1d$var$ipRestrictionMessageDiv.style.display === 'none') {
        if ($efd3ba4ec2608b1d$var$mainContentContainer) $efd3ba4ec2608b1d$var$mainContentContainer.style.display = 'flex';
        if ($efd3ba4ec2608b1d$var$logContainer) $efd3ba4ec2608b1d$var$logContainer.style.display = 'block';
    }
    $efd3ba4ec2608b1d$var$stopSound();
    $efd3ba4ec2608b1d$var$stopCallTimer();
    if ($efd3ba4ec2608b1d$var$callPopupTimer) $efd3ba4ec2608b1d$var$callPopupTimer.textContent = '00:00';
    if ($efd3ba4ec2608b1d$var$callPopupStatus) {
        $efd3ba4ec2608b1d$var$callPopupStatus.textContent = '';
        $efd3ba4ec2608b1d$var$callPopupStatus.className = 'call-status';
    }
    if ($efd3ba4ec2608b1d$var$webrtcMuteButton) {
        $efd3ba4ec2608b1d$var$webrtcMuteButton.classList.remove('active');
        if ($efd3ba4ec2608b1d$var$webrtcMuteButton.querySelector('img')) $efd3ba4ec2608b1d$var$webrtcMuteButton.querySelector('img').src = 'https://api.iconify.design/material-symbols:mic-off.svg';
    }
    if ($efd3ba4ec2608b1d$var$webrtcHoldButton) {
        $efd3ba4ec2608b1d$var$webrtcHoldButton.classList.remove('active');
        if ($efd3ba4ec2608b1d$var$webrtcHoldButton.querySelector('img')) $efd3ba4ec2608b1d$var$webrtcHoldButton.querySelector('img').src = 'https://api.iconify.design/material-symbols:pause.svg';
    }
    if ($efd3ba4ec2608b1d$var$webrtcKeypadButton) {
        $efd3ba4ec2608b1d$var$webrtcKeypadButton.disabled = false;
        $efd3ba4ec2608b1d$var$webrtcKeypadButton.style.opacity = '1';
        $efd3ba4ec2608b1d$var$webrtcKeypadButton.style.cursor = 'pointer';
        $efd3ba4ec2608b1d$var$webrtcKeypadButton.title = "Chuy\u1EC3n ti\u1EBFp cu\u1ED9c g\u1ECDi";
    }
    const modal = document.getElementById('transfer-modal');
    if (modal && modal.style.display === 'flex') {
        modal.classList.remove('show');
        modal.style.display = 'none';
    }
    // Phát lại âm thanh Zalo nếu cần
    if ($efd3ba4ec2608b1d$var$wasZaloAlertPausedForCall) {
        $efd3ba4ec2608b1d$var$wasZaloAlertPausedForCall = false; // Reset flag
        const hasUnread = $efd3ba4ec2608b1d$var$zaloMessageList && $efd3ba4ec2608b1d$var$zaloMessageList.querySelector('.zalo-message-item.unread');
        if (hasUnread) {
            $efd3ba4ec2608b1d$var$playZaloAlert();
            $efd3ba4ec2608b1d$var$appendLog("\u0110\xe3 ph\xe1t l\u1EA1i \xe2m thanh Zalo sau khi cu\u1ED9c g\u1ECDi k\u1EBFt th\xfac.");
        }
    }
}
function $efd3ba4ec2608b1d$var$showZaloView() {
    if (window.innerWidth < 800) {
        if ($efd3ba4ec2608b1d$var$appContainer) $efd3ba4ec2608b1d$var$appContainer.style.display = 'none';
        if ($efd3ba4ec2608b1d$var$callControlContainer) $efd3ba4ec2608b1d$var$callControlContainer.style.display = 'none';
        if ($efd3ba4ec2608b1d$var$contactListContainer) $efd3ba4ec2608b1d$var$contactListContainer.style.display = 'none';
        if ($efd3ba4ec2608b1d$var$zaloMessagesContainer) {
            $efd3ba4ec2608b1d$var$zaloMessagesContainer.style.display = 'flex';
            $efd3ba4ec2608b1d$var$zaloMessagesContainer.style.animation = 'slideUpFadeIn 0.4s ease-out';
        }
    }
}
function $efd3ba4ec2608b1d$var$showContactsView() {
    if (window.innerWidth < 800) {
        if ($efd3ba4ec2608b1d$var$appContainer) $efd3ba4ec2608b1d$var$appContainer.style.display = 'none';
        if ($efd3ba4ec2608b1d$var$callControlContainer) $efd3ba4ec2608b1d$var$callControlContainer.style.display = 'none';
        if ($efd3ba4ec2608b1d$var$zaloMessagesContainer) $efd3ba4ec2608b1d$var$zaloMessagesContainer.style.display = 'none';
        if ($efd3ba4ec2608b1d$var$contactListContainer) {
            $efd3ba4ec2608b1d$var$contactListContainer.style.display = 'block';
            $efd3ba4ec2608b1d$var$contactListContainer.style.animation = 'slideUpFadeIn 0.4s ease-out';
        }
    }
}
function $efd3ba4ec2608b1d$var$showAppView() {
    if (window.innerWidth < 800) {
        if ($efd3ba4ec2608b1d$var$contactListContainer) $efd3ba4ec2608b1d$var$contactListContainer.style.display = 'none';
        if ($efd3ba4ec2608b1d$var$callControlContainer) $efd3ba4ec2608b1d$var$callControlContainer.style.display = 'none';
        if ($efd3ba4ec2608b1d$var$zaloMessagesContainer) $efd3ba4ec2608b1d$var$zaloMessagesContainer.style.display = 'none';
        if ($efd3ba4ec2608b1d$var$appContainer) {
            $efd3ba4ec2608b1d$var$appContainer.style.display = 'block';
            $efd3ba4ec2608b1d$var$appContainer.style.animation = 'slideUpFadeIn 0.4s ease-out';
        }
    }
}
function $efd3ba4ec2608b1d$var$showCallControlView() {
    if (window.innerWidth < 800) {
        if ($efd3ba4ec2608b1d$var$appContainer) $efd3ba4ec2608b1d$var$appContainer.style.display = 'none';
        if ($efd3ba4ec2608b1d$var$contactListContainer) $efd3ba4ec2608b1d$var$contactListContainer.style.display = 'none';
        if ($efd3ba4ec2608b1d$var$zaloMessagesContainer) $efd3ba4ec2608b1d$var$zaloMessagesContainer.style.display = 'none';
        if ($efd3ba4ec2608b1d$var$callControlContainer) {
            $efd3ba4ec2608b1d$var$callControlContainer.style.display = 'block';
            $efd3ba4ec2608b1d$var$callControlContainer.style.animation = 'slideUpFadeIn 0.4s ease-out';
        }
    }
}
function $efd3ba4ec2608b1d$var$displayStatus(message, type = '', duration = null, targetDiv = $efd3ba4ec2608b1d$var$statusDiv) {
    if (targetDiv) {
        let contentToShow = message;
        if (targetDiv === $efd3ba4ec2608b1d$var$statusDiv && message === "H\u1EC7 th\u1ED1ng \u0111ang tr\u1EF1c tuy\u1EBFn. S\u1EB5n s\xe0ng g\u1ECDi." && type === 'success' && $efd3ba4ec2608b1d$var$currentActiveExtension && $efd3ba4ec2608b1d$var$mainContentContainer && $efd3ba4ec2608b1d$var$mainContentContainer.style.display === 'flex') {
            let extensionInfo = $efd3ba4ec2608b1d$var$currentActiveExtension;
            if ($efd3ba4ec2608b1d$var$currentEmployeeName) extensionInfo += ` (${$efd3ba4ec2608b1d$var$currentEmployeeName})`;
            contentToShow = `<span class="loading-spinner"></span>${message} M\xe1y nh\xe1nh: ${extensionInfo}`;
        }
        targetDiv.innerHTML = contentToShow;
        targetDiv.classList.remove('success', 'error');
        if (type === 'success') targetDiv.classList.add('success');
        else if (type === 'error') targetDiv.classList.add('error');
        targetDiv.style.opacity = '1';
        if ($efd3ba4ec2608b1d$var$statusClearTimer && targetDiv === $efd3ba4ec2608b1d$var$statusDiv) clearTimeout($efd3ba4ec2608b1d$var$statusClearTimer);
        if (duration) {
            const timerId = setTimeout(()=>{
                if (targetDiv === $efd3ba4ec2608b1d$var$statusDiv || targetDiv === $efd3ba4ec2608b1d$var$hangupStatusDiv) $efd3ba4ec2608b1d$var$clearStatus(targetDiv);
                else {
                    targetDiv.style.opacity = '0';
                    setTimeout(()=>{
                        if (targetDiv.style.opacity === '0') {
                            targetDiv.innerHTML = '';
                            targetDiv.classList.remove('success', 'error');
                            targetDiv.style.opacity = '1';
                        }
                    }, 500);
                }
            }, duration);
            if (targetDiv === $efd3ba4ec2608b1d$var$statusDiv) $efd3ba4ec2608b1d$var$statusClearTimer = timerId;
        } else if (targetDiv === $efd3ba4ec2608b1d$var$statusDiv) $efd3ba4ec2608b1d$var$statusClearTimer = null;
    }
}
function $efd3ba4ec2608b1d$var$clearStatus(targetDiv = $efd3ba4ec2608b1d$var$statusDiv) {
    if (targetDiv) {
        targetDiv.style.opacity = '0';
        setTimeout(()=>{
            if (targetDiv.style.opacity === '0') {
                targetDiv.innerHTML = '';
                targetDiv.classList.remove('success', 'error');
                targetDiv.style.opacity = '1';
                if (targetDiv === $efd3ba4ec2608b1d$var$statusDiv && $efd3ba4ec2608b1d$var$currentActiveExtension && $efd3ba4ec2608b1d$var$mainContentContainer && $efd3ba4ec2608b1d$var$mainContentContainer.style.display === 'flex' && (!$efd3ba4ec2608b1d$var$webrtcCallPopup || $efd3ba4ec2608b1d$var$webrtcCallPopup.style.display === 'none')) {
                    const isAppViewVisible = window.innerWidth >= 800 || $efd3ba4ec2608b1d$var$appContainer && $efd3ba4ec2608b1d$var$appContainer.style.display === 'block';
                    if (isAppViewVisible && !$efd3ba4ec2608b1d$var$statusDiv.innerHTML.includes("\u0110ang th\u1EF1c hi\u1EC7n cu\u1ED9c g\u1ECDi...") && !$efd3ba4ec2608b1d$var$statusDiv.innerHTML.includes("Y\xeau c\u1EA7u g\u1ECDi \u0111\u1EBFn")) $efd3ba4ec2608b1d$var$displayStatus("H\u1EC7 th\u1ED1ng \u0111ang tr\u1EF1c tuy\u1EBFn. S\u1EB5n s\xe0ng g\u1ECDi.", 'success', 5000);
                }
            }
        }, 500);
    }
    if (targetDiv === $efd3ba4ec2608b1d$var$statusDiv) $efd3ba4ec2608b1d$var$statusClearTimer = null;
}
function $efd3ba4ec2608b1d$var$handleInputFocus(event) {
    if (window.innerWidth < 800) setTimeout(()=>{
        if (event.target) event.target.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
        });
    }, 300);
}
async function $efd3ba4ec2608b1d$var$checkIpPeriodically() {
    const isTokenEntryVisible = $efd3ba4ec2608b1d$var$tokenEntryContainer ? $efd3ba4ec2608b1d$var$tokenEntryContainer.style.display !== 'none' : false;
    const isIpRestrictionVisible = $efd3ba4ec2608b1d$var$ipRestrictionMessageDiv ? $efd3ba4ec2608b1d$var$ipRestrictionMessageDiv.style.display !== 'none' : false;
    const isMainContentVisible = $efd3ba4ec2608b1d$var$mainContentContainer ? $efd3ba4ec2608b1d$var$mainContentContainer.style.display === 'flex' : false;
    if (!$efd3ba4ec2608b1d$var$savedActualToken && !$efd3ba4ec2608b1d$var$isAttemptingAutoLogin && !isTokenEntryVisible && !isIpRestrictionVisible) {
        $efd3ba4ec2608b1d$var$appendLog("Kh\xf4ng c\xf3 token ho\u1EB7c \u0111ang t\u1EF1 \u0111\u0103ng nh\u1EADp (v\xe0 kh\xf4ng \u1EDF m\xe0n h\xecnh l\u1ED7i IP). D\u1EEBng ki\u1EC3m tra IP.");
        clearInterval($efd3ba4ec2608b1d$var$ipCheckIntervalId);
        clearInterval($efd3ba4ec2608b1d$var$fastIpCheckIntervalId);
        $efd3ba4ec2608b1d$var$ipCheckIntervalId = null;
        $efd3ba4ec2608b1d$var$fastIpCheckIntervalId = null;
        return;
    }
    $efd3ba4ec2608b1d$var$appendLog("\u0110ang ki\u1EC3m tra IP \u0111\u1ECBnh k\u1EF3.");
    try {
        const checkIpUrl = `${$efd3ba4ec2608b1d$var$WORKER_BASE_URL}/dial`;
        const formData = new URLSearchParams({
            token: $efd3ba4ec2608b1d$var$savedActualToken || 'temp_token_for_ip_check',
            phone: 'ip_check_ping'
        });
        const response = await fetch(checkIpUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: formData
        });
        $efd3ba4ec2608b1d$var$workerConnectionFailures = 0;
        const responseData = await response.json();
        if (responseData.version) $efd3ba4ec2608b1d$var$updateVersionDisplay(responseData.version);
        if (responseData.supportPhone && responseData.supportPersonName) $efd3ba4ec2608b1d$var$updateSupportInfoDisplay(responseData.supportPhone, responseData.supportPersonName);
        if (response.status === 403) {
            const errorMessage = `Truy c\u{1EAD}p kh\xf4ng th\xe0nh c\xf4ng ho\u{1EB7}c gi\u{1EA5}y ph\xe9p \u{111}\xe3 h\u{1EBF}t h\u{1EA1}n. Vui l\xf2ng li\xean h\u{1EC7}: ${$efd3ba4ec2608b1d$var$formatPhoneNumber(responseData.supportPhone || $efd3ba4ec2608b1d$var$currentSupportPhone)} (${responseData.supportPersonName || $efd3ba4ec2608b1d$var$currentSupportPersonName}) \u{111}\u{1EC3} \u{111}\u{1B0}\u{1EE3}c h\u{1ED7} tr\u{1EE3} - M\xe3 l\u{1ED7}i: 862840`;
            $efd3ba4ec2608b1d$var$handleIpRestriction(errorMessage);
        } else if (!response.ok) {
            $efd3ba4ec2608b1d$var$appendLog(`Worker ph\u{1EA3}n h\u{1ED3}i kh\xf4ng th\xe0nh c\xf4ng trong qu\xe1 tr\xecnh ki\u{1EC3}m tra IP: ${response.status}, ${JSON.stringify(responseData)}`);
            if ($efd3ba4ec2608b1d$var$ipRestrictionMessageDiv && $efd3ba4ec2608b1d$var$ipRestrictionMessageDiv.style.display !== 'none') $efd3ba4ec2608b1d$var$revalidateAndLoginIfIpOk();
            else if (!$efd3ba4ec2608b1d$var$savedActualToken) {
                if ($efd3ba4ec2608b1d$var$mainContentContainer) $efd3ba4ec2608b1d$var$mainContentContainer.style.display = 'none';
                if ($efd3ba4ec2608b1d$var$tokenEntryContainer) {
                    $efd3ba4ec2608b1d$var$tokenEntryContainer.style.display = 'block';
                    $efd3ba4ec2608b1d$var$tokenEntryContainer.style.animation = 'slideUpFadeIn 0.7s ease-out forwards';
                }
                $efd3ba4ec2608b1d$var$displayStatus("Vui l\xf2ng nh\u1EADp token m\xe1y nh\xe1nh.", '', 5000, $efd3ba4ec2608b1d$var$tokenStatusDiv);
            }
        } else {
            $efd3ba4ec2608b1d$var$appendLog("Ki\u1EC3m tra IP \u0111\u1ECBnh k\u1EF3 th\xe0nh c\xf4ng. IP v\u1EABn h\u1EE3p l\u1EC7.");
            $efd3ba4ec2608b1d$var$stopFastIpCheck();
            $efd3ba4ec2608b1d$var$revalidateAndLoginIfIpOk();
        }
    } catch (error) {
        $efd3ba4ec2608b1d$var$appendLog(`L\u{1ED7}i khi ki\u{1EC3}m tra IP \u{111}\u{1ECB}nh k\u{1EF3} (fetch error): ${error}`);
        $efd3ba4ec2608b1d$var$workerConnectionFailures++;
        $efd3ba4ec2608b1d$var$appendLog(`S\u{1ED1} l\u{1EA7}n k\u{1EBF}t n\u{1ED1}i Worker th\u{1EA5}t b\u{1EA1}i: ${$efd3ba4ec2608b1d$var$workerConnectionFailures}`);
        if ($efd3ba4ec2608b1d$var$workerConnectionFailures >= $efd3ba4ec2608b1d$var$MAX_CONNECTION_FAILURES) {
            $efd3ba4ec2608b1d$var$appendLog("M\u1EA5t k\u1EBFt n\u1ED1i Worker. \u0110ang th\u1EF1c hi\u1EC7n \u0111\u0103ng xu\u1EA5t c\u01B0\u1EE1ng b\u1EE9c.");
            alert("M\u1EA5t k\u1EBFt n\u1ED1i v\u1EDBi m\xe1y ch\u1EE7. H\u1EC7 th\u1ED1ng s\u1EBD t\u1EF1 \u0111\u1ED9ng \u0111\u0103ng xu\u1EA5t \u0111\u1EC3 b\u1EA3o m\u1EADt.");
            $efd3ba4ec2608b1d$var$logoutUser();
        } else if ($efd3ba4ec2608b1d$var$savedActualToken && !isIpRestrictionVisible && !isMainContentVisible) $efd3ba4ec2608b1d$var$startFastIpCheck();
    }
}
function $efd3ba4ec2608b1d$var$startIpCheckInterval() {
    if ($efd3ba4ec2608b1d$var$ipCheckIntervalId) clearInterval($efd3ba4ec2608b1d$var$ipCheckIntervalId);
    clearInterval($efd3ba4ec2608b1d$var$fastIpCheckIntervalId);
    $efd3ba4ec2608b1d$var$fastIpCheckIntervalId = null;
    $efd3ba4ec2608b1d$var$checkIpPeriodically();
    $efd3ba4ec2608b1d$var$ipCheckIntervalId = setInterval($efd3ba4ec2608b1d$var$checkIpPeriodically, 10000);
    $efd3ba4ec2608b1d$var$appendLog("\u0110\xe3 b\u1EAFt \u0111\u1EA7u ki\u1EC3m tra IP \u0111\u1ECBnh k\u1EF3 (ch\u1EADm).");
}
function $efd3ba4ec2608b1d$var$startFastIpCheck() {
    if ($efd3ba4ec2608b1d$var$fastIpCheckIntervalId) clearInterval($efd3ba4ec2608b1d$var$fastIpCheckIntervalId);
    if ($efd3ba4ec2608b1d$var$ipCheckIntervalId) {
        clearInterval($efd3ba4ec2608b1d$var$ipCheckIntervalId);
        $efd3ba4ec2608b1d$var$ipCheckIntervalId = null;
    }
    $efd3ba4ec2608b1d$var$fastIpCheckIntervalId = setInterval($efd3ba4ec2608b1d$var$checkIpPeriodically, 3000);
    $efd3ba4ec2608b1d$var$appendLog("\u0110\xe3 b\u1EAFt \u0111\u1EA7u ki\u1EC3m tra IP \u0111\u1ECBnh k\u1EF3 (NHANH).");
}
function $efd3ba4ec2608b1d$var$stopFastIpCheck() {
    if ($efd3ba4ec2608b1d$var$fastIpCheckIntervalId) {
        clearInterval($efd3ba4ec2608b1d$var$fastIpCheckIntervalId);
        $efd3ba4ec2608b1d$var$fastIpCheckIntervalId = null;
        $efd3ba4ec2608b1d$var$appendLog("\u0110\xe3 d\u1EEBng ki\u1EC3m tra IP \u0111\u1ECBnh k\u1EF3 (NHANH).");
    }
    if ($efd3ba4ec2608b1d$var$mainContentContainer && $efd3ba4ec2608b1d$var$mainContentContainer.style.display === 'flex' && $efd3ba4ec2608b1d$var$ipCheckIntervalId === null) $efd3ba4ec2608b1d$var$startIpCheckInterval();
}
function $efd3ba4ec2608b1d$var$handleIpRestriction(message) {
    if ($efd3ba4ec2608b1d$var$voip24hModuleInstance) $efd3ba4ec2608b1d$var$voip24hModuleInstance.release();
    if ($efd3ba4ec2608b1d$var$ipCheckIntervalId) {
        clearInterval($efd3ba4ec2608b1d$var$ipCheckIntervalId);
        $efd3ba4ec2608b1d$var$ipCheckIntervalId = null;
    }
    if ($efd3ba4ec2608b1d$var$fastIpCheckIntervalId) {
        clearInterval($efd3ba4ec2608b1d$var$fastIpCheckIntervalId);
        $efd3ba4ec2608b1d$var$fastIpCheckIntervalId = null;
    }
    if ($efd3ba4ec2608b1d$var$peerStatusInterval) {
        clearInterval($efd3ba4ec2608b1d$var$peerStatusInterval);
        $efd3ba4ec2608b1d$var$peerStatusInterval = null;
    }
    if ($efd3ba4ec2608b1d$var$mainContentContainer) $efd3ba4ec2608b1d$var$mainContentContainer.style.display = 'none';
    if ($efd3ba4ec2608b1d$var$tokenEntryContainer) $efd3ba4ec2608b1d$var$tokenEntryContainer.style.display = 'none';
    if ($efd3ba4ec2608b1d$var$logContainer) $efd3ba4ec2608b1d$var$logContainer.style.display = 'block';
    if ($efd3ba4ec2608b1d$var$webrtcCallPopup && $efd3ba4ec2608b1d$var$webrtcCallPopup.style.display === 'flex') {
        $efd3ba4ec2608b1d$var$hideWebRTCCallPopup();
        $efd3ba4ec2608b1d$var$appendLog("\u0110\xe3 \u1EA9n popup cu\u1ED9c g\u1ECDi do l\u1ED7i h\u1EA1n ch\u1EBF IP.");
    }
    if ($efd3ba4ec2608b1d$var$ipRestrictionMessageDiv) {
        $efd3ba4ec2608b1d$var$ipRestrictionMessageDiv.innerHTML = message;
        $efd3ba4ec2608b1d$var$ipRestrictionMessageDiv.style.display = 'block';
        $efd3ba4ec2608b1d$var$ipRestrictionMessageDiv.style.animation = 'slideUpFadeIn 0.7s ease-out forwards';
    }
    $efd3ba4ec2608b1d$var$savedActualToken = null;
    $efd3ba4ec2608b1d$var$currentActiveExtension = null;
    $efd3ba4ec2608b1d$var$currentEmployeeName = null;
    $efd3ba4ec2608b1d$var$currentSipPassword = null;
    $efd3ba4ec2608b1d$var$isSipRegistered = false;
    if ($efd3ba4ec2608b1d$var$extensionDisplay) $efd3ba4ec2608b1d$var$extensionDisplay.value = "Kh\xf4ng kh\u1EA3 d\u1EE5ng";
    if ($efd3ba4ec2608b1d$var$controlExtensionDisplay) $efd3ba4ec2608b1d$var$controlExtensionDisplay.value = "Kh\xf4ng kh\u1EA3 d\u1EE5ng";
    if ($efd3ba4ec2608b1d$var$callButton) $efd3ba4ec2608b1d$var$callButton.disabled = true;
    if ($efd3ba4ec2608b1d$var$hangupButton) $efd3ba4ec2608b1d$var$hangupButton.disabled = true;
    if ($efd3ba4ec2608b1d$var$webRtcCallButton) $efd3ba4ec2608b1d$var$webRtcCallButton.disabled = true;
    $efd3ba4ec2608b1d$var$displayStatus('', '', 0, $efd3ba4ec2608b1d$var$tokenStatusDiv);
    $efd3ba4ec2608b1d$var$clearStatus();
    $efd3ba4ec2608b1d$var$clearStatus($efd3ba4ec2608b1d$var$hangupStatusDiv);
    $efd3ba4ec2608b1d$var$appendLog("User logged out due to IP restriction.");
}
function $efd3ba4ec2608b1d$var$logoutUser() {
    if ($efd3ba4ec2608b1d$var$peerStatusInterval) {
        clearInterval($efd3ba4ec2608b1d$var$peerStatusInterval);
        $efd3ba4ec2608b1d$var$peerStatusInterval = null;
    }
    $efd3ba4ec2608b1d$var$appendLog("B\u1EAFt \u0111\u1EA7u qu\xe1 tr\xecnh \u0111\u0103ng xu\u1EA5t.");
    localStorage.removeItem($efd3ba4ec2608b1d$var$SAVED_TOKEN_KEY);
    location.reload();
}
async function $efd3ba4ec2608b1d$var$revalidateAndLoginIfIpOk() {
    const storedToken = localStorage.getItem($efd3ba4ec2608b1d$var$SAVED_TOKEN_KEY);
    if (storedToken && !$efd3ba4ec2608b1d$var$isAttemptingAutoLogin && (!$efd3ba4ec2608b1d$var$tokenEntryContainer || $efd3ba4ec2608b1d$var$tokenEntryContainer.style.display !== 'none')) {
        $efd3ba4ec2608b1d$var$isAttemptingAutoLogin = true;
        $efd3ba4ec2608b1d$var$appendLog("IP \u0111\xe3 h\u1EE3p l\u1EC7 tr\u1EDF l\u1EA1i v\xe0 c\xf3 token l\u01B0u. \u0110ang th\u1EED t\u1EF1 \u0111\u1ED9ng \u0111\u0103ng nh\u1EADp l\u1EA1i...");
        if ($efd3ba4ec2608b1d$var$ipRestrictionMessageDiv) {
            $efd3ba4ec2608b1d$var$ipRestrictionMessageDiv.innerHTML = '<span class="loading-spinner"></span> \u0110ang th\u1EED \u0111\u0103ng nh\u1EADp l\u1EA1i t\u1EF1 \u0111\u1ED9ng...';
            $efd3ba4ec2608b1d$var$ipRestrictionMessageDiv.style.display = 'block';
        }
        if ($efd3ba4ec2608b1d$var$tokenEntryContainer) $efd3ba4ec2608b1d$var$tokenEntryContainer.style.display = 'none';
        if ($efd3ba4ec2608b1d$var$tokenStatusDiv) {
            $efd3ba4ec2608b1d$var$tokenStatusDiv.innerHTML = '';
            $efd3ba4ec2608b1d$var$tokenStatusDiv.classList.remove('error');
        }
        const success = await $efd3ba4ec2608b1d$var$validateAndSetToken(storedToken, true);
        if (success) {
            $efd3ba4ec2608b1d$var$appendLog("T\u1EF1 \u0111\u1ED9ng \u0111\u0103ng nh\u1EADp l\u1EA1i th\xe0nh c\xf4ng.");
            $efd3ba4ec2608b1d$var$stopFastIpCheck();
        } else $efd3ba4ec2608b1d$var$appendLog("T\u1EF1 \u0111\u1ED9ng \u0111\u0103ng nh\u1EADp l\u1EA1i th\u1EA5t b\u1EA1i. IP c\xf3 th\u1EC3 v\u1EABn kh\xf4ng h\u1EE3p l\u1EC7 ho\u1EB7c token \u0111\xe3 h\u1EBFt h\u1EA1n.");
        $efd3ba4ec2608b1d$var$isAttemptingAutoLogin = false;
    } else if ($efd3ba4ec2608b1d$var$mainContentContainer && $efd3ba4ec2608b1d$var$mainContentContainer.style.display === 'flex' && (!$efd3ba4ec2608b1d$var$ipRestrictionMessageDiv || $efd3ba4ec2608b1d$var$ipRestrictionMessageDiv.style.display !== 'none')) {
        if ($efd3ba4ec2608b1d$var$ipRestrictionMessageDiv) $efd3ba4ec2608b1d$var$ipRestrictionMessageDiv.style.display = 'none';
        $efd3ba4ec2608b1d$var$appendLog("Th\xf4ng b\xe1o IP Restriction \u0111\xe3 \u0111\u01B0\u1EE3c \u1EA9n do IP h\u1EE3p l\u1EC7 tr\u1EDF l\u1EA1i.");
    }
}
async function $efd3ba4ec2608b1d$var$validateAndSetToken(tokenToValidate, isInitialLoadOrSilent = false) {
    $efd3ba4ec2608b1d$var$appendLog(`validateAndSetToken called. Token: ${tokenToValidate}, Initial/Silent: ${isInitialLoadOrSilent}`);
    if ($efd3ba4ec2608b1d$var$ipRestrictionMessageDiv) $efd3ba4ec2608b1d$var$ipRestrictionMessageDiv.style.display = 'none';
    if (!tokenToValidate) {
        $efd3ba4ec2608b1d$var$displayStatus("Vui l\xf2ng nh\u1EADp token.", 'error', 3000, $efd3ba4ec2608b1d$var$tokenStatusDiv);
        if ($efd3ba4ec2608b1d$var$tokenEntryContainer) $efd3ba4ec2608b1d$var$tokenEntryContainer.style.display = 'block';
        if ($efd3ba4ec2608b1d$var$mainContentContainer) $efd3ba4ec2608b1d$var$mainContentContainer.style.display = 'none';
        return false;
    }
    if (!isInitialLoadOrSilent) $efd3ba4ec2608b1d$var$unlockAudioContext();
    $efd3ba4ec2608b1d$var$displayStatus('<span class="loading-spinner"></span> \u0110ang x\xe1c th\u1EF1c token...', '', null, $efd3ba4ec2608b1d$var$tokenStatusDiv);
    try {
        const verifyTokenUrl = `${$efd3ba4ec2608b1d$var$WORKER_BASE_URL}/dial`;
        const formData = new URLSearchParams({
            token: tokenToValidate,
            phone: '0000000000'
        });
        const response = await fetch(verifyTokenUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: formData
        });
        const responseData = await response.json();
        $efd3ba4ec2608b1d$var$appendLog(`Worker response status (validation): ${response.status}, data: ${JSON.stringify(responseData)}`);
        if (responseData.version) $efd3ba4ec2608b1d$var$updateVersionDisplay(responseData.version);
        if (responseData.supportPhone && responseData.supportPersonName) $efd3ba4ec2608b1d$var$updateSupportInfoDisplay(responseData.supportPhone, responseData.supportPersonName);
        if (responseData.extension) $efd3ba4ec2608b1d$var$currentActiveExtension = responseData.extension;
        else $efd3ba4ec2608b1d$var$currentActiveExtension = tokenToValidate;
        if (responseData.employeeName) $efd3ba4ec2608b1d$var$currentEmployeeName = responseData.employeeName;
        if ($efd3ba4ec2608b1d$var$extensionDisplay) $efd3ba4ec2608b1d$var$extensionDisplay.value = `${$efd3ba4ec2608b1d$var$currentActiveExtension} (${$efd3ba4ec2608b1d$var$currentEmployeeName || "Ng\u01B0\u1EDDi d\xf9ng"})`;
        if ($efd3ba4ec2608b1d$var$controlExtensionDisplay) $efd3ba4ec2608b1d$var$controlExtensionDisplay.value = `${$efd3ba4ec2608b1d$var$currentActiveExtension} (${$efd3ba4ec2608b1d$var$currentEmployeeName || "Ng\u01B0\u1EDDi d\xf9ng"})`;
        if (responseData.password) try {
            const decodedPassword = atob(responseData.password);
            $efd3ba4ec2608b1d$var$currentSipPassword = $efd3ba4ec2608b1d$var$xorCipher(decodedPassword, $efd3ba4ec2608b1d$var$SECRET_KEY);
            $efd3ba4ec2608b1d$var$appendLog("M\u1EADt kh\u1EA9u SIP \u0111\xe3 \u0111\u01B0\u1EE3c nh\u1EADn v\xe0 gi\u1EA3i m\xe3 th\xe0nh c\xf4ng.");
        } catch (e) {
            $efd3ba4ec2608b1d$var$appendLog("L\u1ED7i gi\u1EA3i m\xe3 m\u1EADt kh\u1EA9u Base64. C\xf3 th\u1EC3 Worker ch\u01B0a m\xe3 h\xf3a.");
            $efd3ba4ec2608b1d$var$currentSipPassword = responseData.password;
        }
        else {
            $efd3ba4ec2608b1d$var$currentSipPassword = null;
            $efd3ba4ec2608b1d$var$appendLog("Worker kh\xf4ng cung c\u1EA5p m\u1EADt kh\u1EA9u SIP.");
        }
        if (response.status === 403) {
            const errorMessage = `Truy c\u{1EAD}p kh\xf4ng th\xe0nh c\xf4ng ho\u{1EB7}c gi\u{1EA5}y ph\xe9p \u{111}\xe3 h\u{1EBF}t h\u{1EA1}n. Vui l\xf2ng li\xean h\u{1EC7}: ${$efd3ba4ec2608b1d$var$formatPhoneNumber(responseData.supportPhone || $efd3ba4ec2608b1d$var$currentSupportPhone)} (${responseData.supportPersonName || $efd3ba4ec2608b1d$var$currentSupportPersonName}) \u{111}\u{1EC3} \u{111}\u{1B0}\u{1EE3}c h\u{1ED7} tr\u{1EE3} - M\xe3 l\u{1ED7}i: 862840`;
            $efd3ba4ec2608b1d$var$handleIpRestriction(errorMessage);
            return false;
        } else if (!response.ok) {
            $efd3ba4ec2608b1d$var$displayStatus(`L\u{1ED7}i x\xe1c th\u{1EF1}c: ${responseData.message || "Token kh\xf4ng h\u1EE3p l\u1EC7 ho\u1EB7c l\u1ED7i kh\xf4ng x\xe1c \u0111\u1ECBnh"}`, 'error', 5000, $efd3ba4ec2608b1d$var$tokenStatusDiv);
            if ($efd3ba4ec2608b1d$var$mainContentContainer) $efd3ba4ec2608b1d$var$mainContentContainer.style.display = 'none';
            if ($efd3ba4ec2608b1d$var$tokenEntryContainer) {
                $efd3ba4ec2608b1d$var$tokenEntryContainer.style.display = 'block';
                $efd3ba4ec2608b1d$var$tokenEntryContainer.style.animation = 'slideUpFadeIn 0.7s ease-out forwards';
            }
            $efd3ba4ec2608b1d$var$isSipRegistered = false;
            $efd3ba4ec2608b1d$var$currentActiveExtension = null;
            $efd3ba4ec2608b1d$var$currentSipPassword = null;
            if ($efd3ba4ec2608b1d$var$extensionDisplay) $efd3ba4ec2608b1d$var$extensionDisplay.value = "Kh\xf4ng kh\u1EA3 d\u1EE5ng";
            if ($efd3ba4ec2608b1d$var$controlExtensionDisplay) $efd3ba4ec2608b1d$var$controlExtensionDisplay.value = "Kh\xf4ng kh\u1EA3 d\u1EE5ng";
            return false;
        }
        localStorage.setItem($efd3ba4ec2608b1d$var$SAVED_TOKEN_KEY, tokenToValidate);
        $efd3ba4ec2608b1d$var$savedActualToken = tokenToValidate;
        await $efd3ba4ec2608b1d$var$setupPusherListener();
        await $efd3ba4ec2608b1d$var$fetchContactList();
        await $efd3ba4ec2608b1d$var$fetchForwardingExtensions();
        if ($efd3ba4ec2608b1d$var$tokenEntryContainer) $efd3ba4ec2608b1d$var$tokenEntryContainer.style.display = 'none';
        if ($efd3ba4ec2608b1d$var$mainContentContainer) {
            $efd3ba4ec2608b1d$var$mainContentContainer.style.display = 'flex';
            if (window.innerWidth < 800) $efd3ba4ec2608b1d$var$showAppView();
            else {
                if ($efd3ba4ec2608b1d$var$appContainer) $efd3ba4ec2608b1d$var$appContainer.style.display = 'block';
                if ($efd3ba4ec2608b1d$var$callControlContainer) $efd3ba4ec2608b1d$var$callControlContainer.style.display = 'block';
                if ($efd3ba4ec2608b1d$var$contactListContainer) $efd3ba4ec2608b1d$var$contactListContainer.style.display = 'block';
            }
            if (isInitialLoadOrSilent) $efd3ba4ec2608b1d$var$mainContentContainer.style.animation = 'slideUpFadeIn 0.7s ease-out forwards';
        }
        $efd3ba4ec2608b1d$var$renderContactList();
        if ($efd3ba4ec2608b1d$var$callButton) $efd3ba4ec2608b1d$var$callButton.disabled = true;
        if ($efd3ba4ec2608b1d$var$hangupButton) $efd3ba4ec2608b1d$var$hangupButton.disabled = false;
        if ($efd3ba4ec2608b1d$var$webRtcCallButton) $efd3ba4ec2608b1d$var$webRtcCallButton.disabled = true;
        if ($efd3ba4ec2608b1d$var$tokenInput) $efd3ba4ec2608b1d$var$tokenInput.value = '';
        if ($efd3ba4ec2608b1d$var$tokenStatusDiv) $efd3ba4ec2608b1d$var$tokenStatusDiv.innerHTML = '';
        if ($efd3ba4ec2608b1d$var$logContainer) $efd3ba4ec2608b1d$var$logContainer.style.display = 'block';
        $efd3ba4ec2608b1d$var$displayStatus("H\u1EC7 th\u1ED1ng \u0111ang tr\u1EF1c tuy\u1EBFn. \u0110ang c\u1ED1 g\u1EAFng \u0111\u0103ng k\xfd SIP...", 'success', 5000);
        $efd3ba4ec2608b1d$var$startIpCheckInterval();
        $efd3ba4ec2608b1d$var$stopFastIpCheck();
        if ($efd3ba4ec2608b1d$var$currentActiveExtension && $efd3ba4ec2608b1d$var$currentSipPassword) $efd3ba4ec2608b1d$var$registerSipAccount($efd3ba4ec2608b1d$var$currentActiveExtension, $efd3ba4ec2608b1d$var$currentSipPassword);
        else {
            $efd3ba4ec2608b1d$var$appendLog("Kh\xf4ng \u0111\u1EE7 th\xf4ng tin SIP \u0111\u1EC3 \u0111\u0103ng k\xfd. Ki\u1EC3m tra c\u1EA5u h\xecnh Worker.");
            $efd3ba4ec2608b1d$var$displayStatus("L\u1ED7i: Kh\xf4ng \u0111\u1EE7 th\xf4ng tin SIP \u0111\u1EC3 \u0111\u0103ng k\xfd m\xe1y nh\xe1nh.", 'error', 0, $efd3ba4ec2608b1d$var$statusDiv);
            $efd3ba4ec2608b1d$var$isSipRegistered = false;
        }
        if ($efd3ba4ec2608b1d$var$peerStatusInterval) clearInterval($efd3ba4ec2608b1d$var$peerStatusInterval);
        $efd3ba4ec2608b1d$var$fetchAndRenderPeerStatus();
        $efd3ba4ec2608b1d$var$peerStatusInterval = setInterval($efd3ba4ec2608b1d$var$fetchAndRenderPeerStatus, 15000);
        $efd3ba4ec2608b1d$var$appendLog("\u0110\xe3 b\u1EAFt \u0111\u1EA7u theo d\xf5i tr\u1EA1ng th\xe1i m\xe1y nh\xe1nh.");
        return true;
    } catch (error) {
        $efd3ba4ec2608b1d$var$appendLog(`Error during token validation fetch: ${error}`);
        $efd3ba4ec2608b1d$var$displayStatus(`L\u{1ED7}i k\u{1EBF}t n\u{1ED1}i \u{111}\u{1EBF}n d\u{1ECB}ch v\u{1EE5} x\xe1c th\u{1EF1}c: ${error.message}.`, 'error', 7000, $efd3ba4ec2608b1d$var$tokenStatusDiv);
        if ($efd3ba4ec2608b1d$var$mainContentContainer) $efd3ba4ec2608b1d$var$mainContentContainer.style.display = 'none';
        if ($efd3ba4ec2608b1d$var$tokenEntryContainer) {
            $efd3ba4ec2608b1d$var$tokenEntryContainer.style.display = 'block';
            $efd3ba4ec2608b1d$var$tokenEntryContainer.style.animation = 'slideUpFadeIn 0.7s ease-out forwards';
        }
        $efd3ba4ec2608b1d$var$isSipRegistered = false;
        return false;
    }
}
function $efd3ba4ec2608b1d$var$handleTokenSubmit() {
    $efd3ba4ec2608b1d$var$appendLog("handleTokenSubmit called.");
    if ($efd3ba4ec2608b1d$var$tokenInput) {
        const enteredToken = $efd3ba4ec2608b1d$var$tokenInput.value.trim();
        if (enteredToken) {
            $efd3ba4ec2608b1d$var$displayStatus('<span class="loading-spinner"></span> \u0110ang \u0111\u0103ng nh\u1EADp v\xe0 t\u1EA3i l\u1EA1i...', '', null, $efd3ba4ec2608b1d$var$tokenStatusDiv);
            localStorage.setItem($efd3ba4ec2608b1d$var$SAVED_TOKEN_KEY, enteredToken);
            location.reload();
        } else $efd3ba4ec2608b1d$var$displayStatus("Vui l\xf2ng nh\u1EADp token.", 'error', 3000, $efd3ba4ec2608b1d$var$tokenStatusDiv);
    } else $efd3ba4ec2608b1d$var$appendLog("Token input element not found.");
}
async function $efd3ba4ec2608b1d$var$makeCall(phoneNumberToDial = null, contactNameToDial = null) {
    $efd3ba4ec2608b1d$var$isCallActive = true;
    $efd3ba4ec2608b1d$var$appendLog(`makeCall (IP Phone) called. Phone: ${phoneNumberToDial}, Contact: ${contactNameToDial}`);
    if (!$efd3ba4ec2608b1d$var$savedActualToken) {
        $efd3ba4ec2608b1d$var$displayStatus("L\u1ED7i: Kh\xf4ng t\xecm th\u1EA5y token \u0111\u0103ng nh\u1EADp. Vui l\xf2ng \u0111\u0103ng nh\u1EADp l\u1EA1i.", 'error', 5000);
        $efd3ba4ec2608b1d$var$isCallActive = false;
        return;
    }
    let phoneNumber = phoneNumberToDial || ($efd3ba4ec2608b1d$var$phoneNumberField ? $efd3ba4ec2608b1d$var$phoneNumberField.value : '');
    if (phoneNumber && phoneNumber === $efd3ba4ec2608b1d$var$currentActiveExtension) {
        $efd3ba4ec2608b1d$var$displayStatus("B\u1EA1n kh\xf4ng th\u1EC3 g\u1ECDi \u0111i\u1EC7n cho ch\xednh m\xecnh.", 'error', 5000);
        $efd3ba4ec2608b1d$var$isCallActive = false;
        return;
    }
    if (!phoneNumber) {
        $efd3ba4ec2608b1d$var$displayStatus("Vui l\xf2ng nh\u1EADp s\u1ED1 \u0111i\u1EC7n tho\u1EA1i!", 'error', 5000);
        $efd3ba4ec2608b1d$var$isCallActive = false;
        return;
    }
    if (!/^\d+$/.test(phoneNumber)) {
        $efd3ba4ec2608b1d$var$displayStatus($efd3ba4ec2608b1d$var$nonNumericInputErrorMsg, 'error', 3000);
        $efd3ba4ec2608b1d$var$isCallActive = false;
        return;
    }
    const callTargetDisplay = contactNameToDial || phoneNumber;
    const workerCallUrl = `${$efd3ba4ec2608b1d$var$WORKER_BASE_URL}/dial`;
    const formData = new URLSearchParams({
        token: $efd3ba4ec2608b1d$var$savedActualToken,
        phone: phoneNumber
    });
    $efd3ba4ec2608b1d$var$displayStatus(`\u{110}ang y\xeau c\u{1EA7}u g\u{1ECD}i \u{111}\u{1EBF}n <span class="phone-highlight">${callTargetDisplay}</span>...`, '', 10000);
    try {
        const response = await fetch(workerCallUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: formData
        });
        const responseData = await response.json();
        $efd3ba4ec2608b1d$var$appendLog(`Call worker response: ${response.status}, data: ${JSON.stringify(responseData)}`);
        if (responseData.version) $efd3ba4ec2608b1d$var$updateVersionDisplay(responseData.version);
        if (responseData.supportPhone && responseData.supportPersonName) $efd3ba4ec2608b1d$var$updateSupportInfoDisplay(responseData.supportPhone, responseData.supportPersonName);
        if (response.ok) {
            $efd3ba4ec2608b1d$var$playSound($efd3ba4ec2608b1d$var$PHONE_RINGING_SOUND_URL);
            $efd3ba4ec2608b1d$var$displayStatus(`\u{110}\xe3 g\u{1EED}i y\xeau c\u{1EA7}u g\u{1ECD}i th\xe0nh c\xf4ng \u{111}\u{1EBF}n <span class="phone-highlight">${callTargetDisplay}</span>! Vui l\xf2ng ch\u{1EDD} chu\xf4ng reo tr\xean m\xe1y nh\xe1nh c\u{1EE7}a b\u{1EA1}n.`, 'success', 10000);
        } else if (response.status === 403) {
            const errorMessage = `Truy c\u{1EAD}p kh\xf4ng th\xe0nh c\xf4ng ho\u{1EB7}c gi\u{1EA5}y ph\xe9p \u{111}\xe3 h\u{1EBF}t h\u{1EA1}n. Vui l\xf2ng li\xean h\u{1EC7}: ${$efd3ba4ec2608b1d$var$formatPhoneNumber(responseData.supportPhone || $efd3ba4ec2608b1d$var$currentSupportPhone)} (${responseData.supportPersonName || $efd3ba4ec2608b1d$var$currentSupportPersonName}) \u{111}\u{1EC3} \u{111}\u{1B0}\u{1EE3}c h\u{1ED7} tr\u{1EE3} - M\xe3 l\u{1ED7}i: 862840`;
            $efd3ba4ec2608b1d$var$handleIpRestriction(errorMessage);
        } else $efd3ba4ec2608b1d$var$displayStatus(`L\u{1ED7}i khi g\u{1ECD}i: ${responseData.message || "Kh\xf4ng th\u1EC3 th\u1EF1c hi\u1EC7n cu\u1ED9c g\u1ECDi"}`, 'error', 10000);
    } catch (error) {
        $efd3ba4ec2608b1d$var$appendLog(`Error during call fetch: ${error}`);
        $efd3ba4ec2608b1d$var$displayStatus("L\u1ED7i k\u1EBFt n\u1ED1i \u0111\u1EBFn d\u1ECBch v\u1EE5 g\u1ECDi \u0111i\u1EC7n.", 'error', 10000);
    } finally{
        if ($efd3ba4ec2608b1d$var$phoneNumberField) $efd3ba4ec2608b1d$var$phoneNumberField.value = '';
        setTimeout(()=>{
            if (!$efd3ba4ec2608b1d$var$webrtcCallPopup || $efd3ba4ec2608b1d$var$webrtcCallPopup.style.display === 'none') {
                $efd3ba4ec2608b1d$var$displayStatus("H\u1EC7 th\u1ED1ng \u0111ang tr\u1EF1c tuy\u1EBFn. S\u1EB5n s\xe0ng g\u1ECDi.", 'success', 5000);
                $efd3ba4ec2608b1d$var$isCallActive = false;
            }
        }, 10000);
    }
}
async function $efd3ba4ec2608b1d$var$hangUpIPCall() {
    $efd3ba4ec2608b1d$var$appendLog("hangUpIPCall called.");
    if (!$efd3ba4ec2608b1d$var$savedActualToken || !$efd3ba4ec2608b1d$var$currentActiveExtension) {
        $efd3ba4ec2608b1d$var$displayStatus("L\u1ED7i: Kh\xf4ng t\xecm th\u1EA5y token \u0111\u0103ng nh\u1EADp ho\u1EB7c m\xe1y nh\xe1nh. Vui l\xf2ng \u0111\u0103ng nh\u1EADp l\u1EA1i.", 'error', 5000, $efd3ba4ec2608b1d$var$hangupStatusDiv);
        return;
    }
    const workerHangupUrl = `${$efd3ba4ec2608b1d$var$WORKER_BASE_URL}/hangup`;
    const formData = new URLSearchParams({
        token: $efd3ba4ec2608b1d$var$savedActualToken,
        extension: $efd3ba4ec2608b1d$var$currentActiveExtension
    });
    $efd3ba4ec2608b1d$var$displayStatus(`\u{110}ang y\xeau c\u{1EA7}u k\u{1EBF}t th\xfac cu\u{1ED9}c g\u{1ECD}i cho m\xe1y nh\xe1nh ${$efd3ba4ec2608b1d$var$currentActiveExtension}...`, '', null, $efd3ba4ec2608b1d$var$hangupStatusDiv);
    if ($efd3ba4ec2608b1d$var$hangupButton) $efd3ba4ec2608b1d$var$hangupButton.disabled = true;
    try {
        const response = await fetch(workerHangupUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: formData
        });
        const responseData = await response.json();
        $efd3ba4ec2608b1d$var$appendLog(`Hangup worker response: ${response.status}, data: ${JSON.stringify(responseData)}`);
        if (responseData.version) $efd3ba4ec2608b1d$var$updateVersionDisplay(responseData.version);
        if (responseData.supportPhone && responseData.supportPersonName) $efd3ba4ec2608b1d$var$updateSupportInfoDisplay(responseData.supportPhone, responseData.supportPersonName);
        if (response.ok) {
            $efd3ba4ec2608b1d$var$playSound($efd3ba4ec2608b1d$var$HANGUP_SOUND_URL);
            $efd3ba4ec2608b1d$var$displayStatus(`\u{110}\xe3 g\u{1EED}i y\xeau c\u{1EA7}u k\u{1EBF}t th\xfac cu\u{1ED9}c g\u{1ECD}i th\xe0nh c\xf4ng cho m\xe1y nh\xe1nh ${$efd3ba4ec2608b1d$var$currentActiveExtension}.`, 'success', 5000, $efd3ba4ec2608b1d$var$hangupStatusDiv);
        } else if (response.status === 403) {
            const errorMessage = `Truy c\u{1EAD}p kh\xf4ng th\xe0nh c\xf4ng ho\u{1EB7}c gi\u{1EA5}y ph\xe9p \u{111}\xe3 h\u{1EBF}t h\u{1EA1}n. Vui l\xf2ng li\xean h\u{1EC7}: ${$efd3ba4ec2608b1d$var$formatPhoneNumber(responseData.supportPhone || $efd3ba4ec2608b1d$var$currentSupportPhone)} (${responseData.supportPersonName || $efd3ba4ec2608b1d$var$currentSupportPersonName}) \u{111}\u{1EC3} \u{111}\u{1B0}\u{1EE3}c h\u{1ED7} tr\u{1EE3} - M\xe3 l\u{1ED7}i: 862840`;
            $efd3ba4ec2608b1d$var$handleIpRestriction(errorMessage);
        } else $efd3ba4ec2608b1d$var$displayStatus(`L\u{1ED7}i khi k\u{1EBF}t th\xfac cu\u{1ED9}c g\u{1ECD}i: ${responseData.message || "Kh\xf4ng th\u1EC3 k\u1EBFt th\xfac cu\u1ED9c g\u1ECDi"}`, 'error', 10000, $efd3ba4ec2608b1d$var$hangupStatusDiv);
    } catch (error) {
        $efd3ba4ec2608b1d$var$appendLog(`Error during hangup fetch: ${error}`);
        $efd3ba4ec2608b1d$var$displayStatus("L\u1ED7i k\u1EBFt n\u1ED1i \u0111\u1EBFn d\u1ECBch v\u1EE5 k\u1EBFt th\xfac cu\u1ED9c g\u1ECDi.", 'error', 10000);
    } finally{
        if ($efd3ba4ec2608b1d$var$hangupButton) $efd3ba4ec2608b1d$var$hangupButton.disabled = false;
    }
}
async function $efd3ba4ec2608b1d$var$initiateWebRTCCall() {
    let phoneNumber = $efd3ba4ec2608b1d$var$phoneNumberField ? $efd3ba4ec2608b1d$var$phoneNumberField.value : '';
    if (phoneNumber && phoneNumber === $efd3ba4ec2608b1d$var$currentActiveExtension) {
        $efd3ba4ec2608b1d$var$displayStatus("B\u1EA1n kh\xf4ng th\u1EC3 g\u1ECDi \u0111i\u1EC7n cho ch\xednh m\xecnh.", 'error', 5000);
        return;
    }
    if (!phoneNumber) {
        $efd3ba4ec2608b1d$var$displayStatus("Vui l\xf2ng nh\u1EADp s\u1ED1 \u0111i\u1EC7n tho\u1EA1i \u0111\u1EC3 g\u1ECDi tr\u1EF1c ti\u1EBFp tr\xean web!", 'error', 5000);
        return;
    }
    if (!/^\d+$/.test(phoneNumber)) {
        $efd3ba4ec2608b1d$var$displayStatus($efd3ba4ec2608b1d$var$nonNumericInputErrorMsg, 'error', 3000);
        return;
    }
    if (!$efd3ba4ec2608b1d$var$isSipRegistered) {
        $efd3ba4ec2608b1d$var$displayStatus("B\u1EA1n ch\u01B0a \u0111\u0103ng k\xfd t\xe0i kho\u1EA3n SIP cho WebRTC. Vui l\xf2ng \u0111\u0103ng k\xfd tr\u01B0\u1EDBc khi g\u1ECDi.", 'error', 5000);
        alert("B\u1EA1n ch\u01B0a \u0111\u0103ng k\xfd t\xe0i kho\u1EA3n SIP cho WebRTC. Vui l\xf2ng \u0111\u0103ng k\xfd tr\u01B0\u1EDBc khi g\u1ECDi.");
        return;
    }
    if ($efd3ba4ec2608b1d$var$voip24hModuleInstance) {
        $efd3ba4ec2608b1d$var$appendLog(`\u{110}ang g\u{1ECD}i tr\u{1EF1}c ti\u{1EBF}p WebRTC \u{111}\u{1EBF}n s\u{1ED1}: ${phoneNumber}`);
        $efd3ba4ec2608b1d$var$displayStatus(`\u{110}ang g\u{1ECD}i tr\u{1EF1}c ti\u{1EBF}p qua WebRTC \u{111}\u{1EBF}n <span class="phone-highlight">${phoneNumber}</span>...`, '', 5000);
        const contact = $efd3ba4ec2608b1d$var$dynamicContacts.find((c)=>c.ext && c.ext.includes(phoneNumber) || c.mobile && c.mobile.includes(phoneNumber)) || {
            name: phoneNumber,
            phone: phoneNumber,
            avatar: `https://i.pravatar.cc/150?u=${phoneNumber}`
        };
        $efd3ba4ec2608b1d$var$showWebRTCCallPopup('outgoing', contact);
        $efd3ba4ec2608b1d$var$voip24hModuleInstance.call(phoneNumber);
        if ($efd3ba4ec2608b1d$var$phoneNumberField) $efd3ba4ec2608b1d$var$phoneNumberField.value = '';
    } else {
        $efd3ba4ec2608b1d$var$appendLog("Module WebRTC ch\u01B0a \u0111\u01B0\u1EE3c kh\u1EDFi t\u1EA1o. Kh\xf4ng th\u1EC3 th\u1EF1c hi\u1EC7n cu\u1ED9c g\u1ECDi.");
        $efd3ba4ec2608b1d$var$displayStatus("L\u1ED7i: Module WebRTC ch\u01B0a \u0111\u01B0\u1EE3c kh\u1EDFi t\u1EA1o. Kh\xf4ng th\u1EC3 th\u1EF1c hi\u1EC7n cu\u1ED9c g\u1ECDi.", 'error', 5000);
    }
}
function $efd3ba4ec2608b1d$var$answerWebRTCCall() {
    if ($efd3ba4ec2608b1d$var$voip24hModuleInstance) {
        $efd3ba4ec2608b1d$var$appendLog("\u0110ang tr\u1EA3 l\u1EDDi cu\u1ED9c g\u1ECDi WebRTC.");
        $efd3ba4ec2608b1d$var$voip24hModuleInstance.answer();
        if ($efd3ba4ec2608b1d$var$webrtcAnswerButton) $efd3ba4ec2608b1d$var$webrtcAnswerButton.style.display = 'none';
        if ($efd3ba4ec2608b1d$var$webrtcDeclineButton) $efd3ba4ec2608b1d$var$webrtcDeclineButton.style.display = 'none';
        if ($efd3ba4ec2608b1d$var$webrtcHangupButton) $efd3ba4ec2608b1d$var$webrtcHangupButton.style.display = 'flex';
        if ($efd3ba4ec2608b1d$var$webrtcSpeakerButton) $efd3ba4ec2608b1d$var$webrtcSpeakerButton.style.display = 'flex';
        if ($efd3ba4ec2608b1d$var$webrtcKeypadButton) $efd3ba4ec2608b1d$var$webrtcKeypadButton.style.display = 'flex';
        if ($efd3ba4ec2608b1d$var$webrtcMuteButton) $efd3ba4ec2608b1d$var$webrtcMuteButton.style.display = 'flex';
        if ($efd3ba4ec2608b1d$var$webrtcHoldButton) $efd3ba4ec2608b1d$var$webrtcHoldButton.style.display = 'flex';
        const networkStatus = document.getElementById('network-status');
        if (networkStatus) networkStatus.style.display = 'flex';
        if (!$efd3ba4ec2608b1d$var$networkCheckInterval) $efd3ba4ec2608b1d$var$networkCheckInterval = setInterval($efd3ba4ec2608b1d$var$checkGeneralNetworkQuality, 2000);
        $efd3ba4ec2608b1d$var$startCallTimer();
        $efd3ba4ec2608b1d$var$stopSound();
        $efd3ba4ec2608b1d$var$displayStatus("\u0110\xe3 tr\u1EA3 l\u1EDDi cu\u1ED9c g\u1ECDi.", 'success', 3000);
    }
}
function $efd3ba4ec2608b1d$var$rejectWebRTCCall() {
    if ($efd3ba4ec2608b1d$var$voip24hModuleInstance) {
        $efd3ba4ec2608b1d$var$appendLog("\u0110ang t\u1EEB ch\u1ED1i cu\u1ED9c g\u1ECDi WebRTC.");
        $efd3ba4ec2608b1d$var$voip24hModuleInstance.reject();
        $efd3ba4ec2608b1d$var$hideWebRTCCallPopup();
        $efd3ba4ec2608b1d$var$stopSound();
        $efd3ba4ec2608b1d$var$displayStatus("\u0110\xe3 t\u1EEB ch\u1ED1i cu\u1ED9c g\u1ECDi.", 'error', 3000);
    }
}
function $efd3ba4ec2608b1d$var$hangUpWebRTCCall() {
    if ($efd3ba4ec2608b1d$var$voip24hModuleInstance) {
        $efd3ba4ec2608b1d$var$appendLog("\u0110ang ng\u1EAFt cu\u1ED9c g\u1ECDi WebRTC.");
        $efd3ba4ec2608b1d$var$voip24hModuleInstance.hangUp();
        $efd3ba4ec2608b1d$var$hideWebRTCCallPopup();
        $efd3ba4ec2608b1d$var$stopSound();
        $efd3ba4ec2608b1d$var$displayStatus("Cu\u1ED9c g\u1ECDi \u0111\xe3 k\u1EBFt th\xfac.", 'success', 3000);
    }
}
async function $efd3ba4ec2608b1d$var$toggleWebRTCMute() {
    if ($efd3ba4ec2608b1d$var$isProcessingAction || !$efd3ba4ec2608b1d$var$voip24hModuleInstance) {
        $efd3ba4ec2608b1d$var$appendLog("H\xe0nh \u0111\u1ED9ng \u0111ang \u0111\u01B0\u1EE3c x\u1EED l\xfd. B\u1ECF qua y\xeau c\u1EA7u b\u1EADt/t\u1EAFt mic.");
        return;
    }
    $efd3ba4ec2608b1d$var$isProcessingAction = true;
    if ($efd3ba4ec2608b1d$var$webrtcMuteButton) $efd3ba4ec2608b1d$var$webrtcMuteButton.disabled = true;
    $efd3ba4ec2608b1d$var$appendLog("\u0110ang b\u1EADt/t\u1EAFt mic WebRTC...");
    try {
        await $efd3ba4ec2608b1d$var$voip24hModuleInstance.toggleMute();
        const isMuted = await $efd3ba4ec2608b1d$var$voip24hModuleInstance.isMute();
        if ($efd3ba4ec2608b1d$var$webrtcMuteButton) {
            if (isMuted) {
                $efd3ba4ec2608b1d$var$webrtcMuteButton.classList.add('active');
                if ($efd3ba4ec2608b1d$var$webrtcMuteButton.querySelector('img')) $efd3ba4ec2608b1d$var$webrtcMuteButton.querySelector('img').src = 'https://api.iconify.design/material-symbols:mic-off.svg';
                $efd3ba4ec2608b1d$var$webrtcMuteButton.title = "B\u1EADt ti\u1EBFng";
            } else {
                $efd3ba4ec2608b1d$var$webrtcMuteButton.classList.remove('active');
                if ($efd3ba4ec2608b1d$var$webrtcMuteButton.querySelector('img')) $efd3ba4ec2608b1d$var$webrtcMuteButton.querySelector('img').src = 'https://api.iconify.design/material-symbols:mic.svg';
                $efd3ba4ec2608b1d$var$webrtcMuteButton.title = "T\u1EAFt ti\u1EBFng";
            }
        }
    } catch (error) {
        $efd3ba4ec2608b1d$var$appendLog(`L\u{1ED7}i khi b\u{1EAD}t/t\u{1EAF}t mic: ${error}`);
        $efd3ba4ec2608b1d$var$displayStatus("L\u1ED7i khi th\u1EF1c hi\u1EC7n t\u1EAFt ti\u1EBFng.", 'error', 3000);
    } finally{
        $efd3ba4ec2608b1d$var$isProcessingAction = false;
        if ($efd3ba4ec2608b1d$var$webrtcMuteButton) $efd3ba4ec2608b1d$var$webrtcMuteButton.disabled = false;
    }
}
async function $efd3ba4ec2608b1d$var$toggleWebRTCHold() {
    if ($efd3ba4ec2608b1d$var$isProcessingAction || !$efd3ba4ec2608b1d$var$voip24hModuleInstance) {
        $efd3ba4ec2608b1d$var$appendLog("H\xe0nh \u0111\u1ED9ng \u0111ang \u0111\u01B0\u1EE3c x\u1EED l\xfd. B\u1ECF qua y\xeau c\u1EA7u gi\u1EEF/b\u1ECF gi\u1EEF.");
        return;
    }
    $efd3ba4ec2608b1d$var$isProcessingAction = true;
    if ($efd3ba4ec2608b1d$var$webrtcHoldButton) $efd3ba4ec2608b1d$var$webrtcHoldButton.disabled = true;
    $efd3ba4ec2608b1d$var$appendLog("\u0110ang gi\u1EEF/b\u1ECF gi\u1EEF cu\u1ED9c g\u1ECDi WebRTC...");
    try {
        await $efd3ba4ec2608b1d$var$voip24hModuleInstance.toggleHold();
        const isHeld = await $efd3ba4ec2608b1d$var$voip24hModuleInstance.isHold();
        if ($efd3ba4ec2608b1d$var$webrtcHoldButton) {
            if (isHeld) {
                $efd3ba4ec2608b1d$var$webrtcHoldButton.classList.add('active');
                if ($efd3ba4ec2608b1d$var$webrtcHoldButton.querySelector('img')) $efd3ba4ec2608b1d$var$webrtcHoldButton.querySelector('img').src = 'https://api.iconify.design/material-symbols:play-arrow.svg';
                $efd3ba4ec2608b1d$var$webrtcHoldButton.title = "Ti\u1EBFp t\u1EE5c cu\u1ED9c g\u1ECDi";
            } else {
                $efd3ba4ec2608b1d$var$webrtcHoldButton.classList.remove('active');
                if ($efd3ba4ec2608b1d$var$webrtcHoldButton.querySelector('img')) $efd3ba4ec2608b1d$var$webrtcHoldButton.querySelector('img').src = 'https://api.iconify.design/material-symbols:pause.svg';
                $efd3ba4ec2608b1d$var$webrtcHoldButton.title = "Gi\u1EEF cu\u1ED9c g\u1ECDi";
            }
        }
    } catch (error) {
        $efd3ba4ec2608b1d$var$appendLog(`L\u{1ED7}i khi gi\u{1EEF}/b\u{1ECF} gi\u{1EEF} cu\u{1ED9}c g\u{1ECD}i: ${error}`);
        $efd3ba4ec2608b1d$var$displayStatus("L\u1ED7i khi th\u1EF1c hi\u1EC7n gi\u1EEF cu\u1ED9c g\u1ECDi.", 'error', 3000);
    } finally{
        $efd3ba4ec2608b1d$var$isProcessingAction = false;
        if ($efd3ba4ec2608b1d$var$webrtcHoldButton) $efd3ba4ec2608b1d$var$webrtcHoldButton.disabled = false;
    }
}
function $efd3ba4ec2608b1d$var$renderTransferModalList(withAnimation = true) {
    const extensionList = document.getElementById('transfer-extension-list');
    const timestampDiv = document.getElementById('transfer-timestamp');
    if (!extensionList || !timestampDiv) return;
    extensionList.innerHTML = '';
    const useDynamicList = $efd3ba4ec2608b1d$var$latestPeerStatusData && $efd3ba4ec2608b1d$var$latestPeerStatusData.length > 0;
    const dataToRender = useDynamicList ? $efd3ba4ec2608b1d$var$latestPeerStatusData : $efd3ba4ec2608b1d$var$forwardingExtensions;
    if (useDynamicList && $efd3ba4ec2608b1d$var$lastPeerStatusTimestamp) {
        const formattedTime = $efd3ba4ec2608b1d$var$lastPeerStatusTimestamp.toLocaleString('vi-VN', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
        timestampDiv.textContent = `C\u{1EAD}p nh\u{1EAD}t l\u{1EA7}n cu\u{1ED1}i: ${formattedTime}`;
    } else timestampDiv.textContent = "Danh s\xe1ch chuy\u1EC3n ti\u1EBFp t\u0129nh";
    if (dataToRender.length === 0) {
        extensionList.innerHTML = '<li style="cursor: default; padding: 12px;">Kh\xf4ng c\xf3 m\xe1y nh\xe1nh n\xe0o \u0111\u1EC3 chuy\u1EC3n ti\u1EBFp.</li>';
        return;
    }
    dataToRender.forEach((extData, index)=>{
        const listItem = document.createElement('li');
        listItem.className = 'transfer-list-item';
        if (withAnimation) {
            listItem.classList.add('animate-in');
            listItem.style.animationDelay = `${index * 0.05}s`;
        }
        const extensionToTransfer = useDynamicList ? extData.extension : extData.ext;
        const employeeName = extData.name;
        const statusMessage = extData.statusData?.data?.messageExt;
        const isOnline = statusMessage === 'online';
        const isBusy = !!$efd3ba4ec2608b1d$var$activeCallStates[extensionToTransfer];
        const statusClass = isOnline ? 'online' : 'offline';
        const statusTitle = isOnline ? 'Online' : `Offline (${statusMessage || 'N/A'})`;
        listItem.innerHTML = `<span class="status-dot ${statusClass}" title="${statusTitle}"></span><span>${employeeName} (${extensionToTransfer})</span>`;
        if (isOnline && !isBusy) listItem.addEventListener('click', ()=>{
            if (extensionToTransfer === $efd3ba4ec2608b1d$var$currentActiveExtension) {
                alert("L\u1ED7i: B\u1EA1n kh\xf4ng th\u1EC3 chuy\u1EC3n ti\u1EBFp cu\u1ED9c g\u1ECDi cho ch\xednh m\xecnh!");
                return;
            }
            const modal = document.getElementById('transfer-modal');
            if (modal) {
                modal.classList.remove('show');
                modal.classList.add('hide');
                setTimeout(()=>{
                    modal.style.display = 'none';
                    modal.classList.remove('hide');
                }, 150);
            }
            if ($efd3ba4ec2608b1d$var$voip24hModuleInstance) {
                $efd3ba4ec2608b1d$var$appendLog(`\u{110}ang chuy\u{1EC3}n cu\u{1ED9}c g\u{1ECD}i \u{111}\u{1EBF}n: ${extensionToTransfer}`);
                $efd3ba4ec2608b1d$var$voip24hModuleInstance.transfer(extensionToTransfer);
                $efd3ba4ec2608b1d$var$displayStatus(`\u{110}\xe3 y\xeau c\u{1EA7}u chuy\u{1EC3}n cu\u{1ED9}c g\u{1ECD}i \u{111}\u{1EBF}n m\xe1y nh\xe1nh ${extensionToTransfer}.`, 'success', 4000);
            }
        });
        else {
            listItem.classList.add(isBusy ? 'busy' : 'disabled');
            listItem.title = isBusy ? "Kh\xf4ng th\u1EC3 chuy\u1EC3n ti\u1EBFp: M\xe1y nh\xe1nh \u0111ang b\u1EADn" : "Kh\xf4ng th\u1EC3 chuy\u1EC3n ti\u1EBFp: M\xe1y nh\xe1nh \u0111ang offline";
        }
        extensionList.appendChild(listItem);
    });
}
function $efd3ba4ec2608b1d$var$transferCall() {
    if ($efd3ba4ec2608b1d$var$webrtcKeypadButton && $efd3ba4ec2608b1d$var$webrtcKeypadButton.disabled === true) {
        $efd3ba4ec2608b1d$var$appendLog("N\xfat chuy\u1EC3n ti\u1EBFp \u0111ang b\u1ECB v\xf4 hi\u1EC7u ho\xe1, kh\xf4ng th\u1EC3 th\u1EF1c hi\u1EC7n.");
        return;
    }
    if (!$efd3ba4ec2608b1d$var$isCallActive) {
        alert("Kh\xf4ng c\xf3 cu\u1ED9c g\u1ECDi n\xe0o \u0111ang ho\u1EA1t \u0111\u1ED9ng \u0111\u1EC3 chuy\u1EC3n ti\u1EBFp.");
        return;
    }
    const modal = document.getElementById('transfer-modal');
    if (!modal) return;
    $efd3ba4ec2608b1d$var$isFirstTransferModalRender = true;
    $efd3ba4ec2608b1d$var$renderTransferModalList($efd3ba4ec2608b1d$var$isFirstTransferModalRender);
    $efd3ba4ec2608b1d$var$isFirstTransferModalRender = false;
    modal.style.display = 'flex';
    modal.classList.add('show');
}
function $efd3ba4ec2608b1d$var$sendDtmfSignal() {
    const dtmfNumber = prompt("Nh\u1EADp t\xedn hi\u1EC7u DTMF (s\u1ED1 ho\u1EB7c #*):");
    if ($efd3ba4ec2608b1d$var$voip24hModuleInstance && dtmfNumber) {
        $efd3ba4ec2608b1d$var$appendLog(`\u{110}ang g\u{1EED}i DTMF: ${dtmfNumber}`);
        $efd3ba4ec2608b1d$var$voip24hModuleInstance.sendDtmf(dtmfNumber);
    } else if (!dtmfNumber) $efd3ba4ec2608b1d$var$appendLog("Kh\xf4ng c\xf3 t\xedn hi\u1EC7u DTMF \u0111\u1EC3 g\u1EEDi.");
}
function $efd3ba4ec2608b1d$var$releaseProcess() {
    if ($efd3ba4ec2608b1d$var$voip24hModuleInstance) {
        $efd3ba4ec2608b1d$var$appendLog("\u0110ang h\u1EE7y ti\u1EBFn tr\xecnh WebRTC.");
        $efd3ba4ec2608b1d$var$voip24hModuleInstance.release();
    }
}
function $efd3ba4ec2608b1d$var$setupAutoRefresh() {
    const PAGE_RELOAD_TIME = 18000000;
    $efd3ba4ec2608b1d$var$appendLog(`Thi\u{1EBF}t l\u{1EAD}p t\u{1EF1} \u{111}\u{1ED9}ng t\u{1EA3}i l\u{1EA1}i trang sau ${PAGE_RELOAD_TIME / 1000 / 60} ph\xfat.`);
    setTimeout(()=>{
        $efd3ba4ec2608b1d$var$appendLog("\u0110ang t\u1EA3i l\u1EA1i trang t\u1EF1 \u0111\u1ED9ng...");
        location.reload();
    }, PAGE_RELOAD_TIME);
}
function $efd3ba4ec2608b1d$var$setupSecurityFeatures() {
    document.addEventListener('contextmenu', (event)=>event.preventDefault());
    document.addEventListener('keydown', function(e) {
        if (e.keyCode === 123 || e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74 || e.keyCode === 67) || e.ctrlKey && e.keyCode === 85 || e.ctrlKey && e.keyCode === 83) e.preventDefault();
    });
}
async function $efd3ba4ec2608b1d$var$checkGeneralNetworkQuality() {
    try {
        const startTime = Date.now();
        const testUrl = 'https://www.google.com/images/cleardot.gif?t=' + startTime;
        await fetch(testUrl, {
            cache: 'no-store',
            mode: 'no-cors'
        });
        const latency = Date.now() - startTime;
        const networkStatusDiv = document.getElementById('network-status');
        if (!networkStatusDiv) return;
        networkStatusDiv.classList.remove('good', 'average', 'poor');
        let quality = '';
        let title = '';
        if (latency > 300) {
            quality = 'poor';
            title = "Ch\u1EA5t l\u01B0\u1EE3ng m\u1EA1ng k\xe9m";
        } else if (latency > 150) {
            quality = 'average';
            title = "Ch\u1EA5t l\u01B0\u1EE3ng m\u1EA1ng trung b\xecnh";
        } else {
            quality = 'good';
            title = "Ch\u1EA5t l\u01B0\u1EE3ng m\u1EA1ng t\u1ED1t";
        }
        networkStatusDiv.classList.add(quality);
        networkStatusDiv.title = `${title} (\u{110}\u{1ED9} tr\u{1EC5}: ${latency}ms)`;
    } catch (error) {
        console.error("L\u1ED7i khi \u0111o ch\u1EA5t l\u01B0\u1EE3ng m\u1EA1ng: ", error);
        $efd3ba4ec2608b1d$var$appendLog(`L\u{1ED7}i khi \u{111}o ch\u{1EA5}t l\u{1B0}\u{1EE3}ng m\u{1EA1}ng: ${error}`);
        const networkStatusDiv = document.getElementById('network-status');
        if (networkStatusDiv) {
            networkStatusDiv.classList.remove('good', 'average');
            networkStatusDiv.classList.add('poor');
            networkStatusDiv.title = "M\u1EA5t k\u1EBFt n\u1ED1i";
        }
    }
}
function $efd3ba4ec2608b1d$var$setupEventListeners() {
    if ($efd3ba4ec2608b1d$var$callButton) $efd3ba4ec2608b1d$var$callButton.addEventListener('click', $efd3ba4ec2608b1d$var$makeCall);
    if ($efd3ba4ec2608b1d$var$hangupButton) $efd3ba4ec2608b1d$var$hangupButton.addEventListener('click', $efd3ba4ec2608b1d$var$hangUpIPCall);
    if ($efd3ba4ec2608b1d$var$webRtcCallButton) $efd3ba4ec2608b1d$var$webRtcCallButton.addEventListener('click', $efd3ba4ec2608b1d$var$initiateWebRTCCall);
    if ($efd3ba4ec2608b1d$var$webrtcAnswerButton) $efd3ba4ec2608b1d$var$webrtcAnswerButton.addEventListener('click', $efd3ba4ec2608b1d$var$answerWebRTCCall);
    if ($efd3ba4ec2608b1d$var$webrtcDeclineButton) $efd3ba4ec2608b1d$var$webrtcDeclineButton.addEventListener('click', $efd3ba4ec2608b1d$var$rejectWebRTCCall);
    if ($efd3ba4ec2608b1d$var$webrtcHangupButton) $efd3ba4ec2608b1d$var$webrtcHangupButton.addEventListener('click', $efd3ba4ec2608b1d$var$hangUpWebRTCCall);
    if ($efd3ba4ec2608b1d$var$webrtcMuteButton) $efd3ba4ec2608b1d$var$webrtcMuteButton.addEventListener('click', $efd3ba4ec2608b1d$var$toggleWebRTCMute);
    if ($efd3ba4ec2608b1d$var$webrtcHoldButton) $efd3ba4ec2608b1d$var$webrtcHoldButton.addEventListener('click', $efd3ba4ec2608b1d$var$toggleWebRTCHold);
    if ($efd3ba4ec2608b1d$var$webrtcKeypadButton) $efd3ba4ec2608b1d$var$webrtcKeypadButton.addEventListener('click', $efd3ba4ec2608b1d$var$transferCall);
    if (document.getElementById('open-contacts-btn')) document.getElementById('open-contacts-btn').addEventListener('click', $efd3ba4ec2608b1d$var$showContactsView);
    if (document.getElementById('close-contacts-view-btn')) document.getElementById('close-contacts-view-btn').addEventListener('click', $efd3ba4ec2608b1d$var$showAppView);
    if (document.getElementById('open-call-control-btn')) document.getElementById('open-call-control-btn').addEventListener('click', $efd3ba4ec2608b1d$var$showCallControlView);
    if (document.getElementById('close-call-control-btn')) document.getElementById('close-call-control-btn').addEventListener('click', $efd3ba4ec2608b1d$var$showAppView);
    if ($efd3ba4ec2608b1d$var$tokenSubmitButton) $efd3ba4ec2608b1d$var$tokenSubmitButton.addEventListener('click', $efd3ba4ec2608b1d$var$handleTokenSubmit);
    if ($efd3ba4ec2608b1d$var$openZaloBtn) $efd3ba4ec2608b1d$var$openZaloBtn.addEventListener('click', $efd3ba4ec2608b1d$var$showZaloView);
    if ($efd3ba4ec2608b1d$var$closeZaloBtn) $efd3ba4ec2608b1d$var$closeZaloBtn.addEventListener('click', $efd3ba4ec2608b1d$var$showAppView);
    if ($efd3ba4ec2608b1d$var$zaloModalConfirmBtn) $efd3ba4ec2608b1d$var$zaloModalConfirmBtn.addEventListener('click', $efd3ba4ec2608b1d$var$hideZaloNotificationModal);
    if ($efd3ba4ec2608b1d$var$appLogo) $efd3ba4ec2608b1d$var$appLogo.addEventListener('click', async ()=>{
        const newTokenPrompt = prompt("Nh\u1EADp token m\u1EDBi ho\u1EB7c \u0111\u1EC3 tr\u1ED1ng \u0111\u1EC3 \u0111\u0103ng xu\u1EA5t:");
        if (newTokenPrompt !== null) {
            const newToken = newTokenPrompt.trim();
            if (newToken === "") $efd3ba4ec2608b1d$var$logoutUser();
            else {
                localStorage.setItem($efd3ba4ec2608b1d$var$SAVED_TOKEN_KEY, newToken);
                location.reload();
            }
        }
    });
    if ($efd3ba4ec2608b1d$var$tokenInput) $efd3ba4ec2608b1d$var$tokenInput.addEventListener('focus', $efd3ba4ec2608b1d$var$handleInputFocus);
    if ($efd3ba4ec2608b1d$var$phoneNumberField) {
        $efd3ba4ec2608b1d$var$phoneNumberField.addEventListener('focus', $efd3ba4ec2608b1d$var$handleInputFocus);
        $efd3ba4ec2608b1d$var$phoneNumberField.addEventListener('input', function(event) {
            const maxLen = 11;
            const input = event.target;
            let value = input.value;
            const numericValue = value.replace(/[^0-9]/g, '');
            if (value !== numericValue) {
                $efd3ba4ec2608b1d$var$displayStatus($efd3ba4ec2608b1d$var$nonNumericInputErrorMsg, 'error', 3000);
                value = numericValue;
            }
            if (value.length > maxLen) {
                $efd3ba4ec2608b1d$var$displayStatus(`S\u{1ED1} \u{111}i\u{1EC7}n tho\u{1EA1}i kh\xf4ng \u{111}\u{1B0}\u{1EE3}c v\u{1B0}\u{1EE3}t qu\xe1 ${maxLen} s\u{1ED1}.`, 'error', 3000);
                value = value.slice(0, maxLen);
            }
            if (input.value !== value) input.value = value;
        });
    }
    if ($efd3ba4ec2608b1d$var$voip24hModuleInstance) $efd3ba4ec2608b1d$var$voip24hModuleInstance.pushEventToSide({
        onmessageOutSide: function(event, data) {
            $efd3ba4ec2608b1d$var$appendLog(`Event: ${event}`);
            const isCallTerminationEvent = [
                (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Hangup,
                (0, $100e4ce74f810de6$export$ad206ce4dbda264c).CustomerHangup,
                (0, $100e4ce74f810de6$export$ad206ce4dbda264c).EmployerHangup,
                (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Reject,
                'missed',
                (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Failed,
                (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Canceled,
                (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Error
            ].includes(event);
            const isFatalErrorEvent = [
                (0, $100e4ce74f810de6$export$ad206ce4dbda264c).ServerDown,
                (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Destroyed,
                (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Closing,
                (0, $100e4ce74f810de6$export$ad206ce4dbda264c).RegistrationFailed
            ].includes(event);
            if (isCallTerminationEvent) {
                $efd3ba4ec2608b1d$var$appendLog(`Cu\u{1ED9}c g\u{1ECD}i k\u{1EBF}t th\xfac b\xecnh th\u{1B0}\u{1EDD}ng: ${event}`);
                $efd3ba4ec2608b1d$var$hideWebRTCCallPopup();
                $efd3ba4ec2608b1d$var$stopSound();
                if (event === (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Hangup || event === (0, $100e4ce74f810de6$export$ad206ce4dbda264c).CustomerHangup || event === (0, $100e4ce74f810de6$export$ad206ce4dbda264c).EmployerHangup) $efd3ba4ec2608b1d$var$displayStatus("Cu\u1ED9c g\u1ECDi \u0111\xe3 k\u1EBFt th\xfac.", 'success', 3000);
                else if (event === (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Reject) $efd3ba4ec2608b1d$var$displayStatus("Cu\u1ED9c g\u1ECDi \u0111\xe3 b\u1ECB t\u1EEB ch\u1ED1i.", 'error', 3000);
                else if (event === 'missed') $efd3ba4ec2608b1d$var$displayStatus("Cu\u1ED9c g\u1ECDi nh\u1EE1.", 'error', 4000);
                else if (event === (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Error) $efd3ba4ec2608b1d$var$displayStatus(`L\u{1ED7}i cu\u{1ED9}c g\u{1ECD}i WebRTC: ${data.error}`, 'error', 5000);
                return;
            }
            if (isFatalErrorEvent) {
                $efd3ba4ec2608b1d$var$appendLog(`L\u{1ED7}i k\u{1EBF}t n\u{1ED1}i nghi\xeam tr\u{1ECD}ng: ${event}`);
                $efd3ba4ec2608b1d$var$hideWebRTCCallPopup();
                $efd3ba4ec2608b1d$var$stopSound();
                $efd3ba4ec2608b1d$var$displayStatus(`M\u{1EA5}t k\u{1EBF}t n\u{1ED1}i SIP: ${event}. \u{110}ang th\u{1EED} k\u{1EBF}t n\u{1ED1}i l\u{1EA1}i...`, 'error', 5000);
                $efd3ba4ec2608b1d$var$isSipRegistered = false;
                if ($efd3ba4ec2608b1d$var$callButton) $efd3ba4ec2608b1d$var$callButton.disabled = true;
                if ($efd3ba4ec2608b1d$var$webRtcCallButton) $efd3ba4ec2608b1d$var$webRtcCallButton.disabled = true;
                $efd3ba4ec2608b1d$var$appendLog("\u0110ang th\u1EED \u0111\u0103ng k\xfd l\u1EA1i SIP sau 5 gi\xe2y do l\u1ED7i/gi\xe1n \u0111o\u1EA1n.");
                setTimeout(()=>{
                    if ($efd3ba4ec2608b1d$var$currentActiveExtension && $efd3ba4ec2608b1d$var$currentSipPassword) $efd3ba4ec2608b1d$var$registerSipAccount($efd3ba4ec2608b1d$var$currentActiveExtension, $efd3ba4ec2608b1d$var$currentSipPassword);
                }, 5000);
                return;
            }
            if (event === (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Incomingcall) {
                $efd3ba4ec2608b1d$var$appendLog(`Cu\u{1ED9}c g\u{1ECD}i \u{111}\u{1EBF}n t\u{1EEB}: ${data.phonenumber}`);
                const contact = $efd3ba4ec2608b1d$var$dynamicContacts.find((c)=>c.ext && c.ext.includes(data.phonenumber) || c.mobile && c.mobile.includes(data.phonenumber)) || {
                    name: 'Unknown Caller',
                    phone: data.phonenumber,
                    avatar: `https://i.pravatar.cc/150?u=${data.phonenumber}`
                };
                $efd3ba4ec2608b1d$var$showWebRTCCallPopup('incoming', contact);
            } else if (event === (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Registered) {
                $efd3ba4ec2608b1d$var$appendLog("\u0110\u0103ng k\xfd t\xe0i kho\u1EA3n SIP th\xe0nh c\xf4ng.");
                $efd3ba4ec2608b1d$var$isSipRegistered = true;
                const displayName = $efd3ba4ec2608b1d$var$currentEmployeeName || "Ng\u01B0\u1EDDi d\xf9ng";
                if ($efd3ba4ec2608b1d$var$extensionDisplay) $efd3ba4ec2608b1d$var$extensionDisplay.value = `${$efd3ba4ec2608b1d$var$currentActiveExtension} (${displayName})`;
                if ($efd3ba4ec2608b1d$var$controlExtensionDisplay) $efd3ba4ec2608b1d$var$controlExtensionDisplay.value = `${$efd3ba4ec2608b1d$var$currentActiveExtension} (${displayName})`;
                if ($efd3ba4ec2608b1d$var$callButton) $efd3ba4ec2608b1d$var$callButton.disabled = false;
                if ($efd3ba4ec2608b1d$var$webRtcCallButton) $efd3ba4ec2608b1d$var$webRtcCallButton.disabled = false;
                $efd3ba4ec2608b1d$var$displayStatus("H\u1EC7 th\u1ED1ng \u0111ang tr\u1EF1c tuy\u1EBFn. S\u1EB5n s\xe0ng g\u1ECDi.", 'success', 5000);
            } else if (event === (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Accepted) {
                $efd3ba4ec2608b1d$var$appendLog("Cu\u1ED9c g\u1ECDi \u0111\xe3 \u0111\u01B0\u1EE3c ch\u1EA5p nh\u1EADn.");
                if ($efd3ba4ec2608b1d$var$webrtcKeypadButton) {
                    $efd3ba4ec2608b1d$var$webrtcKeypadButton.disabled = false;
                    $efd3ba4ec2608b1d$var$webrtcKeypadButton.style.opacity = '1';
                    $efd3ba4ec2608b1d$var$webrtcKeypadButton.style.cursor = 'pointer';
                    $efd3ba4ec2608b1d$var$webrtcKeypadButton.title = "Chuy\u1EC3n ti\u1EBFp cu\u1ED9c g\u1ECDi";
                }
                if ($efd3ba4ec2608b1d$var$callPopupStatus) {
                    $efd3ba4ec2608b1d$var$callPopupStatus.textContent = "\u0110ang nghe";
                    $efd3ba4ec2608b1d$var$callPopupStatus.className = 'call-status answered';
                }
                if (!$efd3ba4ec2608b1d$var$networkCheckInterval) $efd3ba4ec2608b1d$var$networkCheckInterval = setInterval($efd3ba4ec2608b1d$var$checkGeneralNetworkQuality, 2000);
                if ($efd3ba4ec2608b1d$var$webrtcCallPopup && $efd3ba4ec2608b1d$var$webrtcCallPopup.style.display !== 'flex') $efd3ba4ec2608b1d$var$showWebRTCCallPopup('active', {
                    phone: $efd3ba4ec2608b1d$var$callPopupNumber.textContent,
                    name: $efd3ba4ec2608b1d$var$callPopupName.textContent
                }, 'Incoming');
                if ($efd3ba4ec2608b1d$var$webrtcAnswerButton) $efd3ba4ec2608b1d$var$webrtcAnswerButton.style.display = 'none';
                if ($efd3ba4ec2608b1d$var$webrtcDeclineButton) $efd3ba4ec2608b1d$var$webrtcDeclineButton.style.display = 'none';
                if ($efd3ba4ec2608b1d$var$webrtcHangupButton) $efd3ba4ec2608b1d$var$webrtcHangupButton.style.display = 'flex';
                $efd3ba4ec2608b1d$var$startCallTimer();
                $efd3ba4ec2608b1d$var$stopSound();
            } else if (event === (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Holding) {
                $efd3ba4ec2608b1d$var$appendLog("Tr\u1EA1ng th\xe1i cu\u1ED9c g\u1ECDi: \u0110ang gi\u1EEF.");
                if ($efd3ba4ec2608b1d$var$webrtcHoldButton) {
                    $efd3ba4ec2608b1d$var$webrtcHoldButton.classList.add('active');
                    if ($efd3ba4ec2608b1d$var$webrtcHoldButton.querySelector('img')) $efd3ba4ec2608b1d$var$webrtcHoldButton.querySelector('img').src = 'https://api.iconify.design/material-symbols:play-arrow.svg';
                    $efd3ba4ec2608b1d$var$webrtcHoldButton.title = "Ti\u1EBFp t\u1EE5c cu\u1ED9c g\u1ECDi";
                }
            } else if (event === (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Unholding) {
                $efd3ba4ec2608b1d$var$appendLog("Tr\u1EA1ng th\xe1i cu\u1ED9c g\u1ECDi: \u0110\xe3 b\u1ECF gi\u1EEF.");
                if ($efd3ba4ec2608b1d$var$webrtcHoldButton) {
                    $efd3ba4ec2608b1d$var$webrtcHoldButton.classList.remove('active');
                    if ($efd3ba4ec2608b1d$var$webrtcHoldButton.querySelector('img')) $efd3ba4ec2608b1d$var$webrtcHoldButton.querySelector('img').src = 'https://api.iconify.design/material-symbols:pause.svg';
                    $efd3ba4ec2608b1d$var$webrtcHoldButton.title = "Gi\u1EEF cu\u1ED9c g\u1ECDi";
                }
            } else if (event === (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Mute) {
                $efd3ba4ec2608b1d$var$appendLog("Mic \u0111\xe3 t\u1EAFt.");
                if ($efd3ba4ec2608b1d$var$webrtcMuteButton) {
                    $efd3ba4ec2608b1d$var$webrtcMuteButton.classList.add('active');
                    if ($efd3ba4ec2608b1d$var$webrtcMuteButton.querySelector('img')) $efd3ba4ec2608b1d$var$webrtcMuteButton.querySelector('img').src = 'https://api.iconify.design/material-symbols:mic-off.svg';
                    $efd3ba4ec2608b1d$var$webrtcMuteButton.title = "B\u1EADt ti\u1EBFng";
                }
            } else if (event === (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Unmute) {
                $efd3ba4ec2608b1d$var$appendLog("Mic \u0111\xe3 b\u1EADt.");
                if ($efd3ba4ec2608b1d$var$webrtcMuteButton) {
                    $efd3ba4ec2608b1d$var$webrtcMuteButton.classList.remove('active');
                    if ($efd3ba4ec2608b1d$var$webrtcMuteButton.querySelector('img')) $efd3ba4ec2608b1d$var$webrtcMuteButton.querySelector('img').src = 'https://api.iconify.design/material-symbols:mic.svg';
                    $efd3ba4ec2608b1d$var$webrtcMuteButton.title = "T\u1EAFt ti\u1EBFng";
                }
            } else if (event === (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Calling) $efd3ba4ec2608b1d$var$appendLog("\u0110ang g\u1ECDi \u0111i...");
            else if (event === (0, $100e4ce74f810de6$export$ad206ce4dbda264c).Transfer) $efd3ba4ec2608b1d$var$appendLog("Cu\u1ED9c g\u1ECDi \u0111ang \u0111\u01B0\u1EE3c chuy\u1EC3n ti\u1EBFp.");
        }
    });
}
async function $efd3ba4ec2608b1d$var$registerSipAccount(numberSIP = null, password = null) {
    const obfuscatedServerIp = 'MjAzLjE2Mi43OS4yMzA=';
    const ipAddressSIP = atob(obfuscatedServerIp);
    const finalNumberSIP = numberSIP || $efd3ba4ec2608b1d$var$currentActiveExtension;
    const finalPassword = password || $efd3ba4ec2608b1d$var$currentSipPassword;
    if (!finalNumberSIP || !finalPassword) {
        $efd3ba4ec2608b1d$var$appendLog("Kh\xf4ng th\u1EC3 \u0111\u0103ng k\xfd SIP: Thi\u1EBFu s\u1ED1 m\xe1y nh\xe1nh ho\u1EB7c m\u1EADt kh\u1EA9u.");
        $efd3ba4ec2608b1d$var$displayStatus("L\u1ED7i: Kh\xf4ng \u0111\u1EE7 th\xf4ng tin SIP \u0111\u1EC3 \u0111\u0103ng k\xfd.", 'error', 0, $efd3ba4ec2608b1d$var$statusDiv);
        $efd3ba4ec2608b1d$var$isSipRegistered = false;
        return;
    }
    if ($efd3ba4ec2608b1d$var$voip24hModuleInstance) {
        $efd3ba4ec2608b1d$var$appendLog(`\u{110}ang \u{111}\u{103}ng k\xfd SIP v\u{1EDB}i s\u{1ED1}: ${finalNumberSIP} t\u{1EA1}i ${ipAddressSIP}`);
        $efd3ba4ec2608b1d$var$voip24hModuleInstance.registerSip(ipAddressSIP, finalNumberSIP, finalPassword);
    } else {
        $efd3ba4ec2608b1d$var$appendLog("Module WebRTC ch\u01B0a \u0111\u01B0\u1EE3c kh\u1EDFi t\u1EA1o. Kh\xf4ng th\u1EC3 \u0111\u0103ng k\xfd SIP.");
        $efd3ba4ec2608b1d$var$displayStatus("L\u1ED7i: Module WebRTC ch\u01B0a \u0111\u01B0\u1EE3c kh\u1EDFi t\u1EA1o.", 'error', 0, $efd3ba4ec2608b1d$var$statusDiv);
        $efd3ba4ec2608b1d$var$isSipRegistered = false;
    }
}
function $efd3ba4ec2608b1d$var$setupTransferModal() {
    if (document.getElementById('transfer-modal')) return;
    const modalHTML = `
    <div id="transfer-modal" class="transfer-modal">
        <div class="transfer-modal-content">
            <div class="transfer-modal-header">
                <h2>Ch\u{1ECD}n m\xe1y nh\xe1nh \u{111}\u{1EC3} chuy\u{1EC3}n ti\u{1EBF}p</h2>
                <span id="close-transfer-modal-btn" class="transfer-close-btn">&times;</span>
            </div>
            <ul id="transfer-extension-list"></ul>
            <div class="transfer-modal-footer">
                <div id="transfer-timestamp" class="transfer-timestamp"></div>
                <button id="confirm-close-transfer-btn" class="blue-btn">\u{110}\xf3ng</button>
            </div>
        </div>
    </div>`;
    const styleHTML = `
        @keyframes modal-fade-in { from { opacity: 0; transform: translateY(-20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes modal-fade-out { from { opacity: 1; transform: translateY(0); } to { opacity: 0; transform: translateY(-20px); } }
        .transfer-modal { display: none; position: fixed; z-index: 2000; left: 0; top: 0; width: 100%; height: 100%; overflow: auto; background-color: rgba(0,0,0,0.6); justify-content: center; align-items: center; }
        .transfer-modal.show .transfer-modal-content { animation: modal-fade-in 0.3s ease-out; }
        .transfer-modal.hide .transfer-modal-content { animation: modal-fade-out 0.15s ease-out forwards; }
        .transfer-modal-content { background-color: #fff; margin: auto; padding: 20px; border-radius: 8px; width: 90%; max-width: 400px; box-shadow: 0 5px 15px rgba(0,0,0,0.3); color: #333; }
        .transfer-modal-header { display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #dee2e6; padding-bottom: 1rem; }
        .transfer-modal-header h2 { margin: 0; font-size: 1.2rem; }
        .transfer-close-btn { color: #aaa; font-size: 28px; font-weight: bold; cursor: pointer; }
        #transfer-extension-list { list-style: none; padding: 0; margin-top: 1rem; max-height: 300px; overflow-y: auto; }
        .transfer-list-item { display: flex; align-items: center; padding: 12px; border-bottom: 1px solid #eee; cursor: pointer; transition: background-color 0.2s; }
        .transfer-list-item:hover { background-color: #f1f1f1; }
        .transfer-list-item.disabled { color: #aaa; background-color: #f8f9fa; cursor: not-allowed; }
        .transfer-list-item.disabled:hover { background-color: #f8f9fa; }
        .transfer-modal-footer { display: flex; justify-content: space-between; align-items: center; padding-top: 1.5rem; border-top: 1px solid #dee2e6; margin-top: 1rem; }
        .transfer-timestamp { font-size: 0.8em; color: #6c757d; flex-grow: 1; }
        .blue-btn { background-color: #007bff; color: white; border: none; padding: 10px 20px; border-radius: 5px; font-size: 15px; cursor: pointer; transition: background-color 0.2s; }
        .blue-btn:hover { background-color: #0056b3; }
        .transfer-list-item .status-dot { width: 10px; height: 10px; border-radius: 50%; margin-right: 10px; flex-shrink: 0; }
        .transfer-list-item .status-dot.online { background-color: #28a745; }
        .transfer-list-item .status-dot.offline { background-color: #dc3545; }
        .transfer-list-item .status-dot.unknown { background-color: #6c757d; }
    `;
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    const styleContainer = document.createElement('style');
    styleContainer.innerHTML = styleHTML;
    document.head.appendChild(styleContainer);
    const modal = document.getElementById('transfer-modal');
    const closeBtn = document.getElementById('close-transfer-modal-btn');
    const confirmCloseBtn = document.getElementById('confirm-close-transfer-btn');
    if (modal && closeBtn && confirmCloseBtn) {
        const closeModal = ()=>{
            modal.classList.remove('show');
            modal.classList.add('hide');
            setTimeout(()=>{
                modal.style.display = 'none';
                modal.classList.remove('hide');
            }, 150);
        };
        closeBtn.onclick = closeModal;
        confirmCloseBtn.onclick = closeModal;
        modal.addEventListener('click', (event)=>{
            if (event.target === modal) closeModal();
        });
    }
}
function $efd3ba4ec2608b1d$var$handlePusherEvent(payload) {
    if (!payload || !payload.callid) return;
    const callId = payload.callid;
    const callerExt = payload.type === 'inbound' ? payload.phone : payload.extend;
    const calleeExt = payload.type === 'inbound' ? payload.extend : payload.phone;
    $efd3ba4ec2608b1d$var$appendLog(`[Pusher] Event: ${payload.state}/${payload.type} | Caller: ${callerExt}, Callee: ${calleeExt}`);
    if (payload.type === 'ended' || payload.state === 'Hangup') {
        $efd3ba4ec2608b1d$var$appendLog(`[Pusher] Call ${callId} ended. Clearing states for ${callerExt} and ${calleeExt}.`);
        if (callerExt && $efd3ba4ec2608b1d$var$activeCallStates[callerExt]?.callId === callId) delete $efd3ba4ec2608b1d$var$activeCallStates[callerExt];
        if (calleeExt && $efd3ba4ec2608b1d$var$activeCallStates[calleeExt]?.callId === callId) delete $efd3ba4ec2608b1d$var$activeCallStates[calleeExt];
    } else if (payload.state === 'Up') {
        $efd3ba4ec2608b1d$var$appendLog(`[Pusher] Call ${callId} answered between ${callerExt} and ${calleeExt}.`);
        if (callerExt) $efd3ba4ec2608b1d$var$activeCallStates[callerExt] = {
            status: 'in-call',
            peer: calleeExt,
            callId: callId
        };
        if (calleeExt) $efd3ba4ec2608b1d$var$activeCallStates[calleeExt] = {
            status: 'in-call',
            peer: callerExt,
            callId: callId
        };
    } else if (payload.state === 'Ring') {
        $efd3ba4ec2608b1d$var$appendLog(`[Pusher] Call ${callId} is ringing.`);
        if (callerExt) $efd3ba4ec2608b1d$var$activeCallStates[callerExt] = {
            status: 'calling-out',
            peer: calleeExt,
            callId: callId
        };
        if (calleeExt) $efd3ba4ec2608b1d$var$activeCallStates[calleeExt] = {
            status: 'ringing',
            peer: callerExt,
            callId: callId
        };
    }
    $efd3ba4ec2608b1d$var$renderPeerStatus($efd3ba4ec2608b1d$var$latestPeerStatusData);
}
// === HÀM THIẾT LẬP PUSHER ĐÃ ĐƯỢC GỘP LẠI (THÊM DEBUG LOG) ===
async function $efd3ba4ec2608b1d$var$setupPusherListener() {
    $efd3ba4ec2608b1d$var$appendLog("Pusher Setup: B\u1EAFt \u0111\u1EA7u h\xe0m setupPusherListener.");
    if (!$efd3ba4ec2608b1d$var$savedActualToken) {
        $efd3ba4ec2608b1d$var$appendLog("Pusher Setup: L\u1ED7i - Ch\u01B0a \u0111\u0103ng nh\u1EADp, kh\xf4ng th\u1EC3 l\u1EA5y c\u1EA5u h\xecnh Pusher.");
        return;
    }
    try {
        $efd3ba4ec2608b1d$var$appendLog("Pusher Setup: \u0110ang g\u1EEDi y\xeau c\u1EA7u l\u1EA5y T\u1EA4T C\u1EA2 c\u1EA5u h\xecnh Pusher t\u1EEB wk-test...");
        const response = await fetch(`${$efd3ba4ec2608b1d$var$WORKER_BASE_URL}/get-pusher-config`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams({
                token: $efd3ba4ec2608b1d$var$savedActualToken
            })
        });
        $efd3ba4ec2608b1d$var$appendLog(`Pusher Setup: Ph\u{1EA3}n h\u{1ED3}i t\u{1EEB} wk-test c\xf3 status: ${response.status}`);
        if (!response.ok) {
            const errorData = await response.text();
            throw new Error(`Server tr\u{1EA3} v\u{1EC1} l\u{1ED7}i: ${response.status} - ${errorData}`);
        }
        const configs = await response.json();
        $efd3ba4ec2608b1d$var$appendLog("Pusher Setup: \u0110\xe3 nh\u1EADn v\xe0 parse JSON c\u1EA5u h\xecnh th\xe0nh c\xf4ng.");
        $efd3ba4ec2608b1d$var$appendLog(`Pusher Setup: D\u{1EEF} li\u{1EC7}u c\u{1EA5}u h\xecnh nh\u{1EAD}n \u{111}\u{1B0}\u{1EE3}c: ${JSON.stringify(configs)}`);
        Pusher.logToConsole = false;
        // --- 1. Thiết lập Pusher cho CUỘC GỌI (event-listener) ---
        if (configs.eventListener && configs.eventListener.key) {
            $efd3ba4ec2608b1d$var$appendLog("Pusher Setup (event-listener): T\xecm th\u1EA5y c\u1EA5u h\xecnh. \u0110ang kh\u1EDFi t\u1EA1o...");
            const pusherA = new Pusher(configs.eventListener.key, {
                cluster: configs.eventListener.cluster
            });
            const channelA = pusherA.subscribe('webhook-channel');
            channelA.bind('new-webhook-event', function(data) {
                $efd3ba4ec2608b1d$var$appendLog("[Pusher event-listener] Nh\u1EADn s\u1EF1 ki\u1EC7n m\u1EDBi!");
                try {
                    let webhookPayload = typeof data === 'string' ? JSON.parse(data) : data;
                    if (webhookPayload.data && typeof webhookPayload.data === 'string') webhookPayload = JSON.parse(webhookPayload.data);
                    $efd3ba4ec2608b1d$var$handlePusherEvent(webhookPayload);
                } catch (e) {
                    console.error("[Pusher event-listener] L\u1ED7i x\u1EED l\xfd d\u1EEF li\u1EC7u:", e, "D\u1EEF li\u1EC7u g\u1ED1c:", data);
                }
            });
            pusherA.connection.bind('connected', ()=>$efd3ba4ec2608b1d$var$appendLog("Pusher Setup (event-listener): K\u1EBFt n\u1ED1i th\xe0nh c\xf4ng."));
            pusherA.connection.bind('error', (err)=>$efd3ba4ec2608b1d$var$appendLog(`Pusher Setup (event-listener): L\u{1ED7}i k\u{1EBF}t n\u{1ED1}i - ${err.error?.data?.message || "Kh\xf4ng r\xf5"}`));
        } else $efd3ba4ec2608b1d$var$appendLog("Pusher Setup: C\u1EA2NH B\xc1O - Kh\xf4ng t\xecm th\u1EA5y c\u1EA5u h\xecnh cho event-listener.");
        // --- 2. Thiết lập Pusher cho TIN NHẮN ZALO (event-zalo) ---
        if (configs.zaloListener && configs.zaloListener.key) {
            $efd3ba4ec2608b1d$var$appendLog("Pusher Setup (event-zalo): T\xecm th\u1EA5y c\u1EA5u h\xecnh. \u0110ang kh\u1EDFi t\u1EA1o...");
            const pusherB = new Pusher(configs.zaloListener.key, {
                cluster: configs.zaloListener.cluster
            });
            const channelB = pusherB.subscribe('zalo-oa-notifications');
            channelB.bind('new-message', function(data) {
                $efd3ba4ec2608b1d$var$appendLog("[Pusher event-zalo] Nh\u1EADn tin nh\u1EAFn Zalo m\u1EDBi!");
                $efd3ba4ec2608b1d$var$handleZaloMessage(data);
            });
            pusherB.connection.bind('connected', ()=>$efd3ba4ec2608b1d$var$appendLog("Pusher Setup (event-zalo): K\u1EBFt n\u1ED1i th\xe0nh c\xf4ng."));
            pusherB.connection.bind('error', (err)=>$efd3ba4ec2608b1d$var$appendLog(`Pusher Setup (event-zalo): L\u{1ED7}i k\u{1EBF}t n\u{1ED1}i - ${err.error?.data?.message || "Kh\xf4ng r\xf5"}`));
        } else $efd3ba4ec2608b1d$var$appendLog("Pusher Setup: C\u1EA2NH B\xc1O - Kh\xf4ng t\xecm th\u1EA5y c\u1EA5u h\xecnh cho zalo-listener.");
    } catch (e) {
        console.error("L\u1ED7i nghi\xeam tr\u1ECDng khi kh\u1EDFi t\u1EA1o Pusher:", e);
        $efd3ba4ec2608b1d$var$appendLog(`Pusher Setup: L\u{1ED7}i nghi\xeam tr\u{1ECD}ng - ${e.message}`);
    }
}
// === CÁC HÀM MỚI CHO TÍNH NĂNG ZALO ===
function $efd3ba4ec2608b1d$var$playZaloAlert() {
    if ($efd3ba4ec2608b1d$var$isZaloAlertPlaying) return;
    if ($efd3ba4ec2608b1d$var$isCallActive) {
        $efd3ba4ec2608b1d$var$appendLog("Kh\xf4ng ph\xe1t \xe2m thanh Zalo v\xec \u0111ang c\xf3 cu\u1ED9c g\u1ECDi.");
        $efd3ba4ec2608b1d$var$wasZaloAlertPausedForCall = true;
        return;
    }
    $efd3ba4ec2608b1d$var$zaloAlertAudio = new Audio($efd3ba4ec2608b1d$var$ZALO_ALERT_SOUND_URL);
    $efd3ba4ec2608b1d$var$zaloAlertAudio.loop = true;
    $efd3ba4ec2608b1d$var$zaloAlertAudio.play().catch((e)=>{
        console.error("L\u1ED7i kh\xf4ng th\u1EC3 ph\xe1t \xe2m thanh c\u1EA3nh b\xe1o Zalo:", e);
    });
    $efd3ba4ec2608b1d$var$isZaloAlertPlaying = true;
    $efd3ba4ec2608b1d$var$appendLog("\u0110\xe3 ph\xe1t \xe2m thanh c\u1EA3nh b\xe1o Zalo.");
}
function $efd3ba4ec2608b1d$var$stopZaloAlert() {
    if ($efd3ba4ec2608b1d$var$zaloAlertAudio) {
        $efd3ba4ec2608b1d$var$zaloAlertAudio.pause();
        $efd3ba4ec2608b1d$var$zaloAlertAudio.currentTime = 0;
        $efd3ba4ec2608b1d$var$zaloAlertAudio = null;
    }
    $efd3ba4ec2608b1d$var$isZaloAlertPlaying = false;
    $efd3ba4ec2608b1d$var$appendLog("\u0110\xe3 d\u1EEBng \xe2m thanh c\u1EA3nh b\xe1o Zalo.");
}
function $efd3ba4ec2608b1d$var$showZaloNotificationModal() {
    if ($efd3ba4ec2608b1d$var$zaloNotificationModal) $efd3ba4ec2608b1d$var$zaloNotificationModal.style.display = 'flex';
}
function $efd3ba4ec2608b1d$var$hideZaloNotificationModal() {
    if ($efd3ba4ec2608b1d$var$zaloNotificationModal) $efd3ba4ec2608b1d$var$zaloNotificationModal.style.display = 'none';
    // Chỉ tắt âm thanh nếu không còn tin nhắn nào chưa đọc
    const hasUnread = $efd3ba4ec2608b1d$var$zaloMessageList && $efd3ba4ec2608b1d$var$zaloMessageList.querySelector('.zalo-message-item.unread');
    if (!hasUnread) $efd3ba4ec2608b1d$var$stopZaloAlert();
}
function $efd3ba4ec2608b1d$var$copyToClipboard(text, element) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    try {
        document.execCommand('copy');
        if (element) {
            const originalText = element.textContent;
            element.textContent = "\u0110\xe3 ch\xe9p ID!";
            element.style.color = '#28a745';
            setTimeout(()=>{
                element.textContent = originalText;
                element.style.color = '';
            }, 1500);
        }
    } catch (err) {
        console.error("Kh\xf4ng th\u1EC3 sao ch\xe9p:", err);
    }
    document.body.removeChild(textarea);
}
function $efd3ba4ec2608b1d$var$handleZaloMessage(data) {
    if (!$efd3ba4ec2608b1d$var$zaloMessageList) return;
    const emptyMessage = $efd3ba4ec2608b1d$var$zaloMessageList.querySelector('.empty-list-message');
    if (emptyMessage) emptyMessage.remove();
    const { content: content, rawZaloEvent: rawZaloEvent } = data;
    const senderId = rawZaloEvent.sender?.id || "Kh\xf4ng r\xf5";
    const timestamp = parseInt(rawZaloEvent.timestamp, 10);
    const messageDate = new Date(timestamp);
    const formattedTime = messageDate.toLocaleString('vi-VN', {
        hour: '2-digit',
        minute: '2-digit',
        day: '2-digit',
        month: '2-digit'
    });
    let messageContentHTML = '';
    switch(content.type){
        case 'text':
            messageContentHTML = `<p>${content.text}</p>`;
            break;
        case 'image':
            messageContentHTML = `<a href="${content.url}" target="_blank" rel="noopener noreferrer"><img src="${content.thumbnail}" alt="\u{1EA2}nh t\u{1EEB} Zalo"></a>`;
            break;
        case 'sticker':
            messageContentHTML = `<img src="${content.url}" alt="Sticker t\u{1EEB} Zalo" style="width: 100px; height: 100px;">`;
            break;
        case 'audio':
            messageContentHTML = `<audio controls src="${content.url}"></audio>`;
            break;
        case 'video':
            messageContentHTML = `<video controls src="${content.url}" poster="${content.thumbnail}"></video>`;
            break;
        case 'file':
            messageContentHTML = `\u{110}\xe3 g\u{1EED}i m\u{1ED9}t t\u{1EC7}p: <a href="${content.url}" target="_blank" rel="noopener noreferrer">${content.name}</a>`;
            break;
        case 'link':
            messageContentHTML = `\u{110}\xe3 g\u{1EED}i m\u{1ED9}t li\xean k\u{1EBF}t: <a href="${content.url}" target="_blank" rel="noopener noreferrer">${content.description || content.url}</a>`;
            break;
        case 'location':
            messageContentHTML = `\u{110}\xe3 g\u{1EED}i m\u{1ED9}t v\u{1ECB} tr\xed: <a href="https://www.google.com/maps?q=${content.latitude},${content.longitude}" target="_blank" rel="noopener noreferrer">Xem tr\xean b\u{1EA3}n \u{111}\u{1ED3}</a>`;
            break;
        default:
            messageContentHTML = `<p><i>Lo\u{1EA1}i tin nh\u{1EAF}n kh\xf4ng \u{111}\u{1B0}\u{1EE3}c h\u{1ED7} tr\u{1EE3} \u{111}\u{1EC3} hi\u{1EC3}n th\u{1ECB}.</i></p>`;
    }
    const messageId = `zalo-msg-${rawZaloEvent.message?.msg_id || timestamp}`;
    const messageItem = document.createElement('div');
    messageItem.className = 'zalo-message-item unread';
    messageItem.id = messageId;
    messageItem.innerHTML = `
        <div class="zalo-message-header">
            <span class="zalo-sender-info" title="Nh\u{1EA5}n \u{111}\u{1EC3} sao ch\xe9p ID">T\u{1EEB}: ${senderId}</span>
            <span class="zalo-timestamp">${formattedTime}</span>
        </div>
        <div class="zalo-message-content">
            ${messageContentHTML}
        </div>
        <button class="zalo-confirm-btn">\u2705 \u{110}\xe3 \u{111}\u{1ECD}c</button>
    `;
    $efd3ba4ec2608b1d$var$zaloMessageList.prepend(messageItem);
    const confirmButton = messageItem.querySelector('.zalo-confirm-btn');
    confirmButton.addEventListener('click', ()=>{
        messageItem.classList.remove('unread');
        confirmButton.textContent = "\u2714 \u0110\xe3 xem";
        confirmButton.disabled = true;
        const hasUnread = $efd3ba4ec2608b1d$var$zaloMessageList.querySelector('.zalo-message-item.unread');
        if (!hasUnread) {
            $efd3ba4ec2608b1d$var$stopZaloAlert();
            $efd3ba4ec2608b1d$var$hideZaloNotificationModal();
        }
    });
    const senderInfoSpan = messageItem.querySelector('.zalo-sender-info');
    senderInfoSpan.addEventListener('click', (e)=>{
        e.stopPropagation();
        $efd3ba4ec2608b1d$var$copyToClipboard(senderId, senderInfoSpan);
    });
    $efd3ba4ec2608b1d$var$playZaloAlert();
    $efd3ba4ec2608b1d$var$showZaloNotificationModal();
}
// === ĐIỂM BẮT ĐẦU CHÍNH CỦA ỨNG DỤNG (ENTRY POINT) ===
document.addEventListener('DOMContentLoaded', async ()=>{
    // Gán tất cả các biến DOM
    $efd3ba4ec2608b1d$var$logContainer = document.getElementById('log_container');
    $efd3ba4ec2608b1d$var$logOutput = document.getElementById('log_output');
    $efd3ba4ec2608b1d$var$peerStatusList = document.getElementById('peer-status-list');
    $efd3ba4ec2608b1d$var$peerStatusTimestamp = document.getElementById('peer-status-timestamp');
    $efd3ba4ec2608b1d$var$phoneNumberField = document.getElementById('phoneNumber');
    $efd3ba4ec2608b1d$var$statusDiv = document.getElementById('status');
    $efd3ba4ec2608b1d$var$tokenStatusDiv = document.getElementById('tokenStatus');
    $efd3ba4ec2608b1d$var$hangupStatusDiv = document.getElementById('hangupStatus');
    $efd3ba4ec2608b1d$var$mainContentContainer = document.getElementById('main-content');
    $efd3ba4ec2608b1d$var$tokenEntryContainer = document.getElementById('token-entry-container');
    $efd3ba4ec2608b1d$var$ipRestrictionMessageDiv = document.getElementById('ip-restriction-message');
    $efd3ba4ec2608b1d$var$callButton = document.getElementById('callButton');
    $efd3ba4ec2608b1d$var$hangupButton = document.getElementById('hangupButton');
    $efd3ba4ec2608b1d$var$extensionDisplay = document.getElementById('extensionDisplay');
    $efd3ba4ec2608b1d$var$controlExtensionDisplay = document.getElementById('controlExtensionDisplay');
    $efd3ba4ec2608b1d$var$tokenInput = document.getElementById('tokenInput');
    $efd3ba4ec2608b1d$var$appLogo = document.getElementById('appLogo');
    $efd3ba4ec2608b1d$var$appContainer = document.getElementById('app-container');
    $efd3ba4ec2608b1d$var$callControlContainer = document.getElementById('call-control-container');
    $efd3ba4ec2608b1d$var$contactListContainer = document.getElementById('contact-list-container');
    $efd3ba4ec2608b1d$var$tokenEntryVersionSpan = document.getElementById('tokenEntryVersion');
    $efd3ba4ec2608b1d$var$callControlVersionSpan = document.getElementById('callControlVersion');
    $efd3ba4ec2608b1d$var$appVersionSpan = document.getElementById('appVersion');
    $efd3ba4ec2608b1d$var$contactsVersionSpan = document.getElementById('contactsVersion');
    $efd3ba4ec2608b1d$var$peerStatusVersionSpan = document.getElementById('peerStatusVersion');
    $efd3ba4ec2608b1d$var$tokenEntrySupportPhoneSpan = document.getElementById('tokenEntrySupportPhone');
    $efd3ba4ec2608b1d$var$tokenEntrySupportNameSpan = document.getElementById('tokenEntrySupportName');
    $efd3ba4ec2608b1d$var$callControlSupportPhoneSpan = document.getElementById('callControlSupportPhone');
    $efd3ba4ec2608b1d$var$callControlSupportNameSpan = document.getElementById('callControlSupportName');
    $efd3ba4ec2608b1d$var$appSupportPhoneSpan = document.getElementById('appSupportPhone');
    $efd3ba4ec2608b1d$var$appSupportNameSpan = document.getElementById('appSupportName');
    $efd3ba4ec2608b1d$var$contactsSupportPhoneSpan = document.getElementById('contactsSupportPhone');
    $efd3ba4ec2608b1d$var$contactsSupportNameSpan = document.getElementById('contactsSupportName');
    $efd3ba4ec2608b1d$var$peerStatusSupportPhoneSpan = document.getElementById('peerStatusSupportPhone');
    $efd3ba4ec2608b1d$var$peerStatusSupportNameSpan = document.getElementById('peerStatusSupportName');
    $efd3ba4ec2608b1d$var$webrtcCallPopup = document.getElementById('webrtc-call-popup');
    $efd3ba4ec2608b1d$var$callPopupTime = document.getElementById('call-popup-time');
    $efd3ba4ec2608b1d$var$callPopupAvatar = document.getElementById('call-popup-avatar');
    $efd3ba4ec2608b1d$var$callPopupName = document.getElementById('call-popup-name');
    $efd3ba4ec2608b1d$var$callPopupNumber = document.getElementById('call-popup-number');
    $efd3ba4ec2608b1d$var$callPopupTimer = document.getElementById('call-popup-timer');
    $efd3ba4ec2608b1d$var$callPopupStatus = document.getElementById('call-popup-status');
    $efd3ba4ec2608b1d$var$webrtcSpeakerButton = document.getElementById('webrtc-speaker-button');
    $efd3ba4ec2608b1d$var$webrtcKeypadButton = document.getElementById('webrtc-keypad-button');
    $efd3ba4ec2608b1d$var$webrtcMuteButton = document.getElementById('webrtc-mute-button');
    $efd3ba4ec2608b1d$var$webrtcHoldButton = document.getElementById('webrtc-hold-button');
    $efd3ba4ec2608b1d$var$webrtcAnswerButton = document.getElementById('webrtc-answer-button');
    $efd3ba4ec2608b1d$var$webrtcDeclineButton = document.getElementById('webrtc-decline-button');
    $efd3ba4ec2608b1d$var$webrtcHangupButton = document.getElementById('webrtc-hangup-button');
    $efd3ba4ec2608b1d$var$webRtcCallButton = document.getElementById('webRtcCallButton');
    $efd3ba4ec2608b1d$var$tokenSubmitButton = document.getElementById('tokenSubmitButton');
    $efd3ba4ec2608b1d$var$zaloMessagesContainer = document.getElementById('zalo-messages-container');
    $efd3ba4ec2608b1d$var$zaloMessageList = document.getElementById('zalo-message-list');
    $efd3ba4ec2608b1d$var$openZaloBtn = document.getElementById('open-zalo-btn');
    $efd3ba4ec2608b1d$var$closeZaloBtn = document.getElementById('close-zalo-view-btn');
    $efd3ba4ec2608b1d$var$zaloVersionSpan = document.getElementById('zaloVersion');
    $efd3ba4ec2608b1d$var$zaloSupportPhoneSpan = document.getElementById('zaloSupportPhone');
    $efd3ba4ec2608b1d$var$zaloSupportNameSpan = document.getElementById('zaloSupportName');
    $efd3ba4ec2608b1d$var$zaloNotificationModal = document.getElementById('zalo-notification-modal');
    $efd3ba4ec2608b1d$var$zaloModalConfirmBtn = document.getElementById('zalo-modal-confirm-btn');
    $efd3ba4ec2608b1d$var$appendLog("DOM Content Loaded! Starting application initialization.");
    function addNetworkStatusIndicator() {
        const styleHTML = `
            .network-status { width: 36px; height: 28px; display: flex; align-items: flex-end; justify-content: space-between; gap: 3px; }
            .network-status .signal-bar { flex-grow: 1; background-color: #e0e0e0; border-radius: 2px; transform-origin: bottom; transform: scaleY(0); transition: transform 0.3s ease-out, background-color 0.5s ease; }
            .network-status .signal-bar:nth-child(1) { height: 25%; transition-delay: 0s; }
            .network-status .signal-bar:nth-child(2) { height: 50%; transition-delay: 0.05s; }
            .network-status .signal-bar:nth-child(3) { height: 75%; transition-delay: 0.1s; }
            .network-status .signal-bar:nth-child(4) { height: 100%; transition-delay: 0.15s; }
            .network-status.good .signal-bar { transform: scaleY(1); background-color: #00d640; }
            .network-status.average .signal-bar:nth-child(-n+3) { transform: scaleY(1); background-color: #ffc107; }
            .network-status.poor .signal-bar:nth-child(1) { transform: scaleY(1); background-color: #dc3545; }
        `;
        const styleContainer = document.createElement('style');
        styleContainer.innerHTML = styleHTML;
        document.head.appendChild(styleContainer);
        const header = document.querySelector('#webrtc-call-popup .popup-header');
        if (header) {
            const indicatorHTML = `<div id="network-status" class="network-status" title="\u{110}ang ki\u{1EC3}m tra ch\u{1EA5}t l\u{1B0}\u{1EE3}ng m\u{1EA1}ng..."><div class="signal-bar"></div><div class="signal-bar"></div><div class="signal-bar"></div><div class="signal-bar"></div></div>`;
            const oldIndicator = header.querySelector('.network-status');
            if (oldIndicator) oldIndicator.remove();
            header.insertAdjacentHTML('afterbegin', indicatorHTML);
        }
    }
    function addContactListStyles() {
        const styleHTML = `
            #contacts { max-height: 420px; overflow-y: auto; padding-right: 5px; }
            .contact-group { border-bottom: 1px solid #eee; }
            .contact-item.expandable { position: relative; }
            .contact-item.expandable .contact-name { flex-grow: 1; }
            .expand-icon { width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; margin-left: auto; }
            .expand-icon svg { width: 18px; height: 18px; transition: transform 0.3s cubic-bezier(0.25, 0.1, 0.25, 1); }
            .expand-icon svg path { stroke: #6c757d; stroke-width: 2; stroke-linecap: round; transition: transform 0.3s cubic-bezier(0.25, 0.1, 0.25, 1); }
            .contact-group.expanded .expand-icon svg { transform: rotate(135deg); }
            .contact-group.expanded > .contact-item { background-color: #f8f9fa; border-radius: 6px 6px 0 0; }
            .sub-contact-list { max-height: 0; overflow: hidden; transition: max-height 0.3s ease-in-out; background-color: #f8f9fa; margin: 0 5px; border-radius: 0 0 6px 6px; }
            .contact-group.expanded .sub-contact-list { max-height: 500px; }
            .sub-contact-item { display: flex; align-items: center; gap: 10px; padding: 12px 10px 12px 60px; cursor: pointer; border-top: 1px solid #e9ecef; opacity: 0; transform: translateY(-10px); animation: sub-item-slide-in 0.3s ease-out forwards; }
            .sub-contact-item:hover { background-color: #e2e6ea; }
            .sub-contact-icon { width: 18px; height: 18px; filter: invert(40%); }
            @keyframes sub-item-slide-in { to { opacity: 1; transform: translateY(0); } }
        `;
        const styleContainer = document.createElement('style');
        styleContainer.innerHTML = styleHTML;
        document.head.appendChild(styleContainer);
    }
    addContactListStyles();
    addNetworkStatusIndicator();
    $efd3ba4ec2608b1d$var$setupTransferModal();
    if (window.innerWidth < 800) {
        if ($efd3ba4ec2608b1d$var$contactListContainer) $efd3ba4ec2608b1d$var$contactListContainer.style.display = 'none';
        if ($efd3ba4ec2608b1d$var$callControlContainer) $efd3ba4ec2608b1d$var$callControlContainer.style.display = 'none';
        if ($efd3ba4ec2608b1d$var$appContainer) $efd3ba4ec2608b1d$var$appContainer.style.display = 'none';
    }
    try {
        const canvasElement = document.getElementById('background-canvas');
        if (canvasElement) {
            (0, $ddc984d9440f81ec$export$f9606e15a6ee4049)();
            $efd3ba4ec2608b1d$var$appendLog("Hi\u1EC7u \u1EE9ng n\u1EC1n \u0111\xe3 \u0111\u01B0\u1EE3c kh\u1EDFi t\u1EA1o.");
        }
        $efd3ba4ec2608b1d$var$voip24hModuleInstance = (0, $ca52eec7d4a3410f$export$41258f2d70482113).getInstance('all');
        await $efd3ba4ec2608b1d$var$voip24hModuleInstance.initializeModule();
        $efd3ba4ec2608b1d$var$appendLog("Module WebRTC \u0111\xe3 \u0111\u01B0\u1EE3c kh\u1EDFi t\u1EA1o th\xe0nh c\xf4ng.");
        if ($efd3ba4ec2608b1d$var$voip24hModuleInstance) $efd3ba4ec2608b1d$var$voip24hModuleInstance._handleJanusDestroyed = function() {
            $efd3ba4ec2608b1d$var$appendLog("Janus session destroyed. Ignored page reload to prevent loop.");
        };
        $efd3ba4ec2608b1d$var$setupEventListeners();
        $efd3ba4ec2608b1d$var$setupSecurityFeatures();
        const versionCheckUrl = `${$efd3ba4ec2608b1d$var$WORKER_BASE_URL}/dial`;
        const formData = new URLSearchParams({
            token: 'initial_version_check',
            phone: '0000000000'
        });
        const response = await fetch(versionCheckUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: formData
        });
        const responseData = await response.json();
        if (responseData.version) $efd3ba4ec2608b1d$var$updateVersionDisplay(responseData.version);
        else $efd3ba4ec2608b1d$var$updateVersionDisplay("1.3.X (L\u1ED7i t\u1EA3i)");
        if (responseData.supportPhone && responseData.supportPersonName) $efd3ba4ec2608b1d$var$updateSupportInfoDisplay(responseData.supportPhone, responseData.supportPersonName);
        else $efd3ba4ec2608b1d$var$updateSupportInfoDisplay('N/A', 'N/A');
        $efd3ba4ec2608b1d$var$appendLog("Th\xf4ng tin phi\xean b\u1EA3n v\xe0 h\u1ED7 tr\u1EE3 \u0111\xe3 \u0111\u01B0\u1EE3c t\u1EA3i.");
        const savedToken = localStorage.getItem($efd3ba4ec2608b1d$var$SAVED_TOKEN_KEY);
        if (savedToken) {
            $efd3ba4ec2608b1d$var$appendLog(`T\xecm th\u{1EA5}y token \u{111}\xe3 l\u{1B0}u: ${savedToken}. \u{110}ang x\xe1c th\u{1EF1}c...`);
            $efd3ba4ec2608b1d$var$savedActualToken = savedToken;
            $efd3ba4ec2608b1d$var$unlockAudioContext();
            const tokenValid = await $efd3ba4ec2608b1d$var$validateAndSetToken(savedToken, true);
            if (!tokenValid) $efd3ba4ec2608b1d$var$appendLog("Token \u0111\xe3 l\u01B0u kh\xf4ng h\u1EE3p l\u1EC7 ho\u1EB7c IP b\u1ECB h\u1EA1n ch\u1EBF khi t\u1EA3i.");
        } else {
            $efd3ba4ec2608b1d$var$appendLog("Kh\xf4ng t\xecm th\u1EA5y token \u0111\xe3 l\u01B0u. \u0110ang hi\u1EC3n th\u1ECB m\xe0n h\xecnh nh\u1EADp token.");
            if ($efd3ba4ec2608b1d$var$tokenEntryContainer) {
                $efd3ba4ec2608b1d$var$tokenEntryContainer.style.display = 'block';
                $efd3ba4ec2608b1d$var$tokenEntryContainer.style.animation = 'slideUpFadeIn 0.7s ease-out forwards';
            }
            if ($efd3ba4ec2608b1d$var$mainContentContainer) $efd3ba4ec2608b1d$var$mainContentContainer.style.display = 'none';
            $efd3ba4ec2608b1d$var$displayStatus("Vui l\xf2ng nh\u1EADp token m\xe1y nh\xe1nh.", '', 5000, $efd3ba4ec2608b1d$var$tokenStatusDiv);
        }
        $efd3ba4ec2608b1d$var$setupAutoRefresh();
        $efd3ba4ec2608b1d$var$appendLog("Ch\u1EE9c n\u0103ng t\u1EF1 \u0111\u1ED9ng l\xe0m m\u1EDBi trang \u0111\xe3 \u0111\u01B0\u1EE3c thi\u1EBFt l\u1EADp.");
    } catch (error) {
        $efd3ba4ec2608b1d$var$appendLog(`L\u{1ED7}i nghi\xeam tr\u{1ECD}ng khi kh\u{1EDF}i t\u{1EA1}o \u{1EE9}ng d\u{1EE5}ng: ${error}`);
        console.error("L\u1ED7i nghi\xeam tr\u1ECDng khi kh\u1EDFi t\u1EA1o \u1EE9ng d\u1EE5ng:", error);
        if ($efd3ba4ec2608b1d$var$logContainer) $efd3ba4ec2608b1d$var$logContainer.style.display = 'block';
        $efd3ba4ec2608b1d$var$displayStatus(`L\u{1ED7}i kh\u{1EDF}i t\u{1EA1}o \u{1EE9}ng d\u{1EE5}ng: ${error.message}. Vui l\xf2ng ki\u{1EC3}m tra console log.`, 'error', 0, $efd3ba4ec2608b1d$var$tokenStatusDiv);
    }
});


//# sourceMappingURL=repo.51795bba.js.map
